/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Basic representation of an advanced filter data structure */
  AdvancedFilter: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** A field whose value is a CSS RGBA color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba(). */
  RGBA: any;
  /** Inputs for Config Values */
  SolutionsStudyMethodologyConfigValue: any;
};

/** Supports Image and Text A/B question type answers */
export type AbQuestionVariableAnswerData = QuestionVariableAnswerData & {
  __typename?: 'ABQuestionVariableAnswerData';
  headers: Array<SurveyQuestionHeader>;
  stimuliPerRespondent?: Maybe<Scalars['Int']>;
  type: SurveyQuestionType;
};

export type AccountOwnerPublicInfo = {
  __typename?: 'AccountOwnerPublicInfo';
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  username: Scalars['String'];
};

/** The types of activities associated with an individual activity log */
export enum ActivityActionType {
  AuthenticationFailed = 'AUTHENTICATION_FAILED',
  AuthenticationSignout = 'AUTHENTICATION_SIGNOUT',
  AuthenticationSucceeded = 'AUTHENTICATION_SUCCEEDED',
  CollectorInfoCreated = 'COLLECTOR_INFO_CREATED',
  CollectorInfoDeleted = 'COLLECTOR_INFO_DELETED',
  CollectorInfoUpdated = 'COLLECTOR_INFO_UPDATED',
  ExportDownloaded = 'EXPORT_DOWNLOADED',
  ExportExportCreate = 'EXPORT_EXPORT_CREATE',
  GrantInfoCreated = 'GRANT_INFO_CREATED',
  GrantInfoDeleted = 'GRANT_INFO_DELETED',
  GroupInfoUpdatedGroupName = 'GROUP_INFO_UPDATED_GROUP_NAME',
  InviteCreated = 'INVITE_CREATED',
  InviteResent = 'INVITE_RESENT',
  MemberDeleted = 'MEMBER_DELETED',
  MemberJoined = 'MEMBER_JOINED',
  MemberUpdatedGroupMemberType = 'MEMBER_UPDATED_GROUP_MEMBER_TYPE',
  PermissionCreated = 'PERMISSION_CREATED',
  PermissionUpdated = 'PERMISSION_UPDATED',
  RespondentDeleted = 'RESPONDENT_DELETED',
  RespondentUpdated = 'RESPONDENT_UPDATED',
  ScimTokenCreated = 'SCIM_TOKEN_CREATED',
  ScimTokenRevoked = 'SCIM_TOKEN_REVOKED',
  ScimTokenUpdated = 'SCIM_TOKEN_UPDATED',
  ScimUserCreated = 'SCIM_USER_CREATED',
  ScimUserDeleted = 'SCIM_USER_DELETED',
  ScimUserLinkedToSso = 'SCIM_USER_LINKED_TO_SSO',
  ScimUserUpdated = 'SCIM_USER_UPDATED',
  SharedViewCreated = 'SHARED_VIEW_CREATED',
  SharedViewUpdated = 'SHARED_VIEW_UPDATED',
  SurveyInfoCopy = 'SURVEY_INFO_COPY',
  SurveyInfoCreate = 'SURVEY_INFO_CREATE',
  SurveyInfoDelete = 'SURVEY_INFO_DELETE',
  SurveyInfoTransfer = 'SURVEY_INFO_TRANSFER',
  SurveyInfoUpdate = 'SURVEY_INFO_UPDATE',
}

export enum ActivityCategories {
  AppInstall = 'APP_INSTALL',
  Collaboration = 'COLLABORATION',
  Collect = 'COLLECT',
  Logins = 'LOGINS',
  Scim = 'SCIM',
  Survey = 'SURVEY',
}

/** The activity category related to app installs */
export type ActivityCategoryAppInstall = ActivityLog & {
  __typename?: 'ActivityCategoryAppInstall';
  actionType: ActivityActionType;
  appName: Scalars['String'];
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  division?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  ipAddress?: Maybe<Scalars['String']>;
  memberType: ActivityMemberType;
  userId: Scalars['ID'];
  username: Scalars['String'];
};

/** The activity category related to collaboration of surveys */
export type ActivityCategoryCollaboration = ActivityLog & {
  __typename?: 'ActivityCategoryCollaboration';
  actionType: ActivityActionType;
  activityEmail?: Maybe<Scalars['String']>;
  activityUsername?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  division?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  ipAddress?: Maybe<Scalars['String']>;
  memberType: ActivityMemberType;
  newVal?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  prevVal?: Maybe<Scalars['String']>;
  shareType?: Maybe<ActivityShareType>;
  title?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
  username: Scalars['String'];
};

/** The activity category related to survey collectors */
export type ActivityCategoryCollect = ActivityLog & {
  __typename?: 'ActivityCategoryCollect';
  action?: Maybe<ActivityCollectorUpdateAction>;
  actionType: ActivityActionType;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  division?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  ipAddress?: Maybe<Scalars['String']>;
  memberType: ActivityMemberType;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<ActivityCollectorType>;
  userId: Scalars['ID'];
  username: Scalars['String'];
};

/** The default activity category for when an activity has no raw activity data */
export type ActivityCategoryDefault = ActivityLog & {
  __typename?: 'ActivityCategoryDefault';
  actionType: ActivityActionType;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  division?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  ipAddress?: Maybe<Scalars['String']>;
  memberType: ActivityMemberType;
  userId: Scalars['ID'];
  username: Scalars['String'];
};

/** The activity category related to exporting data across the service */
export type ActivityCategoryExport = ActivityLog & {
  __typename?: 'ActivityCategoryExport';
  actionType: ActivityActionType;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  division?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  exportJobFormat?: Maybe<ActivityExportJobFormat>;
  exportJobType?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  ipAddress?: Maybe<Scalars['String']>;
  memberType: ActivityMemberType;
  title?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
  username: Scalars['String'];
};

/** The activity category related to user login and authentication */
export type ActivityCategoryLogin = ActivityLog & {
  __typename?: 'ActivityCategoryLogin';
  actionType: ActivityActionType;
  activityEmail?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  division?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  ipAddress?: Maybe<Scalars['String']>;
  memberType: ActivityMemberType;
  thirdParty?: Maybe<ActivityThirdPartyLoginType>;
  userId: Scalars['ID'];
  username: Scalars['String'];
};

/** The activity category related to the changes in permissions for surveys */
export type ActivityCategoryPermissionUpdate = ActivityLog & {
  __typename?: 'ActivityCategoryPermissionUpdate';
  actionType: ActivityActionType;
  activityEmail?: Maybe<Scalars['String']>;
  activityUsername?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  division?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  ipAddress?: Maybe<Scalars['String']>;
  memberType: ActivityMemberType;
  nickname?: Maybe<Scalars['String']>;
  permission0?: Maybe<ActivityPermissionType>;
  permission1?: Maybe<ActivityPermissionType>;
  permission2?: Maybe<ActivityPermissionType>;
  title?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
  username: Scalars['String'];
};

/** The activity category related to survey updates */
export type ActivityCategorySurvey = ActivityLog & {
  __typename?: 'ActivityCategorySurvey';
  actionType: ActivityActionType;
  activityUsername?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  division?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  ipAddress?: Maybe<Scalars['String']>;
  memberType: ActivityMemberType;
  nickname?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
  username: Scalars['String'];
};

/** The types of methods to collect survey results */
export enum ActivityCollectorType {
  Audience = 'AUDIENCE',
  Email = 'EMAIL',
  Facebook = 'FACEBOOK',
  FacebookMessenger = 'FACEBOOK_MESSENGER',
  MobileSdk = 'MOBILE_SDK',
  OfflineKiosk = 'OFFLINE_KIOSK',
  Popup = 'POPUP',
  Sms = 'SMS',
  Weblink = 'WEBLINK',
}

/** The actions a user could take on a collector object */
export enum ActivityCollectorUpdateAction {
  Close = 'CLOSE',
  Open = 'OPEN',
  Rename = 'RENAME',
  Update = 'UPDATE',
}

/** The format of exported jobs */
export enum ActivityExportJobFormat {
  Csv = 'CSV',
  Excel = 'EXCEL',
  ExcelPlus = 'EXCEL_PLUS',
  Gss = 'GSS',
  Html = 'HTML',
  Pdf = 'PDF',
  Png = 'PNG',
  Ppt = 'PPT',
  Spss = 'SPSS',
}

export type ActivityLog = {
  actionType: ActivityActionType;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  division?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  ipAddress?: Maybe<Scalars['String']>;
  memberType: ActivityMemberType;
  userId: Scalars['ID'];
  username: Scalars['String'];
};

export type ActivityLogsInput = {
  categories?: InputMaybe<Array<InputMaybe<ActivityCategories>>>;
  divisionId?: InputMaybe<Scalars['ID']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  memberId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type ActivityLogsList = PaginatedList & {
  __typename?: 'ActivityLogsList';
  items: Array<ActivityLog>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** The types of members associated with an individual activity log */
export enum ActivityMemberType {
  AccountOwner = 'ACCOUNT_OWNER',
  Admin = 'ADMIN',
  Analyst = 'ANALYST',
  Casual = 'CASUAL',
  DivisionAdmin = 'DIVISION_ADMIN',
  NonEnterprise = 'NON_ENTERPRISE',
  Regular = 'REGULAR',
}

/** The permission types on a survey */
export enum ActivityPermissionType {
  Analyze = 'ANALYZE',
  Collect = 'COLLECT',
  Design = 'DESIGN',
}

/** The restrictions on shared surveys */
export enum ActivityShareType {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Restricted = 'RESTRICTED',
}

/** The third party services a user could use as a log in method */
export enum ActivityThirdPartyLoginType {
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE',
  Microsoft = 'MICROSOFT',
  SamlEnterprise = 'SAML_ENTERPRISE',
}

export type AddOnProductItem = {
  __typename?: 'AddOnProductItem';
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  price: PriceItem;
  productId: Scalars['ID'];
  productMetadata: ProductMetaData;
  quantity: ProductQuantity;
  skuId: Scalars['ID'];
  unitLabel: Scalars['String'];
};

export type AddSuggestedLogoToSurveyPayload = {
  __typename?: 'AddSuggestedLogoToSurveyPayload';
  /**
   * Whether or not the logo was added successfully
   * @deprecated Clearbit deprecation CREATE-18066
   */
  logoAdded: Scalars['Boolean'];
  /** @deprecated Clearbit deprecation CREATE-18066 */
  success: Scalars['Boolean'];
  /** @deprecated Clearbit deprecation CREATE-18066 */
  survey?: Maybe<Survey>;
  /**
   * Whether or not a theme was applied successfully
   * @deprecated Clearbit deprecation CREATE-18066
   */
  themeApplied: Scalars['Boolean'];
};

/** Indicates how new surveys created by team members should be automatically shared. */
export enum AdminShareSetting {
  MaxPermissions = 'MAX_PERMISSIONS',
  MaxPermissionsAllowShareOff = 'MAX_PERMISSIONS_ALLOW_SHARE_OFF',
  MaxPermissionsCanDecrease = 'MAX_PERMISSIONS_CAN_DECREASE',
  ViewOnlyPermissionsCanIncrease = 'VIEW_ONLY_PERMISSIONS_CAN_INCREASE',
}

export type AdvancedFeedbackValue = {
  id: Scalars['String'];
  options: Array<Scalars['String']>;
};

export type AdvancedFilterInput = {
  rules?: InputMaybe<Scalars['AdvancedFilter']>;
};

export type AdvancedRecommendation = {
  __typename?: 'AdvancedRecommendation';
  id: Scalars['ID'];
  options: Array<RecommendationOptions>;
};

export enum AlertChannel {
  Email = 'EMAIL',
  Mobile = 'MOBILE',
}

export type AllStimuli = {
  __typename?: 'AllStimuli';
  description: Scalars['String'];
  family: Scalars['String'];
  heading: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<AllStimuliImageStimulus>;
  nickname: Scalars['String'];
  randomAssignment: StimuliRandomAssignment;
  stimuliId: Scalars['ID'];
  type: Scalars['String'];
};

export type AllStimuliImageStimulus = {
  __typename?: 'AllStimuliImageStimulus';
  id?: Maybe<Scalars['ID']>;
  s3Key?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Cell type for XLS format exports */
export enum AnalysisExportCellDisplay {
  ActualText = 'ACTUAL_TEXT',
  NumericalValue = 'NUMERICAL_VALUE',
}

/** Column type for XLS format exports */
export enum AnalysisExportColumnCompression {
  Condensed = 'CONDENSED',
  CondensedMulti = 'CONDENSED_MULTI',
  Expanded = 'EXPANDED',
}

export type AnalysisExportDisplayInfoTypeInput = {
  completeResponses: Scalars['Int'];
  /** Translations to display in export report */
  summaryTranslations?: InputMaybe<AnalysisExportSummaryTranslationsInput>;
  totalResponses: Scalars['Int'];
  /** Date export was created in a vanity string */
  vanityDateCreated: Scalars['String'];
};

export type AnalysisExportFile = {
  __typename?: 'AnalysisExportFile';
  downloadLink?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

/** Analyze Export Job type */
export type AnalysisExportJob = {
  __typename?: 'AnalysisExportJob';
  createdAt: Scalars['DateTime'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  file: AnalysisExportFile;
  format: AnalysisExportJobFormat;
  id: Scalars['ID'];
  responseCount: Scalars['Int'];
  status: AnalysisExportJobStatus;
  survey: Survey;
  type: AnalysisJobType;
};

/** File format for exported data */
export enum AnalysisExportJobFormat {
  Csv = 'CSV',
  Pdf = 'PDF',
  Ppt = 'PPT',
  Spss = 'SPSS',
  Xls = 'XLS',
}

/** Required job info for all analysis export variations */
export type AnalysisExportJobInfoInput = {
  /** Pages to include in the export from show rule (default ALL) */
  pages?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Questions to include in the export from show rule (default ALL) */
  questions?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  viewName: Scalars['String'];
};

/** Inputs required to construct the export job */
export type AnalysisExportJobInput = {
  /** Custom filename */
  analysisExportJobName: Scalars['String'];
  analysisViewId: Scalars['String'];
  /** File format for export job */
  jobFormat: AnalysisExportJobFormat;
  /** Job information for export job */
  jobInfo: AnalysisExportJobInfoInput;
  /** Export job type */
  jobType: AnalysisJobType;
  respondentCount: Scalars['Int'];
  surveyId: Scalars['ID'];
};

export type AnalysisExportJobList = PaginatedList & {
  __typename?: 'AnalysisExportJobList';
  items: Array<AnalysisExportJob>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** Analyze Export Job Status */
export enum AnalysisExportJobStatus {
  Enqueued = 'ENQUEUED',
  ServerError = 'SERVER_ERROR',
  Started = 'STARTED',
  Success = 'SUCCESS',
}

/** Orientation type for PDF format exports */
export enum AnalysisExportOrientation {
  Landscape = 'LANDSCAPE',
  Portait = 'PORTAIT',
}

/** Paper size for PDF format exports */
export enum AnalysisExportPaperSize {
  A4 = 'A4',
  Legal = 'LEGAL',
  Letter = 'LETTER',
}

/** All inputs required for question level exports */
export type AnalysisExportQuestionParamsInput = {
  /** Choice to include branding in export report */
  includeBranding?: InputMaybe<Scalars['Boolean']>;
  /** Choice to include charts in export report */
  includeCharts?: InputMaybe<Scalars['Boolean']>;
  /** Choice to include open ended question responses in export report */
  includeOpenEnded?: InputMaybe<Scalars['Boolean']>;
  /** PDF format specific inputs */
  pdfParams?: InputMaybe<AnalysisPdfExportParamsInput>;
  /** PPT format specific inputs */
  pptParams?: InputMaybe<AnalysisPptExportParamsInput>;
  /** Whether export report has questions all on one page or one per page */
  questionDisplay?: InputMaybe<AnalysisExportQuestionSheetDisplay>;
  /** Information on specific question being exported */
  questionParams: AnalysisQuestionExportParamsInput;
};

/** Whether to display export data on one or multiple sheets */
export enum AnalysisExportQuestionSheetDisplay {
  MultipleSheets = 'MULTIPLE_SHEETS',
  OneSheet = 'ONE_SHEET',
}

/** Copy translations to display for analysis summary type exports */
export type AnalysisExportSummaryTranslationsInput = {
  completeResponses: Scalars['String'];
  dateCreated: Scalars['String'];
  totalResponses: Scalars['String'];
};

/** Survey-level export inputs */
export type AnalysisExportSurveyParamsInput = {
  /** Choice to include branding in export report */
  includeBranding?: InputMaybe<Scalars['Boolean']>;
  /** Choice to include charts in export report */
  includeCharts?: InputMaybe<Scalars['Boolean']>;
  /** Choice to include open ended question responses in export report */
  includeOpenEnded?: InputMaybe<Scalars['Boolean']>;
  /** Optional, only needed for pdf format exports */
  pdfParams?: InputMaybe<AnalysisPdfExportParamsInput>;
  /** Optional, only needed for ppt format exports */
  pptParams?: InputMaybe<AnalysisPptExportParamsInput>;
  /** Whether export report has questions all on one page or one per page */
  questionDisplay?: InputMaybe<AnalysisExportQuestionSheetDisplay>;
  /** Optional respondent id, which if not provided means all respondents */
  respondentId?: InputMaybe<Scalars['ID']>;
  /** Optional, only needed for xls format exports */
  xlsParams?: InputMaybe<AnalysisXlsExportParamsInput>;
};

export type AnalysisFilterGroupInput = {
  ruleFilterAdvanced?: InputMaybe<AdvancedFilterInput>;
  ruleFilterCollector?: InputMaybe<CollectorFilterInput>;
  ruleFilterCompleteness?: InputMaybe<CompletenessFilterInput>;
  ruleFilterQna?: InputMaybe<QnAFilterInput>;
  ruleFilterRandomAssignment?: InputMaybe<RandomAssignmentFilterInput>;
  ruleFilterTimePeriod?: InputMaybe<TimePeriodFilterInput>;
};

export type AnalysisFilterInput = {
  filter: Array<InputMaybe<AnalysisFilterGroupInput>>;
};

/** Type of export */
export enum AnalysisJobType {
  Chart = 'CHART',
  Full = 'FULL',
  Summary = 'SUMMARY',
  WordCloud = 'WORD_CLOUD',
}

/** Fields for PDF format analysis exports */
export type AnalysisPdfExportParamsInput = {
  dimension?: InputMaybe<AnalysisExportPaperSize>;
  forcedPageBreak: Scalars['Boolean'];
  includeOpenended: Scalars['Boolean'];
  orientation?: InputMaybe<AnalysisExportOrientation>;
  showWordCloud?: InputMaybe<Scalars['Boolean']>;
  zoomFactor: Scalars['Float'];
};

/** Fields for PPT format analysis exports */
export type AnalysisPptExportParamsInput = {
  includeTables?: InputMaybe<Scalars['Boolean']>;
  showWordCloud?: InputMaybe<Scalars['Boolean']>;
  surveySummary?: InputMaybe<AnalysisExportDisplayInfoTypeInput>;
  zoomFactor?: InputMaybe<Scalars['Float']>;
};

export enum AnalysisQuestionCommentSearchOperator {
  Eq = 'EQ',
  Gt = 'GT',
  Lt = 'LT',
}

/** Individual question specific input */
export type AnalysisQuestionExportParamsInput = {
  questionId: Scalars['Int'];
  questionNumber: Scalars['Int'];
};

export enum AnalysisQuestionOptionSearchType {
  /** ALL words */
  All = 'ALL',
  /** Any word */
  Any = 'ANY',
  /** Exact phrase */
  Exact = 'EXACT',
}

export type AnalysisQuestionTag = {
  __typename?: 'AnalysisQuestionTag';
  color: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
  question?: Maybe<SurveyQuestion>;
  typeId: Scalars['ID'];
  typeName: Scalars['String'];
};

export type AnalysisQuestionTags = {
  __typename?: 'AnalysisQuestionTags';
  items?: Maybe<Array<Maybe<AnalysisQuestionTag>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AnalysisResponseCounts = {
  __typename?: 'AnalysisResponseCounts';
  /** the total number of responses for the current view (with filters and compares applied) */
  contextualTotal: Scalars['Int'];
  /** the total number of responses for the survey that are currently accessible */
  restrictedTotal: Scalars['Int'];
  /** the total number of responses for the survey */
  total: Scalars['Int'];
};

export type AnalysisResultsDashboard = {
  __typename?: 'AnalysisResultsDashboard';
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  key: Scalars['String'];
  modifiedAt: Scalars['DateTime'];
  survey: Survey;
  title: Scalars['String'];
};

export type AnalysisResultsDashboardList = PaginatedList & {
  __typename?: 'AnalysisResultsDashboardList';
  items: Array<AnalysisResultsDashboard>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A shared results view */
export type AnalysisSharedView = {
  __typename?: 'AnalysisSharedView';
  branding?: Maybe<AnalysisSharedViewBranding>;
  defaultView?: Maybe<AnalysisStandardView>;
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  hasPassword?: Maybe<Scalars['Boolean']>;
  hideOpenEnded?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  modes?: Maybe<Array<Maybe<AnalysisSharedViewMode>>>;
  name?: Maybe<Scalars['String']>;
  sharableView?: Maybe<AnalysisStandardView>;
  sharedViewKey?: Maybe<Scalars['String']>;
  survey?: Maybe<Survey>;
  surveyId?: Maybe<Scalars['ID']>;
  teamOnlyShare?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<AnalysisSharedViewType>;
};

export enum AnalysisSharedViewBranding {
  Custom = 'CUSTOM',
  Default = 'DEFAULT',
  None = 'NONE',
}

export type AnalysisSharedViewList = PaginatedList & {
  __typename?: 'AnalysisSharedViewList';
  items: Array<AnalysisSharedView>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum AnalysisSharedViewMode {
  Browse = 'BROWSE',
  DataTrends = 'DATA_TRENDS',
  Summary = 'SUMMARY',
}

export enum AnalysisSharedViewType {
  Email = 'EMAIL',
  Facebook = 'FACEBOOK',
  InstantResults = 'INSTANT_RESULTS',
  Public = 'PUBLIC',
  Weblink = 'WEBLINK',
}

/**
 * A subset of response data defined by user filtering rules
 * for better data analysis
 */
export type AnalysisStandardView = {
  __typename?: 'AnalysisStandardView';
  audienceQuestions?: Maybe<SurveyQuestionList>;
  compareRules?: Maybe<Array<Maybe<AnalysisStandardViewCompareRule>>>;
  filterRules?: Maybe<Array<Maybe<AnalysisStandardViewFilterRule>>>;
  id: Scalars['ID'];
  /** This is the currently selected view, including any un-saved changes */
  isCurrentView: Scalars['Boolean'];
  /** This is the read-only base view (no rules applied) */
  isDefaultView: Scalars['Boolean'];
  /** This is the currently selected view (does not contain recent, un-saved changes) */
  isSelectedView: Scalars['Boolean'];
  name: Scalars['String'];
  /** list of questions filtered by current view filtering rules */
  questions?: Maybe<SurveyQuestionList>;
  /** respondents filtered by current view filter & compare rules */
  respondents?: Maybe<RespondentList>;
  /** response counts filtered by current view filter & compare rules */
  responseCounts?: Maybe<AnalysisResponseCounts>;
  showRule?: Maybe<AnalysisStandardViewShowRule>;
  surveyId: Scalars['ID'];
  type: AnalysisViewType;
};

/**
 * A subset of response data defined by user filtering rules
 * for better data analysis
 */
export type AnalysisStandardViewAudienceQuestionsArgs = {
  families?: InputMaybe<Array<InputMaybe<SurveyQuestionTypeFamily>>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/**
 * A subset of response data defined by user filtering rules
 * for better data analysis
 */
export type AnalysisStandardViewQuestionsArgs = {
  families?: InputMaybe<Array<InputMaybe<SurveyQuestionTypeFamily>>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/**
 * A subset of response data defined by user filtering rules
 * for better data analysis
 */
export type AnalysisStandardViewRespondentsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<SortDirection>;
};

/** Cross compare answers accross different groups */
export type AnalysisStandardViewCompareRule = {
  active: Scalars['Boolean'];
  customHeading?: Maybe<Scalars['String']>;
  defaultHeading: Scalars['String'];
  id: Scalars['ID'];
};

/** rules to break down the result set */
export type AnalysisStandardViewFilterRule = {
  active: Scalars['Boolean'];
  customHeading?: Maybe<Scalars['String']>;
  defaultHeading: Scalars['String'];
  id: Scalars['ID'];
};

export type AnalysisStandardViewList = PaginatedList & {
  __typename?: 'AnalysisStandardViewList';
  items: Array<AnalysisStandardView>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** Show or hide results from certain question */
export type AnalysisStandardViewShowRule = {
  __typename?: 'AnalysisStandardViewShowRule';
  active: Scalars['Boolean'];
  customHeading?: Maybe<Scalars['String']>;
  defaultHeading: Scalars['String'];
  id: Scalars['ID'];
  /** a list of survey pages filtered by the current show rule */
  surveyPages: Array<Maybe<AnalysisViewFilteredSurveyPage>>;
};

/** Survey pages filtered by analyze rules */
export type AnalysisViewFilteredSurveyPage = {
  __typename?: 'AnalysisViewFilteredSurveyPage';
  heading?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  position: Scalars['Int'];
  questions?: Maybe<Array<Maybe<SurveyQuestion>>>;
  subHeading?: Maybe<Scalars['String']>;
  surveyId: Scalars['ID'];
};

/** Indicate the purpose of the AnalysisView */
export enum AnalysisViewType {
  Export = 'EXPORT',
  ReadOnly = 'READ_ONLY',
  Shared = 'SHARED',
  Standard = 'STANDARD',
}

/** Full XLS Specific export input */
export type AnalysisXlsExportParamsInput = {
  cellDisplay?: InputMaybe<AnalysisExportCellDisplay>;
  columnSetting?: InputMaybe<AnalysisExportColumnCompression>;
};

/** A collection of all analytics for 1D data (e.g. a 1D enumeration question). */
export type Analytics1D = {
  __typename?: 'Analytics1D';
  /** Text-based responses for other answer option on 1D questions */
  otherAnswers?: Maybe<AnalyticsOtherAnswersPayload>;
  /**
   * Sums (or counts) of responses for individual question options (e.g. rows
   * in choice questions).
   */
  sums: AnalyticsSums1DPayload;
};

/**
 * A collection of all analytics for 2D data (e.g. a 2D enumeration question or
 * a crosstab).
 */
export type Analytics2D = {
  __typename?: 'Analytics2D';
  /** Text-based responses for other answer option on 2D questions */
  otherAnswers?: Maybe<AnalyticsOtherAnswersPayload>;
  /**
   * Sums (or counts) of responses for individual option combinations (e.g.
   * row/column combinations in a matrix question)
   */
  sums: AnalyticsSums2DPayload;
};

/** Represents the first dimension of a two-dimensional analytics response. */
export type AnalyticsDataDimension = AnalyticsDimension & {
  __typename?: 'AnalyticsDataDimension';
  data: Array<AnalyticsDataRow>;
  ids: Array<Scalars['ID']>;
};

/** Represents a single, bottom-level dimension of analytics data (e.g. for a 1D enumeration question) */
export type AnalyticsDataRow = AnalyticsDimension & {
  __typename?: 'AnalyticsDataRow';
  data: Array<Scalars['Int']>;
  ids: Array<Scalars['ID']>;
};

/** Common fields for nested/recursive dimensional data. */
export type AnalyticsDimension = {
  ids: Array<Scalars['ID']>;
};

/** Fields common to multiple enumeration question responses. */
export type AnalyticsEnumerationQuestionResponse = {
  /** Total number of responses. */
  context: Scalars['Int'];
  /**
   * Tuple describing the id spaces associated with each dimension of data.
   *
   * e.g. for 1D data, ['row_id'] indicates that the ids in the first data
   * dimension are question row IDs.
   */
  idContext: Array<Scalars['String']>;
  /**
   * The IDs of the entities (e.g. question rows/columns) associated with the
   * first dimension data values. IDs for subsequent (nested) data dimensions
   * are specified within the data field, alongside the requisite data objects.
   */
  ids: Array<Scalars['ID']>;
  /** Total number of respondents. */
  respondents: Scalars['Int'];
};

/** A list of other answer words/phrases. */
export type AnalyticsOtherAnswersList = {
  __typename?: 'AnalyticsOtherAnswersList';
  items: Array<AnalyticsOtherAnswersTexts>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AnalyticsOtherAnswersPayload =
  | AnalyticsOtherAnswersList
  | InvalidInputError
  | NotFoundError
  | UnauthorizedError;

/** A word/phrase for an other answer. */
export type AnalyticsOtherAnswersTexts = {
  __typename?: 'AnalyticsOtherAnswersTexts';
  /** The word/phrase found in text responses. */
  text: Scalars['String'];
};

/** The analytics response for sums of 1D data (e.g. a 1D enumeration question). */
export type AnalyticsSums1D = AnalyticsEnumerationQuestionResponse & {
  __typename?: 'AnalyticsSums1D';
  /** Total number of responses. */
  context: Scalars['Int'];
  /** Response data sums associated with the specified IDs. */
  data: Array<Scalars['Int']>;
  /**
   * Single-value tuple describing the id spaces associated with the provided
   * single dimension of data.
   *
   * e.g. ['row_id'] indicates that the ids in the first data
   * dimension are question row IDs.
   */
  idContext: Array<Scalars['String']>;
  /**
   * The IDs of the entities (e.g. question rows) associated with the
   * first dimension data values. IDs for subsequent (nested) data dimensions
   * are specified within the data field, alongside the requisite data objects.
   */
  ids: Array<Scalars['ID']>;
  /** Total number of respondents. */
  respondents: Scalars['Int'];
};

export type AnalyticsSums1DPayload = AnalyticsSums1D | NotFoundError;

/** The analytics response for sums of 2D data (e.g. a 2D enumeration question or a crosstab). */
export type AnalyticsSums2D = AnalyticsEnumerationQuestionResponse & {
  __typename?: 'AnalyticsSums2D';
  /** Total number of responses. */
  context: Scalars['Int'];
  /**
   * Response data sums associated with the provided ids and subsequent (nested)
   * dimensions of ids.
   */
  data: Array<AnalyticsDataRow>;
  /**
   * Two-value tuple describing the id spaces associated with the provided
   * two dimensions of data.
   *
   * e.g. ['row_id', 'column_id'] indicates that the ids in the first data
   * dimension are question row IDs, and the IDs in the second data dimension are
   * column IDs.
   */
  idContext: Array<Scalars['String']>;
  /**
   * The IDs of the entities (e.g. question rows) associated with the
   * first dimension data values. IDs for subsequent (nested) data dimensions
   * are specified within the data field, alongside the requisite data objects.
   */
  ids: Array<Scalars['ID']>;
  /** Total number of respondents. */
  respondents: Scalars['Int'];
};

export type AnalyticsSums2DPayload = AnalyticsSums2D | NotFoundError;

/**
 * A collection of all analytics for textual data (e.g. from a textbox or other
 * open-ended question).
 */
export type AnalyticsText = {
  __typename?: 'AnalyticsText';
  /**
   * Counts for individual words/phrases, as required for word cloud
   * visualizations.
   */
  wordCloud: AnalyticsWordCloudPayload;
};

/**
 * A collection of all analytics for textual data (e.g. from a textbox or other
 * open-ended question).
 */
export type AnalyticsTextWordCloudArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type AnalyticsWordCloudPayload =
  | AnalyticsWordCloudPhraseList
  | InvalidInputError
  | NotFoundError
  | UnauthorizedError;

/** A word/phrase for a word cloud. */
export type AnalyticsWordCloudPhrase = {
  __typename?: 'AnalyticsWordCloudPhrase';
  /** The word/phrase found in text responses. */
  name: Scalars['String'];
  /** The number of times the word/phrase was found in text responses. */
  weight: Scalars['Int'];
};

/** A paginated list of word cloud words/phrases. */
export type AnalyticsWordCloudPhraseList = PaginatedList & {
  __typename?: 'AnalyticsWordCloudPhraseList';
  items: Array<AnalyticsWordCloudPhrase>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum AnonymousResponseType {
  FullyAnonymous = 'FULLY_ANONYMOUS',
  NotAnonymous = 'NOT_ANONYMOUS',
  PartiallyAnonymous = 'PARTIALLY_ANONYMOUS',
}

export type AnswerOther = QuestionAnswer & {
  __typename?: 'AnswerOther';
  id: Scalars['ID'];
  label: Scalars['String'];
  layout: AnswerOtherLayout;
  /** The following field is null when 'type' is not ANSWER */
  requiredErrorText?: Maybe<Scalars['String']>;
  type: AnswerOtherType;
  visible: Scalars['Boolean'];
};

export type AnswerOtherLayout = {
  __typename?: 'AnswerOtherLayout';
  charsCount: Scalars['Int'];
  linesCount: Scalars['Int'];
};

export enum AnswerOtherType {
  Answer = 'ANSWER',
  Comment = 'COMMENT',
  CommentColumn = 'COMMENT_COLUMN',
}

export type ApplicationListing = {
  __typename?: 'ApplicationListing';
  categories: Array<ApplicationListingCategory>;
  details: ApplicationListingDetails;
  fullDescription: Scalars['String'];
  id: Scalars['ID'];
  installed?: Maybe<Scalars['Boolean']>;
  isIntegration: Scalars['Boolean'];
  links: ApplicationListingLinks;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  tagline: Scalars['String'];
};

export type ApplicationListingCategory = {
  __typename?: 'ApplicationListingCategory';
  id: Scalars['ID'];
  key: Scalars['String'];
  name: Scalars['String'];
  publishedApplicationListings?: Maybe<ApplicationListingList>;
};

export type ApplicationListingCategoryPublishedApplicationListingsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  subdomain?: InputMaybe<Scalars['String']>;
  tld?: InputMaybe<Scalars['String']>;
};

export type ApplicationListingContact = {
  __typename?: 'ApplicationListingContact';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ApplicationListingDetails = {
  __typename?: 'ApplicationListingDetails';
  blogUrl?: Maybe<Scalars['String']>;
  featureList?: Maybe<Array<Scalars['String']>>;
  googleAnalyticsTrackingId?: Maybe<Scalars['String']>;
  installUrl?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  linkType?: Maybe<PublishedApplicationListingLinkType>;
  optionalUpgrade?: Maybe<Scalars['Boolean']>;
  privacyPolicyUrl: Scalars['String'];
  productBusinessContact?: Maybe<ApplicationListingContact>;
  publisher: Scalars['String'];
  requirements?: Maybe<ApplicationListingRequirements>;
  salesContact?: Maybe<ApplicationListingContact>;
  scopes: Array<Scalars['String']>;
  screenshots: Array<Scalars['String']>;
  supportEmail?: Maybe<Scalars['String']>;
  supportPhoneNumber?: Maybe<Scalars['String']>;
  supportUrl?: Maybe<Scalars['String']>;
  technicalContact?: Maybe<ApplicationListingContact>;
  termsOfUseUrl: Scalars['String'];
  upgradeRequired?: Maybe<Scalars['Boolean']>;
  websiteUrl: Scalars['String'];
  youtubeUrl?: Maybe<Scalars['String']>;
};

export type ApplicationListingLinks = {
  __typename?: 'ApplicationListingLinks';
  detail: Scalars['String'];
  launch: Scalars['String'];
};

export type ApplicationListingList = PaginatedList & {
  __typename?: 'ApplicationListingList';
  items: Array<ApplicationListing>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ApplicationListingRequirements = {
  __typename?: 'ApplicationListingRequirements';
  description?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  pricingUrl: Scalars['String'];
  type: Scalars['String'];
};

/** A library svc Asset object */
export type Asset = {
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  s3Key: Scalars['String'];
};

export type AttributeQuestion =
  | MultipleChoiceQuestion
  | OpenEndedQuestion
  | SingleChoiceQuestion;

export type AttributeResponseAggregate = {
  __typename?: 'AttributeResponseAggregate';
  avg: Scalars['Float'];
  max: Scalars['Float'];
  min: Scalars['Float'];
  scores: Array<AttributeStimulusScore>;
};

export type AttributeScorecard = {
  __typename?: 'AttributeScorecard';
  attribute: ConceptTestingAttribute;
  id: Scalars['ID'];
  project: ConceptTestingProject;
  rows: Array<Array<AttributeScorecardCell>>;
  stimuli: ConceptTestingStimuli;
  totalResponses: Scalars['Int'];
};

export type AttributeScorecardCell = {
  __typename?: 'AttributeScorecardCell';
  higherSignificance: Array<ConceptTestingStimulus>;
  isSignificant?: Maybe<Scalars['Boolean']>;
  lowerSignificance: Array<ConceptTestingStimulus>;
  percentage?: Maybe<Scalars['Float']>;
};

export type AttributeStimulusScore = {
  __typename?: 'AttributeStimulusScore';
  percentage: Scalars['Float'];
  stimulus: SurveyQuestionHeader;
};

export type AttributesVariableConfiguration = ProjectVariableConfiguration & {
  __typename?: 'AttributesVariableConfiguration';
  attributes: AttributesVariableList;
  enabled: Scalars['Boolean'];
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export type AttributesVariableConfigurationAttributesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type AttributesVariableList = {
  __typename?: 'AttributesVariableList';
  items: Array<ModuleAttribute>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type AttributeWordClouds = {
  __typename?: 'AttributeWordClouds';
  attribute: ConceptTestingAttribute;
  id: Scalars['ID'];
  project: ConceptTestingProject;
  wordClouds: Array<Maybe<WordCloud>>;
};

export type AudienceAvailableBalancing = {
  __typename?: 'AudienceAvailableBalancing';
  age: Array<AudienceBalanceScheme>;
  gender: Array<AudienceBalanceScheme>;
  /**
   * Region balancing is done with custom buckets, but isn't always available.
   * So this will always only contain NONE and maybe CUSTOM
   */
  region: Array<AudienceBalanceScheme>;
};

/** The types of configured criteria balancing options that may be associated with an Audience project */
export enum AudienceBalanceScheme {
  /** Basic census gender balancing (used to describe a single criteria balancing) */
  BasicCensus = 'BASIC_CENSUS',
  /** Basic census age balancing (used to describe a single criteria balancing) */
  Crude = 'CRUDE',
  /**
   * Basic census age balancing and no gender or location balancing
   * (used to describe a combination of gender/age/location balancing)
   */
  CrudeAge = 'CRUDE_AGE',
  /**
   * Basic census balancing for both gender and age and no balancing for location
   * (used to describe a combination of gender/age/location balancing)
   */
  CrudeGenderAge = 'CRUDE_GENDER_AGE',
  /**
   * Some combination of gender/age/location balancing that does not fall into one of the other enums
   * (used to describe a combination of gender/age/location balancing)
   */
  Custom = 'CUSTOM',
  /** A scheme that may be set by admin configured projects */
  Exact = 'EXACT',
  /**
   * Full census balancing for age and no balancing for gender or location
   * (used to describe a combination of gender/age/location balancing)
   */
  FullAge = 'FULL_AGE',
  /** Full census age balancing (used to describe a single criteria balancing) */
  FullCensus = 'FULL_CENSUS',
  /**
   * Full census age balancing, basic census gender balancing and no location balancing
   * (used to describe a combination of gender/age/location balancing)
   */
  FullGenderAge = 'FULL_GENDER_AGE',
  /** No balancing (used to describe a single criteria balancing) */
  None = 'NONE',
}

/** Describes a criteria balancing configuration */
export type AudienceBalanceSchemeInput = {
  /** Custom balancing buckets */
  details?: InputMaybe<Array<AudienceBalancingDetailsInput>>;
  scheme: AudienceBalanceScheme;
};

export type AudienceBalancingCriteriaSelections = {
  __typename?: 'AudienceBalancingCriteriaSelections';
  /** user-selected criteria balancing details for age/gender/location */
  balancingDetails: AudienceBalancingDetails;
  /**
   * This is combination age/gender/location balancing scheme. If no pre-defined scheme
   * exists for the selected combination, this should be "CUSTOM"
   */
  maxSchemeLevel: Scalars['String'];
};

export type AudienceBalancingDetails = {
  __typename?: 'AudienceBalancingDetails';
  age: AudienceRangeBalanceScheme;
  gender: AudienceCategoricalBalanceScheme;
  regions: AudienceCategoricalBalanceScheme;
};

export type AudienceBalancingDetailsInput = {
  id?: InputMaybe<Scalars['ID']>;
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
  percent: Scalars['Int'];
};

/** Balancing configuration for an Audience project */
export type AudienceBalancingInput = {
  age: AudienceBalanceSchemeInput;
  gender: AudienceBalanceSchemeInput;
  region: AudienceBalanceSchemeInput;
};

export type AudienceBasicCriteria = {
  __typename?: 'AudienceBasicCriteria';
  age: AudienceRangeCriteria;
  gender: AudienceCategoricalCriteria;
  /**
   * householdIncome must be nullable because some target-able countries do not support
   * targeting by household income. (these criteria are fetched by country)
   */
  householdIncome: AudienceTargetingCriteria;
  regions: Array<AudienceRegionType>;
};

/**
 * These are the basic Audience criteria selections that the user will always have a selection
 * for.
 */
export type AudienceBasicCriteriaSelections = {
  __typename?: 'AudienceBasicCriteriaSelections';
  age: AudienceRangeCriteriaSelection;
  country: AudienceCountryCriteriaSelection;
  gender: AudienceCategoricalCriteriaSelection;
  /**
   * Represents the user-selected household income level for respondents. May be a range or
   * categorical selection depending on the targeted country.
   */
  householdIncome: AudienceCriteriaSelection;
  regions: AudienceRegionCriteriaSelection;
};

export type AudienceCategoricalBalanceScheme = {
  __typename?: 'AudienceCategoricalBalanceScheme';
  buckets?: Maybe<Array<AudienceCategoricalBalanceSchemeBucket>>;
  label: Scalars['String'];
  schemeId: AudienceBalanceScheme;
};

/**
 * When using custom balancing, this is a single configured categorical bucket.
 * (IE custom gender balancing: {'female': 49%}, {'non-binary': 51%})
 */
export type AudienceCategoricalBalanceSchemeBucket = {
  __typename?: 'AudienceCategoricalBalanceSchemeBucket';
  id: Scalars['ID'];
  label: Scalars['String'];
  percent: Scalars['Int'];
};

export type AudienceCategoricalCriteria = AudienceTargetingCriteria & {
  __typename?: 'AudienceCategoricalCriteria';
  category: AudienceCriteriaCategory;
  currencyCode: Scalars['String'];
  currencySymbol: Scalars['String'];
  defaultAnswerLabel: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
  /** A list of targeting options available with this targeting criteria */
  options: Array<AudienceTargetingOption>;
  prompt: Scalars['String'];
  /** A list of our panelist suppliers that service this criteria */
  providers: Array<AudienceProvider>;
  type: AudienceCriteriaAnswerType;
};

/**
 * The user-selected options for an Audience criteria. Criteria identity can be accessed
 * through "criteria".
 */
export type AudienceCategoricalCriteriaSelection = {
  __typename?: 'AudienceCategoricalCriteriaSelection';
  criteria: AudienceCategoricalCriteria;
  values: Array<AudienceTargetingOption>;
};

export type AudienceCountryCriteria = {
  __typename?: 'AudienceCountryCriteria';
  /**
   * An Audience criteria category is a way of organizing our criteria. These are used to render them
   * onto the calculator/preview pages and are presentational only.
   */
  category: AudienceCriteriaCategory;
  id: Scalars['ID'];
  label: Scalars['String'];
  /** A list of all of the countries available to target in Audience */
  options: Array<AudienceCountryOption>;
  type: AudienceCriteriaAnswerType;
};

/** A user-selected audience country along with the country option associated with it */
export type AudienceCountryCriteriaSelection = {
  __typename?: 'AudienceCountryCriteriaSelection';
  criteria: AudienceCountryCriteria;
  value: AudienceCountryOption;
};

export type AudienceCountryOption = {
  __typename?: 'AudienceCountryOption';
  countryCode: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type AudienceCreateSavedFavoriteInput = {
  balancing: AudienceSavedFavoriteBalancingInput;
  criteria: Array<AudienceSavedFavoriteCriteriaInput>;
  name: Scalars['String'];
  targetCompletes: Scalars['Int'];
  targetCountryCode: Scalars['String'];
  targetQualificationRate: Scalars['Int'];
};

export type AudienceCriteria = {
  __typename?: 'AudienceCriteria';
  advancedCriteria: Array<AudienceTargetingCriteria>;
  balancingCriteria: AudienceAvailableBalancing;
  basicCriteria: AudienceBasicCriteria;
};

/** The selection type available to Audience clients for a particular criteria. */
export enum AudienceCriteriaAnswerType {
  Multiselect = 'MULTISELECT',
  Range = 'RANGE',
  Select = 'SELECT',
}

export type AudienceCriteriaCategory = {
  __typename?: 'AudienceCriteriaCategory';
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type AudienceCriteriaInput = {
  id: Scalars['ID'];
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Array<Scalars['String']>>;
};

/** Represents a user-selected targeting criteria selection. */
export type AudienceCriteriaSelection =
  | AudienceCategoricalCriteriaSelection
  | AudienceHouseholdIncomeRangeCriteriaSelection
  | AudienceRangeCriteriaSelection;

export type AudienceDemographicBreakdown = {
  __typename?: 'AudienceDemographicBreakdown';
  count: Scalars['Int'];
  percent: Scalars['Int'];
};

export type AudienceFeasibility = {
  __typename?: 'AudienceFeasibility';
  canComplete: Scalars['Boolean'];
  /**
   * Feasibility responses expire after 15 minutes
   * NOTE: We use strings to preserve the date format as provided by
   * audiencesvc; these values are required for invoice creation and must
   * be an exact match with what audiencesvc expects
   */
  checkedAt: Scalars['DateTime'];
  /**
   * The raw checkedAt value as provided by audiencesvc; preserved as a string so that it matches
   * the exact form that audiencesvc expects for invoice creation
   */
  checkedAtString: Scalars['String'];
  /**
   * String hash of an Audience price quote. This is required when performing invoice operations and expires
   * after 15 minutes.
   */
  checksum: Scalars['String'];
  expectedEndAt?: Maybe<Scalars['DateTime']>;
  /**
   * The raw expectedEndAt value as provided by audiencesvc; preserved as a string so that it matches
   * the exact form that audiencesvc expects for invoice creation
   */
  expectedEndAtString?: Maybe<Scalars['String']>;
  expectedStartAt: Scalars['DateTime'];
  /**
   * The raw expectedStartAt value as provided by audiencesvc; preserved as a string so that it matches
   * the exact form that audiencesvc expects for invoice creation
   */
  expectedStartAtString: Scalars['String'];
  guardrailViolations: AudienceGuardrails;
  /** This will always be false if a survey ID isn't provided */
  highPriorityAvailable: Scalars['Boolean'];
  /**
   * This value provides the maximum known inventory of panelists available for a
   * given project configuration. Note, this currently functions as a "lower bound"
   * of panelists – we know that we have at least this many available panelists
   * available to fulfill a given project configuration. It may be nullable since
   * we only have support for this value when targeting SurveyMonkey US panelists.
   * It is not essential to obtain this value to allow a user to checkout.
   */
  maxInventory?: Maybe<Scalars['Int']>;
  /**
   * This value provides the estimated Audience project completion time as predicted
   * by MLSvc. It is nullable because it will currently only be provided for users in the
   * experiment variant.
   */
  predictedCompletionTime?: Maybe<AudienceFeasibilityPredictedCompletionTime>;
  pricing: AudienceFeasibilityPricing;
  /** String hash of the project configuration */
  projectChecksum: Scalars['String'];
  /** This is the selected project configuration associated to the feasibility request */
  projectConfiguration: AudienceProjectFeasibilityConfiguration;
  /**
   * This is a legacy value we need as we transition old AudienceWeb to Web Platform.
   * It should not be used by any pages besides Audience Preview/Calculator
   */
  projectCookie: Scalars['String'];
};

/** Input needed to fetch an Audience project feasibility quote */
export type AudienceFeasibilityInput = {
  collectorId?: InputMaybe<Scalars['Int']>;
  project: AudienceProjectInput;
  /** If this is specified, you should also give a collector ID */
  surveyId?: InputMaybe<Scalars['Int']>;
  /** May be specified if no survey ID is provided */
  surveyLength?: InputMaybe<Scalars['Int']>;
};

export enum AudienceFeasibilityPredictedCompletionTime {
  NineToSixteenHours = 'NINE_TO_SIXTEEN_HOURS',
  None = 'NONE',
  OneToEightHours = 'ONE_TO_EIGHT_HOURS',
  OverTwentyFourHours = 'OVER_TWENTY_FOUR_HOURS',
  SeventeenToTwentyFourHours = 'SEVENTEEN_TO_TWENTY_FOUR_HOURS',
}

export type AudienceFeasibilityPricing = {
  __typename?: 'AudienceFeasibilityPricing';
  ageBalanceCost: Scalars['Float'];
  criteriaCost: Scalars['Float'];
  currencyCode: Scalars['String'];
  /**
   * This is the amount that was discounted,
   * NOT the total amount with discount applied
   */
  discountedAmount: Scalars['Float'];
  discountedUnitCost: Scalars['Float'];
  discountRate: Scalars['Float'];
  exchangeRate: Scalars['Float'];
  genderBalanceCost: Scalars['Float'];
  normalizedQuestionCount: Scalars['Int'];
  originalPrice: Scalars['Float'];
  priorityCost: Scalars['Float'];
  qualificationCost: Scalars['Float'];
  questionCost: Scalars['Float'];
  totalPrice: Scalars['Float'];
  unitCost: Scalars['Float'];
};

/**
 * Values here are retrieved from the audienceProjectFeasibility query and used by the service
 * to validate panelist reservations.
 */
export type AudienceFeasibilityTokenInput = {
  /** The date-time that the feasibility call was performed on the client (from audienceProjectFeasibility) */
  checkedAt: Scalars['String'];
  /** A checksum hash of the project feasibility (from audienceProjectFeasibility) */
  checksum: Scalars['String'];
  /** A checksum has of the project configuration (from audienceProjectFeasibility) */
  configChecksum: Scalars['String'];
  /** The date-time that the Audience project is expected to end (from audienceProjectFeasibility) */
  expectedEndAt: Scalars['String'];
  /** The date-time that the Audience project is expected to start (from audienceProjectFeasibility) */
  expectedStartAt: Scalars['String'];
};

/**
 * These are a few static bucket breakdowns for survey responses that correspond
 * to full-census age balancing. This is only used for parity on the Audience
 * status page and should not be used otherwise. We expect to eventually deprecate
 * these fields.
 */
export type AudienceFullCensusAgeBreakdown = {
  __typename?: 'AudienceFullCensusAgeBreakdown';
  aboveSixty: AudienceDemographicBreakdown;
  belowEighteen: AudienceDemographicBreakdown;
  eighteenToTwentyNine: AudienceDemographicBreakdown;
  fortyFiveToSixty: AudienceDemographicBreakdown;
  thirtyToFortyFour: AudienceDemographicBreakdown;
};

/** Respondent breakdown by gender in percentage */
export type AudienceGenderBreakdown = {
  __typename?: 'AudienceGenderBreakdown';
  /** Percentage of respondents that are female in percentage */
  female: Scalars['Int'];
  /** Percentage of respondents that are male in percentage */
  male: Scalars['Int'];
  /** Total number of respondents for gender breakdown */
  percent: AudienceGenderBreakdownPercent;
  total: Scalars['Int'];
};

/** Respondent breakdown by gender */
export type AudienceGenderBreakdownPercent = {
  __typename?: 'AudienceGenderBreakdownPercent';
  /** Percentage of respondents that are female */
  female: Scalars['Int'];
  /** Percentage of respondents that are male */
  male: Scalars['Int'];
};

export enum AudienceGeniusEvent {
  Accepted = 'ACCEPTED',
  Displayed = 'DISPLAYED',
  Purchased = 'PURCHASED',
  Rejected = 'REJECTED',
}

export type AudienceGeniusFeedbackPayload = {
  __typename?: 'AudienceGeniusFeedbackPayload';
  success: Scalars['Boolean'];
};

export type AudienceGeniusFeedbackV2Input = {
  collectorId: Scalars['String'];
  event: AudienceGeniusEvent;
  level: FeedbackLevel;
  predictionId: Scalars['String'];
  values: Array<AdvancedFeedbackValue>;
};

export type AudienceGeniusRecommendationsV2Input = {
  maxInsights: Scalars['Int'];
  minConfidence: Scalars['Float'];
  provider: Scalars['String'];
  surveyId: Scalars['ID'];
  targetCountry: Scalars['String'];
  userId: Scalars['ID'];
};

export type AudienceGeniusRecommendationsV2Payload = {
  __typename?: 'AudienceGeniusRecommendationsV2Payload';
  predictionId: Scalars['String'];
  recommendations: Array<AdvancedRecommendation>;
};

/**
 * Survey and Audience project violations as related to Audience project requirements.
 * These are in addition to any survey requirements by SM core.
 */
export type AudienceGuardrails = {
  __typename?: 'AudienceGuardrails';
  /**
   * May be set to true if an admin has overridden Audience checks on a customer's
   * behalf.
   */
  guardrailOverrideEnabled: Scalars['Boolean'];
  mobileViolations: Array<AudienceMobileGuardrailViolation>;
  projectViolations: Array<AudienceProjectGuardrailViolation>;
  surveyMonkeyRewardsViolations: Array<AudienceSmrGuardrailViolation>;
  surveyViolations: Array<AudienceSurveyGuardrailViolation>;
};

/** Input needed to fetch project guardrail violations for an Audience project */
export type AudienceGuardrailsInput = {
  collectorId: Scalars['ID'];
  projectConfig: AudienceProjectConfigInput;
  surveyId: Scalars['ID'];
};

export type AudienceHouseholdIncomeRangeCriteria = AudienceTargetingCriteria & {
  __typename?: 'AudienceHouseholdIncomeRangeCriteria';
  category: AudienceCriteriaCategory;
  currencyCode: Scalars['String'];
  /** The following 2 fields are needed for Household Income display */
  currencySymbol: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
  max: Scalars['Int'];
  min: Scalars['Int'];
  /**
   * this field describes whether or not the criteria should allow for
   * an unlimited max value selection beyond the displayed max.
   */
  openEnded: Scalars['Boolean'];
  prompt: Scalars['String'];
  type: AudienceCriteriaAnswerType;
};

export type AudienceHouseholdIncomeRangeCriteriaSelection = {
  __typename?: 'AudienceHouseholdIncomeRangeCriteriaSelection';
  criteria: AudienceHouseholdIncomeRangeCriteria;
  /** If max is null, this signifies that the selection is open ended */
  max?: Maybe<Scalars['Int']>;
  /** If min is null, this signifies that the selection has no lower bound */
  min?: Maybe<Scalars['Int']>;
  /** Denotes whether the max selected value is open ended or not */
  openEnded: Scalars['Boolean'];
};

/** Respondent breakdown by household income range */
export type AudienceIncomeBreakdown = {
  __typename?: 'AudienceIncomeBreakdown';
  percent?: Maybe<AudienceIncomeBreakdownPercent>;
  /** Respondents with income from 0 to 24,000 */
  range0To24k: Scalars['Int'];
  /** Respondents with income from 100,000 to 149,000 */
  range100To149k: Scalars['Int'];
  /** Respondents with income from 150,000+ */
  range150kPlus: Scalars['Int'];
  /** Respondents with income from 25,000 to 49,000 */
  range25To49k: Scalars['Int'];
  /** Respondents with income from 50,000 to 99,000 */
  range50To99k: Scalars['Int'];
  /** Total number of respondents for household income breakdown */
  total: Scalars['Int'];
};

/** Respondent breakdown by household income range in percentage */
export type AudienceIncomeBreakdownPercent = {
  __typename?: 'AudienceIncomeBreakdownPercent';
  /** Percentage of respondents with income from 0 to 24,000 */
  range0To24k: Scalars['Int'];
  /** Percentage of respondents with income from 100,000 to 149,000 */
  range100To149k: Scalars['Int'];
  /** Percentage of respondents with income from 150,000+ */
  range150kPlus: Scalars['Int'];
  /** Percentage of respondents with income from 25,000 to 49,000 */
  range25To49k: Scalars['Int'];
  /** Percentage of respondents with income from 50,000 to 99,000 */
  range50To99k: Scalars['Int'];
};

export enum AudienceInvoiceStatus {
  Authorized = 'AUTHORIZED',
  NotPaid = 'NOT_PAID',
  Paid = 'PAID',
  PaymentFailed = 'PAYMENT_FAILED',
}

/** Survey configurations that are not allowed by Audience mobile apps produce these errors */
export enum AudienceMobileGuardrailViolation {
  HasChatbotEnabled = 'HAS_CHATBOT_ENABLED',
  HasMenuMatrixQuestion = 'HAS_MENU_MATRIX_QUESTION',
  HasTooManyOpenEndedQuestions = 'HAS_TOO_MANY_OPEN_ENDED_QUESTIONS',
  HasTooManyQuestions = 'HAS_TOO_MANY_QUESTIONS',
}

export enum AudiencePriority {
  HighPriority = 'HIGH_PRIORITY',
  Normal = 'NORMAL',
}

export type AudienceProject = {
  __typename?: 'AudienceProject';
  adminEmail: Scalars['String'];
  bulkProjectId?: Maybe<Scalars['ID']>;
  bulkProjectPosition: Scalars['Int'];
  category: AudienceProjectCategory;
  collector: Collector;
  containsDisqualifyLogic: Scalars['Boolean'];
  /**
   * True if this project was configured by somebody with a corporate account.
   * This is an Audience-specific concept introduced to deal with billing complexity
   * and shouldn't be used outside of Audience.
   */
  corpAccountOwned: Scalars['Boolean'];
  id: Scalars['ID'];
  /** This field will be null if the project has not been begun collecting responses */
  invoice?: Maybe<AudienceProjectInvoice>;
  priority: AudiencePriority;
  progress: AudienceProjectProgress;
  savedFavoriteId?: Maybe<Scalars['ID']>;
  selectedCriteria: SelectedAudienceCriteria;
  status: AudienceProjectStatus;
  /** This field will be null if the project has not been begun collecting responses */
  summary?: Maybe<AudienceProjectSummary>;
  survey: Survey;
};

export type AudienceProjectBillingCompletePayload = {
  __typename?: 'AudienceProjectBillingCompletePayload';
  billingStatus: Scalars['String'];
  project: AudienceProject;
};

export enum AudienceProjectCategory {
  Admin = 'ADMIN',
  AdminBt = 'ADMIN_BT',
  AdminCtm = 'ADMIN_CTM',
  AdminMms = 'ADMIN_MMS',
  BrandTracking = 'BRAND_TRACKING',
  ConceptTest = 'CONCEPT_TEST',
  Corp = 'CORP',
  Mms = 'MMS',
  SelfServe = 'SELF_SERVE',
  Solutions = 'SOLUTIONS',
}

/** Represents input needed to create an Audience project configuration */
export type AudienceProjectConfigInput = {
  balancing: AudienceBalancingInput;
  criteria?: InputMaybe<Array<AudienceCriteriaInput>>;
  targetCompletes: Scalars['Int'];
  targetLocaleCode: Scalars['String'];
  targetQualificationRate: Scalars['Int'];
};

export type AudienceProjectFeasibilityConfiguration = {
  __typename?: 'AudienceProjectFeasibilityConfiguration';
  selectedCriteria: SelectedAudienceCriteria;
  targetCompletes: Scalars['Int'];
  targetQualificationRate: Scalars['Int'];
};

/** Audience project configuration errors */
export enum AudienceProjectGuardrailViolation {
  HasDqQuestionWithoutQualificationRate = 'HAS_DQ_QUESTION_WITHOUT_QUALIFICATION_RATE',
  HasQualificationRateWithoutDqQuestion = 'HAS_QUALIFICATION_RATE_WITHOUT_DQ_QUESTION',
}

/** Input needed to create an Audience project */
export type AudienceProjectInput = {
  /**
   * May be provided if the project is associated with a bulk Audience invoice.
   * This ID is the collector ID of the initial Audience project in the bulk project set.
   */
  bulkProjectId?: InputMaybe<Scalars['ID']>;
  category: AudienceProjectCategory;
  projectConfig: AudienceProjectConfigInput;
  /**
   * May be used to override provider. Primarily used by admins. Should not be
   * used elsewhere.
   */
  provider?: InputMaybe<AudienceProvider>;
};

/** All cost values here are localized */
export type AudienceProjectInvoice = {
  __typename?: 'AudienceProjectInvoice';
  /** Additional cost to project resulting from the age balancing configuration */
  ageBalanceCost: Scalars['Float'];
  /** Should localized cost show decimals */
  centless: Scalars['Boolean'];
  /** The billweb redirect url to one-time checkout */
  checkoutRedirectUrl: Scalars['String'];
  criteriaCost: Scalars['Float'];
  /** Number of targeting criteria associated with the project */
  criteriaCount: Scalars['Int'];
  currencyCode: Scalars['String'];
  currencySymbol: Scalars['String'];
  discount: Scalars['Float'];
  discountedCost: Scalars['Float'];
  discountedUnitCost: Scalars['Float'];
  /** Name associated with the version of the exchange rate used in the Audience database */
  exchangeRateVersion: Scalars['String'];
  externalId: Scalars['ID'];
  /** Additional cost to project resulting from the gender balancing configuration */
  genderBalanceCost: Scalars['Float'];
  /** Additional cost to project resulting from the configured qualification rate */
  incidenceCost: Scalars['Float'];
  /**
   * May return null if the billing invoice id is invalid; e.g. for
   * some admin created projects or corporate account created projects
   */
  invoice?: Maybe<BillingInvoice>;
  invoiceNotes?: Maybe<Scalars['String']>;
  /** Number of questions in the associated survey in the longest path through the survey */
  normalizedQuestionCount: Scalars['Int'];
  /** The cost of the project not including any potential discounts */
  originalCost: Scalars['Float'];
  /** Name associated with the version of the pricing model used in the Audience database */
  pricingVersion: Scalars['String'];
  /** Additional cost to project resulting from the configured project priority */
  priorityCost: Scalars['Float'];
  /** Base cost per question */
  questionCost: Scalars['Float'];
  status: AudienceInvoiceStatus;
  /** The actual cost charged to the customer including any applied discounts */
  totalCost: Scalars['Float'];
  /** Cost per question given criteria */
  unitCost: Scalars['Float'];
};

export type AudienceProjectInvoicePayload = {
  __typename?: 'AudienceProjectInvoicePayload';
  errorMessage?: Maybe<Scalars['String']>;
  invoice?: Maybe<AudienceProjectInvoice>;
  success: Scalars['Boolean'];
};

export type AudienceProjectList = PaginatedList & {
  __typename?: 'AudienceProjectList';
  items: Array<AudienceProject>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type AudienceProjectPayload = {
  __typename?: 'AudienceProjectPayload';
  errorMessage?: Maybe<Scalars['String']>;
  project?: Maybe<AudienceProject>;
  statusCode: Scalars['Int'];
  success: Scalars['Boolean'];
};

/**
 * The following states are mutually exclusive:
 *   expired
 *   notStarted
 *   started
 *   skipped
 *   hold
 *   completed
 *   disqualified
 *
 * Finished is a count of all responses that are either
 * completed or disqualified.
 */
export type AudienceProjectProgress = {
  __typename?: 'AudienceProjectProgress';
  abandonRate: Scalars['Float'];
  actualCompleteDate?: Maybe<Scalars['DateTime']>;
  /** in seconds */
  averageCompleteTime?: Maybe<Scalars['Float']>;
  /** Completed responses */
  completed: Scalars['Int'];
  /** Respondents who have been disqualified through survey logic */
  disqualified: Scalars['Int'];
  disqualifyRate?: Maybe<Scalars['Float']>;
  /** Invitations that have been sent but were not started in time */
  expired: Scalars['Int'];
  finished: Scalars['Int'];
  /** Invitation has not been sent but we have reserved this respondent for this project */
  hold: Scalars['Int'];
  /** Percentage of respondents who completed and were not disqualified */
  incidenceRate?: Maybe<Scalars['Float']>;
  marginOfError: Scalars['Float'];
  /** Respondents who have been invited to the survey but haven't started */
  notStarted: Scalars['Int'];
  /** Percentage of responses completed against ordered responses */
  percentComplete: Scalars['Float'];
  /** Respondents who started a survey but never completed (doesn't include DQ) */
  skipped: Scalars['Int'];
  /**
   * This may be null if the project has not launched or if it is an older
   * project as only the new audience service API tracks start date
   */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Begun a survey but not finished; can use as abandoned count for ended/completed projects */
  started: Scalars['Int'];
  /** Completed responses that were ordered */
  targetComplete: Scalars['Int'];
  /** This will be null if the project is in an unscheduled-type state */
  targetCompleteDate?: Maybe<Scalars['DateTime']>;
  /** Incidence percent that was provided by the client */
  targetIncidence: Scalars['Float'];
  /** All tasks that have been assigned to this project */
  total: Scalars['Int'];
};

export type AudienceProjectStatus = {
  __typename?: 'AudienceProjectStatus';
  failReason?: Maybe<Scalars['String']>;
  status: AudienceProjectStatuses;
  transitionedByAdmin: Scalars['Boolean'];
};

export enum AudienceProjectStatuses {
  Active = 'ACTIVE',
  /** Project is over and is complete as ordered */
  Completed = 'COMPLETED',
  Deleted = 'DELETED',
  /** Project has been created but not checked out */
  Draft = 'DRAFT',
  /** Project is over but did not complete as ordered */
  Ended = 'ENDED',
  /** Project is over and was unable to complete as ordered */
  Failed = 'FAILED',
  /**
   * There was an unexpected issue while project was running and
   * the project has stopped actively collecting responses
   */
  Paused = 'PAUSED',
  /** An automated short-term state */
  Processing = 'PROCESSING',
  /** Project is in the process of being purchased */
  Purchasing = 'PURCHASING',
  /** Project has been fielded but hasn't yet started */
  Scheduled = 'SCHEDULED',
  /** Project is being fielded */
  Scheduling = 'SCHEDULING',
  /** Project exists but has not been configured */
  Unscheduled = 'UNSCHEDULED',
}

export type AudienceProjectSummary = {
  __typename?: 'AudienceProjectSummary';
  /** A histogram of the respondents' ages */
  ageBreakdown: AudienceFullCensusAgeBreakdown;
  /** A histogram of the respondents' genders */
  gender: AudienceGenderBreakdown;
  /** A histogram of the respondents' household incomes */
  income?: Maybe<AudienceIncomeBreakdown>;
  /** A summary of the geographic locations of respondents */
  respondentLocations?: Maybe<Array<AudienceRespondentLocation>>;
};

export enum AudienceProvider {
  Cint = 'CINT',
  Contribute = 'CONTRIBUTE',
  Lucid = 'LUCID',
  Rewards = 'REWARDS',
}

export type AudienceRangeBalanceScheme = {
  __typename?: 'AudienceRangeBalanceScheme';
  buckets?: Maybe<Array<AudienceRangeBalanceSchemeBucket>>;
  label: Scalars['String'];
  schemeId: AudienceBalanceScheme;
};

/**
 * When using custom balancing, this is a single configured ranged bucket.
 * (IE custom age balancing: {18-40: 49%}, {41-99: 51%})
 */
export type AudienceRangeBalanceSchemeBucket = {
  __typename?: 'AudienceRangeBalanceSchemeBucket';
  max: Scalars['Int'];
  min: Scalars['Int'];
  percent: Scalars['Int'];
};

export type AudienceRangeCriteria = AudienceTargetingCriteria & {
  __typename?: 'AudienceRangeCriteria';
  category: AudienceCriteriaCategory;
  id: Scalars['ID'];
  label: Scalars['String'];
  max: Scalars['Int'];
  min: Scalars['Int'];
  /**
   * this field describes whether or not the criteria should allow for
   * an unlimited max value selection beyond the displayed max.
   */
  openEnded: Scalars['Boolean'];
  prompt: Scalars['String'];
  /** A list of our panelist suppliers that service this criteria */
  providers: Array<AudienceProvider>;
  type: AudienceCriteriaAnswerType;
};

export type AudienceRangeCriteriaSelection = {
  __typename?: 'AudienceRangeCriteriaSelection';
  criteria: AudienceRangeCriteria;
  /** If max is null, this signifies that the selection is open ended */
  max?: Maybe<Scalars['Int']>;
  /** If min is null, this signifies that the selection has no lower bound */
  min?: Maybe<Scalars['Int']>;
  /** Denotes whether the max selected value is open ended or not */
  openEnded: Scalars['Boolean'];
};

/** A region that Audience can target */
export type AudienceRegion = {
  __typename?: 'AudienceRegion';
  id: Scalars['ID'];
  label: Scalars['String'];
};

/** A list of user-selected regions (values) along with their region types (criteria). */
export type AudienceRegionCriteriaSelection = {
  __typename?: 'AudienceRegionCriteriaSelection';
  criteria: Array<AudienceRegionType>;
  values: Array<AudienceRegion>;
};

/**
 * A collection of regions; usually at the state or province level. For example,
 * a region type might be "Oregon" with regions "Portland, Eugene, and so on..."
 */
export type AudienceRegionType = {
  __typename?: 'AudienceRegionType';
  description: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
  regions: Array<AudienceRegion>;
};

export type AudienceRespondentLocation = {
  __typename?: 'AudienceRespondentLocation';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  /** Location name associated with the lat/long values (if any) */
  name?: Maybe<Scalars['String']>;
  /** Number of responses received from the given lat/long values */
  respondentCount: Scalars['Int'];
};

/**
 * A user-saved targeting configuration for Audience self-serve. Contains all the
 * necessary information to reproduce a project configuration as well as a user-defined
 * name.
 */
export type AudienceSavedFavorite = {
  __typename?: 'AudienceSavedFavorite';
  configuration: AudienceSavedFavoriteConfiguration;
  id: Scalars['ID'];
  name: Scalars['String'];
};

/**
 * Defines any targeted balancing within a criteria option.
 * IE: defining what percentage of respondents should belong to a given age group
 */
export type AudienceSavedFavoriteBalancing = {
  __typename?: 'AudienceSavedFavoriteBalancing';
  age: AudienceSavedFavoriteRangeBalancing;
  gender: AudienceSavedFavoriteCategoricalBalancing;
  region: AudienceSavedFavoriteCategoricalBalancing;
};

/** Balancing information for age, gender and region criteria */
export type AudienceSavedFavoriteBalancingInput = {
  age: AudienceSavedFavoriteRangeBalancingInput;
  gender: AudienceSavedFavoriteCategoricalBalancingInput;
  region: AudienceSavedFavoriteCategoricalBalancingInput;
};

export type AudienceSavedFavoriteBaseCriteria = {
  id: Scalars['ID'];
  label: Scalars['String'];
};

/**
 * Balancing for a categorical criteria. Details only needs to
 * exist if balancing is CUSTOM.
 */
export type AudienceSavedFavoriteCategoricalBalancing = {
  __typename?: 'AudienceSavedFavoriteCategoricalBalancing';
  details?: Maybe<Array<AudienceSavedFavoriteCategoricalBucket>>;
  scheme: AudienceBalanceScheme;
};

/**
 * Details only need to exist if the scheme is CUSTOM, otherwise the scheme
 * provides enough information to balance.
 */
export type AudienceSavedFavoriteCategoricalBalancingInput = {
  details?: InputMaybe<Array<AudienceSavedFavoriteCategoricalBucketInput>>;
  scheme: AudienceBalanceScheme;
};

/**
 * Contains a single categorical option along with the percent of respondents that
 * should have responded with that option.
 */
export type AudienceSavedFavoriteCategoricalBucket = {
  __typename?: 'AudienceSavedFavoriteCategoricalBucket';
  id: Scalars['ID'];
  percent: Scalars['Int'];
};

export type AudienceSavedFavoriteCategoricalBucketInput = {
  id: Scalars['ID'];
  /** defined as a whole integer 1-100 */
  percent: Scalars['Int'];
};

/**
 * A single targeting criteria that defines a set of options to target.
 * IE: a list of genders to target with the survey.
 */
export type AudienceSavedFavoriteCategoricalCriteria = AudienceSavedFavoriteBaseCriteria & {
  __typename?: 'AudienceSavedFavoriteCategoricalCriteria';
  id: Scalars['ID'];
  label: Scalars['String'];
  options: Array<AudienceSavedFavoriteCriteriaOption>;
};

/** A targeting configuration associated with an Audience saved favorite */
export type AudienceSavedFavoriteConfiguration = {
  __typename?: 'AudienceSavedFavoriteConfiguration';
  balancing: AudienceSavedFavoriteBalancing;
  criteria: Array<AudienceSavedFavoriteBaseCriteria>;
  targetCompletes: Scalars['Int'];
  targetCountryCode: Scalars['String'];
  targetQualificationRate: Scalars['Int'];
};

/**
 * This is a single user-selected targeting option and can come in one of two flavors:
 * 1) A range criteria which must include a min (open-ended if no max)
 * 2) A categorical criteria which must include an array of options
 */
export type AudienceSavedFavoriteCriteriaInput = {
  id: Scalars['ID'];
  label: Scalars['String'];
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Array<AudienceSavedFavoriteCriteriaOptionInput>>;
};

/** A single targeting option associated with a categorical criteria. */
export type AudienceSavedFavoriteCriteriaOption = {
  __typename?: 'AudienceSavedFavoriteCriteriaOption';
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type AudienceSavedFavoriteCriteriaOptionInput = {
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type AudienceSavedFavoriteList = PaginatedList & {
  __typename?: 'AudienceSavedFavoriteList';
  items: Array<AudienceSavedFavorite>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/**
 * Balancing for a range criteria. Details only needs to
 * exist if balancing is CUSTOM.
 */
export type AudienceSavedFavoriteRangeBalancing = {
  __typename?: 'AudienceSavedFavoriteRangeBalancing';
  details?: Maybe<Array<AudienceSavedFavoriteRangeBucket>>;
  scheme: AudienceBalanceScheme;
};

/**
 * Details only need to exist if the scheme is CUSTOM, otherwise the scheme
 * provides enough information to balance.
 */
export type AudienceSavedFavoriteRangeBalancingInput = {
  details?: InputMaybe<Array<AudienceSavedFavoriteRangeBucketInput>>;
  scheme: AudienceBalanceScheme;
};

/**
 * Contains a single age range along with the percent of respondents that should
 * be from that range.
 */
export type AudienceSavedFavoriteRangeBucket = {
  __typename?: 'AudienceSavedFavoriteRangeBucket';
  max: Scalars['Int'];
  min: Scalars['Int'];
  percent: Scalars['Int'];
};

export type AudienceSavedFavoriteRangeBucketInput = {
  max: Scalars['Int'];
  min: Scalars['Int'];
  /** defined as a whole integer 1-100 */
  percent: Scalars['Int'];
};

/**
 * A single targeting criteria that defines a range of targeted values.
 * IE: an age range of people to target with the survey.
 */
export type AudienceSavedFavoriteRangeCriteria = AudienceSavedFavoriteBaseCriteria & {
  __typename?: 'AudienceSavedFavoriteRangeCriteria';
  id: Scalars['ID'];
  label: Scalars['String'];
  max?: Maybe<Scalars['Int']>;
  min: Scalars['Int'];
};

/** Survey configurations that are not allowed by SurveyMonkey Rewards */
export enum AudienceSmrGuardrailViolation {
  HasBlockRandomization = 'HAS_BLOCK_RANDOMIZATION',
  HasClickMapQuestion = 'HAS_CLICK_MAP_QUESTION',
  HasIncidenceRateTesting = 'HAS_INCIDENCE_RATE_TESTING',
  HasMatrixRankingScaleQuestion = 'HAS_MATRIX_RANKING_SCALE_QUESTION',
}

/** Survey configurations that are not allowed by Audience produce these errors */
export enum AudienceSurveyGuardrailViolation {
  /** Survey logic can produce an endless loop for survey-takers */
  HasCyclicPath = 'HAS_CYCLIC_PATH',
  HasFileUploadQuestion = 'HAS_FILE_UPLOAD_QUESTION',
  HasPaymentQuestion = 'HAS_PAYMENT_QUESTION',
  /** Survey asks for personal information like address, phone number, etc. */
  HasPii = 'HAS_PII',
  HasQuotas = 'HAS_QUOTAS',
  HasTooManyQuestions = 'HAS_TOO_MANY_QUESTIONS',
  HasWebLinks = 'HAS_WEB_LINKS',
  /**
   * Surveys must have a page break after questions with disqualification logic to prevent
   * survey-takers from answering questions that come after they may have been disqualified.
   */
  NoPageAfterDqQuestion = 'NO_PAGE_AFTER_DQ_QUESTION',
  NoRequiredQuestion = 'NO_REQUIRED_QUESTION',
}

export type AudienceTargetingCriteria = {
  category: AudienceCriteriaCategory;
  id: Scalars['ID'];
  label: Scalars['String'];
  prompt: Scalars['String'];
  type: AudienceCriteriaAnswerType;
};

export type AudienceTargetingOption = {
  __typename?: 'AudienceTargetingOption';
  id: Scalars['ID'];
  label: Scalars['String'];
  /**
   * A list of our panelist suppliers that service this criteria option.
   * (a sub-set of the parent criteria providers)
   */
  providers: Array<AudienceProvider>;
};

export type AudienceUpdateSavedFavoriteInput = {
  balancing: AudienceSavedFavoriteBalancingInput;
  criteria: Array<AudienceSavedFavoriteCriteriaInput>;
  id: Scalars['ID'];
  name: Scalars['String'];
  targetCompletes: Scalars['Int'];
  targetCountryCode: Scalars['String'];
  targetQualificationRate: Scalars['Int'];
};

export type AudienceWallet = {
  __typename?: 'AudienceWallet';
  currencyCode: CurrencyTypeId;
  hasCredits: Scalars['Boolean'];
  /** The total wallet amount in dollars */
  total: Scalars['Float'];
};

/** Specifies input for an autocomplete query */
export type AutocompleteInput = {
  keyword: Scalars['String'];
};

export type Awss3PostPolicy = {
  __typename?: 'AWSS3PostPolicy';
  fields: Awss3PostPolicyFields;
  url: Scalars['String'];
};

export type Awss3PostPolicyFields = {
  __typename?: 'AWSS3PostPolicyFields';
  acl: Scalars['String'];
  bucket: Scalars['String'];
  key: Scalars['String'];
  policy: Scalars['String'];
  xAmzAlgorithm: Scalars['String'];
  xAmzCredential: Scalars['String'];
  xAmzDate: Scalars['String'];
  xAmzServerSideEncryption?: Maybe<Scalars['String']>;
  xAmzSignature: Scalars['String'];
};

/** Abstracted common CSS background styles */
export type BackgroundStyle = {
  backgroundColor?: Maybe<Scalars['RGBA']>;
  backgroundImage?: Maybe<Image>;
};

/**
 * The interface for any language
 * Note: 'Language' and 'LanguageTag' may merge in the future.  presently set as two tracks
 * for backwards compatibility.
 */
export type BaseLanguage = {
  code: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type BaseQuestionHeader = {
  description: Scalars['String'];
  heading?: Maybe<Scalars['String']>;
  randomAssignment?: Maybe<QuestionHeaderRandomAssignment>;
};

export type BasicMutationPayload = {
  __typename?: 'BasicMutationPayload';
  success: Scalars['Boolean'];
};

/** Base implementation of SurveyQuestion */
export type BasicQuestion = SurveyQuestion & {
  __typename?: 'BasicQuestion';
  absolutePosition: Scalars['Int'];
  displayNumber: Scalars['Int'];
  displayOptions: SurveyQuestionDisplayOptions;
  headers: Array<SurveyQuestionHeader>;
  id: Scalars['ID'];
  isAudience: Scalars['Boolean'];
  nickname: Scalars['String'];
  pageId: Scalars['ID'];
  position: Scalars['Int'];
  questionTemplate?: Maybe<BasicQuestionTemplate>;
  responseSummary?: Maybe<QuestionResponseSummary>;
  type: SurveyQuestionType;
  validation: SurveyQuestionValidationOptions;
  visible: Scalars['Boolean'];
};

export type BasicQuestionTemplate = SurveyQuestionTemplate & {
  __typename?: 'BasicQuestionTemplate';
  attributes: Array<SurveyQuestionTemplateAttribute>;
  heading: Scalars['String'];
  id: Scalars['ID'];
  logicalLink: SurveyQuestionTemplateLogicalLink;
  modifiers: Array<SurveyQuestionTemplateModifier>;
};

export enum BifmUseCase {
  AdTesting = 'AD_TESTING',
  AppFeedback = 'APP_FEEDBACK',
  BenefitsSatisfaction = 'BENEFITS_SATISFACTION',
  BrandAwareness = 'BRAND_AWARENESS',
  BrandTracking = 'BRAND_TRACKING',
  CategoryAwareness = 'CATEGORY_AWARENESS',
  CommunityFeedback = 'COMMUNITY_FEEDBACK',
  CompetitorResearch = 'COMPETITOR_RESEARCH',
  ConsumerBehavior = 'CONSUMER_BEHAVIOR',
  CourseEvaluation = 'COURSE_EVALUATION',
  CovidSymptomTracking = 'COVID_SYMPTOM_TRACKING',
  CustomerLoyalty = 'CUSTOMER_LOYALTY',
  CustomerSatisfaction = 'CUSTOMER_SATISFACTION',
  CustomerSupportFeedback = 'CUSTOMER_SUPPORT_FEEDBACK',
  DiversityInclusion = 'DIVERSITY_INCLUSION',
  EmployeeEngagement = 'EMPLOYEE_ENGAGEMENT',
  EmployeePerformance = 'EMPLOYEE_PERFORMANCE',
  EmployeeSatisfaction = 'EMPLOYEE_SATISFACTION',
  EventRegistration = 'EVENT_REGISTRATION',
  Fundraising = 'FUNDRAISING',
  GoalCheckin = 'GOAL_CHECKIN',
  JobApplication = 'JOB_APPLICATION',
  LogoTesting = 'LOGO_TESTING',
  MarketSegmentation = 'MARKET_SEGMENTATION',
  MeetingFeedback = 'MEETING_FEEDBACK',
  MessageTesting = 'MESSAGE_TESTING',
  NameTesting = 'NAME_TESTING',
  NeighborhoodFeedback = 'NEIGHBORHOOD_FEEDBACK',
  NewHireFeedback = 'NEW_HIRE_FEEDBACK',
  NewProductConceptTesting = 'NEW_PRODUCT_CONCEPT_TESTING',
  OnsiteWorkerEngagementBackToX = 'ONSITE_WORKER_ENGAGEMENT_BACK_TO_X',
  OtherCustomers = 'OTHER_CUSTOMERS',
  OtherEmployeeOrCoworkers = 'OTHER_EMPLOYEE_OR_COWORKERS',
  OtherEventAttendees = 'OTHER_EVENT_ATTENDEES',
  OtherStudentsOrParents = 'OTHER_STUDENTS_OR_PARENTS',
  OtherTargetMarket = 'OTHER_TARGET_MARKET',
  OtherVolunteersOrCommunity = 'OTHER_VOLUNTEERS_OR_COMMUNITY',
  PackageTesting = 'PACKAGE_TESTING',
  ParentFeedback = 'PARENT_FEEDBACK',
  PatientSatisfaction = 'PATIENT_SATISFACTION',
  PickATimeEducation = 'PICK_A_TIME_EDUCATION',
  PickATimeEmployees = 'PICK_A_TIME_EMPLOYEES',
  PostEventFeedback = 'POST_EVENT_FEEDBACK',
  PricingTesting = 'PRICING_TESTING',
  QuizEducation = 'QUIZ_EDUCATION',
  QuizEmployees = 'QUIZ_EMPLOYEES',
  RecruitingFeedback = 'RECRUITING_FEEDBACK',
  RemoteWorkerEngagementBackToX = 'REMOTE_WORKER_ENGAGEMENT_BACK_TO_X',
  ReturningToWorkplaceBackToX = 'RETURNING_TO_WORKPLACE_BACK_TO_X',
  Review_360 = 'REVIEW_360',
  SchoolEvaluation = 'SCHOOL_EVALUATION',
  SimpleRsvp = 'SIMPLE_RSVP',
  TrainingFeedback = 'TRAINING_FEEDBACK',
  VolunteerFeedback = 'VOLUNTEER_FEEDBACK',
  VoteEducation = 'VOTE_EDUCATION',
  VoteEmployees = 'VOTE_EMPLOYEES',
  WebsiteFeedback = 'WEBSITE_FEEDBACK',
}

export type BillingAccount = {
  __typename?: 'BillingAccount';
  email?: Maybe<Scalars['String']>;
};

export enum BillingAccountType {
  GroupMember = 'GROUP_MEMBER',
  GroupOwner = 'GROUP_OWNER',
  Individual = 'INDIVIDUAL',
}

export type BillingAddress = {
  __typename?: 'BillingAddress';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  houseNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isTaxExclusiveCountry?: Maybe<Scalars['Boolean']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type BillingContact = {
  __typename?: 'BillingContact';
  contactType: BillingContactType;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  partner: BillingPartner;
  receivesReceipts: Scalars['Boolean'];
};

export type BillingContactInput = {
  contactType: BillingContactType;
  email: Scalars['String'];
  name: Scalars['String'];
  partner: BillingPartner;
  receivesReceipts: Scalars['Boolean'];
};

export type BillingContactList = {
  __typename?: 'BillingContactList';
  items: Array<BillingContact>;
  totalCount: Scalars['Int'];
};

export enum BillingContactType {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
}

export type BillingCustomerMetadata = {
  __typename?: 'BillingCustomerMetadata';
  company?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  partner: BillingPartner;
  phone?: Maybe<Scalars['String']>;
  role: BillingUserRole;
};

export type BillingCustomerTaxRecord = {
  __typename?: 'BillingCustomerTaxRecord';
  createdAt: Scalars['DateTime'];
  partner: BillingPartner;
  status: Scalars['Boolean'];
  taxId?: Maybe<Scalars['String']>;
  verifiedAdminId: Scalars['ID'];
  verifiedAt?: Maybe<Scalars['DateTime']>;
};

/** A payment made by the user or team */
export type BillingInvoice = {
  __typename?: 'BillingInvoice';
  billedAt: Scalars['DateTime'];
  billingEmail?: Maybe<Scalars['String']>;
  checkoutLink: Scalars['String'];
  currencyCode: CurrencyTypeId;
  id: Scalars['ID'];
  lineItems: Array<BillingInvoiceLineItem>;
  link: Scalars['String'];
  package?: Maybe<UserPackage>;
  paid: Scalars['Boolean'];
  paymentMethod?: Maybe<BillingPaymentMethod>;
  paymentMethodSubtype?: Maybe<BillingPaymentMethodSubtype>;
  total: Scalars['Int'];
  transactionProcessType: TransactionProcessType;
  transactionProcessTypeID: Scalars['Int'];
  transactionStatus: TransactionStatusType;
  transactionStatusID: Scalars['Int'];
};

/** Details for invoice line items */
export type BillingInvoiceLineItem = {
  __typename?: 'BillingInvoiceLineItem';
  description: Scalars['String'];
  endPeriodAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isComplimentary?: Maybe<Scalars['Boolean']>;
  isCredit?: Maybe<Scalars['Boolean']>;
  quantity: Scalars['Int'];
  skuNumber: Scalars['Int'];
  startPeriodAt: Scalars['DateTime'];
  totalCostInCents: Scalars['Int'];
};

export type BillingInvoiceList = PaginatedList & {
  __typename?: 'BillingInvoiceList';
  items: Array<BillingInvoice>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum BillingPartner {
  Momentive = 'MOMENTIVE',
  Surveymonkey = 'SURVEYMONKEY',
  Wufoo = 'WUFOO',
}

export enum BillingPaymentMethod {
  BankTransfer = 'BANK_TRANSFER',
  ChargeBack = 'CHARGE_BACK',
  CompUpgrade = 'COMP_UPGRADE',
  CreditCard = 'CREDIT_CARD',
  DirectDebit = 'DIRECT_DEBIT',
  Echeck = 'ECHECK',
  Invoice = 'INVOICE',
  ManualCreditCard = 'MANUAL_CREDIT_CARD',
  Mobile = 'MOBILE',
  Paypal = 'PAYPAL',
  TempUpgrade = 'TEMP_UPGRADE',
  Unassigned = 'UNASSIGNED',
  WalletCredits = 'WALLET_CREDITS',
  WireCheck = 'WIRE_CHECK',
}

export enum BillingPaymentMethodSubtype {
  AmericanExpress = 'AMERICAN_EXPRESS',
  Australia = 'AUSTRALIA',
  Austria = 'AUSTRIA',
  Belgium = 'BELGIUM',
  Canada = 'CANADA',
  Cartasi = 'CARTASI',
  CarteBleue = 'CARTE_BLEUE',
  DankortVisa = 'DANKORT_VISA',
  DinersClub = 'DINERS_CLUB',
  Discover = 'DISCOVER',
  Elv = 'ELV',
  ElvSepa = 'ELV_SEPA',
  GocardlessBacsDd = 'GOCARDLESS_BACS_DD',
  GocardlessSepaDd = 'GOCARDLESS_SEPA_DD',
  Italy = 'ITALY',
  Jcb = 'JCB',
  Mastercard = 'MASTERCARD',
  Netherlands = 'NETHERLANDS',
  PaypalOneTime = 'PAYPAL_ONE_TIME',
  PaypalRecurring = 'PAYPAL_RECURRING',
  Spain = 'SPAIN',
  Switzerland = 'SWITZERLAND',
  Usa = 'USA',
  Visa = 'VISA',
  VisaDelta = 'VISA_DELTA',
}

export enum BillingTaxPartner {
  Avalara = 'AVALARA',
  Taxamo = 'TAXAMO',
}

export enum BillingUserRole {
  GroupMember = 'GROUP_MEMBER',
  GroupOwner = 'GROUP_OWNER',
  Individual = 'INDIVIDUAL',
}

export type BulkTransferSurveyResult = {
  __typename?: 'BulkTransferSurveyResult';
  /** The transfer id associated with the bulk transfer request */
  id: Scalars['ID'];
  results: Array<BulkTransferSurveyStatusResult>;
};

export type BulkTransferSurveysInput = {
  /** The target user who will receive the survey */
  newUserId: Scalars['ID'];
  /** The current owner of the survey */
  ownerUserId: Scalars['ID'];
  surveyIds: Array<Scalars['ID']>;
};

export enum BulkTransferSurveyStatus {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Queued = 'QUEUED',
}

export enum BulkTransferSurveyStatusEntityType {
  Collector = 'COLLECTOR',
  Survey = 'SURVEY',
}

export type BulkTransferSurveyStatusResult = {
  __typename?: 'BulkTransferSurveyStatusResult';
  entityType: BulkTransferSurveyStatusEntityType;
  status: BulkTransferSurveyStatus;
};

export type CartPayload = {
  __typename?: 'CartPayload';
  cartId: Scalars['Int'];
  country: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateExpires: Scalars['DateTime'];
  metadata?: Maybe<Scalars['String']>;
  partner: Scalars['String'];
  products: Array<Maybe<CartProductPayload>>;
  status: Scalars['String'];
  userId: Scalars['Int'];
};

export type CartProductPayload = {
  __typename?: 'CartProductPayload';
  cartId: Scalars['Int'];
  cartItemId: Scalars['Int'];
  dateCreated: Scalars['DateTime'];
  metadata?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  skuId: Scalars['Int'];
  unitCostOverride: Scalars['Int'];
};

export type CheckoutCountryList = {
  __typename?: 'CheckoutCountryList';
  items: Array<CountryMetadata>;
  totalCount: Scalars['Int'];
};

/** Represents a country where Momentive does businesss. */
export type CheckoutRegion = {
  isoCode: Scalars['String'];
  name: Scalars['String'];
};

export type ChoiceAnswer = QuestionAnswer & {
  __typename?: 'ChoiceAnswer';
  id: Scalars['ID'];
  label: Scalars['String'];
  visible: Scalars['Boolean'];
};

/** Responses to questions with a discrete set of responses */
export type ChoiceResponse = {
  __typename?: 'ChoiceResponse';
  /** Next level answer grouping (columns) */
  answerNested?: Maybe<NestedAnswer>;
  /** The selected choice */
  choiceAnswer: QuestionAnswer;
  /** Top level answer grouping (rows) */
  fieldSet?: Maybe<QuestionFieldSet>;
  /**
   * Adding variation (optional) for multiple choice family for quiz result
   * This should probably be made available for other question family too in surveyTaking_migration
   */
  variation?: Maybe<RandomAssignmentHeading>;
};

export type ChoiceScreeningQuestion =
  | MultipleChoiceQuestion
  | SingleChoiceQuestion;

export enum ChoiceScreeningQuestionFamilyType {
  MultipleChoice = 'MULTIPLE_CHOICE',
  SingleChoice = 'SINGLE_CHOICE',
}

export type ClickMapQuestion = SurveyQuestion & {
  __typename?: 'ClickMapQuestion';
  absolutePosition: Scalars['Int'];
  displayNumber: Scalars['Int'];
  displayOptions: SurveyQuestionDisplayOptions;
  headers: Array<SurveyQuestionHeader>;
  id: Scalars['ID'];
  isAudience: Scalars['Boolean'];
  nickname: Scalars['String'];
  options?: Maybe<SurveyQuestionOptionList>;
  pageId: Scalars['ID'];
  position: Scalars['Int'];
  questionTemplate?: Maybe<ClickMapQuestionTemplate>;
  responseSummary?: Maybe<QuestionResponseSummary>;
  rows?: Maybe<SurveyQuestionRowList>;
  type: SurveyQuestionType;
  validation: SurveyQuestionValidationOptions;
  visible: Scalars['Boolean'];
};

export type ClickMapQuestionOptionsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type ClickMapQuestionRowsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type ClickMapQuestionQm = SurveyQuestionQm & {
  __typename?: 'ClickMapQuestionQM';
  createdAt: Scalars['DateTime'];
  family: SurveyQuestionFamily;
  hasPiping: Scalars['Boolean'];
  heading: QuestionHeadingConfiguration;
  id: Scalars['ID'];
  modifiedAt: Scalars['DateTime'];
  position: QuestionPosition;
  required?: Maybe<QuestionAnswerRequired>;
  variant: SurveyQuestionVariant;
};

export type ClickMapQuestionTemplate = SurveyQuestionTemplate & {
  __typename?: 'ClickMapQuestionTemplate';
  attributes: Array<SurveyQuestionTemplateAttribute>;
  heading: Scalars['String'];
  id: Scalars['ID'];
  logicalLink: SurveyQuestionTemplateLogicalLink;
  modifiers: Array<SurveyQuestionTemplateModifier>;
  rows: Array<SurveyQuestionTemplateRow>;
};

export type ClientError = {
  __typename?: 'ClientError';
  code: Scalars['String'];
  family: ClientErrorFamily;
  field?: Maybe<Array<Scalars['String']>>;
  message: Scalars['String'];
};

export enum ClientErrorFamily {
  BadRequest = 'BAD_REQUEST',
  Forbidden = 'FORBIDDEN',
  NotFound = 'NOT_FOUND',
  RequestFailed = 'REQUEST_FAILED',
  Unauthorized = 'UNAUTHORIZED',
}

/** An entity collaborating with a user or team */
export type Collaborator = {
  __typename?: 'Collaborator';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  isShared?: Maybe<Scalars['Boolean']>;
  kind: CollaboratorKind;
  lastName?: Maybe<Scalars['String']>;
  requestedRoles?: Maybe<CollaboratorRole>;
  roles?: Maybe<CollaboratorRole>;
  type?: Maybe<TeamMemberType>;
  /** a collaborator without a userId usually just provided an email. */
  userId?: Maybe<Scalars['ID']>;
  username?: Maybe<Scalars['String']>;
};

export enum CollaboratorAccess {
  FullAccess = 'FULL_ACCESS',
  NoAccess = 'NO_ACCESS',
  ReadOnly = 'READ_ONLY',
}

export enum CollaboratorKind {
  /** Has not yet accepted an invite to be a collaborator */
  Invite = 'INVITE',
  /** Is a member of your team */
  Team = 'TEAM',
  /** Is not a member of your team */
  User = 'USER',
}

export type CollaboratorList = PaginatedList & {
  __typename?: 'CollaboratorList';
  items: Array<Collaborator>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CollaboratorRole = {
  __typename?: 'CollaboratorRole';
  analyze: CollaboratorAccess;
  collect: CollaboratorAccess;
  design: CollaboratorAccess;
};

export type CollaboratorRoleInput = {
  analyze: CollaboratorAccess;
  collect: CollaboratorAccess;
  design: CollaboratorAccess;
};

/** The deployment method of a Survey */
export type Collector = {
  __typename?: 'Collector';
  allowMultipleResponses?: Maybe<Scalars['Boolean']>;
  closedPage: CollectorClosedPage;
  createdAt?: Maybe<Scalars['DateTime']>;
  disqualificationPage?: Maybe<CollectorDisqualificationPage>;
  hideBranding: Scalars['Boolean'];
  id: Scalars['ID'];
  ipAddressFilter?: Maybe<IpFilter>;
  isAnonymous?: Maybe<Scalars['Boolean']>;
  isClosed: Scalars['Boolean'];
  isUserCanned?: Maybe<Scalars['Boolean']>;
  links?: Maybe<CollectorLinks>;
  name: Scalars['String'];
  permissions?: Maybe<CollectorPermissions>;
  responseCount: Scalars['Int'];
  status?: Maybe<CollectorStatus>;
  surveyId: Scalars['ID'];
  surveyResultsUrl?: Maybe<Scalars['String']>;
  thankYouPage?: Maybe<CollectorThankYouPage>;
  type: CollectorType;
  userId: Scalars['ID'];
  weblink?: Maybe<CollectorWeblink>;
};

/** The anonymous setting type of the collector */
export enum CollectorAnonymousType {
  /** Responses are fully anonymous */
  FullyAnonymous = 'FULLY_ANONYMOUS',
  /** Responses are not anonymous */
  NotAnonymous = 'NOT_ANONYMOUS',
  /** Any configured custom value data is still recorded for respondents, but all other data is anonymous */
  PartialyAnonymous = 'PARTIALY_ANONYMOUS',
}

export type CollectorAudienceQm = CollectorQm & {
  __typename?: 'CollectorAudienceQM';
  closedPage: CollectorQmClosedPage;
  createdAt: Scalars['DateTime'];
  cutoffDateTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  ipRestrictions?: Maybe<CollectorIpRestrictions>;
  links: CollectorLinks;
  name: Scalars['String'];
  permissions?: Maybe<CollectorPermissions>;
  responseCount: Scalars['Int'];
  responseCountLimit?: Maybe<Scalars['Int']>;
  status: CollectorStatus;
  survey?: Maybe<Survey>;
  thankYouPage: CollectorQmThankYouPage;
  type: CollectorType;
};

/** Closed page details for a Collector */
export type CollectorClosedPage = {
  __typename?: 'CollectorClosedPage';
  closedMessage: Scalars['String'];
  isBrandingDisabled: Scalars['Boolean'];
};

export type CollectorCustomDisqualification = {
  __typename?: 'CollectorCustomDisqualification';
  message?: Maybe<Scalars['String']>;
  type: CollectorDisqualificationType;
  url?: Maybe<Scalars['String']>;
};

/** Disqualification page details for a Collector */
export type CollectorDisqualificationPage = {
  __typename?: 'CollectorDisqualificationPage';
  defaultMessage: Scalars['String'];
  message: Scalars['String'];
  type: Scalars['String'];
  url: Scalars['String'];
};

export enum CollectorDisqualificationType {
  CustomMessage = 'CUSTOM_MESSAGE',
  CustomUrl = 'CUSTOM_URL',
  StandardMessage = 'STANDARD_MESSAGE',
}

export type CollectorEmailQm = CollectorQm & {
  __typename?: 'CollectorEmailQM';
  closedPage: CollectorQmClosedPage;
  createdAt: Scalars['DateTime'];
  cutoffDateTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  ipRestrictions?: Maybe<CollectorIpRestrictions>;
  links: CollectorLinks;
  name: Scalars['String'];
  permissions?: Maybe<CollectorPermissions>;
  responseCount: Scalars['Int'];
  responseCountLimit?: Maybe<Scalars['Int']>;
  status: CollectorStatus;
  survey?: Maybe<Survey>;
  thankYouPage: CollectorQmThankYouPage;
  type: CollectorType;
};

/** Collector email recipient */
export type CollectorEmailRecipient = {
  __typename?: 'CollectorEmailRecipient';
  collectorId: Scalars['ID'];
  email: Scalars['String'];
  id: Scalars['ID'];
  links: CollectorEmailRecipientLinks;
  optOutToken: Scalars['String'];
  surveyId: Scalars['ID'];
};

/** Pages an email recipient can navigate to */
export type CollectorEmailRecipientLinks = {
  __typename?: 'CollectorEmailRecipientLinks';
  survey: Scalars['String'];
};

export type CollectorFacebookMessengerQm = CollectorQm & {
  __typename?: 'CollectorFacebookMessengerQM';
  closedPage: CollectorQmClosedPage;
  createdAt: Scalars['DateTime'];
  cutoffDateTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  ipRestrictions?: Maybe<CollectorIpRestrictions>;
  links: CollectorLinks;
  name: Scalars['String'];
  permissions?: Maybe<CollectorPermissions>;
  responseCount: Scalars['Int'];
  responseCountLimit?: Maybe<Scalars['Int']>;
  status: CollectorStatus;
  survey?: Maybe<Survey>;
  thankYouPage: CollectorQmThankYouPage;
  type: CollectorType;
};

/** Filter results by Collector */
export type CollectorFilter = AnalysisStandardViewFilterRule & {
  __typename?: 'CollectorFilter';
  active: Scalars['Boolean'];
  collectors: Array<Maybe<Collector>>;
  customHeading?: Maybe<Scalars['String']>;
  defaultHeading: Scalars['String'];
  id: Scalars['ID'];
};

export type CollectorFilterInput = {
  collectorIds: Array<Scalars['ID']>;
};

export type CollectorIpRestrictions = {
  __typename?: 'CollectorIpRestrictions';
  ipList: Array<Scalars['String']>;
  type: CollectorIpRestrictionType;
};

export enum CollectorIpRestrictionType {
  Allowlist = 'ALLOWLIST',
  Blocklist = 'BLOCKLIST',
}

export type CollectorKioskQm = CollectorQm & {
  __typename?: 'CollectorKioskQM';
  closedPage: CollectorQmClosedPage;
  createdAt: Scalars['DateTime'];
  cutoffDateTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  ipRestrictions?: Maybe<CollectorIpRestrictions>;
  links: CollectorLinks;
  name: Scalars['String'];
  permissions?: Maybe<CollectorPermissions>;
  responseCount: Scalars['Int'];
  responseCountLimit?: Maybe<Scalars['Int']>;
  status: CollectorStatus;
  survey?: Maybe<Survey>;
  thankYouPage: CollectorQmThankYouPage;
  type: CollectorType;
};

/** Computed relative paths to common SurveyMonkey pages associate with a collector */
export type CollectorLinks = {
  __typename?: 'CollectorLinks';
  edit?: Maybe<Scalars['String']>;
  mobileEdit?: Maybe<Scalars['String']>;
};

export type CollectorList = PaginatedList & {
  __typename?: 'CollectorList';
  items: Array<Collector>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CollectorListQm = PaginatedList & {
  __typename?: 'CollectorListQM';
  items: Array<CollectorQm>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CollectorMobileSdkQm = CollectorQm & {
  __typename?: 'CollectorMobileSdkQM';
  closedPage: CollectorQmClosedPage;
  createdAt: Scalars['DateTime'];
  cutoffDateTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  ipRestrictions?: Maybe<CollectorIpRestrictions>;
  links: CollectorLinks;
  name: Scalars['String'];
  permissions?: Maybe<CollectorPermissions>;
  responseCount: Scalars['Int'];
  responseCountLimit?: Maybe<Scalars['Int']>;
  status: CollectorStatus;
  survey?: Maybe<Survey>;
  thankYouPage: CollectorQmThankYouPage;
  type: CollectorType;
};

export type CollectorPasswordOptions = {
  __typename?: 'CollectorPasswordOptions';
  /** Label displayed on the button used to submit the password */
  buttonLabel: Scalars['String'];
  /** Message shown to the user upon entering wrong password */
  errorMessage: Scalars['String'];
  /** Label displayed on the input field where the password is entered */
  inputLabel: Scalars['String'];
  /** Message shown to the user when prompting for password */
  message: Scalars['String'];
};

/** Permissions on the collector for the current user */
export type CollectorPermissions = {
  __typename?: 'CollectorPermissions';
  close: Scalars['Boolean'];
  create: Scalars['Boolean'];
  delete: Scalars['Boolean'];
  edit: Scalars['Boolean'];
  open: Scalars['Boolean'];
  view: Scalars['Boolean'];
};

export type CollectorPopupQm = CollectorQm & {
  __typename?: 'CollectorPopupQM';
  closedPage: CollectorQmClosedPage;
  createdAt: Scalars['DateTime'];
  cutoffDateTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  ipRestrictions?: Maybe<CollectorIpRestrictions>;
  links: CollectorLinks;
  name: Scalars['String'];
  permissions?: Maybe<CollectorPermissions>;
  responseCount: Scalars['Int'];
  responseCountLimit?: Maybe<Scalars['Int']>;
  status: CollectorStatus;
  survey?: Maybe<Survey>;
  thankYouPage: CollectorQmThankYouPage;
  type: CollectorType;
};

/** The deployment method of a Survey */
export type CollectorQm = {
  closedPage: CollectorQmClosedPage;
  createdAt: Scalars['DateTime'];
  cutoffDateTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  ipRestrictions?: Maybe<CollectorIpRestrictions>;
  links: CollectorLinks;
  name: Scalars['String'];
  permissions?: Maybe<CollectorPermissions>;
  responseCount: Scalars['Int'];
  responseCountLimit?: Maybe<Scalars['Int']>;
  status: CollectorStatus;
  survey?: Maybe<Survey>;
  thankYouPage: CollectorQmThankYouPage;
  type: CollectorType;
};

/** Details used for collector closed page */
export type CollectorQmClosedPage = {
  __typename?: 'CollectorQMClosedPage';
  isWhiteLabel: Scalars['Boolean'];
  message: Scalars['String'];
};

export type CollectorQmThankYouPage = {
  __typename?: 'CollectorQMThankYouPage';
  isEnabled: Scalars['Boolean'];
  message: Scalars['String'];
};

export type CollectorsDeleted = {
  __typename?: 'CollectorsDeleted';
  deletedCount?: Maybe<Scalars['Int']>;
};

export type CollectorSmsQm = CollectorQm & {
  __typename?: 'CollectorSmsQM';
  closedPage: CollectorQmClosedPage;
  createdAt: Scalars['DateTime'];
  cutoffDateTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  ipRestrictions?: Maybe<CollectorIpRestrictions>;
  links: CollectorLinks;
  name: Scalars['String'];
  permissions?: Maybe<CollectorPermissions>;
  responseCount: Scalars['Int'];
  responseCountLimit?: Maybe<Scalars['Int']>;
  status: CollectorStatus;
  survey?: Maybe<Survey>;
  thankYouPage: CollectorQmThankYouPage;
  type: CollectorType;
};

export type CollectorSocialMediaQm = CollectorQm & {
  __typename?: 'CollectorSocialMediaQM';
  closedPage: CollectorQmClosedPage;
  createdAt: Scalars['DateTime'];
  cutoffDateTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  ipRestrictions?: Maybe<CollectorIpRestrictions>;
  links: CollectorLinks;
  name: Scalars['String'];
  permissions?: Maybe<CollectorPermissions>;
  responseCount: Scalars['Int'];
  responseCountLimit?: Maybe<Scalars['Int']>;
  status: CollectorStatus;
  survey?: Maybe<Survey>;
  thankYouPage: CollectorQmThankYouPage;
  type: CollectorType;
};

/** The status of the collector, computed based on its questions and collectors. */
export enum CollectorStatus {
  /** The collector has been archived, it can't collect responses */
  Archived = 'ARCHIVED',
  /** The responses within the collector are currently in the process of being cleared */
  Clearing = 'CLEARING',
  /** The collector is closed to respondents and responses can't be recorded */
  Closed = 'CLOSED',
  /** The collector is open to respondents and responses can be recorded */
  Open = 'OPEN',
  /** The collector isn't fully set up and can't be used to collect responses yet */
  Unconfigured = 'UNCONFIGURED',
}

/** ThankYou page details for a Collector */
export type CollectorThankYouPage = {
  __typename?: 'CollectorThankYouPage';
  isEnabled: Scalars['Boolean'];
  message: Scalars['String'];
};

/** The type of the collector, specifies how the survey is deployed */
export enum CollectorType {
  Audience = 'AUDIENCE',
  Email = 'EMAIL',
  FacebookMessenger = 'FACEBOOK_MESSENGER',
  KioskSurvey = 'KIOSK_SURVEY',
  ManualDataEntry = 'MANUAL_DATA_ENTRY',
  MobileSdk = 'MOBILE_SDK',
  Popup = 'POPUP',
  Sms = 'SMS',
  SocialMedia = 'SOCIAL_MEDIA',
  Weblink = 'WEBLINK',
}

export type CollectorTypeAvailability = {
  /**
   * A survey built with BIFM (Build it For Me) is assigned an use case.  A use case
   * is mapped to a list of recommended collectors to send the survey
   */
  isRecommendedFromBIFM: Scalars['Boolean'];
  type: CollectorType;
};

/** The full details of the url for the collector */
export type CollectorUrlConfig = {
  __typename?: 'CollectorUrlConfig';
  domain: Scalars['String'];
  scheme: Scalars['String'];
  slug: Scalars['String'];
  subdomain: Scalars['String'];
  url: Scalars['String'];
};

/** Collector Weblink */
export type CollectorWeblink = {
  __typename?: 'CollectorWeblink';
  completionUrl?: Maybe<Scalars['String']>;
  disqualicationMessage?: Maybe<Scalars['String']>;
  /** @deprecated Moved functionality from collector to responsesHelper */
  isSMDomain?: Maybe<Scalars['Boolean']>;
  /** @deprecated Moved functionality from collector to responsesHelper */
  isWhiteLabelDomain?: Maybe<Scalars['Boolean']>;
  redirectType?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['String']>;
  type?: Maybe<WeblinkVariant>;
  url?: Maybe<Scalars['String']>;
};

export type CollectorWeblinkQm = CollectorQm & {
  __typename?: 'CollectorWeblinkQM';
  anonymous: CollectorAnonymousType;
  closedPage: CollectorQmClosedPage;
  createdAt: Scalars['DateTime'];
  cutoffDateTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  disqualification?: Maybe<CollectorCustomDisqualification>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  ipRestrictions?: Maybe<CollectorIpRestrictions>;
  links: CollectorLinks;
  multipleResponsesEnabled: Scalars['Boolean'];
  name: Scalars['String'];
  password?: Maybe<CollectorPasswordOptions>;
  permissions?: Maybe<CollectorPermissions>;
  responseCount: Scalars['Int'];
  responseCountLimit?: Maybe<Scalars['Int']>;
  status: CollectorStatus;
  survey?: Maybe<Survey>;
  thankYouPage: CollectorQmThankYouPage;
  type: CollectorType;
  urlConfig: CollectorUrlConfig;
  variant: WeblinkVariant;
};

/** Color Palette and Current Selection Indicator */
export type ColorPalette = {
  __typename?: 'ColorPalette';
  answerColor?: Maybe<Scalars['RGBA']>;
  primaryAccentColor?: Maybe<Scalars['RGBA']>;
  primaryBackgroundColor?: Maybe<Scalars['RGBA']>;
  questionColor?: Maybe<Scalars['RGBA']>;
  secondaryAccentColor?: Maybe<Scalars['RGBA']>;
  secondaryBackgroundColor?: Maybe<Scalars['RGBA']>;
  /** Indicator of user selection */
  selected: Scalars['Boolean'];
  titleColor?: Maybe<Scalars['RGBA']>;
};

export type ColorPaletteInput = {
  answerColor?: InputMaybe<Scalars['RGBA']>;
  primaryAccentColor?: InputMaybe<Scalars['RGBA']>;
  primaryBackgroundColor?: InputMaybe<Scalars['RGBA']>;
  questionColor?: InputMaybe<Scalars['RGBA']>;
  secondaryAccentColor?: InputMaybe<Scalars['RGBA']>;
  secondaryBackgroundColor?: InputMaybe<Scalars['RGBA']>;
  selected: Scalars['Boolean'];
  titleColor?: InputMaybe<Scalars['RGBA']>;
};

/**
 * !!!
 * this entire file is pending to be deleted once the frontend refactoring is done
 * !!!
 * Combining either the top two or the bottom two options of the likert-scale questions
 * for the performance score calculation
 */
export enum CombineOptions {
  BottomTwo = 'BOTTOM_TWO',
  TopTwo = 'TOP_TWO',
}

/** Common group settings that will be shared at the team and division level */
export type CommonGroupSettings = {
  divisionAdminsCanManageUsers: Scalars['Boolean'];
};

/** Common CSS styles */
export type CommonStyle = BackgroundStyle &
  FontStyle & {
    __typename?: 'CommonStyle';
    backgroundColor?: Maybe<Scalars['RGBA']>;
    backgroundImage?: Maybe<Image>;
    color?: Maybe<Scalars['RGBA']>;
    fontFamily?: Maybe<Scalars['String']>;
    fontSize?: Maybe<Scalars['Int']>;
    fontStyle?: Maybe<FontStyleType>;
    fontWeight?: Maybe<FontWeightType>;
    textDecoration?: Maybe<TextDecorationType>;
  };

export type CommonStyleInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  backgroundImage?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  fontFamily?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['String']>;
  fontStyle?: InputMaybe<FontStyleType>;
  fontWeight?: InputMaybe<FontWeightType>;
  textDecoration?: InputMaybe<TextDecorationType>;
};

/** Filter results by completeness */
export type CompletenessFilter = AnalysisStandardViewFilterRule & {
  __typename?: 'CompletenessFilter';
  active: Scalars['Boolean'];
  completenessLabels: Array<Scalars['String']>;
  completenessStatuses: Array<CompletenessTypes>;
  customHeading?: Maybe<Scalars['String']>;
  defaultHeading: Scalars['String'];
  id: Scalars['ID'];
};

export type CompletenessFilterInput = {
  completely: Scalars['Boolean'];
  disqualified: Scalars['Boolean'];
  overquota: Scalars['Boolean'];
  partially: Scalars['Boolean'];
};

export enum CompletenessTypes {
  Completely = 'COMPLETELY',
  Disqualified = 'DISQUALIFIED',
  Overquota = 'OVERQUOTA',
  Partially = 'PARTIALLY',
}

export type ConceptTestingAllStimuli = {
  __typename?: 'ConceptTestingAllStimuli';
  stimuli: Array<AllStimuli>;
  totalCount: Scalars['Int'];
};

export type ConceptTestingAttribute = {
  __typename?: 'ConceptTestingAttribute';
  /** Canonical name for the attribute */
  id: Scalars['ID'];
  isCustomAttribute: Scalars['Boolean'];
  isSelected: Scalars['Boolean'];
  /** Back reference to the project, mostly used by child resolver */
  project: ConceptTestingProject;
  question: AttributeQuestion;
  /** data used for analysis */
  responseAggregate?: Maybe<AttributeResponseAggregate>;
  /** Attribute Label */
  title: Scalars['String'];
};

export type ConceptTestingAttributeResponseAggregateArgs = {
  combineOption: CombineOptions;
  filter?: InputMaybe<AnalysisFilterInput>;
};

/**
 * This value could be hydrated from the variable answer
 * however the exact data format is not finalized yet
 */
export type ConceptTestingBenchmark = {
  __typename?: 'ConceptTestingBenchmark';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

/** A sub-column consist of a single SurveyQuestionOption */
export type ConceptTestingCrossTabAnswerOption = ConceptTestingCrossTabOption & {
  __typename?: 'ConceptTestingCrossTabAnswerOption';
  position: Scalars['Int'];
  questionOption: SurveyQuestionOption;
  type: ConceptTestingOptionType;
};

/** Contains all data that could be displayed in a CrossTab table Cell */
export type ConceptTestingCrossTabCell = {
  __typename?: 'ConceptTestingCrossTabCell';
  /** The option id of the corresponding cell column */
  columnKey?: Maybe<Scalars['String']>;
  columnPercentage?: Maybe<Scalars['Float']>;
  frequency?: Maybe<Scalars['Int']>;
  higherSignificanceOptions: Array<ConceptTestingCrossTabOption>;
  highlighted?: Maybe<Scalars['Boolean']>;
  lowerSignificanceOptions: Array<ConceptTestingCrossTabOption>;
  /** The option id of the corresponding cell row */
  rowKey?: Maybe<Scalars['String']>;
  rowPercentage?: Maybe<Scalars['Float']>;
  totalPercentage?: Maybe<Scalars['Float']>;
};

/** This could be either a banner/ stub consists of the subgroups for data analysis */
export type ConceptTestingCrossTabDimension = {
  __typename?: 'ConceptTestingCrossTabDimension';
  question: SurveyQuestion;
  selectedOptions: Array<ConceptTestingCrossTabOption>;
};

/** A sub-column consist of multiple SurveyQuestionOption */
export type ConceptTestingCrosstabGroupedByAnswerOption = ConceptTestingCrossTabOption & {
  __typename?: 'ConceptTestingCrosstabGroupedByAnswerOption';
  label: Scalars['String'];
  position: Scalars['Int'];
  questionOptions: Array<SurveyQuestionOption>;
  type: ConceptTestingOptionType;
};

/** A sub-column of a CrossTabTable */
export type ConceptTestingCrossTabOption = {
  position: Scalars['Int'];
  type: ConceptTestingOptionType;
};

/**
 * A table view defined by user to show comparison across different groups by concepts
 * Need to generalize further per https://momentiveai.atlassian.net/browse/DMND-2258
 */
export type ConceptTestingCrossTabReport = {
  __typename?: 'ConceptTestingCrossTabReport';
  banners: Array<ConceptTestingCrossTabDimension>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  modifiedAt: Scalars['DateTime'];
  project: Project;
  stubs: Array<ConceptTestingCrossTabDimension>;
  table: ConceptTestingCrossTabTable;
  title: Scalars['String'];
};

/**
 * A table view defined by user to show comparison across different groups by concepts
 * Need to generalize further per https://momentiveai.atlassian.net/browse/DMND-2258
 */
export type ConceptTestingCrossTabReportTableArgs = {
  filter?: InputMaybe<AnalysisFilterInput>;
};

/** A list of crossTab reports */
export type ConceptTestingCrossTabReportList = PaginatedList & {
  __typename?: 'ConceptTestingCrossTabReportList';
  items: Array<ConceptTestingCrossTabReport>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/**
 * A table in a matrix format that displays the (multivariate)
 * frequency distribution of the variables
 */
export type ConceptTestingCrossTabTable = {
  __typename?: 'ConceptTestingCrossTabTable';
  confidenceLevel: Scalars['String'];
  pValue: Scalars['String'];
  rows: Array<Array<ConceptTestingCrossTabCell>>;
};

/**
 * A table in a matrix format that displays the (multivariate)
 * frequency distribution of the variables
 * This is a preview version of the table that is not persisted in the backend
 */
export type ConceptTestingCrossTabTablePreview = {
  __typename?: 'ConceptTestingCrossTabTablePreview';
  banners: Array<ConceptTestingCrossTabDimension>;
  confidenceLevel: Scalars['String'];
  pValue: Scalars['String'];
  rows: Array<Array<ConceptTestingCrossTabCell>>;
  stubs: Array<ConceptTestingCrossTabDimension>;
};

export type ConceptTestingImageStimulus = ConceptTestingStimulus & {
  __typename?: 'ConceptTestingImageStimulus';
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  nickname: Scalars['String'];
  percentage: Scalars['Float'];
  position: Scalars['Int'];
  previewLink: Scalars['String'];
  total?: Maybe<Scalars['Int']>;
  type: ConceptTestingStimulusType;
};

export type ConceptTestingInsight = {
  __typename?: 'ConceptTestingInsight';
  dislike?: Maybe<ConceptTestingInsightFilters>;
  hasPredictions: Scalars['Boolean'];
  /** A concept may have zero or more predictions */
  like?: Maybe<ConceptTestingInsightFilters>;
  /** The losing variableId of the random randomAssignment stimuli question for the project */
  losingConcept?: Maybe<Scalars['ID']>;
  /** the predictionId for the insight */
  predictionId?: Maybe<Scalars['ID']>;
  /** The winning variableId of the random randomAssignment stimuli question for the project */
  winningConcept?: Maybe<Scalars['ID']>;
};

export type ConceptTestingInsightFilter = {
  __typename?: 'ConceptTestingInsightFilter';
  /** stringified  filter object for the respondent cluster */
  filter: Scalars['String'];
  filterDescription?: Maybe<Array<Maybe<RuleDescription>>>;
  id: Scalars['ID'];
  score: Scalars['Float'];
  /** variableId of the random randomAssignment stimuli question for the project */
  variableId: Scalars['ID'];
};

export type ConceptTestingInsightFilters = {
  __typename?: 'ConceptTestingInsightFilters';
  items: Array<ConceptTestingInsightFilter>;
  totalCount: Scalars['Int'];
};

export type ConceptTestingKeyDriver = UseCaseKeyDriver & {
  __typename?: 'ConceptTestingKeyDriver';
  attribute: ConceptTestingAttribute;
  concept: ConceptTestingStimulus;
  correlation?: Maybe<Scalars['Float']>;
};

/** All the possible values that can be used as a CrossTabOption */
export enum ConceptTestingOptionType {
  AnswerOption = 'ANSWER_OPTION',
  GroupByAnswerOptions = 'GROUP_BY_ANSWER_OPTIONS',
}

export type ConceptTestingProject = Project & {
  __typename?: 'ConceptTestingProject';
  /** Price for additional responses, requires response count and qualification rate */
  additionalPrice?: Maybe<ProjectPrice>;
  allStimuli: ConceptTestingAllStimuli;
  answers: ProjectVariableAnswerList;
  /** list of attribute questions selected by the project author */
  attributes: Array<ConceptTestingAttribute>;
  audienceCollector?: Maybe<ProjectAudienceCollectorEntity>;
  /**
   * There may be multiple collectors associated with a project if there
   * was a problem fielding responses, or if the user purchased additional responses
   */
  audienceCollectors: Array<Maybe<ProjectAudienceCollectorEntity>>;
  /** list of benchmarks selected by the project author */
  benchmarks: Array<ConceptTestingBenchmark>;
  collections: ProjectVariableCollectionList;
  comparisonQuestion?: Maybe<MultipleComparisonQuestion>;
  createdAt: Scalars['DateTime'];
  customQuestions: Array<CustomQuestion>;
  /**
   * Project feasibility based on response count and qualification rate. If these parameters are not provided, the responses
   * and qualification rate saved to the project are used
   */
  feasibility?: Maybe<ProjectFeasibility>;
  hasComparisonQuestion: Scalars['Boolean'];
  hasCustomQuestionsAfterStimuli: Scalars['Boolean'];
  hasCustomQuestionsBeforeStimuli: Scalars['Boolean'];
  id: Scalars['ID'];
  insights: ConceptTestingInsight;
  invoices?: Maybe<ProjectInvoiceList>;
  /** A boolean flag to indicate if the current project is a sample/demo project or not */
  isSample: Scalars['Boolean'];
  links: ProjectLinks;
  module: Module;
  price?: Maybe<ProjectPrice>;
  /** list of recall questions set by the project author */
  recallQuestions: Array<OpenEndedQuestion>;
  screeningQuestion?: Maybe<ScreeningQuestion>;
  screeningQuestions?: Maybe<ScreeningQuestions>;
  status: ProjectStatus;
  stimuli?: Maybe<ConceptTestingStimuli>;
  subtype: ModuleSubType;
  supportedNorms: Array<NormsIndustry>;
  survey?: Maybe<ProjectSurveyEntity>;
  templates: ProjectTemplateList;
  title: Scalars['String'];
  type: ModuleType;
  /** The visible question count associated with the project */
  visibleQuestionCount: Scalars['Int'];
};

export type ConceptTestingProjectAdditionalPriceArgs = {
  qualificationRate?: InputMaybe<Scalars['Int']>;
  responseCount?: InputMaybe<Scalars['Int']>;
};

export type ConceptTestingProjectAnswersArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type ConceptTestingProjectBenchmarksArgs = {
  selectedBenchmarks?: InputMaybe<Array<Scalars['String']>>;
};

export type ConceptTestingProjectCollectionsArgs = {
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type ConceptTestingProjectCustomQuestionsArgs = {
  display?: InputMaybe<CustomQuestionDisplay>;
};

export type ConceptTestingProjectFeasibilityArgs = {
  qualificationRate?: InputMaybe<Scalars['Int']>;
  responseCount?: InputMaybe<Scalars['Int']>;
};

export type ConceptTestingProjectInvoicesArgs = {
  filter?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type ConceptTestingProjectTemplatesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type ConceptTestingStimuli = {
  __typename?: 'ConceptTestingStimuli';
  /** @deprecated Please use the previewLink under each ConceptTestingStimulus */
  previewLinks: Array<StimuliPreviewLink>;
  question: PresentationQuestion;
  stimuli: Array<ConceptTestingStimulus>;
  totalCount: Scalars['Int'];
};

export type ConceptTestingStimulus = {
  id: Scalars['ID'];
  nickname: Scalars['String'];
  percentage: Scalars['Float'];
  position: Scalars['Int'];
  previewLink: Scalars['String'];
  total?: Maybe<Scalars['Int']>;
  type: ConceptTestingStimulusType;
};

export enum ConceptTestingStimulusType {
  Image = 'IMAGE',
  Text = 'TEXT',
  Video = 'VIDEO',
}

export type ConceptTestingTextStimulus = ConceptTestingStimulus & {
  __typename?: 'ConceptTestingTextStimulus';
  id: Scalars['ID'];
  nickname: Scalars['String'];
  percentage: Scalars['Float'];
  position: Scalars['Int'];
  previewLink: Scalars['String'];
  text: Scalars['String'];
  total?: Maybe<Scalars['Int']>;
  type: ConceptTestingStimulusType;
};

export type ContactQuestionFieldSet = QuestionFieldSet & {
  __typename?: 'ContactQuestionFieldSet';
  fieldType: ContactQuestionFieldType;
  id: Scalars['ID'];
  label: Scalars['String'];
  visible: Scalars['Boolean'];
};

export enum ContactQuestionFieldType {
  Address = 'ADDRESS',
  Address2 = 'ADDRESS2',
  City = 'CITY',
  Company = 'COMPANY',
  Country = 'COUNTRY',
  Email = 'EMAIL',
  Name = 'NAME',
  Phone = 'PHONE',
  State = 'STATE',
  Zip = 'ZIP',
}

export type ContactQuestionQm = SurveyQuestionQm & {
  __typename?: 'ContactQuestionQM';
  createdAt: Scalars['DateTime'];
  family: SurveyQuestionFamily;
  fieldSetsContact: Array<ContactQuestionFieldSet>;
  hasPiping: Scalars['Boolean'];
  heading: QuestionHeadingConfiguration;
  id: Scalars['ID'];
  layout: MatrixContactLayoutOptions;
  modifiedAt: Scalars['DateTime'];
  position: QuestionPosition;
  requiredContact?: Maybe<ContactQuestionRequired>;
  stateFieldDisplayMode: ContactQuestionStateType;
  variant: SurveyQuestionVariant;
};

export type ContactQuestionRequired = {
  __typename?: 'ContactQuestionRequired';
  errorMessage: Scalars['String'];
  fieldTypes: Array<ContactQuestionFieldType>;
};

export enum ContactQuestionStateType {
  OpenEnded = 'OPEN_ENDED',
  UsStatesList = 'US_STATES_LIST',
}

export type ContentModule = {
  __typename?: 'ContentModule';
  name: Scalars['String'];
  placement: Placement;
  variation?: Maybe<Scalars['String']>;
};

export enum ContentModuleEvent {
  CtaClicked = 'CTA_CLICKED',
  Interaction = 'INTERACTION',
  ModuleDismissed = 'MODULE_DISMISSED',
}

export type ContentModuleProperties = {
  destination?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  signal?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The type of contributor */
export enum ContributorRoleType {
  Analyst = 'ANALYST',
  Casual = 'CASUAL',
  Unspecified = 'UNSPECIFIED',
}

/** Responses to ClickMap */
export type CoordinateResponse = {
  __typename?: 'CoordinateResponse';
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type CopyLibraryAssetInput = {
  assetId: Scalars['String'];
  divisionIds: Array<Scalars['ID']>;
};

export type CopyLibraryAssetPayload = {
  __typename?: 'CopyLibraryAssetPayload';
  libraryAssets?: Maybe<Array<LibraryAsset>>;
  success: Scalars['Boolean'];
};

export type CopyThemeInput = {
  themeId: Scalars['ID'];
  themeName: Scalars['String'];
};

export type CopyThemePayload = {
  __typename?: 'CopyThemePayload';
  success: Scalars['Boolean'];
  theme?: Maybe<SurveyTheme>;
};

export type CountryMetadata = CheckoutRegion & {
  __typename?: 'CountryMetadata';
  isBanned?: Maybe<Scalars['Boolean']>;
  isoCode: Scalars['String'];
  name: Scalars['String'];
  subdivisions?: Maybe<Array<CountrySubdivisionMetadata>>;
  translatedName?: Maybe<Scalars['String']>;
};

export type CountrySubdivisionMetadata = CheckoutRegion & {
  __typename?: 'CountrySubdivisionMetadata';
  isBanned: Scalars['Boolean'];
  isoCode: Scalars['String'];
  name: Scalars['String'];
};

export type CreateAnalysisExportJobPayload = {
  __typename?: 'CreateAnalysisExportJobPayload';
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<AnalysisExportJobStatus>;
  success: Scalars['Boolean'];
};

export type CreateAudienceProjectBulkInvoiceInput = {
  /**
   * This is data gathered from the audienceProjectFeasibility query. We need to pass it along
   * so that the service can validate that the reserved panelists can still be allocated to the
   * Audience project. These are only valid for a period of time after the call happens. The exact
   * time may change and can be confirmed by contacting the Audience Service platform team.
   */
  feasibilityTokens?: InputMaybe<
    Array<InputMaybe<CreateAudienceProjectInvoiceInput>>
  >;
};

export type CreateAudienceProjectInput = {
  /**
   * This should be set as the initial Audience project's collector ID in the bulk
   * project set (if creating a bulk project).
   */
  bulkProjectId?: InputMaybe<Scalars['Int']>;
  /** If this project is part of a bulk project, you may specify where in the list it should exist. */
  bulkProjectPosition?: InputMaybe<Scalars['Int']>;
  category: AudienceProjectCategory;
  collectorId: Scalars['Int'];
  projectConfig: AudienceProjectConfigInput;
};

export type CreateAudienceProjectInvoiceInput = {
  collectorId: Scalars['Int'];
  /**
   * This is data gathered from the audienceProjectFeasibility query. We need to pass it along
   * so that the service can validate that the reserved panelists can still be allocated to the
   * Audience project. These are only valid for a period of time after the call happens. The exact
   * time may change and can be confirmed by contacting the Audience Service platform team.
   */
  feasibilityToken: AudienceFeasibilityTokenInput;
};

export type CreateAudienceProjectPayload = {
  __typename?: 'CreateAudienceProjectPayload';
  errorMessage?: Maybe<Scalars['String']>;
  project?: Maybe<AudienceProject>;
  success: Scalars['Boolean'];
};

export type CreateCartInput = {
  country: Scalars['String'];
  metadata?: InputMaybe<Scalars['String']>;
  partner: Scalars['String'];
  products: Array<CreateCartProduct>;
  userId: Scalars['Int'];
};

export type CreateCartProduct = {
  metadata?: InputMaybe<Scalars['String']>;
  priceId?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  skuId: Scalars['Int'];
  unitCostOverride?: InputMaybe<Scalars['Int']>;
};

export type CreateCollectorAudienceInput = {
  category: Scalars['String'];
  source: Scalars['String'];
};

export type CreateCollectorError = {
  __typename?: 'CreateCollectorError';
  type: CreateCollectorErrorType;
};

export enum CreateCollectorErrorType {
  FreeUserReachedCollectorLimit = 'FREE_USER_REACHED_COLLECTOR_LIMIT',
  SurveyWithPaidFeaturesCreatingNonAudienceCollector = 'SURVEY_WITH_PAID_FEATURES_CREATING_NON_AUDIENCE_COLLECTOR',
}

export type CreateCollectorInput = {
  audienceParams?: InputMaybe<CreateCollectorAudienceInput>;
  popupType?: InputMaybe<PopupType>;
  surveyId: Scalars['ID'];
  type: CollectorType;
  /** BIFM = Build it For Me */
  usedBIFMRecommendation?: InputMaybe<Scalars['Boolean']>;
};

export type CreateCollectorPayload = {
  __typename?: 'CreateCollectorPayload';
  collector?: Maybe<Collector>;
  success: Scalars['Boolean'];
  userErrors: Array<CreateCollectorError>;
};

export type CreateConceptTestingCrossTabReportInput = {
  banners: Array<CrossTabTableBannerInput>;
  projectId: Scalars['ID'];
  stubs: Array<CrossTabTableStubInput>;
  title: Scalars['String'];
};

export type CreateConceptTestingCrossTabReportPayload = {
  __typename?: 'CreateConceptTestingCrossTabReportPayload';
  crosstab?: Maybe<ConceptTestingCrossTabReport>;
  success: Scalars['Boolean'];
};

export type CreateCrossTabReportInput = {
  banners?: InputMaybe<Array<InputMaybe<CrossTabTableBannerInput>>>;
  description?: InputMaybe<Scalars['String']>;
  stubs?: InputMaybe<Array<InputMaybe<CrossTabTableStubInput>>>;
  surveyId: Scalars['ID'];
  title: Scalars['String'];
  viewId: Scalars['ID'];
};

export type CreateCrossTabReportPayload = {
  __typename?: 'CreateCrossTabReportPayload';
  crosstab?: Maybe<CrossTabReport>;
  success: Scalars['Boolean'];
};

export type CreateFileUploadPolicyPayload = {
  __typename?: 'CreateFileUploadPolicyPayload';
  fileKey: Scalars['String'];
  putUrl: Scalars['String'];
};

/** The common payload object which wraps up the result of POST policy creation in S3 storage. */
export type CreateFileUploadPostPolicyPayload = {
  __typename?: 'CreateFileUploadPostPolicyPayload';
  fileKey: Scalars['String'];
  policy: Awss3PostPolicy;
  url: Scalars['String'];
};

export type CreateGeniusSurveyInput = {
  /** Whether or not a logo was uploaded */
  logoSkipped?: InputMaybe<Scalars['Boolean']>;
  /** What word to replace */
  modifier?: InputMaybe<Scalars['String']>;
  /** What text to substitute for the replaced modifier */
  replacementText?: InputMaybe<Scalars['String']>;
  /** Name of the template to copy */
  templateCanonicalName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The usecase of the survey being created */
  usecase?: InputMaybe<Scalars['String']>;
};

export type CreateInsightFeedbackInput = {
  filterId?: InputMaybe<Scalars['ID']>;
  predictionId: Scalars['ID'];
  type: InsightFeedbackType;
};

export type CreateJobDataInput = {
  oecData: OecData;
  surveyId: Scalars['ID'];
};

export type CreateLibraryAssetPayload = {
  __typename?: 'CreateLibraryAssetPayload';
  libraryAsset: LibraryAsset;
  success: Scalars['Boolean'];
};

export type CreateLibraryDocumentInput = {
  description?: InputMaybe<Scalars['String']>;
  divisionId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  s3Key: Scalars['String'];
};

export type CreateLibraryImageInput = {
  description?: InputMaybe<Scalars['String']>;
  divisionId?: InputMaybe<Scalars['ID']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  s3Key: Scalars['String'];
};

export type CreateLibraryPresentationInput = {
  description?: InputMaybe<Scalars['String']>;
  divisionId?: InputMaybe<Scalars['ID']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  s3Key: Scalars['String'];
};

export type CreateLibrarySurveyTemplateInput = {
  description?: InputMaybe<Scalars['String']>;
  divisionId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  surveyId: Scalars['String'];
};

export type CreateLibraryThemeInput = {
  description?: InputMaybe<Scalars['String']>;
  divisionId?: InputMaybe<Scalars['ID']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  themeId: Scalars['String'];
};

/** @deprecated: Will be refactored into common types soon (ENT-5398) */
export type CreateLibraryUploadPolicyPayload = {
  __typename?: 'CreateLibraryUploadPolicyPayload';
  acl: Scalars['String'];
  fileKey: Scalars['String'];
  policy: Scalars['String'];
  publicKey: Scalars['String'];
  serverSideEncryption: Scalars['Boolean'];
  signature: Scalars['String'];
  url: Scalars['String'];
};

export type CreateLookerQueryTaskError = UserError & {
  __typename?: 'CreateLookerQueryTaskError';
  code: CreateLookerQueryTaskErrorType;
  detail: Scalars['String'];
  field?: Maybe<Array<Scalars['String']>>;
};

export enum CreateLookerQueryTaskErrorType {
  InvalidInput = 'INVALID_INPUT',
  NotFound = 'NOT_FOUND',
}

export type CreateLookerQueryTaskPayload = {
  __typename?: 'CreateLookerQueryTaskPayload';
  queryTaskId?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
  userErrors?: Maybe<Array<CreateLookerQueryTaskError>>;
};

export type CreateOecJobPayload = {
  __typename?: 'CreateOecJobPayload';
  job: OecJob;
  success: Scalars['Boolean'];
};

export type CreateOecQuestionTagPayload = {
  __typename?: 'CreateOecQuestionTagPayload';
  success: Scalars['Boolean'];
  tag: OecQuestionTag;
};

export type CreateProjectInput = {
  moduleId: Scalars['ID'];
};

export type CreateProjectInvoiceError = {
  __typename?: 'CreateProjectInvoiceError';
  type: CreateProjectInvoiceErrorType;
};

export enum CreateProjectInvoiceErrorType {
  AssociatedModuleRetired = 'ASSOCIATED_MODULE_RETIRED',
  EntityManuallyChanged = 'ENTITY_MANUALLY_CHANGED',
  InvalidProject = 'INVALID_PROJECT',
  MissingRequiredAnswerAudiencePanel = 'MISSING_REQUIRED_ANSWER_AUDIENCE_PANEL',
  MissingRequiredAnswers = 'MISSING_REQUIRED_ANSWERS',
  MissingRequiredStimuliScreener = 'MISSING_REQUIRED_STIMULI_SCREENER',
  MissingRequiredSurveyEntity = 'MISSING_REQUIRED_SURVEY_ENTITY',
  OverQuestionLimit = 'OVER_QUESTION_LIMIT',
  SurveyCreationCallIncomplete = 'SURVEY_CREATION_CALL_INCOMPLETE',
  SurveyFeaturesMissing = 'SURVEY_FEATURES_MISSING',
  SurveyServiceUnavailable = 'SURVEY_SERVICE_UNAVAILABLE',
  UnsupportedBillingCountry = 'UNSUPPORTED_BILLING_COUNTRY',
}

/**
 * Parameters responseCount and qualificationRate are optional,
 * include to generate an additional responses invoice.
 */
export type CreateProjectInvoiceInput = {
  /** An optional countryCode to reissue invoice for different billing country */
  countryCode?: InputMaybe<Scalars['String']>;
  /** An optional currencyCode to reissue invoice for different billing currency */
  currencyCode?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
  qualificationRate?: InputMaybe<Scalars['Int']>;
  responseCount?: InputMaybe<Scalars['Int']>;
};

export type CreateProjectInvoicePayload = {
  __typename?: 'CreateProjectInvoicePayload';
  billingRedirectUrl?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  userError?: Maybe<CreateProjectInvoiceError>;
};

export type CreateProjectPayload = {
  __typename?: 'CreateProjectPayload';
  project: Project;
  success: Scalars['Boolean'];
};

export type CreateScreeningQuestionMetadataInput = {
  answerOther?: InputMaybe<ScreeningQuestionAnswerOtherMetadataInput>;
  displayNumber: Scalars['Int'];
  disqualifyingRows: Array<ScreeningQuestionRowOptionMetadataInput>;
  heading: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  mustSelectRows: Array<ScreeningQuestionRowOptionMetadataInput>;
  projectId: Scalars['ID'];
  required: ScreeningQuestionRequiredMetadataInput;
  rows: Array<ScreeningQuestionRowOptionMetadataInput>;
  sorting?: InputMaybe<ScreeningQuestionSortingMetadataInput>;
  type: ChoiceScreeningQuestionFamilyType;
  validation?: InputMaybe<ScreeningQuestionValidationMetadataInput>;
};

export type CreateScreeningQuestionMetadataPayload = {
  __typename?: 'CreateScreeningQuestionMetadataPayload';
  metadata: ScreeningQuestionMetadata;
  success: Scalars['Boolean'];
};

export type CreateSeatRequestInput = {
  /** User provided reason as to why they want the upgraded seat */
  reason?: InputMaybe<Scalars['String']>;
  seatType: SeatRequestSeatType;
  /** The category for source location where the user is making the seat request from. Must match pre-existing category key that is already translated. */
  sourceCategoryKey: Scalars['String'];
  /** The specific feature that the user is requesting a feature from. should match feature key in pricingSvc. */
  sourceFeatureKey?: InputMaybe<Scalars['String']>;
};

export type CreateSharedViewInput = {
  allowTeamExport?: InputMaybe<Scalars['Boolean']>;
  branding: AnalysisSharedViewBranding;
  cloneViews?: InputMaybe<Scalars['Boolean']>;
  defaultViewId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  domain: Scalars['String'];
  hideOpenEnded: Scalars['Boolean'];
  isEnabled: Scalars['Boolean'];
  isPublic?: InputMaybe<Scalars['Boolean']>;
  modes: Array<InputMaybe<AnalysisSharedViewMode>>;
  name: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  sharableViewId: Scalars['ID'];
  sharedViewKey?: InputMaybe<Scalars['String']>;
  surveyId: Scalars['ID'];
  teamOnlyShare?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
  type: AnalysisSharedViewType;
};

export type CreateSurveyInput = {
  categoryId?: InputMaybe<Scalars['Int']>;
  format?: InputMaybe<SurveyFormat>;
  title: Scalars['String'];
};

export type CreateSurveyPayload = {
  __typename?: 'CreateSurveyPayload';
  success: Scalars['Boolean'];
  survey?: Maybe<Survey>;
};

export type CreateTagDataInput = {
  label: Scalars['String'];
  questionId: Scalars['ID'];
  surveyId: Scalars['ID'];
};

export type CreateTeamInviteFailure = {
  __typename?: 'CreateTeamInviteFailure';
  email: Scalars['String'];
  message: Scalars['String'];
};

export type CreateTeamInviteInput = {
  /** A message to send to each inviteee */
  customMessage?: InputMaybe<Scalars['String']>;
  invites: Array<CreateTeamInviteUserInput>;
};

export type CreateTeamInvitePayload = {
  __typename?: 'CreateTeamInvitePayload';
  invites: Array<CreateTeamInviteResult>;
};

/** Either a successfully create invite or a failure message */
export type CreateTeamInviteResult = CreateTeamInviteFailure | TeamInvite;

export type CreateTeamInviteUserInput = {
  /** Optionally a divisionId that this invited user will be assigned to */
  divisionId?: InputMaybe<Scalars['ID']>;
  /** Email address to send invitation to */
  email: Scalars['String'];
  /** if this ID is defined, the request will be a reassignment instead of a new invite */
  teamMembershipId?: InputMaybe<Scalars['ID']>;
};

export type CreateTrackingDashboardError = UserError & {
  __typename?: 'CreateTrackingDashboardError';
  code: CreateTrackingDashboardErrorType;
  detail: Scalars['String'];
  field?: Maybe<Array<Scalars['String']>>;
};

export enum CreateTrackingDashboardErrorType {
  DuplicateTitle = 'DUPLICATE_TITLE',
}

export type CreateTrackingDashboardInput = {
  projectId: Scalars['ID'];
  title: Scalars['String'];
};

export type CreateTrackingDashboardPayload = {
  __typename?: 'CreateTrackingDashboardPayload';
  dashboard?: Maybe<TrackingDashboard>;
  success: Scalars['Boolean'];
  userErrors?: Maybe<Array<CreateTrackingDashboardError>>;
};

export type CreateTrackingSharedDashboardAuthSessionError = UserError & {
  __typename?: 'CreateTrackingSharedDashboardAuthSessionError';
  code: CreateTrackingSharedDashboardAuthSessionErrorType;
  detail: Scalars['String'];
  field?: Maybe<Array<Scalars['String']>>;
};

/** A single tracking shared dashboard session */
export enum CreateTrackingSharedDashboardAuthSessionErrorType {
  IncorrectPassword = 'INCORRECT_PASSWORD',
}

export type CreateTrackingSharedDashboardAuthSessionPayload = {
  __typename?: 'CreateTrackingSharedDashboardAuthSessionPayload';
  session?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  userErrors?: Maybe<Array<CreateTrackingSharedDashboardAuthSessionError>>;
};

export type CreateUseCaseCustomAttributeInput = {
  data: Scalars['String'];
  label: Scalars['String'];
};

/** A table header consists of the subgroups for data analysis */
export type CrossTabBanner = {
  __typename?: 'CrossTabBanner';
  question: SurveyQuestion;
  selectedOptions: Array<Maybe<SurveyQuestionOption>>;
};

/** Contains all data that could be displayed in the CrossTabTable */
export type CrossTabCell = {
  __typename?: 'CrossTabCell';
  columnPercentage?: Maybe<Scalars['Float']>;
  confidenceLevel?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['Int']>;
  higherSignificanceOptions: Array<Maybe<SurveyQuestionOption>>;
  highlighted?: Maybe<Scalars['Boolean']>;
  lowerSignificanceOptions: Array<Maybe<SurveyQuestionOption>>;
  pValue?: Maybe<Scalars['String']>;
  rowPercentage?: Maybe<Scalars['Float']>;
  totalPercentage?: Maybe<Scalars['Float']>;
};

/** A table view defined by user to show comparison across differnt groups */
export type CrossTabReport = {
  __typename?: 'CrossTabReport';
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  modifiedAt: Scalars['DateTime'];
  shareEnabled: Scalars['Boolean'];
  ssoAuthRequired: Scalars['Boolean'];
  survey: Survey;
  table: CrossTabTable;
  title: Scalars['String'];
  view: AnalysisStandardView;
};

export type CrossTabReportList = PaginatedList & {
  __typename?: 'CrossTabReportList';
  items: Array<CrossTabReport>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** The stub contains the table rows. */
export type CrossTabStub = {
  __typename?: 'CrossTabStub';
  question: SurveyQuestion;
  selectedOptions: Array<Maybe<SurveyQuestionOption>>;
};

/**
 * A table in a matrix format that displays the (multivariate)
 * frequency distribution of the variables
 */
export type CrossTabTable = {
  __typename?: 'CrossTabTable';
  banners?: Maybe<Array<Maybe<CrossTabBanner>>>;
  crosstabReportId: Scalars['ID'];
  rows?: Maybe<Array<Maybe<Array<CrossTabCell>>>>;
  stubs?: Maybe<Array<Maybe<CrossTabStub>>>;
};

export type CrossTabTableBannerInput = {
  questionId: Scalars['ID'];
  selectedOptions?: InputMaybe<Array<Scalars['ID']>>;
};

export type CrossTabTableStubInput = {
  questionId: Scalars['ID'];
  selectedOptions?: InputMaybe<Array<Scalars['ID']>>;
};

export type CurrencyData = {
  __typename?: 'CurrencyData';
  code: CurrencyTypeId;
  id: Scalars['ID'];
};

/** Contains metadata about a given currency */
export type CurrencyInfo = {
  __typename?: 'CurrencyInfo';
  currencyCode: Scalars['String'];
  decimalPlaces: Scalars['Int'];
};

export enum CurrencyTypeId {
  Aed = 'AED',
  Ars = 'ARS',
  Aud = 'AUD',
  Brl = 'BRL',
  Cad = 'CAD',
  Chf = 'CHF',
  Clp = 'CLP',
  Cop = 'COP',
  Crc = 'CRC',
  Czk = 'CZK',
  Dkk = 'DKK',
  Egp = 'EGP',
  Eur = 'EUR',
  Gbp = 'GBP',
  Hkd = 'HKD',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Isk = 'ISK',
  Jpy = 'JPY',
  Krw = 'KRW',
  Mxn = 'MXN',
  Myr = 'MYR',
  Nok = 'NOK',
  Nzd = 'NZD',
  Pen = 'PEN',
  Php = 'PHP',
  Pln = 'PLN',
  Qar = 'QAR',
  Rub = 'RUB',
  Sar = 'SAR',
  Sek = 'SEK',
  Sgd = 'SGD',
  Thb = 'THB',
  Try = 'TRY',
  Twd = 'TWD',
  Usd = 'USD',
  Zar = 'ZAR',
}

export type CustomEmailDomain = {
  __typename?: 'CustomEmailDomain';
  displayName: Scalars['String'];
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  localName: Scalars['String'];
  replyToEmail?: Maybe<Scalars['String']>;
  rolledOutUsers?: Maybe<Array<User>>;
  rolloutStatus: EmailDomainRolloutStatus;
  sendingDomain: Scalars['String'];
  verificationStatus?: Maybe<CustomEmailDomainVerificationStatus>;
};

export type CustomEmailDomainDnsRecordInstructions = {
  __typename?: 'CustomEmailDomainDNSRecordInstructions';
  hostname: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['String'];
};

export enum CustomEmailDomainDnsVerificationStatus {
  Invalid = 'INVALID',
  Pending = 'PENDING',
  Unverified = 'UNVERIFIED',
  Valid = 'VALID',
}

export type CustomEmailDomainRolledOutUserInput = {
  userId: Scalars['ID'];
};

export type CustomEmailDomainUpdateInput = {
  create: Scalars['Boolean'];
  displayName: Scalars['String'];
  groupId: Scalars['ID'];
  localName: Scalars['String'];
  replyToEmail?: InputMaybe<Scalars['String']>;
  rolledOutUsers?: InputMaybe<Array<CustomEmailDomainRolledOutUserInput>>;
  rolloutStatus: EmailDomainRolloutStatus;
  sendingDomain: Scalars['String'];
};

export type CustomEmailDomainUpdatePayload = {
  __typename?: 'CustomEmailDomainUpdatePayload';
  customEmailDomain?: Maybe<CustomEmailDomain>;
  errors?: Maybe<Array<ClientError>>;
  success: Scalars['Boolean'];
};

export type CustomEmailDomainVerificationStatus = {
  __typename?: 'CustomEmailDomainVerificationStatus';
  cnameValue: CustomEmailDomainDnsRecordInstructions;
  cnameVerified: CustomEmailDomainDnsVerificationStatus;
  dkimValue: CustomEmailDomainDnsRecordInstructions;
  dkimVerified: CustomEmailDomainDnsVerificationStatus;
  mxValue: Scalars['String'];
  spfValue: Scalars['String'];
};

export type CustomerMetadataInput = {
  company?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  partner: BillingPartner;
  phone?: InputMaybe<Scalars['String']>;
  role: BillingUserRole;
};

export type CustomerTaxInput = {
  partner: BillingPartner;
  status: Scalars['Boolean'];
  taxId?: InputMaybe<Scalars['String']>;
  verifiedAdminId: Scalars['ID'];
};

export type CustomQuestion =
  | MatrixQuestion
  | MultipleChoiceQuestion
  | OpenEndedQuestion
  | SingleChoiceQuestion;

export enum CustomQuestionDisplay {
  AfterStimuli = 'AFTER_STIMULI',
  All = 'ALL',
  BeforeStimuli = 'BEFORE_STIMULI',
}

export type CustomQuestionResponseSummary = {
  __typename?: 'CustomQuestionResponseSummary';
  display?: Maybe<CustomQuestionDisplay>;
  hasTextResponses: Scalars['Boolean'];
  items: Array<CustomQuestionSummaryData>;
};

export type CustomQuestionResponseSummaryList = {
  __typename?: 'CustomQuestionResponseSummaryList';
  question: SurveyQuestion;
  responseSummary: CustomQuestionResponseSummary;
};

export type CustomQuestionResponseSummaryListByStimulus = {
  __typename?: 'CustomQuestionResponseSummaryListByStimulus';
  question: SurveyQuestion;
  responseSummary: CustomQuestionResponseSummary;
  stimulus: ConceptTestingStimulus;
};

export type CustomQuestionsAfterStimuliVariableConfiguration = ProjectVariableConfiguration & {
  __typename?: 'CustomQuestionsAfterStimuliVariableConfiguration';
  customQuestionsAfterStimuli: CustomQuestionsAfterStimuliVariableList;
  enabled: Scalars['Boolean'];
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export type CustomQuestionsAfterStimuliVariableConfigurationCustomQuestionsAfterStimuliArgs = {
  filter?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type CustomQuestionsAfterStimuliVariableList = {
  __typename?: 'CustomQuestionsAfterStimuliVariableList';
  items: Array<ModuleCustomQuestionsAfterStimuli>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CustomQuestionsBeforeStimuliVariableConfiguration = ProjectVariableConfiguration & {
  __typename?: 'CustomQuestionsBeforeStimuliVariableConfiguration';
  customQuestionsBeforeStimuli: CustomQuestionsBeforeStimuliVariableList;
  enabled: Scalars['Boolean'];
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export type CustomQuestionsBeforeStimuliVariableConfigurationCustomQuestionsBeforeStimuliArgs = {
  filter?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type CustomQuestionsBeforeStimuliVariableList = {
  __typename?: 'CustomQuestionsBeforeStimuliVariableList';
  items: Array<ModuleCustomQuestionsBeforeStimuli>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CustomQuestionSummaryData =
  | CustomQuestionSummaryOneDimensionalData
  | CustomQuestionSummaryOneDimensionalStimuliData
  | CustomQuestionSummaryTwoDimensionalData
  | CustomQuestionSummaryTwoDimensionalStimuliData;

export type CustomQuestionSummaryOneDimensionalData = {
  __typename?: 'CustomQuestionSummaryOneDimensionalData';
  percentage: Scalars['Float'];
  row: SurveyQuestionRow;
  total: Scalars['Int'];
};

export type CustomQuestionSummaryOneDimensionalStimuliData = {
  __typename?: 'CustomQuestionSummaryOneDimensionalStimuliData';
  percentage: Scalars['Float'];
  row: SurveyQuestionRow;
  stimulus: ConceptTestingStimulus;
  total: Scalars['Int'];
};

export type CustomQuestionSummaryTwoDimensionalData = {
  __typename?: 'CustomQuestionSummaryTwoDimensionalData';
  column?: Maybe<SurveyQuestionColumn>;
  rows: Array<CustomQuestionSummaryTwoDimensionalDataRow>;
};

export type CustomQuestionSummaryTwoDimensionalDataRow = {
  __typename?: 'CustomQuestionSummaryTwoDimensionalDataRow';
  percentage: Scalars['Float'];
  row: SurveyQuestionRow;
  total: Scalars['Int'];
};

export type CustomQuestionSummaryTwoDimensionalStimuliColumnData = {
  __typename?: 'CustomQuestionSummaryTwoDimensionalStimuliColumnData';
  column?: Maybe<SurveyQuestionColumn>;
  stimuliData: Array<CustomQuestionSummaryTwoDimensionalStimulusData>;
};

export type CustomQuestionSummaryTwoDimensionalStimuliData = {
  __typename?: 'CustomQuestionSummaryTwoDimensionalStimuliData';
  columns: Array<CustomQuestionSummaryTwoDimensionalStimuliColumnData>;
  row: SurveyQuestionRow;
};

export type CustomQuestionSummaryTwoDimensionalStimulusData = {
  __typename?: 'CustomQuestionSummaryTwoDimensionalStimulusData';
  percentage: Scalars['Float'];
  stimulus: ConceptTestingStimulus;
  total: Scalars['Int'];
};

export type CustomSurveyLinkDomain = SurveyLinkDomain & {
  __typename?: 'CustomSurveyLinkDomain';
  available: Scalars['Boolean'];
  canonicalName: Scalars['String'];
  customDomainType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  type: SurveyLinkDomainType;
};

export type CustomSurveyLinkDomainSetting = {
  __typename?: 'CustomSurveyLinkDomainSetting';
  customSurveyLinkDomains: Array<CustomSurveyLinkDomain>;
  defaultCustomSurveyLinkDomain?: Maybe<CustomSurveyLinkDomain>;
  isCustomSurveyLinkDomainEnabled: Scalars['Boolean'];
};

/**
 * Defines analyze dashboard that is used to present survey results.
 * Enables user to customize survey results, add charts and text and share Dashboard with anyone.
 */
export type Dashboard = {
  __typename?: 'Dashboard';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  owner?: Maybe<User>;
  rows: Array<Maybe<DashboardRow>>;
  surveyTitle: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
};

/** Describes analyze dashboard element that contains only user entered text */
export type DashboardContentElement = DashboardElement & {
  __typename?: 'DashboardContentElement';
  column: Scalars['Int'];
  id: Scalars['ID'];
  row: Scalars['Int'];
  text: Scalars['String'];
  type: DashboardElementType;
};

export type DashboardElement = {
  column: Scalars['Int'];
  id: Scalars['ID'];
  row: Scalars['Int'];
  type: DashboardElementType;
};

export enum DashboardElementType {
  Content = 'CONTENT',
  Empty = 'EMPTY',
  Question = 'QUESTION',
}

/** Describes empty analyze dashboard element */
export type DashboardEmptyElement = DashboardElement & {
  __typename?: 'DashboardEmptyElement';
  column: Scalars['Int'];
  id: Scalars['ID'];
  row: Scalars['Int'];
  type: DashboardElementType;
};

/** Describes summary of the survey question that is used in analyze dashboards. */
export type DashboardQuestionData = {
  __typename?: 'DashboardQuestionData';
  id: Scalars['ID'];
  smQuestion: SmqSingleQuestionController;
};

/** Describes analyze dashboard element that represents a question from survey */
export type DashboardQuestionElement = DashboardElement & {
  __typename?: 'DashboardQuestionElement';
  column: Scalars['Int'];
  compareRules: Array<Maybe<AnalysisStandardViewCompareRule>>;
  filterRules: Array<Maybe<AnalysisStandardViewFilterRule>>;
  id: Scalars['ID'];
  questionId: Scalars['ID'];
  row: Scalars['Int'];
  surveyId: Scalars['ID'];
  type: DashboardElementType;
};

/** Defines analyze dashboard row. */
export type DashboardRow = {
  __typename?: 'DashboardRow';
  elements: Array<Maybe<DashboardElement>>;
  id: Scalars['ID'];
  position?: Maybe<Scalars['Int']>;
};

/** This validation configuration is used to enforce date inputs using the correct format. */
export type DateFormatValidation = QuestionValidation & {
  __typename?: 'DateFormatValidation';
  errorMessage: Scalars['String'];
  /** Can only be DATE_US or DATE_INTL */
  type: QuestionFieldValidationType;
};

export type DateRange = {
  __typename?: 'DateRange';
  endAt?: Maybe<Scalars['DateTime']>;
  startAt?: Maybe<Scalars['DateTime']>;
};

/**
 * datatime question type
 * contains rows
 * we can also use options field to fetch all the rows
 */
export type DatetimeQuestion = SurveyQuestion & {
  __typename?: 'DatetimeQuestion';
  absolutePosition: Scalars['Int'];
  displayNumber: Scalars['Int'];
  displayOptions: SurveyQuestionDisplayOptions;
  headers: Array<SurveyQuestionHeader>;
  id: Scalars['ID'];
  isAudience: Scalars['Boolean'];
  nickname: Scalars['String'];
  options?: Maybe<SurveyQuestionOptionList>;
  pageId: Scalars['ID'];
  position: Scalars['Int'];
  questionTemplate?: Maybe<DatetimeQuestionTemplate>;
  responseSummary?: Maybe<QuestionResponseSummary>;
  rows?: Maybe<SurveyQuestionRowList>;
  type: SurveyQuestionType;
  validation: SurveyQuestionValidationOptions;
  visible: Scalars['Boolean'];
};

/**
 * datatime question type
 * contains rows
 * we can also use options field to fetch all the rows
 */
export type DatetimeQuestionOptionsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/**
 * datatime question type
 * contains rows
 * we can also use options field to fetch all the rows
 */
export type DatetimeQuestionRowsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type DateTimeQuestionQm = SurveyQuestionQm & {
  __typename?: 'DateTimeQuestionQM';
  createdAt: Scalars['DateTime'];
  family: SurveyQuestionFamily;
  fieldSets: Array<FieldSet>;
  hasPiping: Scalars['Boolean'];
  heading: QuestionHeadingConfiguration;
  id: Scalars['ID'];
  layout: RatingDateTimeFileUploadLayoutOptions;
  modifiedAt: Scalars['DateTime'];
  position: QuestionPosition;
  required?: Maybe<QuestionAnswerRequired>;
  sorting?: Maybe<QuestionSorting>;
  validation?: Maybe<DateFormatValidation>;
  variant: SurveyQuestionVariant;
};

export type DatetimeQuestionTemplate = SurveyQuestionTemplate & {
  __typename?: 'DatetimeQuestionTemplate';
  attributes: Array<SurveyQuestionTemplateAttribute>;
  heading: Scalars['String'];
  id: Scalars['ID'];
  logicalLink: SurveyQuestionTemplateLogicalLink;
  modifiers: Array<SurveyQuestionTemplateModifier>;
  rows: Array<SurveyQuestionTemplateRow>;
};

/**
 * This validation configuration is used to enforce date inputs using the correct format and are within the defined
 * date range.
 */
export type DateValidation = QuestionValidation & {
  __typename?: 'DateValidation';
  errorMessage: Scalars['String'];
  maxDate: Scalars['String'];
  minDate: Scalars['String'];
  /** Can only be DATE_US or DATE_INTL */
  type: QuestionFieldValidationType;
};

export type DefaultAssets = {
  __typename?: 'DefaultAssets';
  image?: Maybe<LibraryImage>;
  presentation?: Maybe<LibraryPresentation>;
  theme?: Maybe<LibraryTheme>;
};

export type DefaultAssetsRestrictions = {
  __typename?: 'DefaultAssetsRestrictions';
  image: DefaultLogoRestrictions;
  introText: DefaultIntroTextRestrictions;
  template: DefaultTemplateRestrictions;
  theme: DefaultThemeRestrictions;
};

export type DefaultAssetsSettingsLibrary = {
  __typename?: 'DefaultAssetsSettingsLibrary';
  image?: Maybe<DefaultImageSettings>;
  introText?: Maybe<DefaultTextSettings>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  template?: Maybe<DefaultTemplateSettings>;
  theme?: Maybe<DefaultThemeSettings>;
};

/** Each supported variable has a specific configuration to drive the front-end */
export type DefaultConfiguration = ProjectVariableConfiguration & {
  __typename?: 'DefaultConfiguration';
  enabled: Scalars['Boolean'];
};

/** Settings provided by admin used to render EnterpriseThankYou page */
export type DefaultEndPageSettings = {
  __typename?: 'DefaultEndPageSettings';
  bodyText?: Maybe<Scalars['String']>;
  image?: Maybe<LibraryImage>;
  imageRedirectUrl?: Maybe<Scalars['String']>;
  isEnabled: Scalars['Boolean'];
  logo?: Maybe<LibraryImage>;
  thankYouText?: Maybe<Scalars['String']>;
};

export type DefaultImageSettings = {
  __typename?: 'DefaultImageSettings';
  altText?: Maybe<Scalars['String']>;
  asset?: Maybe<LibraryImage>;
  assetInherited: Scalars['Boolean'];
  clear: Scalars['Boolean'];
  divisionAdminOverride: Scalars['Boolean'];
  divisionAdminOverrideInherited: Scalars['Boolean'];
  isAltTextEnabled: Scalars['Boolean'];
  restriction: LibraryRestriction;
  restrictionInherited: Scalars['Boolean'];
  sizeType: LibraryImageSizeType;
  verticalAlign: LibraryImageAlignType;
};

export type DefaultIntroTextRestrictions = {
  __typename?: 'DefaultIntroTextRestrictions';
  data?: Maybe<Array<TextSetting>>;
  enforceDefault: Scalars['Boolean'];
};

export type DefaultLogoRestrictions = {
  __typename?: 'DefaultLogoRestrictions';
  data?: Maybe<LibraryImage>;
  enforceDefault: Scalars['Boolean'];
  restrictToLibrary: Scalars['Boolean'];
};

export type DefaultQuestionVariableAnswerData = QuestionVariableAnswerData & {
  __typename?: 'DefaultQuestionVariableAnswerData';
  type: SurveyQuestionType;
};

export type DefaultTemplateRestrictions = {
  __typename?: 'DefaultTemplateRestrictions';
  restrictToLibrary: Scalars['Boolean'];
};

export type DefaultTemplateSettings = {
  __typename?: 'DefaultTemplateSettings';
  divisionAdminOverride: Scalars['Boolean'];
  divisionAdminOverrideInherited: Scalars['Boolean'];
  restriction: LibraryRestriction;
  restrictionInherited: Scalars['Boolean'];
};

export type DefaultTextSettings = {
  __typename?: 'DefaultTextSettings';
  divisionAdminOverride: Scalars['Boolean'];
  divisionAdminOverrideInherited: Scalars['Boolean'];
  text?: Maybe<Array<TextSetting>>;
  textInherited: Scalars['Boolean'];
};

export type DefaultThemeRestrictions = {
  __typename?: 'DefaultThemeRestrictions';
  data?: Maybe<LibraryTheme>;
  enforceDefault: Scalars['Boolean'];
  restrictToLibrary: Scalars['Boolean'];
};

export type DefaultThemeSettings = {
  __typename?: 'DefaultThemeSettings';
  asset?: Maybe<ThemeAsset>;
  assetInherited: Scalars['Boolean'];
  clear: Scalars['Boolean'];
  divisionAdminOverride: Scalars['Boolean'];
  divisionAdminOverrideInherited: Scalars['Boolean'];
  restriction: LibraryRestriction;
  restrictionInherited: Scalars['Boolean'];
};

export type DeiResponseUploadPolicyInput = {
  fileName: Scalars['String'];
  groupId: Scalars['String'];
};

export type DeleteAnalysisExportJobPayload = {
  __typename?: 'DeleteAnalysisExportJobPayload';
  id?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type DeleteConceptTestingCrossTabReportInput = {
  projectId: Scalars['ID'];
  reportId: Scalars['ID'];
};

export type DeleteLibraryAssetInput = {
  assetId: Scalars['ID'];
  assetType: LibraryAssetType;
};

export type DeleteOecQuestionTagPayload = {
  __typename?: 'DeleteOecQuestionTagPayload';
  success: Scalars['Boolean'];
  tagId: Scalars['ID'];
};

export type DeleteProfileInput = {
  deleteProfileConfirm: Scalars['Boolean'];
};

export type DeleteRespondentInput = {
  collectorId: Scalars['ID'];
  id: Scalars['ID'];
  surveyId: Scalars['ID'];
};

export type DeleteRespondentPayload = {
  __typename?: 'DeleteRespondentPayload';
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type DeleteScreeningQuestionMetadataPayload = {
  __typename?: 'DeleteScreeningQuestionMetadataPayload';
  metadata: ScreeningQuestionMetadata;
  success: Scalars['Boolean'];
};

export type DeleteSharedViewInput = {
  sharedViewId: Scalars['ID'];
  surveyId: Scalars['ID'];
};

export type DeleteTagDataInput = {
  questionId: Scalars['ID'];
  surveyId: Scalars['ID'];
  tagId: Scalars['ID'];
};

export type DeleteThemeInput = {
  themeId: Scalars['ID'];
};

export type DeleteUserInput = {
  id: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};

/**
 * demographic question type
 * contains rows
 * we can also use options field to fetch all the rows
 */
export type DemographicQuestion = SurveyQuestion & {
  __typename?: 'DemographicQuestion';
  absolutePosition: Scalars['Int'];
  displayNumber: Scalars['Int'];
  displayOptions: SurveyQuestionDisplayOptions;
  headers: Array<SurveyQuestionHeader>;
  id: Scalars['ID'];
  isAudience: Scalars['Boolean'];
  nickname: Scalars['String'];
  options?: Maybe<SurveyQuestionOptionList>;
  pageId: Scalars['ID'];
  position: Scalars['Int'];
  questionTemplate?: Maybe<DemographicQuestionTemplate>;
  responseSummary?: Maybe<QuestionResponseSummary>;
  rows?: Maybe<SurveyQuestionRowList>;
  type: SurveyQuestionType;
  validation: SurveyQuestionValidationOptions;
  visible: Scalars['Boolean'];
};

/**
 * demographic question type
 * contains rows
 * we can also use options field to fetch all the rows
 */
export type DemographicQuestionOptionsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/**
 * demographic question type
 * contains rows
 * we can also use options field to fetch all the rows
 */
export type DemographicQuestionRowsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type DemographicQuestionTemplate = SurveyQuestionTemplate & {
  __typename?: 'DemographicQuestionTemplate';
  attributes: Array<SurveyQuestionTemplateAttribute>;
  heading: Scalars['String'];
  id: Scalars['ID'];
  logicalLink: SurveyQuestionTemplateLogicalLink;
  modifiers: Array<SurveyQuestionTemplateModifier>;
  rows: Array<SurveyQuestionTemplateRow>;
};

export type DetailsFormField = {
  __typename?: 'DetailsFormField';
  dataVariant?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  formFieldName: Scalars['String'];
  fullWidth?: Maybe<Scalars['Boolean']>;
  labelVariant?: Maybe<Scalars['String']>;
  required: Scalars['Boolean'];
};

export type DetailsFormFieldSet = {
  __typename?: 'DetailsFormFieldSet';
  items: Array<DetailsFormField>;
  totalCount: Scalars['Int'];
};

/** represents the direction taken from the current page */
export enum DirectionType {
  Back = 'BACK',
  Next = 'NEXT',
  Same = 'SAME',
}

export enum DisabledCollectorReason {
  DisabledByCasualSeat = 'DISABLED_BY_CASUAL_SEAT',
  DisabledByTeamAdmin = 'DISABLED_BY_TEAM_ADMIN',
  SurveyHasBestWorstQuestion = 'SURVEY_HAS_BEST_WORST_QUESTION',
  SurveyHasClickmapQuestion = 'SURVEY_HAS_CLICKMAP_QUESTION',
  SurveyHasPaymentPage = 'SURVEY_HAS_PAYMENT_PAGE',
}

export type DisabledCollectorType = CollectorTypeAvailability & {
  __typename?: 'DisabledCollectorType';
  disabledReason?: Maybe<DisabledCollectorReason>;
  isRecommendedFromBIFM: Scalars['Boolean'];
  type: CollectorType;
};

export enum DiscoverabilityStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
}

export type DiscoverableTeam = {
  __typename?: 'DiscoverableTeam';
  activeMemberCount: Scalars['Int'];
  description: Scalars['String'];
  discoverabilityStatus: DiscoverabilityStatus;
  id: Scalars['ID'];
  inviteRequest: InviteRequest;
  name: Scalars['String'];
  ownerEmail: Scalars['String'];
};

export type DiscoverableTeamsList = {
  __typename?: 'DiscoverableTeamsList';
  items: Array<DiscoverableTeam>;
};

export type Division = {
  __typename?: 'Division';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** The division override status for a team widget. If enabled, division admins are able to change the settings for their managed divisions. */
export type DivisionAdminOverride = {
  __typename?: 'DivisionAdminOverride';
  /** Determines if the division admin is able to change a widget's settings for their managed divisions. */
  enabled: Scalars['Boolean'];
  /**
   * Determines if this override is inherited from the team and not specifically set for a division.
   * Null for team-level widgets.
   */
  inherited?: Maybe<Scalars['Boolean']>;
};

export type EditOecQuestionTagPayload = {
  __typename?: 'EditOecQuestionTagPayload';
  success: Scalars['Boolean'];
  tag: OecQuestionTag;
};

export type EditTagDataInput = {
  label: Scalars['String'];
  questionId: Scalars['ID'];
  surveyId: Scalars['ID'];
  tagId: Scalars['ID'];
};

export enum EmailDomainRolloutStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Experiment = 'EXPERIMENT',
}

export type EmailQuestionValidation = QuestionValidation & {
  __typename?: 'EmailQuestionValidation';
  errorMessage: Scalars['String'];
  /** EMAIL */
  type: QuestionFieldValidationType;
};

export type EmailRevertPayload = {
  __typename?: 'EmailRevertPayload';
  newEmail: Scalars['String'];
  oldEmail: Scalars['String'];
};

export enum EmailVerificationStatus {
  Deleted = 'DELETED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Unsent = 'UNSENT',
  Verified = 'VERIFIED',
}

export type EnabledCollectorType = CollectorTypeAvailability & {
  __typename?: 'EnabledCollectorType';
  isRecommendedFromBIFM: Scalars['Boolean'];
  type: CollectorType;
};

export type EndPageContents = {
  __typename?: 'EndPageContents';
  bodyText?: Maybe<Scalars['String']>;
  headerText: Scalars['String'];
  image?: Maybe<LibraryImage>;
  imageRedirectUrl?: Maybe<Scalars['String']>;
  logo?: Maybe<LibraryImage>;
};

export type EndPageContentsInput = {
  bodyText?: InputMaybe<Scalars['String']>;
  headerText?: InputMaybe<Scalars['String']>;
  imageAssetId?: InputMaybe<Scalars['ID']>;
  imageRedirectUrl?: InputMaybe<Scalars['String']>;
  logoAssetId?: InputMaybe<Scalars['ID']>;
};

export type EndPageSettingInput = {
  contents?: InputMaybe<EndPageContentsInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
};

/** represents the result of an entity autocomplete query */
export type EntityAutocompleteData = {
  __typename?: 'EntityAutocompleteData';
  matches: Array<Maybe<EntityAutocompleteItem>>;
};

/** represents a single element returned by an autocomplete query */
export type EntityAutocompleteItem = {
  __typename?: 'EntityAutocompleteItem';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** Specifies input for the get entity questions query */
export type EntityQuestionsInput = {
  entityType: Scalars['String'];
};

/** Experiment object */
export type Experiment = {
  __typename?: 'Experiment';
  assignmentType: ExperimentAssignmentType;
  id: Scalars['ID'];
  isDisabled: Scalars['Boolean'];
  name: Scalars['String'];
  treatment: ExperimentTreatment;
};

export enum ExperimentAssignmentType {
  Existing = 'EXISTING',
  New = 'NEW',
  Winner = 'WINNER',
}

/** Treatment assigned to user */
export type ExperimentTreatment = {
  __typename?: 'ExperimentTreatment';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** ExperimentSvc get_assignment V1 response object */
export type ExperimentV1Assignment = {
  __typename?: 'ExperimentV1Assignment';
  assignmentType?: Maybe<ExperimentAssignmentType>;
  setCookies?: Maybe<Array<Maybe<ExperimentV1SetCookie>>>;
  treatmentName?: Maybe<Scalars['String']>;
};

/** Cookie to set as part of the experiment assignment. Usually for LO or preview */
export type ExperimentV1SetCookie = {
  __typename?: 'ExperimentV1SetCookie';
  age: Scalars['Int'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type ExtraPriceInput = {
  surveyLength?: InputMaybe<Scalars['Int']>;
};

export enum FeedbackLevel {
  Category = 'CATEGORY',
  Option = 'OPTION',
}

export type FieldSet = QuestionFieldSet & {
  __typename?: 'FieldSet';
  id: Scalars['ID'];
  label: Scalars['String'];
  visible: Scalars['Boolean'];
};

export type FileFormatValidation = QuestionValidation & {
  __typename?: 'FileFormatValidation';
  errorMessage: Scalars['String'];
  formats: Array<Scalars['String']>;
  /** Can only be FILE_FORMAT */
  type: QuestionFieldValidationType;
};

export type FileUploadQuestionQm = SurveyQuestionQm & {
  __typename?: 'FileUploadQuestionQM';
  createdAt: Scalars['DateTime'];
  family: SurveyQuestionFamily;
  fieldSet: FieldSet;
  hasPiping: Scalars['Boolean'];
  heading: QuestionHeadingConfiguration;
  id: Scalars['ID'];
  instructions?: Maybe<Scalars['String']>;
  layout: RatingDateTimeFileUploadLayoutOptions;
  modifiedAt: Scalars['DateTime'];
  position: QuestionPosition;
  required?: Maybe<QuestionAnswerRequired>;
  validation?: Maybe<FileFormatValidation>;
  variant: SurveyQuestionVariant;
};

export type FontFaceInput = {
  fontFamily?: InputMaybe<Scalars['String']>;
  src?: InputMaybe<Scalars['String']>;
};

export type FontFaceType = {
  __typename?: 'FontFaceType';
  fontFamily?: Maybe<Scalars['String']>;
  src?: Maybe<Scalars['String']>;
};

/** Abstracted common CSS font styles */
export type FontStyle = {
  fontFamily?: Maybe<Scalars['String']>;
  fontSize?: Maybe<Scalars['Int']>;
  fontStyle?: Maybe<FontStyleType>;
  fontWeight?: Maybe<FontWeightType>;
  textDecoration?: Maybe<TextDecorationType>;
};

/** Supported CSS font-style options */
export enum FontStyleType {
  Inherit = 'INHERIT',
  Initial = 'INITIAL',
  Italic = 'ITALIC',
  Normal = 'NORMAL',
  Oblique = 'OBLIQUE',
}

/** Supported CSS font-weight options */
export enum FontWeightType {
  Bold = 'BOLD',
  Light = 'LIGHT',
  Medium = 'MEDIUM',
  Regular = 'REGULAR',
  Ultralight = 'ULTRALIGHT',
}

/** Represents error states in query responses corresponding to 'forbidden' API responses. */
export type ForbiddenError = {
  __typename?: 'ForbiddenError';
  code: ForbiddenErrorCode;
  message?: Maybe<Scalars['String']>;
};

/** Codes for errors corresponding to 'forbidden' error states. */
export enum ForbiddenErrorCode {
  Forbidden = 'FORBIDDEN',
}

export type GenerateOecKeywordTagsInput = {
  questionId: Scalars['ID'];
  surveyId: Scalars['ID'];
  tagIds: Array<Scalars['ID']>;
};

export type GenerateOecKeywordTagsPayload = {
  __typename?: 'GenerateOecKeywordTagsPayload';
  modelId: Scalars['ID'];
  modelVersion: Scalars['String'];
  success: Scalars['Boolean'];
};

export type GroupSurveyLinkDomain = SurveyLinkDomain & {
  __typename?: 'GroupSurveyLinkDomain';
  available: Scalars['Boolean'];
  canonicalName: Scalars['String'];
  customDomainType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  type: SurveyLinkDomainType;
};

export type GroupSurveyLinkDomainSetting = {
  __typename?: 'GroupSurveyLinkDomainSetting';
  default?: Maybe<GroupSurveyLinkDomain>;
  enabled: Scalars['Boolean'];
};

/** Indicates whether the team was set up with the assistance of the sales team, granted complimentarily, or self-service. */
export enum GroupType {
  Complimentary = 'COMPLIMENTARY',
  SalesAssisted = 'SALES_ASSISTED',
  SelfServe = 'SELF_SERVE',
}

export type HeadingImage = {
  __typename?: 'HeadingImage';
  alt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  s3Key?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

/** @deprecated: Will be refactored into common types soon (ENT-5398) */
export type HrisUploadPolicy = {
  __typename?: 'HRISUploadPolicy';
  fields: HrisUploadPolicyFields;
  url: Scalars['String'];
};

/** @deprecated: Will be refactored into common types soon (ENT-5398) */
export type HrisUploadPolicyFields = {
  __typename?: 'HRISUploadPolicyFields';
  accessKeyId: Scalars['String'];
  key: Scalars['String'];
  policy: Scalars['String'];
  signature: Scalars['String'];
};

export type HrisUploadPolicyInput = {
  fileName: Scalars['String'];
};

export type Image = {
  __typename?: 'Image';
  description?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type ImageAnswer = QuestionAnswer & {
  __typename?: 'ImageAnswer';
  id: Scalars['ID'];
  image: ImageAnswerImageDefinition;
  label: Scalars['String'];
  visible: Scalars['Boolean'];
};

export type ImageAnswerImageDefinition = {
  __typename?: 'ImageAnswerImageDefinition';
  altText?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type ImageAsset = {
  thumbnailUrl: Scalars['String'];
  url: Scalars['String'];
};

export type ImageStimuliVariableConfiguration = ProjectVariableConfiguration & {
  __typename?: 'ImageStimuliVariableConfiguration';
  defaultLabel: Scalars['String'];
  enabled: Scalars['Boolean'];
  max: Scalars['Int'];
  min: Scalars['Int'];
};

/** Responses to questions that are not explicityl answers (A/B questions) */
export type ImplicitResponse = {
  __typename?: 'ImplicitResponse';
  variation: RandomAssignmentHeading;
};

export type InputDateRangeInput = {
  endAt?: InputMaybe<Scalars['DateTime']>;
  startAt?: InputMaybe<Scalars['DateTime']>;
};

export enum InsightFeedbackType {
  Apply = 'APPLY',
  BtViewAll = 'BT_VIEW_ALL',
  BtViewQuestion = 'BT_VIEW_QUESTION',
  Click = 'CLICK',
  CtmViewAll = 'CTM_VIEW_ALL',
  Export = 'EXPORT',
  View = 'VIEW',
}

/**
 * Represents error states corresponding to invalid config value input that could
 * not be saved.
 */
export type InvalidConfigValueError = {
  __typename?: 'InvalidConfigValueError';
  code: InvalidConfigValueErrorCode;
  message?: Maybe<Scalars['String']>;
  userMessage?: Maybe<Scalars['String']>;
};

/** Codes for errors corresponding to invalid config value update error states. */
export enum InvalidConfigValueErrorCode {
  InvalidConfigValue = 'INVALID_CONFIG_VALUE',
}

export enum InvalidEmailReason {
  DomainLocked = 'DOMAIN_LOCKED',
  EmailMalformed = 'EMAIL_MALFORMED',
  EmailMisencoded = 'EMAIL_MISENCODED',
  EmailRoleBased = 'EMAIL_ROLE_BASED',
  EmailTooLong = 'EMAIL_TOO_LONG',
  EmailTooShort = 'EMAIL_TOO_SHORT',
}

/**
 * Represents error states in query responses corresponding to 'invalid input' API responses.
 * Used to flag invalid user input.
 */
export type InvalidInputError = {
  __typename?: 'InvalidInputError';
  code: InvalidInputErrorCode;
  /** Optionally indicates which input fields are invalid. */
  field?: Maybe<Array<Scalars['String']>>;
  message?: Maybe<Scalars['String']>;
};

/** Codes for errors corresponding to 'invalid input' error states. */
export enum InvalidInputErrorCode {
  InvalidInput = 'INVALID_INPUT',
}

export type InviteRequest = {
  __typename?: 'InviteRequest';
  createdAt?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  inviteRequestEmail?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  mangledEmail?: Maybe<Scalars['String']>;
  status: TeamInviteRequestStatus;
};

export type InviteRequestsList = {
  __typename?: 'InviteRequestsList';
  items: Array<InviteRequest>;
};

export type IpFilter = {
  __typename?: 'IPFilter';
  type: Scalars['String'];
  value: Array<Scalars['String']>;
};

export type IsEmailValidInput = {
  /**
   * Can an email domain be used that is locked to a group?
   * For example, if a customer has SSO, email addresses from that domain cannot be used
   * for new users because they should be going through SSO instead.
   */
  allowLockedDomain?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  userId?: InputMaybe<Scalars['ID']>;
};

export type IsEmailValidPayload = {
  __typename?: 'IsEmailValidPayload';
  isValid: Scalars['Boolean'];
  reason?: Maybe<InvalidEmailReason>;
};

/** The language details of any type */
export type Language = BaseLanguage & {
  __typename?: 'Language';
  /** Based on ISO 639-1 */
  code: Scalars['String'];
  displayName: Scalars['String'];
  helpLinkCode: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** IETF BCP 47 Language Tag */
export type LanguageTag = BaseLanguage & {
  __typename?: 'LanguageTag';
  /** complete language tag */
  code: Scalars['String'];
  /** Display name of language (if different from name) */
  displayName: Scalars['String'];
  id: Scalars['ID'];
  /** Internal name of language */
  name: Scalars['String'];
  /** ISO 639 code */
  primary: Scalars['String'];
  /** ISO 3166-1 code */
  region?: Maybe<Scalars['String']>;
  /** ISO 15924 code */
  script?: Maybe<Scalars['String']>;
  /** registered variants */
  variant?: Maybe<Scalars['String']>;
};

/** Supported layout options */
export enum LayoutOptionType {
  BackgroundFullTextCenter = 'BACKGROUND_FULL_TEXT_CENTER',
  BackgroundFullTextLeft = 'BACKGROUND_FULL_TEXT_LEFT',
  BackgroundFullTextRight = 'BACKGROUND_FULL_TEXT_RIGHT',
  BackgroundPartialLeftHalf = 'BACKGROUND_PARTIAL_LEFT_HALF',
  BackgroundPartialLeftThird = 'BACKGROUND_PARTIAL_LEFT_THIRD',
  BackgroundPartialRightHalf = 'BACKGROUND_PARTIAL_RIGHT_HALF',
  BackgroundPartialRightThird = 'BACKGROUND_PARTIAL_RIGHT_THIRD',
  BackgroundPartialTopBanner = 'BACKGROUND_PARTIAL_TOP_BANNER',
}

export type LibraryAsset = {
  assetType: LibraryAssetType;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  division?: Maybe<Division>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LibraryAssetDownloadUrlPayload = {
  __typename?: 'LibraryAssetDownloadUrlPayload';
  downloadUrl: Scalars['String'];
  success: Scalars['Boolean'];
};

export type LibraryAssetsList = PaginatedList & {
  __typename?: 'LibraryAssetsList';
  items: Array<LibraryAsset>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum LibraryAssetType {
  Document = 'DOCUMENT',
  EndPage = 'END_PAGE',
  Image = 'IMAGE',
  IntroText = 'INTRO_TEXT',
  Presentation = 'PRESENTATION',
  Question = 'QUESTION',
  Template = 'TEMPLATE',
  Theme = 'THEME',
}

export type LibraryCustomQuestion = LibraryAsset & {
  __typename?: 'LibraryCustomQuestion';
  assetType: LibraryAssetType;
  /** Can the current user use this question */
  canUseQuestion: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  division?: Maybe<Division>;
  id: Scalars['ID'];
  name: Scalars['String'];
  /** A questionType maps to a feature key that is required to use this question */
  questionType?: Maybe<Scalars['String']>;
};

export type LibraryDocument = LibraryAsset & {
  __typename?: 'LibraryDocument';
  assetType: LibraryAssetType;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  division?: Maybe<Division>;
  id: Scalars['ID'];
  name: Scalars['String'];
  s3Key: Scalars['String'];
  url: Scalars['String'];
};

export type LibraryEndPageSetting = TeamWidgetSetting & {
  __typename?: 'LibraryEndPageSetting';
  contents?: Maybe<EndPageContents>;
  divisionOverride?: Maybe<DivisionAdminOverride>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  inherited?: Maybe<Scalars['Boolean']>;
  level: TeamWidgetSettingLevel;
  restriction?: Maybe<TeamWidgetSettingRestriction>;
  type: TeamWidgetType;
};

export type LibraryImage = LibraryAsset & {
  __typename?: 'LibraryImage';
  assetType: LibraryAssetType;
  createdAt: Scalars['DateTime'];
  defaultInDivisions?: Maybe<Array<Division>>;
  description?: Maybe<Scalars['String']>;
  division?: Maybe<Division>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
  s3Key: Scalars['String'];
  thumbnails: LibraryImageThumbnails;
  url: Scalars['String'];
};

export enum LibraryImageAlignType {
  Center = 'CENTER',
  Left = 'LEFT',
  Right = 'RIGHT',
}

/** Determines the default logo used for surveys created by team and division members. */
export type LibraryImageSetting = TeamWidgetSetting & {
  __typename?: 'LibraryImageSetting';
  altText?: Maybe<Scalars['String']>;
  divisionOverride?: Maybe<DivisionAdminOverride>;
  id: Scalars['ID'];
  image?: Maybe<LibraryImage>;
  inherited?: Maybe<Scalars['Boolean']>;
  isAltTextEnabled: Scalars['Boolean'];
  level: TeamWidgetSettingLevel;
  restriction?: Maybe<TeamWidgetSettingRestriction>;
  sizeType: LibraryImageSizeType;
  type: TeamWidgetType;
  verticalAlign: LibraryImageAlignType;
};

export enum LibraryImageSizeType {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Original = 'ORIGINAL',
  Small = 'SMALL',
}

export type LibraryImageThumbnails = {
  __typename?: 'LibraryImageThumbnails';
  medium: Scalars['String'];
  small: Scalars['String'];
};

export type LibraryPresentation = LibraryAsset & {
  __typename?: 'LibraryPresentation';
  assetType: LibraryAssetType;
  createdAt: Scalars['DateTime'];
  defaultInDivisions?: Maybe<Array<Division>>;
  description?: Maybe<Scalars['String']>;
  division?: Maybe<Division>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
  s3Key: Scalars['String'];
  url: Scalars['String'];
};

/** Determines the default presentation template used for exporting responses of surveys created by team and division members. */
export type LibraryPresentationSetting = TeamWidgetSetting & {
  __typename?: 'LibraryPresentationSetting';
  divisionOverride?: Maybe<DivisionAdminOverride>;
  id: Scalars['ID'];
  inherited?: Maybe<Scalars['Boolean']>;
  level: TeamWidgetSettingLevel;
  presentation?: Maybe<LibraryPresentation>;
  restriction?: Maybe<TeamWidgetSettingRestriction>;
  type: TeamWidgetType;
};

export enum LibraryRestriction {
  Enforce = 'ENFORCE',
  Library = 'LIBRARY',
  None = 'NONE',
}

export enum LibrarySortBy {
  AssetType = 'ASSET_TYPE',
  CreatedAt = 'CREATED_AT',
  Division = 'DIVISION',
  Name = 'NAME',
}

export type LibrarySurveyTemplate = LibraryAsset & {
  __typename?: 'LibrarySurveyTemplate';
  assetType: LibraryAssetType;
  /** Can the current user use this template */
  canUseTemplate: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  division?: Maybe<Division>;
  id: Scalars['ID'];
  links: SurveyLinks;
  /**
   * A list of missing feature keys that the current user would need
   * to use this template
   */
  missingRequiredFeatures: Array<Scalars['String']>;
  name: Scalars['String'];
  survey: Survey;
  /**
   * The Id of the underlying template that can be used when creating new surveys
   * from the  library survey template
   */
  templateId: Scalars['ID'];
};

/** Determines the default template used for surveys created by team and division members. */
export type LibraryTemplateSetting = TeamWidgetSetting & {
  __typename?: 'LibraryTemplateSetting';
  divisionOverride?: Maybe<DivisionAdminOverride>;
  id: Scalars['ID'];
  inherited?: Maybe<Scalars['Boolean']>;
  level: TeamWidgetSettingLevel;
  restriction?: Maybe<TeamWidgetSettingRestriction>;
  type: TeamWidgetType;
};

/** Determines the intro text used for surveys created by team and division members. */
export type LibraryTextSetting = TeamWidgetSetting & {
  __typename?: 'LibraryTextSetting';
  divisionOverride?: Maybe<DivisionAdminOverride>;
  id: Scalars['ID'];
  inherited?: Maybe<Scalars['Boolean']>;
  level: TeamWidgetSettingLevel;
  restriction?: Maybe<TeamWidgetSettingRestriction>;
  textSettings?: Maybe<Array<TextSetting>>;
  type: TeamWidgetType;
};

export type LibraryTheme = LibraryAsset & {
  __typename?: 'LibraryTheme';
  assetType: LibraryAssetType;
  createdAt: Scalars['DateTime'];
  defaultInDivisions?: Maybe<Array<Division>>;
  description?: Maybe<Scalars['String']>;
  division?: Maybe<Division>;
  id: Scalars['ID'];
  isCSSTheme: Scalars['Boolean'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
  theme: SurveyThemeType;
};

/** Determines the default theme used for surveys created by team and division members. */
export type LibraryThemeSetting = TeamWidgetSetting & {
  __typename?: 'LibraryThemeSetting';
  divisionOverride?: Maybe<DivisionAdminOverride>;
  id: Scalars['ID'];
  inherited?: Maybe<Scalars['Boolean']>;
  level: TeamWidgetSettingLevel;
  restriction?: Maybe<TeamWidgetSettingRestriction>;
  theme?: Maybe<ThemeAsset>;
  type: TeamWidgetType;
};

export type LinkedAccount = {
  __typename?: 'LinkedAccount';
  /** the source of the oauth account, e.g., "google", "microsoft", "facebook" */
  authSource: Scalars['String'];
};

export type LinkedIdentities = {
  __typename?: 'LinkedIdentities';
  items: Array<LinkedIdentity>;
  totalCount: Scalars['Int'];
};

export type LinkedIdentitiesItemsArgs = {
  filter?: InputMaybe<LinkedIdentityTypeFilter>;
};

/**
 * Represents a SurveyMonkey user linked to the logged-in user's Auth0 identity.
 * This type is powered by the same service data object as the User type, but
 * LinkedIdentity is a separate type so it's easier to limit/reason about what
 * it can reach.
 */
export type LinkedIdentity = {
  __typename?: 'LinkedIdentity';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastLoggedInAt: Scalars['DateTime'];
  lastName?: Maybe<Scalars['String']>;
  package: PricingExperiencePackage;
  packageId: Scalars['String'];
  teamName?: Maybe<Scalars['String']>;
  username: Scalars['String'];
};

/** Allows the list of returned identities to be filtered */
export enum LinkedIdentityTypeFilter {
  /** Return all identities. */
  All = 'ALL',
  /** Return only identities that are linked to a Contribute account. */
  Contribute = 'CONTRIBUTE',
}

export type LocalizedPackagePricing = PackageBase & {
  __typename?: 'LocalizedPackagePricing';
  addons: Array<ProductPricingMetadata>;
  canonicalName: Scalars['String'];
  coreProducts: Array<ProductPricingMetadata>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  label: Scalars['String'];
  locale: Scalars['String'];
  renewalInterval: RenewalType;
  renewalIntervalCount: Scalars['Int'];
};

/** represents the result of a location autocomplete query */
export type LocationAutocompleteData = {
  __typename?: 'LocationAutocompleteData';
  matches: Array<Maybe<LocationAutocompleteItem>>;
};

/** represents a single element returned by a location autocomplete query */
export type LocationAutocompleteItem = {
  __typename?: 'LocationAutocompleteItem';
  location: Scalars['String'];
};

/**
 * LookerAuth is a type that holds the signed Looker authorization
 * information for the current user.
 * It is in a url format that should be passed to the Looker SDK
 */
export type LookerAuth = {
  __typename?: 'LookerAuth';
  locale: Scalars['String'];
  url: Scalars['String'];
};

export type LookerExportResponse = {
  __typename?: 'LookerExportResponse';
  /**
   * The backend is returning the content-type of the resulting export from looker
   * which we will use on the front end for specifying the content-type for the file
   * download.
   */
  contentType: Scalars['String'];
  /** moduleapi currently sends the raw file from looker in the specified format as a string */
  rawFileData: Scalars['String'];
};

/**
 * LookerQuery is a type that defines what information we want Looker
 * to export data for.
 */
export type LookerQuery = {
  dynamicFields?: InputMaybe<Scalars['String']>;
  fields: Array<Scalars['String']>;
  filters: Scalars['String'];
  limit: Scalars['Int'];
  pivots?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sorts: Array<Scalars['String']>;
  total?: InputMaybe<Scalars['Boolean']>;
};

export type LookerQueryTask = {
  __typename?: 'LookerQueryTask';
  /** The content-type of the stringified data. */
  contentType?: Maybe<Scalars['String']>;
  /** The stringified data. Returns when the task is completed */
  rawFileData?: Maybe<Scalars['String']>;
  /** Status of the task. running / error / completed */
  status: Scalars['String'];
  /** The ID of the task */
  taskId: Scalars['ID'];
};

export type MarketingEmailPreferences = {
  __typename?: 'MarketingEmailPreferences';
  customerOpportunities: Scalars['Boolean'];
  dataStories: Scalars['Boolean'];
  newsletter: Scalars['Boolean'];
  productResearch: Scalars['Boolean'];
  purchaseInquiries: Scalars['Boolean'];
  surveyBestPractices: Scalars['Boolean'];
};

export type MarketingEmailPreferencesInput = {
  customerOpportunities: Scalars['Boolean'];
  dataStories: Scalars['Boolean'];
  newsletter: Scalars['Boolean'];
  productResearch: Scalars['Boolean'];
  purchaseInquiries: Scalars['Boolean'];
  surveyBestPractices: Scalars['Boolean'];
};

export type MarketMeasurementCategoricalQuestionInsight = MarketMeasurementQuestionInsight & {
  __typename?: 'MarketMeasurementCategoricalQuestionInsight';
  filters: Array<MarketMeasurementMetricFilterSet>;
  metric: MmsMetricType;
  question: SurveyQuestion;
};

export type MarketMeasurementInsightsPayload = {
  __typename?: 'MarketMeasurementInsightsPayload';
  id: Scalars['ID'];
  questionInsights: Array<MarketMeasurementQuestionInsight>;
  surveyInsightsHigh: Array<MarketMeasurementSurveyInsight>;
  surveyInsightsLow: Array<MarketMeasurementSurveyInsight>;
  surveyInsightsOther: Array<MarketMeasurementSurveyInsight>;
};

export type MarketMeasurementMetricFilterSet = {
  __typename?: 'MarketMeasurementMetricFilterSet';
  answerOptions: Array<SurveyQuestionOption>;
  filter: Array<QuestionFilterConfiguration>;
  id: Scalars['ID'];
  percentChange: Scalars['Float'];
  score: Scalars['Float'];
  subGroupResponseCount: Scalars['Int'];
};

export type MarketMeasurementOrdinalQuestionInsight = MarketMeasurementQuestionInsight & {
  __typename?: 'MarketMeasurementOrdinalQuestionInsight';
  highFilters: Array<MarketMeasurementMetricFilterSet>;
  lowFilters: Array<MarketMeasurementMetricFilterSet>;
  metric: MmsMetricType;
  question: SurveyQuestion;
};

export type MarketMeasurementQuestionInsight = {
  metric: MmsMetricType;
  question: SurveyQuestion;
};

export type MarketMeasurementSolutionsAttribute = {
  __typename?: 'MarketMeasurementSolutionsAttribute';
  id: Scalars['ID'];
  project: MarketMeasurementSolutionsProject;
  question: AttributeQuestion;
};

/**
 * All the possible values that can be used as a rank param on the
 * MarketMeasurementSolutionsPerformanceScoreInput input. The rank represents the scale of
 * the single-choice likert question driver attributes provided; all must be of the same rank.
 */
export enum MarketMeasurementSolutionsAttributeRank {
  Five = 'FIVE',
  Four = 'FOUR',
  Seven = 'SEVEN',
  Six = 'SIX',
  Three = 'THREE',
  Two = 'TWO',
}

export type MarketMeasurementSolutionsKeyDriver = UseCaseKeyDriver & {
  __typename?: 'MarketMeasurementSolutionsKeyDriver';
  attribute: MarketMeasurementSolutionsAttribute;
  correlation?: Maybe<Scalars['Float']>;
};

/** Performance score for a market measurement solutions project */
export type MarketMeasurementSolutionsPerformanceScore = {
  __typename?: 'MarketMeasurementSolutionsPerformanceScore';
  attribute: AttributeQuestion;
  percentage: Scalars['Float'];
};

export type MarketMeasurementSolutionsPerformanceScoreInput = {
  drivers: Array<Scalars['ID']>;
  filter?: InputMaybe<AnalysisFilterInput>;
  projectId: Scalars['ID'];
  rank: MarketMeasurementSolutionsAttributeRank;
};

export type MarketMeasurementSolutionsProject = Project & {
  __typename?: 'MarketMeasurementSolutionsProject';
  /** A list of variable values related to the project */
  answers: ProjectVariableAnswerList;
  /** List of tagged attribute questions present on the project survey */
  attributes: Array<Maybe<MarketMeasurementSolutionsAttribute>>;
  /** Entity of the audience collector(s) created for the project */
  audienceCollector?: Maybe<ProjectAudienceCollectorEntity>;
  audienceCollectors: Array<Maybe<ProjectAudienceCollectorEntity>>;
  /** List of variable collections associated with the module type */
  collections: ProjectVariableCollectionList;
  /** Time the project was created */
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  /** State related URLs as generated by moduleapi for this project */
  links: ProjectLinks;
  /** Schema data for the module used to create this project */
  module: Module;
  /** The current price of the project */
  price?: Maybe<ProjectPrice>;
  /** Current lifecycle status of the project */
  status: ProjectStatus;
  /** The type of MMS project the project is */
  subtype: ModuleSubType;
  /** Entity of the survey created for the project */
  survey?: Maybe<ProjectSurveyEntity>;
  /** List of templates associated with the module type */
  templates: ProjectTemplateList;
  /** Title of the MMS project */
  title: Scalars['String'];
  /** The type of module the project is. Will always be "MMS" */
  type: ModuleType;
};

export type MarketMeasurementSolutionsProjectAnswersArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type MarketMeasurementSolutionsProjectCollectionsArgs = {
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type MarketMeasurementSolutionsProjectPriceArgs = {
  extraPriceArgs?: InputMaybe<ExtraPriceInput>;
};

export type MarketMeasurementSolutionsProjectTemplatesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type MarketMeasurementSurveyInsight = {
  __typename?: 'MarketMeasurementSurveyInsight';
  filter: MarketMeasurementMetricFilterSet;
  metric: MmsMetricType;
  question: SurveyQuestion;
  rankingScore: Scalars['Float'];
};

export type MasterScorecard = {
  __typename?: 'MasterScorecard';
  id: Scalars['ID'];
  project: ConceptTestingProject;
  rows: Array<Array<MasterScorecardCell>>;
  stimuli: ConceptTestingStimuli;
  totalResponses: Scalars['Int'];
};

export type MasterScorecardCell = {
  __typename?: 'MasterScorecardCell';
  higherSignificance: Array<ConceptTestingStimulus>;
  isSignificant?: Maybe<Scalars['Boolean']>;
  lowerSignificance: Array<ConceptTestingStimulus>;
  percentage?: Maybe<Scalars['Float']>;
};

export type MatrixContactLayoutOptions = {
  __typename?: 'MatrixContactLayoutOptions';
  labelWidthPercent: Scalars['Int'];
  placement: QuestionLayoutPlacement;
  spacing: QuestionLayoutSpacingOptions;
  width: QuestionLayoutWidthOptions;
};

export type MatrixManyAnswersQuestionBankQuestionQm = QuestionBankQuestion & {
  __typename?: 'MatrixManyAnswersQuestionBankQuestionQM';
  answerOther?: Maybe<AnswerOther>;
  answers: Array<ChoiceAnswer>;
  heading: QuestionBankHeading;
  id: Scalars['ID'];
  logicalLink: QuestionBankLogicalLink;
};

/**
 * matrix question type
 * contains rows, columns and other fields
 * we can also use options field to fetch both rows, columns and other
 */
export type MatrixQuestion = SurveyQuestion & {
  __typename?: 'MatrixQuestion';
  absolutePosition: Scalars['Int'];
  /** Analytics for matrix questions. */
  analytics: Analytics2D;
  columns?: Maybe<SurveyQuestionColumnList>;
  displayNumber: Scalars['Int'];
  displayOptions: SurveyQuestionDisplayOptions;
  headers: Array<SurveyQuestionHeader>;
  id: Scalars['ID'];
  isAudience: Scalars['Boolean'];
  nickname: Scalars['String'];
  options?: Maybe<SurveyQuestionOptionList>;
  other?: Maybe<SurveyQuestionOther>;
  pageId: Scalars['ID'];
  position: Scalars['Int'];
  questionTemplate?: Maybe<MatrixQuestionTemplate>;
  responseSummary?: Maybe<QuestionResponseSummary>;
  rows?: Maybe<SurveyQuestionRowList>;
  type: SurveyQuestionType;
  validation: SurveyQuestionValidationOptions;
  visible: Scalars['Boolean'];
};

/**
 * matrix question type
 * contains rows, columns and other fields
 * we can also use options field to fetch both rows, columns and other
 */
export type MatrixQuestionAnalyticsArgs = {
  filter?: InputMaybe<AnalysisFilterInput>;
};

/**
 * matrix question type
 * contains rows, columns and other fields
 * we can also use options field to fetch both rows, columns and other
 */
export type MatrixQuestionColumnsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/**
 * matrix question type
 * contains rows, columns and other fields
 * we can also use options field to fetch both rows, columns and other
 */
export type MatrixQuestionOptionsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/**
 * matrix question type
 * contains rows, columns and other fields
 * we can also use options field to fetch both rows, columns and other
 */
export type MatrixQuestionRowsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type MatrixQuestionManyAnswersQm = SurveyQuestionQm & {
  __typename?: 'MatrixQuestionManyAnswersQM';
  answerOther?: Maybe<AnswerOther>;
  answers: Array<ChoiceAnswer>;
  createdAt: Scalars['DateTime'];
  family: SurveyQuestionFamily;
  fieldSets: Array<FieldSet>;
  hasPiping: Scalars['Boolean'];
  heading: QuestionHeadingConfiguration;
  id: Scalars['ID'];
  layout: MatrixContactLayoutOptions;
  modifiedAt: Scalars['DateTime'];
  position: QuestionPosition;
  questionBank?: Maybe<QuestionBankConnection>;
  required?: Maybe<QuestionAnswerRequired>;
  sorting?: Maybe<QuestionSorting>;
  variant: SurveyQuestionVariant;
};

export type MatrixQuestionSingleAnswerQm = SurveyQuestionQm & {
  __typename?: 'MatrixQuestionSingleAnswerQM';
  answerNA?: Maybe<ChoiceAnswer>;
  answerOther?: Maybe<AnswerOther>;
  answersWeighted: Array<WeightedAnswer>;
  createdAt: Scalars['DateTime'];
  family: SurveyQuestionFamily;
  fieldSets: Array<FieldSet>;
  hasPiping: Scalars['Boolean'];
  heading: QuestionHeadingConfiguration;
  id: Scalars['ID'];
  isForcedRanking: Scalars['Boolean'];
  isWeighted: Scalars['Boolean'];
  layout: MatrixContactLayoutOptions;
  modifiedAt: Scalars['DateTime'];
  position: QuestionPosition;
  questionBank?: Maybe<QuestionBankConnection>;
  required?: Maybe<QuestionAnswerRequired>;
  sorting?: Maybe<QuestionSorting>;
  variant: SurveyQuestionVariant;
};

export type MatrixQuestionTemplate = SurveyQuestionTemplate & {
  __typename?: 'MatrixQuestionTemplate';
  attributes: Array<SurveyQuestionTemplateAttribute>;
  columns: Array<SurveyQuestionTemplateColumn>;
  heading: Scalars['String'];
  id: Scalars['ID'];
  logicalLink: SurveyQuestionTemplateLogicalLink;
  modifiers: Array<SurveyQuestionTemplateModifier>;
  other?: Maybe<SurveyQuestionTemplateOther>;
  rows: Array<SurveyQuestionTemplateRow>;
};

export type MatrixSingleAnswerQuestionBankQuestionQm = QuestionBankQuestion & {
  __typename?: 'MatrixSingleAnswerQuestionBankQuestionQM';
  answerNA?: Maybe<ChoiceAnswer>;
  answerOther?: Maybe<AnswerOther>;
  answersWeighted: Array<WeightedAnswer>;
  heading: QuestionBankHeading;
  id: Scalars['ID'];
  isWeighted: Scalars['Boolean'];
  logicalLink: QuestionBankLogicalLink;
};

export enum MembershipSeatType {
  Casual = 'CASUAL',
  Contributor = 'CONTRIBUTOR',
  Full = 'FULL',
}

export type MenuMatrixQuestionBankQuestionQm = QuestionBankQuestion & {
  __typename?: 'MenuMatrixQuestionBankQuestionQM';
  answerNA?: Maybe<ChoiceAnswer>;
  answerOther?: Maybe<AnswerOther>;
  answersNested: Array<NestedAnswer>;
  heading: QuestionBankHeading;
  id: Scalars['ID'];
  logicalLink: QuestionBankLogicalLink;
};

export type MenuMatrixQuestionQm = SurveyQuestionQm & {
  __typename?: 'MenuMatrixQuestionQM';
  answerOther?: Maybe<AnswerOther>;
  answersNested: Array<NestedAnswer>;
  createdAt: Scalars['DateTime'];
  family: SurveyQuestionFamily;
  fieldSets: Array<FieldSet>;
  hasPiping: Scalars['Boolean'];
  heading: QuestionHeadingConfiguration;
  id: Scalars['ID'];
  layout: RankingMenuMatrixLayoutOptions;
  modifiedAt: Scalars['DateTime'];
  position: QuestionPosition;
  questionBank?: Maybe<QuestionBankConnection>;
  required?: Maybe<QuestionAnswerRequired>;
  sorting?: Maybe<QuestionSorting>;
  variant: SurveyQuestionVariant;
};

export enum MmsMetricType {
  AttributeEvaluation = 'ATTRIBUTE_EVALUATION',
  AttributeImportance = 'ATTRIBUTE_IMPORTANCE',
  Behavioral = 'BEHAVIORAL',
  CompetitorInfo = 'COMPETITOR_INFO',
  Custom = 'CUSTOM',
  Demographic = 'DEMOGRAPHIC',
  Ecommerce = 'ECOMMERCE',
  FrequencyOfUse = 'FREQUENCY_OF_USE',
  FrequencyOfUseHypothetical = 'FREQUENCY_OF_USE_HYPOTHETICAL',
  Geographic = 'GEOGRAPHIC',
  ProductUse = 'PRODUCT_USE',
  Psychographic = 'PSYCHOGRAPHIC',
  PurchaseApproaches = 'PURCHASE_APPROACHES',
  PurchaseBehaviors = 'PURCHASE_BEHAVIORS',
  PurchaseBehaviorsInfluence = 'PURCHASE_BEHAVIORS_INFLUENCE',
  PurchaseFrequency = 'PURCHASE_FREQUENCY',
  PurchaseInfluencers = 'PURCHASE_INFLUENCERS',
  PurchaseIntent = 'PURCHASE_INTENT',
  Recognition = 'RECOGNITION',
  UnknownMetric = 'UNKNOWN_METRIC',
}

export type Module = {
  __typename?: 'Module';
  description: Scalars['String'];
  id: Scalars['ID'];
  image: Scalars['String'];
  links: ModuleLinks;
  meta?: Maybe<ModuleMetaInfo>;
  price: ModulePricing;
  subtype: ModuleSubType;
  tagline: Scalars['String'];
  title: Scalars['String'];
  type: ModuleType;
};

export type ModuleAttribute = {
  __typename?: 'ModuleAttribute';
  isBenchmarkable: Scalars['Boolean'];
  isSelected: Scalars['Boolean'];
  label: Scalars['String'];
  question?: Maybe<SurveyQuestionTemplate>;
  questionBankCanonicalName: Scalars['String'];
};

export type ModuleCustomQuestionsAfterStimuli = {
  __typename?: 'ModuleCustomQuestionsAfterStimuli';
  canonicalName: Scalars['String'];
  label: Scalars['String'];
};

export type ModuleCustomQuestionsBeforeStimuli = {
  __typename?: 'ModuleCustomQuestionsBeforeStimuli';
  canonicalName: Scalars['String'];
  label: Scalars['String'];
};

export type ModuleItemizedPricing = {
  __typename?: 'ModuleItemizedPricing';
  costPerBenchmark: Scalars['Int'];
};

export type ModuleLinks = {
  __typename?: 'ModuleLinks';
  marketingPage?: Maybe<Scalars['String']>;
};

export type ModuleList = {
  __typename?: 'ModuleList';
  items: Array<Module>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ModuleMetaInfo = {
  __typename?: 'ModuleMetaInfo';
  preview?: Maybe<ModuleMetaPreview>;
};

export type ModuleMetaPreview = {
  __typename?: 'ModuleMetaPreview';
  id: Scalars['ID'];
};

export type ModulePricing = {
  __typename?: 'ModulePricing';
  cost: Scalars['Float'];
  currency: Scalars['String'];
  itemized?: Maybe<ModuleItemizedPricing>;
  locale: Scalars['String'];
};

export type ModuleStimuliComparison = {
  __typename?: 'ModuleStimuliComparison';
  header: Scalars['String'];
};

export enum ModuleSubType {
  Ad = 'AD',
  ConsumerBehavior = 'CONSUMER_BEHAVIOR',
  ConsumerSegmentation = 'CONSUMER_SEGMENTATION',
  Logo = 'LOGO',
  Message = 'MESSAGE',
  Name = 'NAME',
  Package = 'PACKAGE',
  Product = 'PRODUCT',
  Screener = 'SCREENER',
  UsageAndAttitudes = 'USAGE_AND_ATTITUDES',
  Video = 'VIDEO',
}

export enum ModuleType {
  ConceptTesting = 'CONCEPT_TESTING',
  Mms = 'MMS',
}

export enum MultipleChoiceAnswerLayout {
  Horizontal = 'HORIZONTAL',
  ThreeColumns = 'THREE_COLUMNS',
  TwoColumns = 'TWO_COLUMNS',
  Vertical = 'VERTICAL',
}

export type MultipleChoiceImageQuestionQm = SurveyQuestionQm & {
  __typename?: 'MultipleChoiceImageQuestionQM';
  answerNA?: Maybe<ChoiceAnswer>;
  answersImage: Array<ImageAnswer>;
  createdAt: Scalars['DateTime'];
  family: SurveyQuestionFamily;
  hasPiping: Scalars['Boolean'];
  heading: QuestionHeadingConfiguration;
  id: Scalars['ID'];
  modifiedAt: Scalars['DateTime'];
  position: QuestionPosition;
  quiz?: Maybe<Quiz>;
  required?: Maybe<QuestionAnswerRequired>;
  skipLogicRules: Array<QuestionSkipLogicRule>;
  sorting?: Maybe<QuestionSorting>;
  variant: SurveyQuestionVariant;
};

export type MultipleChoiceLayoutOptions = {
  __typename?: 'MultipleChoiceLayoutOptions';
  answerLayout: MultipleChoiceAnswerLayout;
  placement: QuestionLayoutPlacement;
  spacing: QuestionLayoutSpacingOptions;
  width: QuestionLayoutWidthOptions;
};

export type MultipleChoiceQuestion = SurveyQuestion & {
  __typename?: 'MultipleChoiceQuestion';
  absolutePosition: Scalars['Int'];
  /** Analytics for multiple choice questions. */
  analytics: Analytics1D;
  displayNumber: Scalars['Int'];
  displayOptions: SurveyQuestionDisplayOptions;
  headers: Array<SurveyQuestionHeader>;
  id: Scalars['ID'];
  isAudience: Scalars['Boolean'];
  nickname: Scalars['String'];
  options?: Maybe<SurveyQuestionOptionList>;
  other?: Maybe<SurveyQuestionOther>;
  pageId: Scalars['ID'];
  position: Scalars['Int'];
  questionTemplate?: Maybe<MultipleChoiceQuestionTemplate>;
  responseSummary?: Maybe<QuestionResponseSummary>;
  rows?: Maybe<SurveyQuestionRowList>;
  type: SurveyQuestionType;
  validation: SurveyQuestionValidationOptions;
  visible: Scalars['Boolean'];
};

export type MultipleChoiceQuestionAnalyticsArgs = {
  filter?: InputMaybe<AnalysisFilterInput>;
};

export type MultipleChoiceQuestionOptionsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type MultipleChoiceQuestionRowsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type MultipleChoiceQuestionBankQuestionQm = QuestionBankQuestion & {
  __typename?: 'MultipleChoiceQuestionBankQuestionQM';
  answerOther?: Maybe<AnswerOther>;
  answers: Array<ChoiceAnswer>;
  heading: QuestionBankHeading;
  id: Scalars['ID'];
  logicalLink: QuestionBankLogicalLink;
};

export type MultipleChoiceQuestionQm = SurveyQuestionQm & {
  __typename?: 'MultipleChoiceQuestionQM';
  answerNA?: Maybe<ChoiceAnswer>;
  answerOther?: Maybe<AnswerOther>;
  answers: Array<ChoiceAnswer>;
  createdAt: Scalars['DateTime'];
  family: SurveyQuestionFamily;
  hasPiping: Scalars['Boolean'];
  heading: QuestionHeadingConfiguration;
  id: Scalars['ID'];
  layout: MultipleChoiceLayoutOptions;
  modifiedAt: Scalars['DateTime'];
  position: QuestionPosition;
  questionBank?: Maybe<QuestionBankConnection>;
  quiz?: Maybe<Quiz>;
  required?: Maybe<QuestionAnswerRequired>;
  skipLogicRules: Array<QuestionSkipLogicRule>;
  sorting?: Maybe<QuestionSorting>;
  validation?: Maybe<QuestionValidation>;
  variant: SurveyQuestionVariant;
};

export type MultipleChoiceQuestionTemplate = SurveyQuestionTemplate & {
  __typename?: 'MultipleChoiceQuestionTemplate';
  attributes: Array<SurveyQuestionTemplateAttribute>;
  heading: Scalars['String'];
  id: Scalars['ID'];
  logicalLink: SurveyQuestionTemplateLogicalLink;
  modifiers: Array<SurveyQuestionTemplateModifier>;
  other?: Maybe<SurveyQuestionTemplateOther>;
  rows: Array<SurveyQuestionTemplateRow>;
};

export type MultipleComparisonQuestion =
  | MultipleChoiceQuestion
  | SingleChoiceQuestion;

export type Mutation = {
  __typename?: 'Mutation';
  /** Create a new billing contact for the specified user+partner */
  addBillingContact: BasicMutationPayload;
  /** Add a chart to a dashboard */
  addChartToTrackingDashboard: BasicMutationPayload;
  /**
   * Add a logo to a survey if one is found based on the user's email domain
   * @deprecated Clearbit deprecation CREATE-18066
   */
  addSuggestedLogoToSurvey?: Maybe<AddSuggestedLogoToSurveyPayload>;
  /**
   * This associates a user's collector with one of their saved Audience configurations. This makes it so
   * the given saved configuration will persist with any Audience projects it is applied to.
   */
  associateCollectorWithAudienceSavedFavorite: BasicMutationPayload;
  audienceGeniusFeedbackV2?: Maybe<AudienceGeniusFeedbackPayload>;
  /** Returns true if the invoice was successfully authorized */
  authorizeAudienceBulkInvoice: Scalars['Boolean'];
  authorizeAudienceInvoice: AudienceProjectInvoicePayload;
  /** Bulk transfer a list of surveys to a new user */
  bulkTransferSurveys: BulkTransferSurveyResult;
  /** Returns true if the invoice was successfully cancelled */
  cancelAudienceBulkInvoice: BasicMutationPayload;
  cancelAudienceInvoice: AudienceProjectInvoicePayload;
  /** Delete your own seat request */
  cancelSeatRequest: BasicMutationPayload;
  /** Cancel an existing team invitation */
  cancelTeamInvite: BasicMutationPayload;
  copyLibraryAsset?: Maybe<CopyLibraryAssetPayload>;
  /** Copy an existing survey */
  copySurvey?: Maybe<CreateSurveyPayload>;
  copyTheme?: Maybe<CopyThemePayload>;
  createAudienceProject: CreateAudienceProjectPayload;
  createAudienceProjectBulkInvoice: Array<AudienceProjectInvoice>;
  /**
   * This cookie string is created in the audienceProjectFeasibility call and is used to move a project created
   * by the Audience preview page between dissimilar apps. The value is encoded so we need to have a special call
   * to do the decoding and project creation here. In general, this call should only be used by the
   * Audience team; if you need it, make sure to reach out to somebody on Audience demand first.
   */
  createAudienceProjectFromSnapshotCookie: AudienceProject;
  createAudienceProjectInvoice: AudienceProjectInvoicePayload;
  /** Saves a new Audience configuration under the current user. */
  createAudienceSavedFavorite: AudienceSavedFavorite;
  /** Create a cart */
  createCart: CartPayload;
  createChartResponsesExport?: Maybe<CreateAnalysisExportJobPayload>;
  createCollector?: Maybe<CreateCollectorPayload>;
  createConceptTestingCrossTabReport?: Maybe<
    CreateConceptTestingCrossTabReportPayload
  >;
  createConceptTestingResponsesExport?: Maybe<CreateAnalysisExportJobPayload>;
  createCrossTabReport?: Maybe<CreateCrossTabReportPayload>;
  createDEIResponseUploadPolicy: HrisUploadPolicy;
  createDemoProject?: Maybe<CreateProjectPayload>;
  /** Create a survey using SurveyMonkey Genius to substitute keywords, add a logo, and apply a theme */
  createGeniusSurvey?: Maybe<CreateSurveyPayload>;
  createHRISUploadPolicy: HrisUploadPolicy;
  createInsightFeedback?: Maybe<BasicMutationPayload>;
  createLibraryDocument?: Maybe<CreateLibraryAssetPayload>;
  createLibraryImage?: Maybe<CreateLibraryAssetPayload>;
  createLibraryPresentation?: Maybe<CreateLibraryAssetPayload>;
  createLibraryThemeAsset?: Maybe<CreateLibraryAssetPayload>;
  createLibraryUploadPolicy?: Maybe<CreateLibraryUploadPolicyPayload>;
  /** Create a tracking dashboard */
  createLookerQueryTask: CreateLookerQueryTaskPayload;
  /** Create a job */
  createOecJob: CreateOecJobPayload;
  /** Create a question tag */
  createOecQuestionTag: CreateOecQuestionTagPayload;
  /** Create a tag associated to response. */
  createOecTagsForResponse: OecTagResponsePayload;
  createProject?: Maybe<CreateProjectPayload>;
  createProjectInvoice?: Maybe<CreateProjectInvoicePayload>;
  createQuestionResponsesExport?: Maybe<CreateAnalysisExportJobPayload>;
  createScreeningQuestionMetadata?: Maybe<
    CreateScreeningQuestionMetadataPayload
  >;
  /** Request access to upgrade your seat to a power user seat. */
  createSeatRequest: SeatRequestPayload;
  createSharedView?: Maybe<SharedViewPayload>;
  createStimuliUploadPolicy?: Maybe<CreateFileUploadPostPolicyPayload>;
  /** Create a new survey */
  createSurvey?: Maybe<CreateSurveyPayload>;
  /** Copy a survey from the current user's team library */
  createSurveyFromTeamSurvey?: Maybe<CreateSurveyPayload>;
  /** Create a survey from a copy of a template */
  createSurveyFromTemplate?: Maybe<CreateSurveyPayload>;
  createSurveyLogoUploadPolicy?: Maybe<CreateFileUploadPolicyPayload>;
  createSurveyLogoUploadPostPolicy?: Maybe<CreateFileUploadPostPolicyPayload>;
  createSurveyResponsesExport?: Maybe<CreateAnalysisExportJobPayload>;
  createSurveyTemplateAsset?: Maybe<CreateLibraryAssetPayload>;
  /** Create a invitation for a user to join the team or for member reassignment */
  createTeamInvites: CreateTeamInvitePayload;
  /** Create a tracking dashboard */
  createTrackingDashboard?: Maybe<CreateTrackingDashboardPayload>;
  /** Create a single tracking shared dashboard session */
  createTrackingSharedDashboardAuthSession?: Maybe<
    CreateTrackingSharedDashboardAuthSessionPayload
  >;
  createUseCaseCustomAttribute?: Maybe<UseCaseAttributeReponsePayload>;
  createUseCaseResponsesExport?: Maybe<CreateAnalysisExportJobPayload>;
  /** Submit user selection for rbp bundle */
  createUserAddOnSelection?: Maybe<RbpUserAddOnProductSelection>;
  createWordCloudResponsesExport?: Maybe<CreateAnalysisExportJobPayload>;
  deleteAnalysisExportJob?: Maybe<DeleteAnalysisExportJobPayload>;
  /** Deletes an audience project and its collector by a given collectorId */
  deleteAudienceProject: BasicMutationPayload;
  /** Deletes a saved Audience configuration for the current user. */
  deleteAudienceSavedFavorite: BasicMutationPayload;
  deleteConceptTestingCrossTabReport?: Maybe<BasicMutationPayload>;
  deleteCrossTabReport?: Maybe<BasicMutationPayload>;
  deleteDashboard?: Maybe<BasicMutationPayload>;
  deleteLibraryAsset?: Maybe<BasicMutationPayload>;
  /** Delete an existing question tag */
  deleteOecQuestionTag: DeleteOecQuestionTagPayload;
  /** Delete a tag associated to response. */
  deleteOecTagsForResponse: OecTagResponsePayload;
  /** Delete user's profile */
  deleteProfile: BasicMutationPayload;
  /** Delete respondent given the surveyId as well as the respondentId */
  deleteRespondent?: Maybe<DeleteRespondentPayload>;
  deleteScreeningQuestionMetadata?: Maybe<
    DeleteScreeningQuestionMetadataPayload
  >;
  deleteSharedView?: Maybe<BasicMutationPayload>;
  /** Delete an individual survey */
  deleteSurvey: BasicMutationPayload;
  /** Delete a survey payment page */
  deleteSurveyPaymentPage?: Maybe<BasicMutationPayload>;
  /** Delete a given question from a given survey */
  deleteSurveyQuestion?: Maybe<BasicMutationPayload>;
  /** Delete a survey quota */
  deleteSurveyQuota?: Maybe<BasicMutationPayload>;
  /** Delete a list of surveys */
  deleteSurveys: BasicMutationPayload;
  deleteTeamInviteRequest: BasicMutationPayload;
  deleteTheme?: Maybe<BasicMutationPayload>;
  deleteUseCaseAttribute?: Maybe<UseCaseAttributeReponsePayload>;
  /** Soft delete a user */
  deleteUser: BasicMutationPayload;
  deleteUserAddOnSelection?: Maybe<BasicMutationPayload>;
  deleteVariableAnswer?: Maybe<BasicMutationPayload>;
  /** Demote a user on your team to a contributor role */
  demoteUser: BasicMutationPayload;
  /** Edit an existing question tag */
  editOecQuestionTag: EditOecQuestionTagPayload;
  /** Generate all tags */
  generateOecKeywordTags: GenerateOecKeywordTagsPayload;
  /** Create a payment intent for a pre-existing cart object */
  initializePaymentViaStripe: PaymentIntentPayload;
  /** Get info on costs associated with a Stripe subscription upgrade (i.e. P2P purchase) */
  previewSubscriptionUpgrade: UpgradePreviewPayload;
  /** Promote User a user on your team to a full seat */
  promoteUser: BasicMutationPayload;
  putSurveyPersonalizationEvent?: Maybe<BasicMutationPayload>;
  recordContentModuleEvent: BasicMutationPayload;
  refreshProjectState?: Maybe<CreateProjectPayload>;
  refreshProjectSurvey?: Maybe<RefreshProjectSurveyPayload>;
  rejectTeamInviteRequest: BasicMutationPayload;
  /** Prompt admins to review seat request */
  remindSeatRequest: BasicMutationPayload;
  /**
   * This does not remove the saved Audience configuration. It just disassociates the Audience project
   * and saved configuration.
   */
  removeCollectorAssociationWithAudienceSavedFavorite: BasicMutationPayload;
  requestAccess?: Maybe<BasicMutationPayload>;
  /** Make a survey question required for the survey respondent */
  requireSurveyQuestion?: Maybe<RequireSurveyQuestionPayload>;
  resendEmailVerification?: Maybe<BasicMutationPayload>;
  /** Resend an existing team invitation */
  resendTeamInvite: BasicMutationPayload;
  /** allow admin to respond to seat request */
  respondToSeatRequest: SeatRequestPayload;
  /**
   * Claim the email revert token and revert the user's email.
   * Triggers a password reset email sent to the reverted email.
   */
  revertEmail?: Maybe<BasicMutationPayload>;
  saveExperimentTreatment?: Maybe<SaveExperimentTreatmentPayload>;
  sendCustomEmailDomainTestEmail: SendCustomEmailDomainTestEmailPayload;
  /** Triggers email opt in email based on an email that the user provides */
  sendEmailOptInEmail?: Maybe<BasicMutationPayload>;
  /** Send keyword feedback */
  sendOecKeywordFeedback: BasicMutationPayload;
  /** Send tag feedback */
  sendOecTagFeedback: BasicMutationPayload;
  sendTeamInviteRequest: BasicMutationPayload;
  sendTeamInviteRequestReminder: BasicMutationPayload;
  /** Set the user's has_agreed_to_enterprise_tou preference */
  setAcceptTOU?: Maybe<BasicMutationPayload>;
  /** Toggle whether survey is marked as an audience panel survey or not */
  setAudienceSurvey?: Maybe<SetAudienceSurveyPayload>;
  /** Subscribe user for receiving email */
  setEmailOptIn?: Maybe<SetEmailOptInPayload>;
  /** Unsubscribe user from receiving email */
  setEmailOptOut?: Maybe<BasicMutationPayload>;
  /** Set the user's has_seen_account_picker preference */
  setHasSeenAccountPicker?: Maybe<BasicMutationPayload>;
  /** Update user preferences */
  setMyAccountPreference: BasicMutationPayload;
  /** Set the users preference for the new LIHP experience */
  setNewHomePageEnabled?: Maybe<BasicMutationPayload>;
  /** Update user's time zone */
  setNewTimeZone: BasicMutationPayload;
  setQualificationRate: SetQualificationRatePayload;
  setShareCrosstabReport?: Maybe<SetShareCrosstabReportPayload>;
  /** Update survey alerts preference */
  setSurveyAlerts: BasicMutationPayload;
  /** Set user's survey domain */
  setSurveyDomain: BasicMutationPayload;
  /** Toggle whether survey is marked as favorite or not */
  setSurveyFavorite?: Maybe<SetSurveyFavoritePayload>;
  /** Set notifications about new survey responses ON or OFF for a specific survey */
  setSurveyResponseAlerts?: Maybe<SetSurveyResponseAlertsPayload>;
  /**
   * Set the user's configured language to the given language code. There isn't any language code validation in GQL
   * but, if an invalid code is given, the service will just not update it.
   */
  setUserLanguage?: Maybe<SetUserLanguagePayload>;
  /** Share a list of resources with a team workgroup. For example: surveys */
  shareResourcesWithWorkgroup: ShareResourcesWithWorkgroupPayload;
  /** Share survey with team members */
  shareSurvey?: Maybe<ShareSurveyPayload>;
  /** Toggle notifications about responses ON or OFF for survey */
  shareSurveyResponseAlerts?: Maybe<ShareSurveyResponseAlertsPayload>;
  /** Soft delete a user */
  shareSurveys: BasicMutationPayload;
  /** Share survey with each current member of the group individually */
  shareSurveyWithGroup?: Maybe<ShareSurveyWithGroupPayload>;
  /** Share survey with the entire group such that new members will also receive access to the survey */
  shareSurveyWithOrganization?: Maybe<BasicMutationPayload>;
  /** Checkout a study */
  solutionsCheckoutStudy?: Maybe<SolutionsCheckoutStudyPayload>;
  /** Creates a study object, which is an instance of a market research solution with a single survey. */
  solutionsCreateStudy: SolutionsCreateStudyResponse;
  /** Launch a study audience project */
  solutionsLaunchStudy: SolutionsLaunchStudyPayload;
  /** Updates a study object, which is an instance of a market research solution with a single survey. */
  solutionsUpdateStudy: SolutionsUpdateStudyPayload;
  /**
   * Updates a study configuration value for a specific configuration field.
   *
   * Config fields are associated with a specific research methodology.
   */
  solutionsUpdateStudyMethodologyConfigValue: SolutionsUpdateStudyMethodologyConfigValuePayload;
  stopAudienceCollector: StopAudienceCollectorResult;
  submitSurveyResponse?: Maybe<SubmitSurveyResponsePayload>;
  toggleUseCaseAttribute?: Maybe<UseCaseAttributeReponsePayload>;
  uninstallApp?: Maybe<UninstallAppPayload>;
  updateAudienceProject: UpdateAudienceProjectPayload;
  /**
   * Updates an existing Audience configuration for the current user. It is found using the id field
   * in the input.
   */
  updateAudienceSavedFavorite: AudienceSavedFavorite;
  /** Update an existing billing contact for the specified user+partner */
  updateBillingContact: BasicMutationPayload;
  /** Update an existing billing customer's metadata for the specified user+partner */
  updateBillingCustomerMetadata: BasicMutationPayload;
  /** Update an existing billing customer's tax record for the specified user+partner */
  updateBillingCustomerTaxRecord: BasicMutationPayload;
  updateCollector?: Maybe<UpdateCollectorPayload>;
  updateConceptTestingCrossTabReport?: Maybe<
    UpdateConceptTestingCrossTabReportPayload
  >;
  updateCrossTabReport?: Maybe<UpdateCrossTabReportPayload>;
  updateCustomEmailDomain: CustomEmailDomainUpdatePayload;
  updateDashboard?: Maybe<UpdateAnalysisDashboardPayload>;
  updateLibraryAsset?: Maybe<CreateLibraryAssetPayload>;
  updateLibraryDefaultAssetsSettings?: Maybe<
    UpdateDefaultAssetsSettingsPayload
  >;
  /** Set the user preference counting the times the user has seen the LIHP Toggle Coachmark */
  updateLoggedInHomeToggleCoachmarkViewCount?: Maybe<BasicMutationPayload>;
  updateManageSharingSettings: UpdateTeamSettingsPayload;
  updateManageUsersSettings: UpdateTeamSettingsPayload;
  updateMarketingEmailPreferences: UpdateMarketingEmailPreferencesPayload;
  /** Update a single keyword tag */
  updateOecKeywordTags: BasicMutationPayload;
  updatePIISettings: UpdateTeamSettingsPayload;
  updateProjectStatus?: Maybe<CreateProjectPayload>;
  updateProjectTitle?: Maybe<CreateProjectPayload>;
  updateSharedView?: Maybe<SharedViewPayload>;
  /** Update the auto-renew status (on or off) for a given subscription */
  updateSubscriptionRenewal: BasicMutationPayload;
  /** Update display settings for a survey */
  updateSurveyDesign?: Maybe<UpdateSurveyDesignPayload>;
  /** Create a invitation for a user to join the team or for member reassignment */
  updateTeamMembership: BasicMutationPayload;
  updateTrackingDashboardSharing?: Maybe<UpdateTrackingDashboardSharingPayload>;
  updateUseCaseAttribute?: Maybe<UseCaseAttributeReponsePayload>;
  updateUseCaseAttributes?: Maybe<UseCaseAttributeReponsePayload>;
  updateUserAddOnSelection?: Maybe<BasicMutationPayload>;
  /** updates a user's profiling information */
  updateUserProfile?: Maybe<UpdateUserProfilePayload>;
  updateUserProfileForProfiler?: Maybe<ProfilerUpdatePayload>;
  updateUserTheme: UpdateUserThemePayload;
  updateVariableAnswer?: Maybe<VariableAnswerPayload>;
  updateVariableAnswerMetadata?: Maybe<VariableAnswerPayload>;
  /** Validate a tax ID (i.e. VAT) for a specific country */
  validateTaxExemption: Scalars['Boolean'];
  /** Set the user preference if the user has seen the welcome modal */
  welcomeModalSeenLIHP?: Maybe<BasicMutationPayload>;
};

export type MutationAddBillingContactArgs = {
  input: BillingContactInput;
};

export type MutationAddChartToTrackingDashboardArgs = {
  chartSrc: Scalars['String'];
  dashboardId: Scalars['ID'];
  projectId: Scalars['ID'];
  title: Scalars['String'];
};

export type MutationAddSuggestedLogoToSurveyArgs = {
  autoTheme?: InputMaybe<Scalars['Boolean']>;
  surveyId: Scalars['ID'];
};

export type MutationAssociateCollectorWithAudienceSavedFavoriteArgs = {
  collectorId: Scalars['ID'];
  savedFavoriteId: Scalars['ID'];
};

export type MutationAudienceGeniusFeedbackV2Args = {
  input: AudienceGeniusFeedbackV2Input;
};

export type MutationAuthorizeAudienceBulkInvoiceArgs = {
  collectorId: Scalars['Int'];
};

export type MutationAuthorizeAudienceInvoiceArgs = {
  collectorId: Scalars['Int'];
};

export type MutationBulkTransferSurveysArgs = {
  input: BulkTransferSurveysInput;
};

export type MutationCancelAudienceBulkInvoiceArgs = {
  collectorId: Scalars['Int'];
};

export type MutationCancelAudienceInvoiceArgs = {
  collectorId: Scalars['Int'];
};

export type MutationCancelTeamInviteArgs = {
  teamMembershipId: Scalars['String'];
};

export type MutationCopyLibraryAssetArgs = {
  input: CopyLibraryAssetInput;
};

export type MutationCopySurveyArgs = {
  surveyId: Scalars['ID'];
  themeId?: InputMaybe<Scalars['ID']>;
  title: Scalars['String'];
};

export type MutationCopyThemeArgs = {
  input: CopyThemeInput;
};

export type MutationCreateAudienceProjectArgs = {
  input: CreateAudienceProjectInput;
};

export type MutationCreateAudienceProjectBulkInvoiceArgs = {
  input: CreateAudienceProjectBulkInvoiceInput;
};

export type MutationCreateAudienceProjectFromSnapshotCookieArgs = {
  bulkProjectId?: InputMaybe<Scalars['ID']>;
  bulkProjectPosition?: InputMaybe<Scalars['Int']>;
  collectorId?: InputMaybe<Scalars['ID']>;
  collectorName?: InputMaybe<Scalars['String']>;
  cookie: Scalars['String'];
  projectIndex?: InputMaybe<Scalars['Int']>;
  surveyId?: InputMaybe<Scalars['ID']>;
};

export type MutationCreateAudienceProjectInvoiceArgs = {
  input: CreateAudienceProjectInvoiceInput;
};

export type MutationCreateAudienceSavedFavoriteArgs = {
  savedFavorite: AudienceCreateSavedFavoriteInput;
};

export type MutationCreateCartArgs = {
  input: CreateCartInput;
};

export type MutationCreateChartResponsesExportArgs = {
  jobInput: AnalysisExportJobInput;
  questionParams: AnalysisQuestionExportParamsInput;
};

export type MutationCreateCollectorArgs = {
  input: CreateCollectorInput;
};

export type MutationCreateConceptTestingCrossTabReportArgs = {
  input?: InputMaybe<CreateConceptTestingCrossTabReportInput>;
};

export type MutationCreateConceptTestingResponsesExportArgs = {
  dataParameters?: InputMaybe<UseCaseExportDataParamsInput>;
  jobInput: UseCaseExportJobInput;
  projectId: Scalars['ID'];
};

export type MutationCreateCrossTabReportArgs = {
  input?: InputMaybe<CreateCrossTabReportInput>;
};

export type MutationCreateDeiResponseUploadPolicyArgs = {
  input: DeiResponseUploadPolicyInput;
};

export type MutationCreateDemoProjectArgs = {
  input?: InputMaybe<CreateProjectInput>;
};

export type MutationCreateGeniusSurveyArgs = {
  input?: InputMaybe<CreateGeniusSurveyInput>;
};

export type MutationCreateHrisUploadPolicyArgs = {
  input: HrisUploadPolicyInput;
};

export type MutationCreateInsightFeedbackArgs = {
  input: CreateInsightFeedbackInput;
};

export type MutationCreateLibraryDocumentArgs = {
  input: CreateLibraryDocumentInput;
};

export type MutationCreateLibraryImageArgs = {
  input?: InputMaybe<CreateLibraryImageInput>;
};

export type MutationCreateLibraryPresentationArgs = {
  input: CreateLibraryPresentationInput;
};

export type MutationCreateLibraryThemeAssetArgs = {
  input: CreateLibraryThemeInput;
};

export type MutationCreateLibraryUploadPolicyArgs = {
  input: UploadFileParametersInput;
};

export type MutationCreateLookerQueryTaskArgs = {
  format: Scalars['String'];
  query: LookerQuery;
};

export type MutationCreateOecJobArgs = {
  input: CreateJobDataInput;
};

export type MutationCreateOecQuestionTagArgs = {
  input: CreateTagDataInput;
};

export type MutationCreateOecTagsForResponseArgs = {
  input: OecTagResponseInput;
};

export type MutationCreateProjectArgs = {
  input?: InputMaybe<CreateProjectInput>;
};

export type MutationCreateProjectInvoiceArgs = {
  input?: InputMaybe<CreateProjectInvoiceInput>;
};

export type MutationCreateQuestionResponsesExportArgs = {
  dataParameters: AnalysisExportQuestionParamsInput;
  jobInput: AnalysisExportJobInput;
};

export type MutationCreateScreeningQuestionMetadataArgs = {
  input: CreateScreeningQuestionMetadataInput;
};

export type MutationCreateSeatRequestArgs = {
  input: CreateSeatRequestInput;
};

export type MutationCreateSharedViewArgs = {
  input?: InputMaybe<CreateSharedViewInput>;
};

export type MutationCreateStimuliUploadPolicyArgs = {
  fileParameters: UploadFileParametersInput;
  projectId: Scalars['ID'];
  serverSideEncryption?: InputMaybe<Scalars['Boolean']>;
};

export type MutationCreateSurveyArgs = {
  input?: InputMaybe<CreateSurveyInput>;
};

export type MutationCreateSurveyFromTeamSurveyArgs = {
  teamSurveyId: Scalars['ID'];
};

export type MutationCreateSurveyFromTemplateArgs = {
  templateId: Scalars['ID'];
  themeId?: InputMaybe<Scalars['ID']>;
};

export type MutationCreateSurveyLogoUploadPolicyArgs = {
  fileParameters?: InputMaybe<UploadFileParametersInput>;
  serverSideEncryption?: InputMaybe<Scalars['Boolean']>;
  surveyId: Scalars['ID'];
};

export type MutationCreateSurveyLogoUploadPostPolicyArgs = {
  fileParameters?: InputMaybe<UploadFileParametersInput>;
  serverSideEncryption?: InputMaybe<Scalars['Boolean']>;
  surveyId: Scalars['ID'];
};

export type MutationCreateSurveyResponsesExportArgs = {
  dataParameters: AnalysisExportSurveyParamsInput;
  jobInput: AnalysisExportJobInput;
};

export type MutationCreateSurveyTemplateAssetArgs = {
  input: CreateLibrarySurveyTemplateInput;
};

export type MutationCreateTeamInvitesArgs = {
  input: CreateTeamInviteInput;
};

export type MutationCreateTrackingDashboardArgs = {
  input: CreateTrackingDashboardInput;
};

export type MutationCreateTrackingSharedDashboardAuthSessionArgs = {
  password: Scalars['String'];
  slug: Scalars['String'];
};

export type MutationCreateUseCaseCustomAttributeArgs = {
  input: CreateUseCaseCustomAttributeInput;
  projectId: Scalars['ID'];
};

export type MutationCreateUseCaseResponsesExportArgs = {
  dataParameters?: InputMaybe<UseCaseExportDataParamsInput>;
  jobInput: UseCaseExportJobInput;
  projectId: Scalars['ID'];
};

export type MutationCreateUserAddOnSelectionArgs = {
  input: ProductAddOnSelectionInput;
};

export type MutationCreateWordCloudResponsesExportArgs = {
  jobInput: AnalysisExportJobInput;
  questionParams: AnalysisQuestionExportParamsInput;
};

export type MutationDeleteAnalysisExportJobArgs = {
  analysisExportJobId: Scalars['ID'];
  surveyId: Scalars['ID'];
};

export type MutationDeleteAudienceProjectArgs = {
  collectorId: Scalars['ID'];
};

export type MutationDeleteAudienceSavedFavoriteArgs = {
  savedFavoriteId: Scalars['ID'];
};

export type MutationDeleteConceptTestingCrossTabReportArgs = {
  input?: InputMaybe<DeleteConceptTestingCrossTabReportInput>;
};

export type MutationDeleteCrossTabReportArgs = {
  reportId: Scalars['ID'];
};

export type MutationDeleteDashboardArgs = {
  dashboardId: Scalars['ID'];
  surveyId: Scalars['ID'];
};

export type MutationDeleteLibraryAssetArgs = {
  input: DeleteLibraryAssetInput;
};

export type MutationDeleteOecQuestionTagArgs = {
  input: DeleteTagDataInput;
};

export type MutationDeleteOecTagsForResponseArgs = {
  input: OecTagResponseInput;
};

export type MutationDeleteProfileArgs = {
  input: DeleteProfileInput;
};

export type MutationDeleteRespondentArgs = {
  input: DeleteRespondentInput;
};

export type MutationDeleteScreeningQuestionMetadataArgs = {
  id: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type MutationDeleteSharedViewArgs = {
  input?: InputMaybe<DeleteSharedViewInput>;
};

export type MutationDeleteSurveyArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteSurveyPaymentPageArgs = {
  surveyId: Scalars['ID'];
};

export type MutationDeleteSurveyQuestionArgs = {
  questionId: Scalars['ID'];
  surveyId: Scalars['ID'];
};

export type MutationDeleteSurveyQuotaArgs = {
  quotaId: Scalars['ID'];
  surveyId: Scalars['ID'];
};

export type MutationDeleteSurveysArgs = {
  ids: Array<Scalars['ID']>;
};

export type MutationDeleteThemeArgs = {
  input: DeleteThemeInput;
};

export type MutationDeleteUseCaseAttributeArgs = {
  attributeId: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};

export type MutationDeleteUserAddOnSelectionArgs = {
  selectionId: Scalars['String'];
};

export type MutationDeleteVariableAnswerArgs = {
  projectId: Scalars['ID'];
  variableId: Scalars['ID'];
};

export type MutationDemoteUserArgs = {
  id: Scalars['ID'];
  roleType: ContributorRoleType;
};

export type MutationEditOecQuestionTagArgs = {
  input: EditTagDataInput;
};

export type MutationGenerateOecKeywordTagsArgs = {
  input: GenerateOecKeywordTagsInput;
};

export type MutationInitializePaymentViaStripeArgs = {
  input: PaymentIntentInput;
};

export type MutationPreviewSubscriptionUpgradeArgs = {
  input: PreviewSubscriptionUpgradeInput;
};

export type MutationPromoteUserArgs = {
  id: Scalars['ID'];
};

export type MutationPutSurveyPersonalizationEventArgs = {
  input?: InputMaybe<PutSurveyPersonalizationEventInput>;
};

export type MutationRecordContentModuleEventArgs = {
  input: RecordContentModuleEventInput;
};

export type MutationRefreshProjectStateArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type MutationRefreshProjectSurveyArgs = {
  projectId: Scalars['ID'];
};

export type MutationRejectTeamInviteRequestArgs = {
  input: RejectTeamInviteRequestInput;
};

export type MutationRemoveCollectorAssociationWithAudienceSavedFavoriteArgs = {
  collectorId: Scalars['ID'];
};

export type MutationRequestAccessArgs = {
  part: PermissionPart;
  surveyId: Scalars['ID'];
};

export type MutationRequireSurveyQuestionArgs = {
  input: SurveyQuestionRequiredInput;
  questionId: Scalars['ID'];
  surveyId: Scalars['ID'];
};

export type MutationResendEmailVerificationArgs = {
  input: ResendEmailInput;
};

export type MutationResendTeamInviteArgs = {
  teamMembershipId: Scalars['String'];
};

export type MutationRespondToSeatRequestArgs = {
  input: RespondToSeatRequestInput;
};

export type MutationRevertEmailArgs = {
  input: RevertEmailInput;
};

export type MutationSaveExperimentTreatmentArgs = {
  input: SaveExperimentTreatmentInput;
};

export type MutationSendCustomEmailDomainTestEmailArgs = {
  sendTestEmailInput: SendCustomEmailDomainTestEmailInput;
};

export type MutationSendEmailOptInEmailArgs = {
  input: SendEmailOptInEmailInput;
};

export type MutationSendOecKeywordFeedbackArgs = {
  input: SendKeywordFeedbackInput;
};

export type MutationSendOecTagFeedbackArgs = {
  input: SendTagFeedbackInput;
};

export type MutationSendTeamInviteRequestArgs = {
  input: TeamInviteRequestInput;
};

export type MutationSetAcceptTouArgs = {
  accepted: Scalars['Boolean'];
};

export type MutationSetAudienceSurveyArgs = {
  isAudienceSurvey: Scalars['Boolean'];
  surveyId: Scalars['ID'];
};

export type MutationSetEmailOptInArgs = {
  input: SetEmailOptInInput;
};

export type MutationSetEmailOptOutArgs = {
  input: SetEmailOptOutInput;
};

export type MutationSetHasSeenAccountPickerArgs = {
  seen: Scalars['Boolean'];
};

export type MutationSetMyAccountPreferenceArgs = {
  input: SetMyAccountPreferenceInput;
};

export type MutationSetNewHomePageEnabledArgs = {
  enabled: Scalars['Boolean'];
};

export type MutationSetNewTimeZoneArgs = {
  input: SetNewTimeZoneInput;
};

export type MutationSetQualificationRateArgs = {
  projectId: Scalars['ID'];
  qualificationRate: Scalars['Int'];
};

export type MutationSetShareCrosstabReportArgs = {
  input?: InputMaybe<SetShareCrosstabReportInput>;
};

export type MutationSetSurveyAlertsArgs = {
  input: SetSurveyAlertsInput;
};

export type MutationSetSurveyDomainArgs = {
  input: SetSurveyDomainInput;
};

export type MutationSetSurveyFavoriteArgs = {
  isFavorite: Scalars['Boolean'];
  surveyId: Scalars['ID'];
};

export type MutationSetSurveyResponseAlertsArgs = {
  input: SetSurveyResponseAlertsInput;
};

export type MutationSetUserLanguageArgs = {
  languageCode: Scalars['String'];
};

export type MutationShareResourcesWithWorkgroupArgs = {
  input: ShareResourcesWithWorkgroupInput;
};

export type MutationShareSurveyArgs = {
  input: ShareSurveyInput;
};

export type MutationShareSurveyResponseAlertsArgs = {
  input: ShareSurveyResponseAlertsInput;
};

export type MutationShareSurveysArgs = {
  input: ShareSurveysInput;
};

export type MutationShareSurveyWithGroupArgs = {
  input: ShareSurveyWithGroupInput;
};

export type MutationShareSurveyWithOrganizationArgs = {
  input: ShareSurveyWithOrganizationInput;
};

export type MutationSolutionsCheckoutStudyArgs = {
  studyId: Scalars['ID'];
};

export type MutationSolutionsCreateStudyArgs = {
  solutionId: Scalars['ID'];
};

export type MutationSolutionsLaunchStudyArgs = {
  data: Scalars['String'];
  studyId: Scalars['ID'];
};

export type MutationSolutionsUpdateStudyArgs = {
  input: SolutionsUpdateStudyInput;
  studyId: Scalars['ID'];
};

export type MutationSolutionsUpdateStudyMethodologyConfigValueArgs = {
  fieldName: Scalars['String'];
  methodologyStateId: Scalars['ID'];
  methodologyType: Scalars['String'];
  solutionId: Scalars['ID'];
  studyId: Scalars['ID'];
  value: Scalars['SolutionsStudyMethodologyConfigValue'];
};

export type MutationStopAudienceCollectorArgs = {
  collectorId: Scalars['ID'];
  reason: Scalars['String'];
};

export type MutationSubmitSurveyResponseArgs = {
  input: SubmitSurveyResponseInput;
  surveyId: Scalars['ID'];
};

export type MutationToggleUseCaseAttributeArgs = {
  attributeId: Scalars['ID'];
  input: ToggleUseCaseAttributeInput;
  projectId: Scalars['ID'];
};

export type MutationUninstallAppArgs = {
  input: UninstallAppInput;
};

export type MutationUpdateAudienceProjectArgs = {
  input: UpdateAudienceProjectInput;
};

export type MutationUpdateAudienceSavedFavoriteArgs = {
  savedFavorite: AudienceUpdateSavedFavoriteInput;
};

export type MutationUpdateBillingContactArgs = {
  input: BillingContactInput;
};

export type MutationUpdateBillingCustomerMetadataArgs = {
  input: CustomerMetadataInput;
};

export type MutationUpdateBillingCustomerTaxRecordArgs = {
  input: CustomerTaxInput;
};

export type MutationUpdateCollectorArgs = {
  input: UpdateCollectorInput;
};

export type MutationUpdateConceptTestingCrossTabReportArgs = {
  input?: InputMaybe<UpdateConceptTestingCrossTabReportInput>;
};

export type MutationUpdateCrossTabReportArgs = {
  input?: InputMaybe<UpdateCrossTabReportInput>;
};

export type MutationUpdateCustomEmailDomainArgs = {
  customEmailDomainInput: CustomEmailDomainUpdateInput;
};

export type MutationUpdateDashboardArgs = {
  input?: InputMaybe<UpdateAnalysisDashboardInput>;
  surveyId: Scalars['ID'];
};

export type MutationUpdateLibraryAssetArgs = {
  input: UpdateLibraryInput;
};

export type MutationUpdateLibraryDefaultAssetsSettingsArgs = {
  input: UpdateDefaultAssetsSettingsInput;
};

export type MutationUpdateLoggedInHomeToggleCoachmarkViewCountArgs = {
  count: Scalars['Int'];
};

export type MutationUpdateManageSharingSettingsArgs = {
  input: UpdateManageSharingSettingsInput;
};

export type MutationUpdateManageUsersSettingsArgs = {
  input: UpdateManageUsersSettingsInput;
};

export type MutationUpdateMarketingEmailPreferencesArgs = {
  input?: InputMaybe<UpdateMarketingEmailPreferencesInput>;
};

export type MutationUpdateOecKeywordTagsArgs = {
  input: UpdateOecKeywordTagsInput;
};

export type MutationUpdatePiiSettingsArgs = {
  input: UpdatePiiSettingsInput;
};

export type MutationUpdateProjectStatusArgs = {
  projectId: Scalars['ID'];
  status: ProjectStatus;
};

export type MutationUpdateProjectTitleArgs = {
  input?: InputMaybe<UpdateProjectTitleInput>;
};

export type MutationUpdateSharedViewArgs = {
  input?: InputMaybe<UpdateSharedViewInput>;
};

export type MutationUpdateSubscriptionRenewalArgs = {
  input: SubscriptionRenewalInput;
};

export type MutationUpdateSurveyDesignArgs = {
  input?: InputMaybe<SurveyDesignInput>;
  surveyId: Scalars['ID'];
};

export type MutationUpdateTeamMembershipArgs = {
  input: UpdateTeamMembershipInput;
};

export type MutationUpdateTrackingDashboardSharingArgs = {
  dashboardId: Scalars['ID'];
  input: UpdateTrackingDashboardSharingInput;
  projectId: Scalars['ID'];
};

export type MutationUpdateUseCaseAttributeArgs = {
  attribute: UseCaseAttributeInput;
  projectId: Scalars['ID'];
};

export type MutationUpdateUseCaseAttributesArgs = {
  attributes: Array<UseCaseAttributeInput>;
  projectId: Scalars['ID'];
};

export type MutationUpdateUserAddOnSelectionArgs = {
  input: UpdateProductAddOnInput;
  selectionId: Scalars['String'];
};

export type MutationUpdateUserProfileArgs = {
  input?: InputMaybe<UpdateUserProfileInput>;
};

export type MutationUpdateUserProfileForProfilerArgs = {
  input?: InputMaybe<UpdateProfilerDataInput>;
};

export type MutationUpdateUserThemeArgs = {
  input: UpdateUserThemeInput;
};

export type MutationUpdateVariableAnswerArgs = {
  input?: InputMaybe<UpdateVariableAnswerInput>;
};

export type MutationUpdateVariableAnswerMetadataArgs = {
  input?: InputMaybe<UpdateVariableAnswerMetadataInput>;
};

export type MutationValidateTaxExemptionArgs = {
  input: ValidateTaxExemptionInput;
};

export type MutationWelcomeModalSeenLihpArgs = {
  seen: Scalars['Boolean'];
};

export type MyWorkgroupsInput = {
  /** Filter workgroups that contain this text in the name */
  name?: InputMaybe<Scalars['String']>;
  /** User which is a member of all workgroup */
  ownerId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type NestedAnswer = QuestionAnswer & {
  __typename?: 'NestedAnswer';
  choices: Array<ChoiceAnswer>;
  id: Scalars['ID'];
  label: Scalars['String'];
  visible: Scalars['Boolean'];
};

export type NormsIndustry = {
  __typename?: 'NormsIndustry';
  canonicalName: Scalars['String'];
  label: Scalars['String'];
  nesting: Scalars['Int'];
};

export type NormsVariableConfiguration = ProjectVariableConfiguration & {
  __typename?: 'NormsVariableConfiguration';
  enabled: Scalars['Boolean'];
  max: Scalars['Int'];
  min: Scalars['Int'];
};

/** Represents error states in query responses corresponding to 'resource not found' API responses. */
export type NotFoundError = {
  __typename?: 'NotFoundError';
  code: NotFoundErrorCode;
  message?: Maybe<Scalars['String']>;
};

/** Codes for errors corresponding to 'resource not found' error states. */
export enum NotFoundErrorCode {
  NotFound = 'NOT_FOUND',
}

export enum NotificationAppType {
  CommentSurveyPreviewTest = 'COMMENT_SURVEY_PREVIEW_TEST',
  EmailCampaignTest = 'EMAIL_CAMPAIGN_TEST',
  EmailCollector = 'EMAIL_COLLECTOR',
  EmailService = 'EMAIL_SERVICE',
  EmailVerification = 'EMAIL_VERIFICATION',
  SharedResponse = 'SHARED_RESPONSE',
  Test = 'TEST',
  WeblinkCollector = 'WEBLINK_COLLECTOR',
}

export enum NotificationFrequency {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Minute = 'MINUTE',
  Monthly = 'MONTHLY',
  Realtime = 'REALTIME',
  Second = 'SECOND',
  Weekly = 'WEEKLY',
}

/** A user preference on how and when they'd like to be notified */
export type NotificationPreference = {
  __typename?: 'NotificationPreference';
  appType?: Maybe<NotificationAppType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  frequency?: Maybe<NotificationFrequency>;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  referenceId?: Maybe<Scalars['ID']>;
  terminatedAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<NotificationType>;
  userId?: Maybe<Scalars['ID']>;
};

export type NotificationPreferenceList = PaginatedList & {
  __typename?: 'NotificationPreferenceList';
  items: Array<NotificationPreference>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum NotificationType {
  AutorenewOff = 'AUTORENEW_OFF',
  ChangeStatusComment = 'CHANGE_STATUS_COMMENT',
  CollectorFlaggedToClose = 'COLLECTOR_FLAGGED_TO_CLOSE',
  CreatedCommenter = 'CREATED_COMMENTER',
  CreditCardFailed = 'CREDIT_CARD_FAILED',
  DeletedComment = 'DELETED_COMMENT',
  FirstResponse = 'FIRST_RESPONSE',
  NewComment = 'NEW_COMMENT',
  NewExternalSurveyAvailable = 'NEW_EXTERNAL_SURVEY_AVAILABLE',
  NewResponses = 'NEW_RESPONSES',
  NewSurveyAvailable = 'NEW_SURVEY_AVAILABLE',
  Permission = 'PERMISSION',
  PermissionV1 = 'PERMISSION_V1',
  QuizReceipt = 'QUIZ_RECEIPT',
  ReplyComment = 'REPLY_COMMENT',
  SraEmailSharePendingState = 'SRA_EMAIL_SHARE_PENDING_STATE',
  SraFirstResponse = 'SRA_FIRST_RESPONSE',
  SraNewSurveysAlert = 'SRA_NEW_SURVEYS_ALERT',
  UpdatedComment = 'UPDATED_COMMENT',
  UserDeletionHard = 'USER_DELETION_HARD',
  UserDeletionSoft = 'USER_DELETION_SOFT',
  UserEmailVerification = 'USER_EMAIL_VERIFICATION',
  WeblinkcollectorRecurringSurvey = 'WEBLINKCOLLECTOR_RECURRING_SURVEY',
  WorkgroupsMemberAdd = 'WORKGROUPS_MEMBER_ADD',
  WorkgroupsMemberApplied = 'WORKGROUPS_MEMBER_APPLIED',
  WorkgroupsMemberApproved = 'WORKGROUPS_MEMBER_APPROVED',
  WorkgroupsMemberDenied = 'WORKGROUPS_MEMBER_DENIED',
  WorkgroupsMemberRemove = 'WORKGROUPS_MEMBER_REMOVE',
  WorkgroupsMemberRoleChanged = 'WORKGROUPS_MEMBER_ROLE_CHANGED',
  WorkgroupsSurveyShared = 'WORKGROUPS_SURVEY_SHARED',
  WorkgroupsSurveyUnshared = 'WORKGROUPS_SURVEY_UNSHARED',
  WorkgroupsWorkgroupChanged = 'WORKGROUPS_WORKGROUP_CHANGED',
  WorkgroupsWorkgroupDeleted = 'WORKGROUPS_WORKGROUP_DELETED',
}

/** This validation configuration is used to enforce numerical inputs. */
export type NumericalValidation = QuestionValidation & {
  __typename?: 'NumericalValidation';
  errorMessage: Scalars['String'];
  maxValue: Scalars['Float'];
  minValue: Scalars['Float'];
  /** Can only be DECIMAL or INTEGER */
  type: QuestionFieldValidationType;
};

/**
 * Open Ended Coding (OEC) question tag generated by
 * the machine learning model. This will have a unique tag
 * type and belongs to a regular question tag. There are
 * two different tag types in order to differentiate manually
 * created tags from autogenerated tags in the UI.
 */
export type OecAutogeneratedTag = {
  __typename?: 'OecAutogeneratedTag';
  id: Scalars['ID'];
  responseTextIds: Array<Scalars['ID']>;
};

export type OecData = {
  questionId: Scalars['ID'];
};

/** The oec job to train the model */
export type OecJob = {
  __typename?: 'OecJob';
  id: Scalars['ID'];
  jobCreatedAt?: Maybe<Scalars['DateTime']>;
  jobFinishedAt?: Maybe<Scalars['DateTime']>;
  predictionId?: Maybe<Scalars['String']>;
  processedRespondents?: Maybe<Scalars['String']>;
  questionId: Scalars['ID'];
  /** State of the job */
  state: OecJobState;
  /** The http response code */
  status?: Maybe<Scalars['Int']>;
  surveyId: Scalars['ID'];
  type: Scalars['String'];
};

/** Status of the Open Ended Coding (OEC) job */
export enum OecJobState {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Queued = 'QUEUED',
  Success = 'SUCCESS',
}

/** A keyword tag can contain multiple keywords: e.g: expensive = [pricey, expensive, not cheap] */
export type OecKeywordTag = {
  __typename?: 'OecKeywordTag';
  id: Scalars['ID'];
  keywords: Array<Scalars['String']>;
  label: Scalars['String'];
};

export type OecKeywordTagInput = {
  id: Scalars['ID'];
  keywords: Array<Scalars['String']>;
  label: Scalars['String'];
};

/** Open Ended Coding (OEC) question tag manually created by a user */
export type OecQuestionTag = {
  __typename?: 'OecQuestionTag';
  autogeneratedTag?: Maybe<OecAutogeneratedTag>;
  color: Scalars['RGBA'];
  id: Scalars['ID'];
  label: Scalars['String'];
  responseTextIds: Array<Scalars['ID']>;
  tagType: OecTagType;
};

/** Open Ended Coding (OEC) Response */
export type OecResponse = {
  __typename?: 'OecResponse';
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  optionId: Scalars['ID'];
  questionId: Scalars['ID'];
  respondentId: Scalars['ID'];
  stimulus: Scalars['String'];
  stimulusId: Scalars['ID'];
  tagIds: Array<Scalars['ID']>;
};

export type OecResponseList = PaginatedList & {
  __typename?: 'OecResponseList';
  items: Array<OecResponse>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** Response sort keys. */
export enum OecResponseSortBy {
  Content = 'CONTENT',
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Stimulus = 'STIMULUS',
}

/** Open Ended Coding (OEC) Response Summary */
export type OecResponseSummary = {
  __typename?: 'OecResponseSummary';
  counts: OecResponseSummaryCounts;
  themes: Array<OecResponseThemeSummary>;
};

export type OecResponseSummaryCounts = {
  __typename?: 'OecResponseSummaryCounts';
  autoTaggedCount: Scalars['Int'];
  manualTaggedCount: Scalars['Int'];
  responseCount: Scalars['Int'];
  themesCount: Scalars['Int'];
  untaggedCount: Scalars['Int'];
};

/**
 * The stimuli counts across a user's responses that have a given theme.
 * For OEC, there are duplicate themes created to differentiate between
 * manually created and autogenerated by the machine learning model,
 * so we need to include both theme ids.
 */
export type OecResponseThemeSummary = {
  __typename?: 'OecResponseThemeSummary';
  stimuli: Array<OecStimulus>;
  themeIds: Array<Scalars['ID']>;
  themeName: Scalars['String'];
};

export type OecStimulus = {
  __typename?: 'OecStimulus';
  count: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type OecTagResponseInput = {
  questionId: Scalars['ID'];
  responseTextId: Scalars['ID'];
  surveyId: Scalars['ID'];
  tagIds: Array<Scalars['ID']>;
};

export type OecTagResponsePayload = {
  __typename?: 'OecTagResponsePayload';
  responseTextId: Scalars['ID'];
  success: Scalars['Boolean'];
  tagIds: Array<Scalars['ID']>;
};

/** Tag Types present in the OEC question tag */
export enum OecTagType {
  Oecmodel = 'OECMODEL',
  Oecuser = 'OECUSER',
  Sentiment = 'SENTIMENT',
  User = 'USER',
}

export type OneDimensionalResponseData = {
  __typename?: 'OneDimensionalResponseData';
  mean?: Maybe<Scalars['Float']>;
  percentage: Scalars['Float'];
  question?: Maybe<SurveyQuestion>;
  row?: Maybe<SurveyQuestionRow>;
  sum?: Maybe<Scalars['Float']>;
  total: Scalars['Int'];
};

export type OneDimensionalResponseSummary = QuestionResponseSummary & {
  __typename?: 'OneDimensionalResponseSummary';
  analysisTags: Array<SentimentAnalysisTag>;
  basicStats?: Maybe<SummaryBasicStats>;
  items?: Maybe<Array<Maybe<OneDimensionalResponseData>>>;
  metadata?: Maybe<ResponseMetadata>;
  respondentSummary?: Maybe<RespondentSummary>;
};

export type OpenEndedLayoutOptions = {
  __typename?: 'OpenEndedLayoutOptions';
  charsCount: Scalars['Int'];
  linesCount: Scalars['Int'];
  placement: QuestionLayoutPlacement;
  spacing: QuestionLayoutSpacingOptions;
};

export type OpenEndedManyFieldsQuestionQm = SurveyQuestionQm & {
  __typename?: 'OpenEndedManyFieldsQuestionQM';
  answers: Array<ChoiceAnswer>;
  createdAt: Scalars['DateTime'];
  family: SurveyQuestionFamily;
  fieldSets: Array<FieldSet>;
  hasPiping: Scalars['Boolean'];
  heading: QuestionHeadingConfiguration;
  id: Scalars['ID'];
  layout: OpenEndedMultiLayoutOptions;
  modifiedAt: Scalars['DateTime'];
  position: QuestionPosition;
  questionBank?: Maybe<QuestionBankConnection>;
  required?: Maybe<QuestionAnswerRequired>;
  sorting?: Maybe<QuestionSorting>;
  sumValidation?: Maybe<SumValidation>;
  validation?: Maybe<QuestionValidation>;
  variant: SurveyQuestionVariant;
};

export type OpenEndedMultiLayoutOptions = {
  __typename?: 'OpenEndedMultiLayoutOptions';
  charsCount: Scalars['Int'];
  labelWidthPercent: Scalars['Int'];
  placement: QuestionLayoutPlacement;
  spacing: QuestionLayoutSpacingOptions;
  width: QuestionLayoutWidthOptions;
};

export type OpenEndedQuestion = SurveyQuestion & {
  __typename?: 'OpenEndedQuestion';
  absolutePosition: Scalars['Int'];
  analytics: AnalyticsText;
  displayNumber: Scalars['Int'];
  displayOptions: SurveyQuestionDisplayOptions;
  headers: Array<SurveyQuestionHeader>;
  id: Scalars['ID'];
  isAudience: Scalars['Boolean'];
  nickname: Scalars['String'];
  pageId: Scalars['ID'];
  position: Scalars['Int'];
  questionTemplate?: Maybe<OpenEndedQuestionTemplate>;
  responseSummary?: Maybe<QuestionResponseSummary>;
  rows?: Maybe<SurveyQuestionRowList>;
  type: SurveyQuestionType;
  validation: SurveyQuestionValidationOptions;
  visible: Scalars['Boolean'];
};

export type OpenEndedQuestionRowsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type OpenEndedQuestionBankQuestionQm = QuestionBankQuestion & {
  __typename?: 'OpenEndedQuestionBankQuestionQM';
  heading: QuestionBankHeading;
  id: Scalars['ID'];
  logicalLink: QuestionBankLogicalLink;
};

export type OpenEndedQuestionQm = SurveyQuestionQm & {
  __typename?: 'OpenEndedQuestionQM';
  createdAt: Scalars['DateTime'];
  family: SurveyQuestionFamily;
  fieldSet: FieldSet;
  hasPiping: Scalars['Boolean'];
  heading: QuestionHeadingConfiguration;
  id: Scalars['ID'];
  layout: OpenEndedLayoutOptions;
  modifiedAt: Scalars['DateTime'];
  position: QuestionPosition;
  questionBank?: Maybe<QuestionBankConnection>;
  required?: Maybe<QuestionAnswerRequired>;
  validation?: Maybe<QuestionValidation>;
  variant: SurveyQuestionVariant;
};

export type OpenEndedQuestionTemplate = SurveyQuestionTemplate & {
  __typename?: 'OpenEndedQuestionTemplate';
  attributes: Array<SurveyQuestionTemplateAttribute>;
  heading: Scalars['String'];
  id: Scalars['ID'];
  logicalLink: SurveyQuestionTemplateLogicalLink;
  modifiers: Array<SurveyQuestionTemplateModifier>;
  rows: Array<SurveyQuestionTemplateRow>;
};

/** Responses to questions with open text responses */
export type OpenResponse = {
  __typename?: 'OpenResponse';
  dateAnswer?: Maybe<Scalars['DateTime']>;
  /** Field description */
  fieldSet?: Maybe<QuestionFieldSet>;
  numericAnswer?: Maybe<Scalars['Float']>;
  textAnswer?: Maybe<Scalars['String']>;
};

/** Governs what survey permissions a user has for surveys shared with the workgroup */
export type OrganizationRole = {
  __typename?: 'OrganizationRole';
  description: Scalars['String'];
  id: Scalars['ID'];
  /** Is this role enabled in the system */
  isEnabled: Scalars['Boolean'];
  /** Is the role a default system role or a custom created role. */
  isSystemRole: Scalars['Boolean'];
  name: Scalars['String'];
  privileges?: Maybe<CollaboratorRole>;
};

/** Responses to the "other" answer option */
export type OtherResponse = {
  __typename?: 'OtherResponse';
  answerOther: AnswerOther;
  textAnswer?: Maybe<Scalars['String']>;
};

export type OverQuotaDestination = {
  __typename?: 'OverQuotaDestination';
  /** customMessage is relevant only when the type is CUSTOM_MESSAGE */
  customMessage?: Maybe<Scalars['String']>;
  /** redirectUrl is relevant only when the type is REDIRECT_URL */
  redirectUrl?: Maybe<Scalars['String']>;
  type: OverQuotaDestinationType;
};

export enum OverQuotaDestinationType {
  CloseWindow = 'CLOSE_WINDOW',
  CustomMessage = 'CUSTOM_MESSAGE',
  EndSurvey = 'END_SURVEY',
  RedirectUrl = 'REDIRECT_URL',
}

export type PackageBase = {
  canonicalName: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
  renewalInterval: RenewalType;
  renewalIntervalCount: Scalars['Int'];
};

export type PackageBundle = {
  __typename?: 'PackageBundle';
  cost: Scalars['Int'];
  id: Scalars['ID'];
  label: Scalars['String'];
  quantity?: Maybe<Scalars['Int']>;
  sku: PricingSkuId;
  skuType: PricingSkuTypeId;
};

export type PackageDetails = {
  __typename?: 'PackageDetails';
  displayName: Scalars['String'];
  isOverageable: Scalars['Boolean'];
  isPaid: Scalars['Boolean'];
  label: Scalars['String'];
  tier: Scalars['Int'];
};

export type PackageFeature = {
  __typename?: 'PackageFeature';
  baseResponseCount: Scalars['Int'];
};

export type PackageFeatureSet = {
  __typename?: 'PackageFeatureSet';
  features: PackageFeature;
  featureSetId: Scalars['ID'];
  label: Scalars['String'];
};

export type PackageSummaries = {
  __typename?: 'PackageSummaries';
  items: Array<PackageSummaryMetadata>;
  totalCount: Scalars['Int'];
};

export type PackageSummaryMetadata = PackageBase & {
  __typename?: 'PackageSummaryMetadata';
  canonicalName: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
  renewalInterval: RenewalType;
  renewalIntervalCount: Scalars['Int'];
};

export type Page = {
  __typename?: 'Page';
  id: Scalars['ID'];
  skipLogicRule?: Maybe<PageSkipLogicRule>;
};

/**
 * Information on how to traverse through the pages of a query.
 * A list starts at page 1. So page=1, pageSize=10 would give you
 * the first 10 items of a query.
 */
export type PageInfo = {
  __typename?: 'PageInfo';
  /**
   * The index of the first page in the list.
   *
   * This field should not be nullable, as there should always be a reference to
   * a first page. For legacy reasons, it is nullable.
   *
   * Should be 1 to comply with the GraphAPI standard.
   */
  firstPage?: Maybe<Scalars['Int']>;
  /**
   * The index of the last page in the list.
   *
   * null indicates that the index could (or would) not be provided. Perhaps it
   * was an overly expensive operation?
   */
  lastPage?: Maybe<Scalars['Int']>;
  /**
   * The index of the next page in the list.
   *
   * null indicates that there is no next page (meaning that the current
   * response corresponds to the last page).
   */
  nextPage?: Maybe<Scalars['Int']>;
  /**
   * The number of items in a page. Typically this is specified as an input,
   * but it should also be returned so that clients can react appropriately.
   *
   * This field should not be nullable, but it was added at a time when the
   * PageInfo type was already widely used, and so the field is nullable for
   * backward compatibility.
   */
  pageSize?: Maybe<Scalars['Int']>;
  /**
   * The index of the previous page in the list.
   *
   * null indicates that there is no previous page (meaning that the current
   * response corresponds to the first page).
   */
  prevPage?: Maybe<Scalars['Int']>;
};

export type PageSkipLogicRule = {
  __typename?: 'PageSkipLogicRule';
  destination: SkipLogicDestination;
  id: Scalars['ID'];
  skipType: PageSkipLogicType;
  sourcePage: Page;
};

export enum PageSkipLogicType {
  PageUnconditional = 'PAGE_UNCONDITIONAL',
}

/** The interface of any query that returns a list of objects should follow */
export type PaginatedList = {
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PaymentAddress = {
  __typename?: 'PaymentAddress';
  city?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  houseNumber?: Maybe<Scalars['String']>;
  isDefault: Scalars['Boolean'];
  neighborhood?: Maybe<Scalars['String']>;
  partner?: Maybe<BillingPartner>;
  postalCode?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  subdivision?: Maybe<Scalars['String']>;
};

export type PaymentIntentInput = {
  address: PurchaseBillingAddress;
  cartId: Scalars['Int'];
  company?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  partner: BillingPartner;
  purchaseOrderNumber?: InputMaybe<Scalars['String']>;
  surname: Scalars['String'];
  taxExemptionNumber?: InputMaybe<Scalars['String']>;
};

export type PaymentIntentPayload = {
  __typename?: 'PaymentIntentPayload';
  amount?: Maybe<Scalars['Float']>;
  invoiceId?: Maybe<Scalars['Int']>;
  paymentIntentClientSecret?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePublishableKey?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['Float']>;
  success: Scalars['Boolean'];
  tax?: Maybe<Scalars['Float']>;
};

export type PaymentMethodCard = {
  __typename?: 'PaymentMethodCard';
  bankIdentificationNumber?: Maybe<Scalars['String']>;
  cardType: PaymentMethodCardType;
  expiryMonth: Scalars['Int'];
  expiryYear: Scalars['Int'];
  isDefault: Scalars['Boolean'];
  lastFour: Scalars['String'];
  nameOnCard: Scalars['String'];
  partner: BillingPartner;
  stripePlatformPaymentMethodId: Scalars['String'];
};

export enum PaymentMethodCardType {
  AmericanExpress = 'AMERICAN_EXPRESS',
  Cartasi = 'CARTASI',
  CarteBleue = 'CARTE_BLEUE',
  DankortVisa = 'DANKORT_VISA',
  DinersClub = 'DINERS_CLUB',
  Discover = 'DISCOVER',
  Elv = 'ELV',
  ElvSepa = 'ELV_SEPA',
  GocardlessBacsDd = 'GOCARDLESS_BACS_DD',
  GocardlessSepaDd = 'GOCARDLESS_SEPA_DD',
  Jcb = 'JCB',
  Mastercard = 'MASTERCARD',
  Visa = 'VISA',
  VisaDelta = 'VISA_DELTA',
}

export enum PaymentStatus {
  Approved = 'APPROVED',
  Failed = 'FAILED',
  NotPaid = 'NOT_PAID',
  Pending = 'PENDING',
}

export type PendingAccessRequests = {
  __typename?: 'PendingAccessRequests';
  analyze: Scalars['Boolean'];
  collect: Scalars['Boolean'];
  design: Scalars['Boolean'];
};

/**
 * Combining either the top two or the bottom two options of the likert-scale questions
 * for the performance score calculation
 */
export enum PerformanceScoreCombineOption {
  BottomTwo = 'BOTTOM_TWO',
  TopTwo = 'TOP_TWO',
}

/** A section, as defined by the Fine Grained Permissions model of usersvc */
export enum PermissionPart {
  Analyze = 'ANALYZE',
  Collect = 'COLLECT',
  Design = 'DESIGN',
}

export type PerRowBasicStats = {
  __typename?: 'PerRowBasicStats';
  basicStats?: Maybe<Array<SummaryBasicStats>>;
  row: SurveyQuestionRow;
};

export type PersonalizationEventDataInput = {
  surveyId: Scalars['ID'];
};

export enum Placement {
  BottomBar = 'BOTTOM_BAR',
  Carousel = 'CAROUSEL',
  Escalator = 'ESCALATOR',
  LiHomeBottom = 'LI_HOME_BOTTOM',
  SignInRight = 'SIGN_IN_RIGHT',
  SurveySummarySideBar = 'SURVEY_SUMMARY_SIDE_BAR',
  TopBar = 'TOP_BAR',
}

/** A Website collector is divided into these "Popup" types. */
export enum PopupType {
  /** "Embedded Survey". Embed survey, does not have close button */
  Embedded = 'EMBEDDED',
  /** "Popup Invitation". Embed widget contains link to take survey on surveymonkey.com */
  Invitation = 'INVITATION',
  /** "Popup Survey". Embed whole survey on page, has close button */
  Survey = 'SURVEY',
}

export type PostcodeMetadata = {
  __typename?: 'PostcodeMetadata';
  areaCode: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  postalCode: Scalars['String'];
  region: Scalars['String'];
};

export type PresentationLayoutOptions = {
  __typename?: 'PresentationLayoutOptions';
  placement: QuestionLayoutPlacement;
  spacing: QuestionLayoutSpacingOptions;
};

export type PresentationQuestion = SurveyQuestion & {
  __typename?: 'PresentationQuestion';
  absolutePosition: Scalars['Int'];
  displayNumber: Scalars['Int'];
  displayOptions: SurveyQuestionDisplayOptions;
  headers: Array<SurveyQuestionHeader>;
  id: Scalars['ID'];
  isAudience: Scalars['Boolean'];
  nickname: Scalars['String'];
  pageId: Scalars['ID'];
  position: Scalars['Int'];
  type: SurveyQuestionType;
  validation: SurveyQuestionValidationOptions;
  visible: Scalars['Boolean'];
};

export type PresentationQuestionQm = SurveyQuestionQm & {
  __typename?: 'PresentationQuestionQM';
  createdAt: Scalars['DateTime'];
  family: SurveyQuestionFamily;
  hasPiping: Scalars['Boolean'];
  heading: QuestionHeadingConfiguration;
  id: Scalars['ID'];
  layout: PresentationLayoutOptions;
  modifiedAt: Scalars['DateTime'];
  position: QuestionPosition;
  variant: SurveyQuestionVariant;
};

export type PresentationQuestionTemplate = SurveyQuestionTemplate & {
  __typename?: 'PresentationQuestionTemplate';
  attributes: Array<SurveyQuestionTemplateAttribute>;
  heading: Scalars['String'];
  id: Scalars['ID'];
  logicalLink: SurveyQuestionTemplateLogicalLink;
  modifiers: Array<SurveyQuestionTemplateModifier>;
};

export type PreviewConceptTestingCrossTabTableInput = {
  banners: Array<CrossTabTableBannerInput>;
  filter?: InputMaybe<AnalysisFilterInput>;
  projectId: Scalars['ID'];
  stubs: Array<CrossTabTableStubInput>;
};

export type PreviewConceptTestingCrossTabTablePayload = {
  __typename?: 'PreviewConceptTestingCrossTabTablePayload';
  crosstab?: Maybe<ConceptTestingCrossTabTablePreview>;
  success: Scalars['Boolean'];
};

export type PreviewPalette = {
  __typename?: 'PreviewPalette';
  colors: Array<Maybe<Scalars['String']>>;
  id: Scalars['ID'];
};

export type PreviewSubscriptionUpgradeInput = {
  address: PurchaseBillingAddress;
  partner: BillingPartner;
  products: Array<CreateCartProduct>;
};

export type PriceItem = {
  __typename?: 'PriceItem';
  country?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  metadata: PriceMetaData;
  priceId: Scalars['ID'];
  productId: Scalars['ID'];
  taxBehavior?: Maybe<Scalars['String']>;
  unitAmount: Scalars['Int'];
};

export type PriceMetaData = {
  __typename?: 'PriceMetaData';
  priceType: Scalars['String'];
  skuCostId: Scalars['ID'];
};

/**
 * Gets the list of packages based off an "experience'.
 * An experience can be different based on the user's
 * current pricing experiment.  The experience can give a
 * different bundle, prices, packages etc...
 */
export type PricingExperience = {
  __typename?: 'PricingExperience';
  country?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  package?: Maybe<Array<PricingExperiencePackage>>;
};

/**
 * The items of any given package.
 * details and features are required
 * sku cost and bundles are optional
 * for any given package
 */
export type PricingExperiencePackage = {
  __typename?: 'PricingExperiencePackage';
  bundle: Array<Maybe<PackageBundle>>;
  details: PackageDetails;
  features: PricingFeatureSet;
  package: PricingPackage;
  skuCost: Array<Maybe<PricingSkuCost>>;
};

export type PricingFeatureSet = {
  __typename?: 'PricingFeatureSet';
  aBTesting?: Maybe<Scalars['Boolean']>;
  addUsers?: Maybe<Scalars['Boolean']>;
  adminDashboard?: Maybe<Scalars['Boolean']>;
  advancedLogic?: Maybe<Scalars['Boolean']>;
  allLanguagesSupported?: Maybe<Scalars['Boolean']>;
  analyzeAccessBenchmarking?: Maybe<Scalars['Boolean']>;
  analyzeCanCustomizeCharts?: Maybe<Scalars['Boolean']>;
  analyzeCanExportHideBranding?: Maybe<Scalars['Boolean']>;
  analyzeCanExportTa?: Maybe<Scalars['Boolean']>;
  analyzeCanSaveViews?: Maybe<Scalars['Boolean']>;
  analyzeCanShareCustomizeBranding?: Maybe<Scalars['Boolean']>;
  analyzeCanShareCustomizeDomain?: Maybe<Scalars['Boolean']>;
  analyzeCanTaSearch?: Maybe<Scalars['Boolean']>;
  analyzeCanTaTag?: Maybe<Scalars['Boolean']>;
  analyzeDeleteRespondentLimit?: Maybe<Scalars['String']>;
  analyzeExportEnabled?: Maybe<Scalars['Boolean']>;
  analyzeExportSpssEnabled?: Maybe<Scalars['Boolean']>;
  analyzeIntegrations?: Maybe<Scalars['Boolean']>;
  analyzePasswordEnabled?: Maybe<Scalars['Boolean']>;
  analyzeResponseDeleteLimit?: Maybe<Scalars['String']>;
  analyzeResponseLimit?: Maybe<Scalars['String']>;
  analyzeResultsTogether?: Maybe<Scalars['Boolean']>;
  analyzeRuleLimit?: Maybe<Scalars['String']>;
  analyzeSharedResultsEnabled?: Maybe<Scalars['Boolean']>;
  analyzeTaEnabled?: Maybe<Scalars['Boolean']>;
  analyzeTrendsEnabled?: Maybe<Scalars['Boolean']>;
  apiAccess?: Maybe<Scalars['Boolean']>;
  assetLibrary?: Maybe<Scalars['Boolean']>;
  assignAdminRole?: Maybe<Scalars['Boolean']>;
  benchmarks?: Maybe<Scalars['Boolean']>;
  buildSurveysTogether?: Maybe<Scalars['Boolean']>;
  carryForward?: Maybe<Scalars['Boolean']>;
  collaboration?: Maybe<Scalars['Boolean']>;
  collectContactInformation?: Maybe<Scalars['Boolean']>;
  collectEmailThrottleLimit?: Maybe<Scalars['String']>;
  collectEndPageQuestionBankDemographics?: Maybe<Scalars['Boolean']>;
  collectMinDailyMessagesLimit?: Maybe<Scalars['String']>;
  collectorCompletionUrlEnabled?: Maybe<Scalars['Boolean']>;
  collectorContactListLimit?: Maybe<Scalars['String']>;
  collectorCreateLimit?: Maybe<Scalars['String']>;
  collectorEmailLimit?: Maybe<Scalars['String']>;
  collectorFriendlyUrlEnabled?: Maybe<Scalars['Boolean']>;
  collectorMaxResponsesDeleteCount?: Maybe<Scalars['String']>;
  collectorRecipientsLimit?: Maybe<Scalars['String']>;
  collectorsRead?: Maybe<Scalars['Boolean']>;
  collectorsWrite?: Maybe<Scalars['Boolean']>;
  collectorThankYouEnabled?: Maybe<Scalars['Boolean']>;
  collectorWhiteLabelEnabled?: Maybe<Scalars['Boolean']>;
  collectorZoomEnabled?: Maybe<Scalars['Boolean']>;
  collectResponses?: Maybe<Scalars['Boolean']>;
  consolidatedBilling?: Maybe<Scalars['Boolean']>;
  contactsRead?: Maybe<Scalars['Boolean']>;
  contactsWrite?: Maybe<Scalars['Boolean']>;
  createCustomHtmlEmailMessageEnabled?: Maybe<Scalars['Boolean']>;
  createCustomThemeEnabled?: Maybe<Scalars['Boolean']>;
  createCustomVariablesEnabled?: Maybe<Scalars['Boolean']>;
  createGrayscaleFooter?: Maybe<Scalars['Boolean']>;
  createLogoEnabled?: Maybe<Scalars['Boolean']>;
  createPipingEnabled?: Maybe<Scalars['Boolean']>;
  createPrintEnabled?: Maybe<Scalars['Boolean']>;
  createQuestionLimit?: Maybe<Scalars['String']>;
  createQuotasEnabled?: Maybe<Scalars['Boolean']>;
  createRandomAssignmentEnabled?: Maybe<Scalars['Boolean']>;
  createRandomizationEnabled?: Maybe<Scalars['Boolean']>;
  createSkipLogicEnabled?: Maybe<Scalars['Boolean']>;
  createTemplatesEnabled?: Maybe<Scalars['Boolean']>;
  createToggleFooterEnabled?: Maybe<Scalars['Boolean']>;
  customCharts?: Maybe<Scalars['Boolean']>;
  customizeDisqualificationPageEnabled?: Maybe<Scalars['Boolean']>;
  customTemplates?: Maybe<Scalars['Boolean']>;
  dataOwnership?: Maybe<Scalars['Boolean']>;
  disableClosedPageBrandingEnabled?: Maybe<Scalars['Boolean']>;
  disableEmailMessageBrandingEnabled?: Maybe<Scalars['Boolean']>;
  disableFooterBrandingEnabled?: Maybe<Scalars['Boolean']>;
  downloadAsCsvXlsPdf?: Maybe<Scalars['Boolean']>;
  downloadAsPpt?: Maybe<Scalars['Boolean']>;
  emailSupport?: Maybe<Scalars['Boolean']>;
  emailTrackingEnabled?: Maybe<Scalars['Boolean']>;
  enableIpBlocking?: Maybe<Scalars['Boolean']>;
  essentialQuestionTypes?: Maybe<Scalars['Boolean']>;
  extendedPiping?: Maybe<Scalars['Boolean']>;
  extractData?: Maybe<Scalars['Boolean']>;
  fileUpload?: Maybe<Scalars['Boolean']>;
  filterCrosstab?: Maybe<Scalars['Boolean']>;
  fiveZeroEightAccessibility?: Maybe<Scalars['Boolean']>;
  funnelingEnabled?: Maybe<Scalars['Boolean']>;
  goldFeaturesIncluded?: Maybe<Scalars['Boolean']>;
  groupContactsLimit?: Maybe<Scalars['String']>;
  groupsRead?: Maybe<Scalars['Boolean']>;
  groupsWrite?: Maybe<Scalars['Boolean']>;
  groupTemplates?: Maybe<Scalars['Boolean']>;
  hideExportBrandingEnabled?: Maybe<Scalars['Boolean']>;
  hipaaEnabled?: Maybe<Scalars['Boolean']>;
  kioskModeInactivityTimer?: Maybe<Scalars['Boolean']>;
  kioskModePasscodeLock?: Maybe<Scalars['Boolean']>;
  labelingTitlesNumbering?: Maybe<Scalars['Boolean']>;
  libraryRead?: Maybe<Scalars['Boolean']>;
  liteLibrary?: Maybe<Scalars['Boolean']>;
  matrixQuestionType?: Maybe<Scalars['Boolean']>;
  maxCollectorsPerSurvey?: Maybe<Scalars['String']>;
  maximumDailyMessages?: Maybe<Scalars['String']>;
  menuMatrixEnabled?: Maybe<Scalars['Boolean']>;
  metadataSettings?: Maybe<Scalars['Boolean']>;
  mobileSdkPullResponseDataEnabled?: Maybe<Scalars['Boolean']>;
  mtaSparkpostLowRiskIpPools?: Maybe<Scalars['Boolean']>;
  multilingual?: Maybe<Scalars['Boolean']>;
  multipleBlockRotationEnabled?: Maybe<Scalars['Boolean']>;
  multipleUsers?: Maybe<Scalars['Boolean']>;
  newStockThemes?: Maybe<Scalars['Boolean']>;
  numFreeResponses?: Maybe<Scalars['String']>;
  onboarding?: Maybe<Scalars['Boolean']>;
  pagination?: Maybe<Scalars['Boolean']>;
  paidToGroupRollout?: Maybe<Scalars['Boolean']>;
  passwordProtection?: Maybe<Scalars['Boolean']>;
  paymentQt?: Maybe<Scalars['Boolean']>;
  phoneSupport?: Maybe<Scalars['Boolean']>;
  plansBenchmarks?: Maybe<Scalars['Boolean']>;
  popUpCollector?: Maybe<Scalars['Boolean']>;
  premiumThemes?: Maybe<Scalars['Boolean']>;
  priorityEmailSupport?: Maybe<Scalars['Boolean']>;
  privateApps?: Maybe<Scalars['Boolean']>;
  progressBar?: Maybe<Scalars['Boolean']>;
  questionLibrary?: Maybe<Scalars['Boolean']>;
  questionLibraryIntl?: Maybe<Scalars['Boolean']>;
  quizzesPro?: Maybe<Scalars['Boolean']>;
  randomizeAnswerChoices?: Maybe<Scalars['Boolean']>;
  ratingQuestionType?: Maybe<Scalars['Boolean']>;
  realTimeResults?: Maybe<Scalars['Boolean']>;
  receiveTransferredSurveyEnabled?: Maybe<Scalars['Boolean']>;
  recordRespondentEmailAddress?: Maybe<Scalars['Boolean']>;
  recurringSurveys?: Maybe<Scalars['Boolean']>;
  requireAnswer?: Maybe<Scalars['Boolean']>;
  responsesRead?: Maybe<Scalars['Boolean']>;
  responsesReadDetail?: Maybe<Scalars['Boolean']>;
  responsesWrite?: Maybe<Scalars['Boolean']>;
  rolesRead?: Maybe<Scalars['Boolean']>;
  rolesWrite?: Maybe<Scalars['Boolean']>;
  selectFeaturesIncluded?: Maybe<Scalars['Boolean']>;
  sendSurveys?: Maybe<Scalars['Boolean']>;
  sentimentAnalysis?: Maybe<Scalars['Boolean']>;
  setMaxResponseCount?: Maybe<Scalars['Boolean']>;
  setSurveyEndDate?: Maybe<Scalars['Boolean']>;
  sharedGroupLibrary?: Maybe<Scalars['Boolean']>;
  sharedLibrary?: Maybe<Scalars['Boolean']>;
  shareSurveys?: Maybe<Scalars['Boolean']>;
  showCreateHeaderUpgradeButton?: Maybe<Scalars['Boolean']>;
  showSigDiffsEnabled?: Maybe<Scalars['Boolean']>;
  singleSignOn?: Maybe<Scalars['Boolean']>;
  sslTlsEncryption?: Maybe<Scalars['Boolean']>;
  statisticalSignificance?: Maybe<Scalars['Boolean']>;
  surveysRead?: Maybe<Scalars['Boolean']>;
  surveysWrite?: Maybe<Scalars['Boolean']>;
  surveyTemplatesIntl?: Maybe<Scalars['Boolean']>;
  teamOwnership?: Maybe<Scalars['Boolean']>;
  teamsEnabled?: Maybe<Scalars['Boolean']>;
  teamThemes?: Maybe<Scalars['Boolean']>;
  textFormatting?: Maybe<Scalars['Boolean']>;
  trackEmailResponses?: Maybe<Scalars['Boolean']>;
  tryBeforeYouBuyEnabled?: Maybe<Scalars['Boolean']>;
  userManagement?: Maybe<Scalars['Boolean']>;
  usersRead?: Maybe<Scalars['Boolean']>;
  validateAnswer?: Maybe<Scalars['Boolean']>;
  videoQuestionType?: Maybe<Scalars['Boolean']>;
  viewRespondentIpAddress?: Maybe<Scalars['Boolean']>;
  webhooksRead?: Maybe<Scalars['Boolean']>;
  webhooksWrite?: Maybe<Scalars['Boolean']>;
  workgroupsMembersRead?: Maybe<Scalars['Boolean']>;
  workgroupsMembersWrite?: Maybe<Scalars['Boolean']>;
  workgroupsRead?: Maybe<Scalars['Boolean']>;
  workgroupsSharesRead?: Maybe<Scalars['Boolean']>;
  workgroupsSharesWrite?: Maybe<Scalars['Boolean']>;
  workgroupsWrite?: Maybe<Scalars['Boolean']>;
};

export type PricingMetadata = {
  __typename?: 'PricingMetadata';
  amount: Scalars['Int'];
  currencyCode: Scalars['String'];
  experimentName?: Maybe<Scalars['String']>;
  isDefault: Scalars['Boolean'];
  renewalInterval: RenewalType;
  renewalIntervalCount: Scalars['Int'];
  stripeID: Scalars['String'];
  taxBehavior: PricingTaxBehavior;
};

export enum PricingPackage {
  AdvantageAnnual = 'ADVANTAGE_ANNUAL',
  AdvantageMonthly = 'ADVANTAGE_MONTHLY',
  AnalyzeMonthly = 'ANALYZE_MONTHLY',
  Basic = 'BASIC',
  EntPlatinum = 'ENT_PLATINUM',
  PremierAnnual = 'PREMIER_ANNUAL',
  PremierMonthly = 'PREMIER_MONTHLY',
  StandardAnnual = 'STANDARD_ANNUAL',
  StandardMonthly = 'STANDARD_MONTHLY',
  TeamAdvantageAnnual = 'TEAM_ADVANTAGE_ANNUAL',
  TeamPremierAnnual = 'TEAM_PREMIER_ANNUAL',
}

/**
 * For logged out users, pricing pages will forward around
 * arbitrary key/value pairs in an encrypted SM parameter. This
 * will allow the client to pass any additional parameters
 * to a pricing page call that need to be encrypted.
 */
export type PricingPageEncryptParam = {
  key: Scalars['String'];
  value: Scalars['String'];
};

/**
 * Returns a pricing experience with server side data decorations. Does
 * the following additional actions:
 * - check for an actice price test and return cookies for LO users
 * - decorate packages with encrypted parameters for sign up page
 */
export type PricingPageExperience = {
  __typename?: 'PricingPageExperience';
  country?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  package?: Maybe<Array<PricingPageExperiencePackage>>;
  priceTestCookies?: Maybe<Array<ExperimentV1SetCookie>>;
};

/**
 * Clone of PricingExperiencePackage with added server side
 * decorated fields for pricing pages
 */
export type PricingPageExperiencePackage = {
  __typename?: 'PricingPageExperiencePackage';
  bundle: Array<Maybe<PackageBundle>>;
  details: PackageDetails;
  encryptedCtaParam?: Maybe<Scalars['String']>;
  features: PricingFeatureSet;
  package: PricingPackage;
  skuCost: Array<Maybe<PricingSkuCost>>;
};

export type PricingSkuCost = {
  __typename?: 'PricingSkuCost';
  cost: Scalars['Int'];
  country: Scalars['String'];
  currency: CurrencyData;
  label: Scalars['String'];
  sku: PricingSkuId;
  skuType: PricingSkuTypeId;
};

export enum PricingSkuId {
  AdvantageAnnualPlanAdditionalSeat = 'ADVANTAGE_ANNUAL_PLAN_ADDITIONAL_SEAT',
  AdvantageAnnualPlanCoreSeat = 'ADVANTAGE_ANNUAL_PLAN_CORE_SEAT',
  AdvantageMonthlyPlanCoreSeat = 'ADVANTAGE_MONTHLY_PLAN_CORE_SEAT',
  AnnualUpgradeCredit = 'ANNUAL_UPGRADE_CREDIT',
  AudienceAdminTool = 'AUDIENCE_ADMIN_TOOL',
  AudienceBundledCredits = 'AUDIENCE_BUNDLED_CREDITS',
  AudienceDiscountedCredits = 'AUDIENCE_DISCOUNTED_CREDITS',
  AudienceErrorFixingCredits = 'AUDIENCE_ERROR_FIXING_CREDITS',
  AudienceInternalCredits = 'AUDIENCE_INTERNAL_CREDITS',
  AudiencePaidCredits = 'AUDIENCE_PAID_CREDITS',
  AudiencePromotionalCredits = 'AUDIENCE_PROMOTIONAL_CREDITS',
  AudienceResponse = 'AUDIENCE_RESPONSE',
  AudienceResponseAu = 'AUDIENCE_RESPONSE_AU',
  AudienceResponseCa = 'AUDIENCE_RESPONSE_CA',
  AudienceResponseGb = 'AUDIENCE_RESPONSE_GB',
  AudienceResponseNz = 'AUDIENCE_RESPONSE_NZ',
  AudienceResponseSg = 'AUDIENCE_RESPONSE_SG',
  CreditItem = 'CREDIT_ITEM',
  Enterprise = 'ENTERPRISE',
  EnterprisePlanAdditionalSeat = 'ENTERPRISE_PLAN_ADDITIONAL_SEAT',
  EnterprisePlanCoreSeat = 'ENTERPRISE_PLAN_CORE_SEAT',
  EnterpriseResellerSoftbank = 'ENTERPRISE_RESELLER_SOFTBANK',
  EnterpriseResellerSunbridge = 'ENTERPRISE_RESELLER_SUNBRIDGE',
  FlexMonthlyPlanCoreSeat = 'FLEX_MONTHLY_PLAN_CORE_SEAT',
  MiscOneTime = 'MISC_ONE_TIME',
  PackageCredits = 'PACKAGE_CREDITS',
  PremierAnnualPlanAdditionalSeat = 'PREMIER_ANNUAL_PLAN_ADDITIONAL_SEAT',
  PremierAnnualPlanCoreSeat = 'PREMIER_ANNUAL_PLAN_CORE_SEAT',
  PremierMonthlyPlanCoreSeat = 'PREMIER_MONTHLY_PLAN_CORE_SEAT',
  ResponseOverage = 'RESPONSE_OVERAGE',
  SalesforceProPackage = 'SALESFORCE_PRO_PACKAGE',
  SalesforceProPlusPackage = 'SALESFORCE_PRO_PLUS_PACKAGE',
  SalesforceStarterPackage = 'SALESFORCE_STARTER_PACKAGE',
  StandardAnnualPlanAdditionalSeat = 'STANDARD_ANNUAL_PLAN_ADDITIONAL_SEAT',
  StandardAnnualPlanCoreSeat = 'STANDARD_ANNUAL_PLAN_CORE_SEAT',
  StandardMonthlyPlanCoreSeat = 'STANDARD_MONTHLY_PLAN_CORE_SEAT',
  TeamAdvantageAnnualPlanAdditionalSeat = 'TEAM_ADVANTAGE_ANNUAL_PLAN_ADDITIONAL_SEAT',
  TeamAdvantageAnnualPlanCoreSeat = 'TEAM_ADVANTAGE_ANNUAL_PLAN_CORE_SEAT',
  TeamPremierAnnualPlanAdditionalSeat = 'TEAM_PREMIER_ANNUAL_PLAN_ADDITIONAL_SEAT',
  TeamPremierAnnualPlanCoreSeat = 'TEAM_PREMIER_ANNUAL_PLAN_CORE_SEAT',
}

export enum PricingSkuTypeId {
  AnnualUpgrade = 'ANNUAL_UPGRADE',
  AudienceWallet = 'AUDIENCE_WALLET',
  Benchmark = 'BENCHMARK',
  Discount = 'DISCOUNT',
  Incentives = 'INCENTIVES',
  Misc = 'MISC',
  OtherWallet = 'OTHER_WALLET',
  Panel = 'PANEL',
  Refund = 'REFUND',
  Responses = 'RESPONSES',
  Salesforce = 'SALESFORCE',
  Smi = 'SMI',
  Ssl = 'SSL',
  SubscriptionAdditionalSeat = 'SUBSCRIPTION_ADDITIONAL_SEAT',
  SubscriptionCoreSeat = 'SUBSCRIPTION_CORE_SEAT',
}

export enum PricingTaxBehavior {
  Exclusive = 'EXCLUSIVE',
  Inclusive = 'INCLUSIVE',
}

export type ProductAddOnSelectionInput = {
  createdBy: Scalars['Int'];
  isComplete?: InputMaybe<Scalars['Boolean']>;
  modifiedBy?: InputMaybe<Scalars['Int']>;
  quantity: Scalars['Int'];
  skuCostId: Scalars['Int'];
  skuId: Scalars['Int'];
  stripeAddonProductId: Scalars['String'];
  stripePriceId: Scalars['String'];
};

export enum ProductClass {
  Responses = 'RESPONSES',
  Seat = 'SEAT',
}

export type ProductMetaData = {
  __typename?: 'ProductMetaData';
  responsesInPack: Scalars['String'];
  skuId: Scalars['String'];
};

export type ProductPricingMetadata = {
  __typename?: 'ProductPricingMetadata';
  active: Scalars['Boolean'];
  canonicalName: Scalars['String'];
  default: Scalars['Int'];
  increment: Scalars['Int'];
  maximum: Scalars['Int'];
  minimum: Scalars['Int'];
  price: PricingMetadata;
  productClass: ProductClass;
  skuId: Scalars['Int'];
  stripeID: Scalars['String'];
};

export type ProductQuantity = {
  __typename?: 'ProductQuantity';
  default?: Maybe<Scalars['Int']>;
  increment?: Maybe<Scalars['Int']>;
  maximum?: Maybe<Scalars['Int']>;
  minimum?: Maybe<Scalars['Int']>;
};

export type ProductStimuliVariableConfiguration = ProjectVariableConfiguration & {
  __typename?: 'ProductStimuliVariableConfiguration';
  defaultLabel: Scalars['String'];
  enabled: Scalars['Boolean'];
  max: Scalars['Int'];
  min: Scalars['Int'];
};

/** data for a multiple choice question */
export type ProfileMultipleChoiceData = {
  __typename?: 'ProfileMultipleChoiceData';
  choices: Array<Scalars['String']>;
  name: Scalars['String'];
  other?: Maybe<Scalars['String']>;
};

/** input to a multiple choice question */
export type ProfileMultipleChoiceInput = {
  choices: Array<Scalars['String']>;
  other?: InputMaybe<Scalars['String']>;
};

export type ProfilerQuestion = {
  __typename?: 'ProfilerQuestion';
  answerOptions: Array<ProfilerQuestionAnswerOption>;
  answerOther?: Maybe<ProfilerQuestionAnswerOption>;
  name: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: ProfilerQuestionType;
};

export type ProfilerQuestionAnswerOption = {
  __typename?: 'ProfilerQuestionAnswerOption';
  /** answer display name */
  label: Scalars['String'];
  /** answer value */
  name: Scalars['String'];
};

/** represents the set of distinct question types currently supported */
export enum ProfilerQuestionType {
  MultipleChoice = 'MULTIPLE_CHOICE',
  SingleChoice = 'SINGLE_CHOICE',
}

/** A universal input type for all question types for the profiler */
export type ProfilerQuestionUpdateInput = {
  answer: Array<Scalars['String']>;
  name: Scalars['String'];
  otherAnswer?: InputMaybe<Scalars['String']>;
  type: ProfilerQuestionType;
};

export type ProfilerUpdatePayload = {
  __typename?: 'ProfilerUpdatePayload';
  profile?: Maybe<Array<Maybe<UserProfileItem>>>;
  success: Scalars['Boolean'];
};

/** data for a single choice question */
export type ProfileSingleChoiceData = {
  __typename?: 'ProfileSingleChoiceData';
  choice?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  other?: Maybe<Scalars['String']>;
};

/** input for a single choice response */
export type ProfileSingleChoiceInput = {
  choice?: InputMaybe<Scalars['String']>;
  other?: InputMaybe<Scalars['String']>;
};

export type Project = {
  answers: ProjectVariableAnswerList;
  collections: ProjectVariableCollectionList;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  links: ProjectLinks;
  module: Module;
  price?: Maybe<ProjectPrice>;
  status: ProjectStatus;
  subtype: ModuleSubType;
  templates: ProjectTemplateList;
  title: Scalars['String'];
  type: ModuleType;
};

export type ProjectAnswersArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type ProjectCollectionsArgs = {
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type ProjectTemplatesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type ProjectAudienceCollectorEntity = ProjectEntity & {
  __typename?: 'ProjectAudienceCollectorEntity';
  audienceProject?: Maybe<AudienceProject>;
  id: Scalars['ID'];
  subtype: ProjectEntitySubtype;
  type: ProjectEntityType;
};

/**
 * This data type is used to represent both standard attributes and
 * custom_attributes of the Use Case Project
 */
export type ProjectConceptTestingAnswer = {
  __typename?: 'ProjectConceptTestingAnswer';
  createdAt: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  /** id representing a custom string of Project ID with Variable ID, for instance: project123_variable456 */
  id: Scalars['ID'];
  type: ProjectVariableAnswerType;
  /** A stringified JSON object. Currently has an open data structure. */
  value: Scalars['String'];
  /** variableId representing Project Answer Variable ID */
  variableId: Scalars['ID'];
};

export type ProjectConceptTestingAttributes = {
  __typename?: 'ProjectConceptTestingAttributes';
  /** Custom attribute answer from the survey template. */
  customAnswer?: Maybe<ProjectConceptTestingAnswer>;
  /** id representing Project ID */
  id: Scalars['ID'];
  /** Attribute answer coming from the survey template. */
  projectAnswer: ProjectConceptTestingAnswer;
  projectVariable: ProjectVariable;
};

export type ProjectEntity = {
  id: Scalars['ID'];
  subtype: ProjectEntitySubtype;
  type: ProjectEntityType;
};

export enum ProjectEntitySubtype {
  Audience = 'AUDIENCE',
}

export enum ProjectEntityType {
  Analyze = 'ANALYZE',
  Collector = 'COLLECTOR',
  MmsSurvey = 'MMS_SURVEY',
  Survey = 'SURVEY',
}

export type ProjectFeasibility = {
  __typename?: 'ProjectFeasibility';
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};

export type ProjectInvoice = {
  __typename?: 'ProjectInvoice';
  billingRedirectUrl: Scalars['String'];
  id: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type ProjectInvoiceList = {
  __typename?: 'ProjectInvoiceList';
  items: Array<Maybe<ProjectInvoice>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProjectLinks = {
  __typename?: 'ProjectLinks';
  analyze: Scalars['String'];
  authoring: Scalars['String'];
  overview: Scalars['String'];
  reports: Scalars['String'];
};

export type ProjectPrice = {
  __typename?: 'ProjectPrice';
  cost?: Maybe<Scalars['Int']>;
  currency: Scalars['String'];
};

export enum ProjectStatus {
  Cancelled = 'CANCELLED',
  Collection = 'COLLECTION',
  Completion = 'COMPLETION',
  Creation = 'CREATION',
  Locked = 'LOCKED',
  PartialCompletion = 'PARTIAL_COMPLETION',
}

export type ProjectSurveyEntity = ProjectEntity & {
  __typename?: 'ProjectSurveyEntity';
  /** the number of blocks if the survey has block randomization */
  blockLimit?: Maybe<Scalars['Int']>;
  defaultPalette: Scalars['String'];
  defaultPreviewLink: Scalars['String'];
  demographicQuestions?: Maybe<SurveyQuestionList>;
  id: Scalars['ID'];
  palettes: Array<PreviewPalette>;
  responseCounts: ProjectSurveyResponseCounts;
  subtype: ProjectEntitySubtype;
  /** list of survey questions associated with the project */
  surveyQuestions: SurveyQuestionList;
  themeId: Scalars['ID'];
  type: ProjectEntityType;
};

export type ProjectSurveyEntityDemographicQuestionsArgs = {
  families?: InputMaybe<Array<SurveyQuestionTypeFamily>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ProjectSurveyEntityResponseCountsArgs = {
  filter?: InputMaybe<AnalysisFilterInput>;
};

export type ProjectSurveyEntitySurveyQuestionsArgs = {
  families?: InputMaybe<Array<SurveyQuestionTypeFamily>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ProjectSurveyResponseCounts = {
  __typename?: 'ProjectSurveyResponseCounts';
  filtered: Scalars['Int'];
  total: Scalars['Int'];
};

export type ProjectTemplate = {
  __typename?: 'ProjectTemplate';
  canonicalName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  fulfillmentType: ProjectTemplateFulfillmentType;
  id: Scalars['ID'];
  subtype?: Maybe<ProjectTemplateSubType>;
  type: ProjectTemplateType;
  variables: ProjectVariableList;
};

export type ProjectTemplateVariablesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export enum ProjectTemplateFulfillmentType {
  Change = 'CHANGE',
  CheckoutPaid = 'CHECKOUT_PAID',
}

export type ProjectTemplateList = {
  __typename?: 'ProjectTemplateList';
  items: Array<ProjectTemplate>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum ProjectTemplateSubType {
  Audience = 'AUDIENCE',
}

export enum ProjectTemplateType {
  Analyze = 'ANALYZE',
  Collector = 'COLLECTOR',
  Survey = 'SURVEY',
}

export type ProjectVariable = {
  __typename?: 'ProjectVariable';
  canonicalName: Scalars['String'];
  configuration?: Maybe<ProjectVariableConfiguration>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  required: Scalars['Boolean'];
  subtype: ProjectVariableSubType;
  type: ProjectVariableType;
};

export type ProjectVariableAnswer = {
  createdAt: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  type: ProjectVariableAnswerType;
  variableId: Scalars['ID'];
};

export type ProjectVariableAnswerList = {
  __typename?: 'ProjectVariableAnswerList';
  items: Array<ProjectVariableAnswer>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum ProjectVariableAnswerType {
  Question = 'QUESTION',
  QuestionBank = 'QUESTION_BANK',
  Value = 'VALUE',
}

export type ProjectVariableCollection = {
  __typename?: 'ProjectVariableCollection';
  canonicalName: Scalars['String'];
  label: Scalars['String'];
  variables: ProjectVariableList;
};

export type ProjectVariableCollectionVariablesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type ProjectVariableCollectionList = {
  __typename?: 'ProjectVariableCollectionList';
  items: Array<ProjectVariableCollection>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProjectVariableConfiguration = {
  enabled: Scalars['Boolean'];
};

export type ProjectVariableList = {
  __typename?: 'ProjectVariableList';
  items: Array<ProjectVariable>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum ProjectVariableSubType {
  Boolean = 'BOOLEAN',
  CommentBox = 'COMMENT_BOX',
  Dropdown = 'DROPDOWN',
  FileUpload = 'FILE_UPLOAD',
  MultipleChoice = 'MULTIPLE_CHOICE',
  Question = 'QUESTION',
  QuestionBank = 'QUESTION_BANK',
  QuestionList = 'QUESTION_LIST',
  SingleChoice = 'SINGLE_CHOICE',
  TextBox = 'TEXT_BOX',
}

export enum ProjectVariableType {
  Component = 'COMPONENT',
  Question = 'QUESTION',
}

export enum PublishedApplicationListingFilter {
  Featured = 'FEATURED',
  MostPopular = 'MOST_POPULAR',
  RecentlyAdded = 'RECENTLY_ADDED',
}

export enum PublishedApplicationListingLinkType {
  Install = 'INSTALL',
  Launch = 'LAUNCH',
  Upgrade = 'UPGRADE',
  VisitSite = 'VISIT_SITE',
}

export type PurchaseBillingAddress = {
  city?: InputMaybe<Scalars['String']>;
  complement?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  houseNumber?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  neighborhood?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  secondaryAddressLine?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  subdivision?: InputMaybe<Scalars['String']>;
};

export type PutSurveyPersonalizationEventInput = {
  eventData: PersonalizationEventDataInput;
  eventType: PutSurveyPersonalizationEventType;
};

export enum PutSurveyPersonalizationEventType {
  SurveyCompleted = 'SURVEY_COMPLETED',
}

export type QnAComment = {
  __typename?: 'QnAComment';
  rows?: Maybe<Array<SurveyQuestionOption>>;
  searchOperator?: Maybe<AnalysisQuestionCommentSearchOperator>;
  searchTerm: Scalars['String'];
  searchType?: Maybe<AnalysisQuestionOptionSearchType>;
};

export type QnACommentInput = {
  rows?: InputMaybe<Array<Scalars['ID']>>;
  searchOperator?: InputMaybe<AnalysisQuestionOptionSearchType>;
  searchTerm: Scalars['String'];
  searchType?: InputMaybe<AnalysisQuestionOptionSearchType>;
};

/** Filter results by Question And Answers */
export type QnAFilter = AnalysisStandardViewFilterRule & {
  __typename?: 'QnAFilter';
  active: Scalars['Boolean'];
  answers: Array<Maybe<QnAFilterAnswer>>;
  comment?: Maybe<QnAComment>;
  customHeading?: Maybe<Scalars['String']>;
  defaultHeading: Scalars['String'];
  id: Scalars['ID'];
  questionToFilter: SurveyQuestion;
};

export type QnAFilterAnswer = {
  __typename?: 'QnAFilterAnswer';
  cols?: Maybe<Array<SurveyQuestionOption>>;
  rows?: Maybe<Array<SurveyQuestionOption>>;
};

export type QnAFilterAnswerInput = {
  cols?: InputMaybe<Array<Scalars['ID']>>;
  rows?: InputMaybe<Array<Scalars['ID']>>;
};

export type QnAFilterInput = {
  answers: Array<QnAFilterAnswerInput>;
  comment?: InputMaybe<QnACommentInput>;
  questionId: Scalars['ID'];
};

export type Query = {
  __typename?: 'Query';
  adminPing: Scalars['String'];
  allAttributeWordClouds: Array<Maybe<AttributeWordClouds>>;
  /** Get the current analyze view */
  analysisCurrentView?: Maybe<AnalysisStandardView>;
  analysisExportJob?: Maybe<AnalysisExportJob>;
  analysisExportJobs?: Maybe<AnalysisExportJobList>;
  /** Get tags for question in a survey */
  analysisQuestionTags?: Maybe<AnalysisQuestionTags>;
  analysisRespondentSummary?: Maybe<ResponseSummaryList>;
  /** Get all saved views */
  analysisSavedViews?: Maybe<AnalysisStandardViewList>;
  /** Get a shared view */
  analysisSharedView?: Maybe<AnalysisSharedView>;
  /** Get all shared views for a survey */
  analysisSharedViews?: Maybe<AnalysisSharedViewList>;
  /** Get a standard analyze view */
  analysisStandardView?: Maybe<AnalysisStandardView>;
  /**
   * Returns a type that contains all analytics for 1D data (e.g. a 1D
   * enumeration question).
   */
  analytics1D: Analytics1D;
  /**
   * Returns a type that contains all analytics for 2D data (e.g. a 2D
   * enumeration question, or a 1D crosstab).
   */
  analytics2D: Analytics2D;
  /** Returns a type that contains all analytics for textual analytics data. */
  analyticsText: AnalyticsText;
  attributeScorecard?: Maybe<AttributeScorecard>;
  attributeScorecards: Array<AttributeScorecard>;
  /** Get multiple Bulk Audience projects. Projects are linked by the bulk project ID. */
  audienceBulkProjectsByCollectorId: AudienceProjectList;
  /** get the list of countries available to target for Audience projects */
  audienceCountries: Array<AudienceCountryOption>;
  /** get the list of targeting criteria options for a given country */
  audienceCriteria: AudienceCriteria;
  audienceGeniusRecommendationsV2?: Maybe<
    AudienceGeniusRecommendationsV2Payload
  >;
  /** get the detected audience guardrails on a project */
  audienceGuardrails: AudienceGuardrails;
  /** get a single audience project */
  audienceProject: AudienceProjectPayload;
  /** Get the Audience project associated with the encrypted billing token. */
  audienceProjectByBillingToken?: Maybe<AudienceProjectBillingCompletePayload>;
  audienceProjectFeasibility: AudienceFeasibility;
  /** Get multiple Audience projects for a user. */
  audienceProjects: AudienceProjectList;
  /** Get a list of saved Audience configurations that have been created by the current user. */
  audienceSavedFavorites: AudienceSavedFavoriteList;
  availableCollectorTypesForSurvey: Array<CollectorTypeAvailability>;
  /** Returns a list of the packages available for purchase in a customer's locale */
  availablePackages: PackageSummaries;
  /** Returns a list of billing contacts for the logged-in user, for the specified billing partner */
  billingContacts: BillingContactList;
  /** Returns the billing customer metadata (e.g. name, company, taxID) for the logged-in user+partner */
  billingCustomer?: Maybe<BillingCustomerMetadata>;
  /** Gets the tax record (taxID, validation, etc) for the logged in user+partner */
  billingCustomerTaxRecord?: Maybe<BillingCustomerTaxRecord>;
  /** Returns a list of Stripe billing invoices for the logged-in user, for the specified billing partner */
  billingInvoices: StripeInvoiceList;
  /** get status bulk transfer */
  bulkTransferSurveysStatus: BulkTransferSurveyResult;
  /** Get the list of available countries, with translated names for languageCode */
  checkoutCountries: CheckoutCountryList;
  /** Get a single collector */
  collector?: Maybe<Collector>;
  /** Get the list of collectors for a survey */
  collectors?: Maybe<CollectorList>;
  /**
   * Get Information on deleted collectors
   * Implemented:
   *   deletedCount
   * Not Implemented:
   *   paginated list of deleted collector data
   */
  collectorsDeleted?: Maybe<CollectorsDeleted>;
  /** Get a single crosstab */
  conceptTestingCrossTab?: Maybe<ConceptTestingCrossTabReport>;
  /** get a list of crosstabs for a given project */
  conceptTestingCrossTabList: ConceptTestingCrossTabReportList;
  conceptTestingProject?: Maybe<ConceptTestingProject>;
  contentModules: Array<ContentModule>;
  /** Returns if the given country is tax-exclusive or not */
  countryIsTaxExclusive: Scalars['Boolean'];
  countryMetadata?: Maybe<CountryMetadata>;
  /** Get a single crosstab */
  crosstabReport?: Maybe<CrossTabReport>;
  /** Get a list of crosstabs for a survey */
  crosstabReportList?: Maybe<CrossTabReportList>;
  /** Get info about the currency used in the given country */
  currencyForCountry?: Maybe<CurrencyInfo>;
  customEmailDomainByGroup?: Maybe<CustomEmailDomain>;
  customEmailDomainVerificationStatus?: Maybe<
    CustomEmailDomainVerificationStatus
  >;
  customQuestionResponseSummaries: Array<CustomQuestionResponseSummaryList>;
  /** Retrieve response summaries for a list of custom questions from a project. */
  customQuestionResponseSummariesByIds: Array<
    CustomQuestionResponseSummaryList
  >;
  /** used to get all stimulus details charts */
  customQuestionResponseSummariesByStimulus: Array<
    CustomQuestionResponseSummaryListByStimulus
  >;
  /** Get custom question response summary */
  customQuestionResponseSummary?: Maybe<CustomQuestionResponseSummary>;
  customQuestionWordClouds: Array<WordCloud>;
  /** Get a single dashboard */
  dashboard?: Maybe<AnalysisResultsDashboard>;
  /** Get a list of dashboards for a survey */
  dashboardList?: Maybe<AnalysisResultsDashboardList>;
  dashboardQuestionData?: Maybe<DashboardQuestionData>;
  /** Returns the default assets (image, Theme) from the user's  library */
  defaultAssetsByUserId: DefaultAssets;
  /** Returns the default assets permissions from the user's  library */
  defaultAssetsSettings: DefaultAssetsSettingsLibrary;
  /** Returns the admin settings for this enterprise end page */
  defaultEndPageSettings: DefaultEndPageSettings;
  /** Get the list of form fields for the billing details form for a given country */
  detailsFormFields: DetailsFormFieldSet;
  discoverableTeams?: Maybe<DiscoverableTeamsList>;
  emailRecipientBySMToken?: Maybe<CollectorEmailRecipient>;
  entityAutocomplete?: Maybe<EntityAutocompleteData>;
  /** Get all experiments */
  experiments: Array<Experiment>;
  filterTitles?: Maybe<Array<Maybe<RuleDescription>>>;
  /**
   * Get user data from an email revert token
   * @deprecated Clearbit deprecation CREATE-18066
   */
  getEmailRevertInfo?: Maybe<EmailRevertPayload>;
  getEntityQuestions?: Maybe<QuestionData>;
  /** Get created jobs */
  getOecJobs: Array<OecJob>;
  /** Get all keywords */
  getOecKeywords: Array<OecKeywordTag>;
  /** Get all tags */
  getOecQuestionTags: Array<OecQuestionTag>;
  /** Get all Responses for survey and question id. Include tags and stimuli */
  getOecResponses: OecResponseList;
  /** Get summary of Responses for survey and question id. */
  getOecResponseSummary: OecResponseSummary;
  getPackageFeatureSet: PackageFeatureSet;
  /** Get the current price test */
  getPriceTest?: Maybe<ExperimentV1Assignment>;
  getResponseAllocation: ResponseAllocation;
  getResponseBasedPricingSummary: ResponseBasedPricingSummary;
  getResponseBundles?: Maybe<ResponsePackages>;
  /** get the stats for the current survey */
  getSurveyStats: SurveyStatsResults;
  getUserBillingAccount: UserBillingAccount;
  installedApplications?: Maybe<ApplicationListingList>;
  inviteRequests?: Maybe<InviteRequestsList>;
  /** Gets full details (with line items) for a user's billing invoice */
  invoiceDetails: StripeInvoice;
  /**
   * Is this email address valid. Optionally, pass in a userId because
   * there may be additional restrictions due to the user's team.
   * @deprecated Clearbit deprecation CREATE-18066
   */
  isEmailValid: IsEmailValidPayload;
  /**
   * Determine if a given password reset token is valid
   * @deprecated Clearbit deprecation CREATE-18066
   */
  isValidToken?: Maybe<Scalars['Boolean']>;
  libraryAssetById?: Maybe<CreateLibraryAssetPayload>;
  /** Returns a temporary S3 link to download Image or Document library asset */
  libraryAssetDownloadUrl: LibraryAssetDownloadUrlPayload;
  libraryAssets: LibraryAssetsList;
  locationAutocomplete?: Maybe<LocationAutocompleteData>;
  /** Signs up a src url with Looker and returns the the signed URL */
  lookerAuth?: Maybe<LookerAuth>;
  /**
   * Sends a query via moduleapi to Looker and gets a response in the specified
   * format.
   */
  lookerExport?: Maybe<LookerExportResponse>;
  /** Either returns a query task status and, if the query is complete, it returns the query data. */
  lookerQueryTask?: Maybe<LookerQueryTask>;
  marketingEmailPreferences?: Maybe<MarketingEmailPreferences>;
  marketMeasurementInsights?: Maybe<MarketMeasurementInsightsPayload>;
  marketMeasurementSolutionsPerformanceScores: Array<
    MarketMeasurementSolutionsPerformanceScore
  >;
  /** get the master scorecard associated with the project */
  masterScorecard?: Maybe<MasterScorecard>;
  modules?: Maybe<ModuleList>;
  otherAnswersByProject?: Maybe<SurveyOtherResponseList>;
  packagePricingForCountry?: Maybe<LocalizedPackagePricing>;
  postcodeMetadata?: Maybe<PostcodeMetadata>;
  previewApplicationListingDetails?: Maybe<ApplicationListing>;
  /** preview a crosstab table content by banners and stubs without saving */
  previewConceptTestingCrossTabTable: PreviewConceptTestingCrossTabTablePayload;
  /**
   * This grabs a pricing experience based on three items:
   * ( countryCode, languageCode, experienceName )
   * experienceName is either the name of the experiment
   * that a user belongs to, or the default experience
   */
  pricingExperience?: Maybe<PricingExperience>;
  /**
   * Pulls together and massages pricing data for a pricing
   * page display including price tests and encrypted link CTAs
   */
  pricingPageExperience?: Maybe<PricingPageExperience>;
  profilerQuestions?: Maybe<Array<ProfilerQuestion>>;
  project?: Maybe<Project>;
  projectAnswer?: Maybe<ProjectVariableAnswer>;
  projectAttributeData?: Maybe<ProjectConceptTestingAttributes>;
  projectByBillingToken?: Maybe<Project>;
  projectVariable?: Maybe<ProjectVariable>;
  publishedApplicationListingCategories: Array<ApplicationListingCategory>;
  publishedApplicationListingCategory?: Maybe<ApplicationListingCategory>;
  publishedApplicationListingDetails?: Maybe<ApplicationListing>;
  publishedApplicationListings?: Maybe<ApplicationListingList>;
  publishedApplicationListingsByKeyword?: Maybe<ApplicationListingList>;
  /** Get a single published dashboard */
  publishedDashboard?: Maybe<Dashboard>;
  /** Get whether user is authorized to have a list of specific permissions */
  rbacPermissions: Array<RbacPermission>;
  rbpUserAddOnProductSelections: RbpUserAddOnProductSelections;
  /** get a single respondent */
  respondent?: Maybe<Respondent>;
  /** get respondent for obfuscated respondent id in smParams */
  respondentObfuscated?: Maybe<Respondent>;
  /** Get the list of respondents for a survey, optionally by filter */
  respondents?: Maybe<RespondentList>;
  /**
   * get the scorecard associated with the project
   * returns either an attribute scorecard (if attributeId is in req)
   * or a summary scorecard
   */
  screenerScorecard?: Maybe<ScreenerScorecard>;
  screeningQuestions?: Maybe<ScreeningQuestions>;
  /** Get a single survey */
  searchSurveyQuestionTemplates?: Maybe<SurveyQuestionTemplateList>;
  /** Gets a solution object, which describes a market research product or suite of products. */
  solutionsSolution: SolutionsSolutionResponse;
  /** Gets a solutionStudy object. */
  solutionsStudy: SolutionsStudyResponse;
  solutionsStudyCheckoutInfo: SolutionsStudyCheckoutInfoPayload;
  /** Returns the specified stock theme from the free and premium stock themes */
  stockThemeByThemeName?: Maybe<SurveyTheme>;
  /** Returns a list of saved payment methods for this user */
  storedPaymentMethods: UserPaymentMethodList;
  /** Get a single survey */
  survey?: Maybe<Survey>;
  surveyByObfuscatedId?: Maybe<Survey>;
  surveyCategories?: Maybe<SurveyCategoryList>;
  surveyCategoryIdsByAttribute?: Maybe<SurveyCategoryIdList>;
  surveyQuizFeedback?: Maybe<SurveyQuizFeedback>;
  /** Get the trends of new responses being collected for a given survey */
  surveyRespondentTrend?: Maybe<SurveyRespondentTrend>;
  surveys?: Maybe<SurveyList>;
  /** Search for surveys by partial title match */
  surveysByTitle?: Maybe<SurveyList>;
  /** get survey taking session data */
  surveyTakingSession: SurveyTakingSessionResponse;
  surveyTemplate?: Maybe<SurveyTemplate>;
  surveyTemplateAttributes?: Maybe<SurveyTemplateAttributesList>;
  surveyTemplateByCanonicalNames: Array<SurveyTemplate>;
  surveyTemplateCategories?: Maybe<SurveyTemplateCategoryList>;
  surveyTemplates?: Maybe<SurveyTemplateList>;
  /** Search for survey templates by partial title match */
  surveyTemplatesByTitle?: Maybe<SurveyTemplateList>;
  surveyVersion: Scalars['Int'];
  /** Returns the default assets and restrictions for the user */
  teamDefaultAssetsAndRestrictions: DefaultAssetsRestrictions;
  teamImageAssets?: Maybe<TeamImageAssetsList>;
  /** Get a team invite by its invite token */
  teamInvite?: Maybe<TeamInvite>;
  /** Get a list of all template surveys for the user's team */
  teamSurveys?: Maybe<TeamSurveyList>;
  /** Search for team surveys by partial title match */
  teamSurveysByTitle?: Maybe<TeamSurveyList>;
  /** Returns the specified themeId */
  themeByThemeId?: Maybe<SurveyCssTheme>;
  /** Get a single tracking dashboard */
  trackingDashboard?: Maybe<TrackingDashboard>;
  /** Get a single tracking dashboard embed */
  trackingDashboardEmbed?: Maybe<TrackingDashboardEmbed>;
  /** Get a filter schema for tracking dashboard (regular not shared) */
  trackingDashboardFilterSchema?: Maybe<TrackingDashboardFilterSchema>;
  /** Get a list of tracking dashboards */
  trackingDashboards?: Maybe<TrackingDashboardList>;
  /** Returns a tracking project by its ID */
  trackingProject?: Maybe<TrackingProject>;
  /** Returns the status of the current ETL job for a tracking project if it exists */
  trackingProjectDataCleaning?: Maybe<TrackingProjectDataCleaning>;
  /** Get a single tracking shared dashboard */
  trackingSharedDashboard?: Maybe<TrackingSharedDashboard>;
  /** Returns the status of the current ETL job for a tracking project if it exists */
  trackingSharedDashboardDataCleaning?: Maybe<
    TrackingSharedDashboardDataCleaning
  >;
  /** Get a filter schema for tracking shared dashboard */
  trackingSharedDashboardFilterSchema?: Maybe<TrackingDashboardFilterSchema>;
  /** Get a single tracking shared dashboard sharing details */
  trackingSharedDashboardSharingDetails?: Maybe<
    TrackingSharedDashboardSharingDetails
  >;
  /** Returns a specific tracker from a tracking project */
  trackingTracker?: Maybe<TrackingTracker>;
  /** Returns a specific wave from a tracking project */
  trackingWave?: Maybe<TrackingWave>;
  useCaseCorrelationAnalysis?: Maybe<UseCaseCorrelationAnalysis>;
  useCaseExportJob?: Maybe<UseCaseExportJob>;
  useCasePerformanceScores: Array<UseCasePerformanceScore>;
  /** Get current and original view IDs for Use Cases */
  useCaseViewList?: Maybe<UseCaseViewList>;
  /** Get the calling user */
  user?: Maybe<User>;
  /** Get a user by ID. Not implemented yet. */
  userById?: Maybe<User>;
  /** Get whether user is authorized to have an specific permission */
  userPermission?: Maybe<UserPermission>;
  /** @deprecated Clearbit deprecation CREATE-18066 */
  userPersonalization?: Maybe<UserPersonalization>;
  userProfileItems?: Maybe<Array<UserProfileItem>>;
  /** Get a team member by team member id. Not implemented yet. */
  userTeamMembershipById?: Maybe<UserTeamMembership>;
  /** Validate if bulk transfer is possible. This does not actually transfer surveys. See also Mutations.bulkTransferSurveys. */
  validateBulkTransferSurveys: ValidateBulkTransferSurveyResults;
  /** the top level query for getting welcome flow state */
  welcomeFlowState?: Maybe<WelcomeFlowState>;
  wordCloudByProject?: Maybe<WordCloud>;
  wordCloudBySurvey?: Maybe<WordCloud>;
  /** Retrieve all word clouds for the survey and open-ended questions specified. */
  wordCloudsByQuestions: Array<WordCloud>;
};

export type QueryAllAttributeWordCloudsArgs = {
  filter?: InputMaybe<AnalysisFilterInput>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['ID'];
};

export type QueryAnalysisCurrentViewArgs = {
  surveyId: Scalars['ID'];
};

export type QueryAnalysisExportJobArgs = {
  id: Scalars['ID'];
  surveyId: Scalars['ID'];
};

export type QueryAnalysisExportJobsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  surveyId: Scalars['ID'];
};

export type QueryAnalysisQuestionTagsArgs = {
  surveyId: Scalars['ID'];
};

export type QueryAnalysisRespondentSummaryArgs = {
  filters?: InputMaybe<AnalysisFilterInput>;
  openEndResponseLimit?: InputMaybe<Scalars['Int']>;
  questionIdList: Array<InputMaybe<Scalars['ID']>>;
  surveyId: Scalars['ID'];
  useCache?: InputMaybe<Scalars['Boolean']>;
};

export type QueryAnalysisSavedViewsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  surveyId: Scalars['ID'];
};

export type QueryAnalysisSharedViewArgs = {
  id: Scalars['ID'];
};

export type QueryAnalysisSharedViewsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  surveyId: Scalars['ID'];
};

export type QueryAnalysisStandardViewArgs = {
  surveyId: Scalars['ID'];
  viewId: Scalars['ID'];
};

export type QueryAnalytics1DArgs = {
  filter?: InputMaybe<AnalysisFilterInput>;
  otherOptionId?: InputMaybe<Scalars['ID']>;
  questionId: Scalars['ID'];
  surveyId: Scalars['ID'];
};

export type QueryAnalytics2DArgs = {
  filter?: InputMaybe<AnalysisFilterInput>;
  otherOptionId?: InputMaybe<Scalars['ID']>;
  questionId: Scalars['ID'];
  surveyId: Scalars['ID'];
};

export type QueryAnalyticsTextArgs = {
  questionId: Scalars['ID'];
  surveyId: Scalars['ID'];
};

export type QueryAttributeScorecardArgs = {
  attributeId: Scalars['ID'];
  attributeQuestionId: Scalars['ID'];
  confidenceLevel?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<AnalysisFilterInput>;
  projectId: Scalars['ID'];
  selectedBenchmarks?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryAttributeScorecardsArgs = {
  confidenceLevel?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<AnalysisFilterInput>;
  projectId: Scalars['ID'];
  selectedBenchmarks?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryAudienceBulkProjectsByCollectorIdArgs = {
  collectorId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type QueryAudienceCriteriaArgs = {
  countryCode: Scalars['String'];
};

export type QueryAudienceGeniusRecommendationsV2Args = {
  input: AudienceGeniusRecommendationsV2Input;
};

export type QueryAudienceGuardrailsArgs = {
  input: AudienceGuardrailsInput;
};

export type QueryAudienceProjectArgs = {
  collectorId: Scalars['ID'];
  languageId: Scalars['Int'];
};

export type QueryAudienceProjectByBillingTokenArgs = {
  billingToken: Scalars['String'];
};

export type QueryAudienceProjectFeasibilityArgs = {
  input?: InputMaybe<AudienceFeasibilityInput>;
};

export type QueryAudienceProjectsArgs = {
  categories?: InputMaybe<Array<InputMaybe<AudienceProjectCategory>>>;
  collectorId?: InputMaybe<Scalars['ID']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<InputMaybe<AudienceProjectStatuses>>>;
  surveyId?: InputMaybe<Scalars['ID']>;
};

export type QueryAudienceSavedFavoritesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type QueryAvailableCollectorTypesForSurveyArgs = {
  surveyId: Scalars['ID'];
};

export type QueryAvailablePackagesArgs = {
  countryCode: Scalars['String'];
  partner: Scalars['String'];
};

export type QueryBillingContactsArgs = {
  partner: BillingPartner;
};

export type QueryBillingCustomerArgs = {
  partner: BillingPartner;
};

export type QueryBillingCustomerTaxRecordArgs = {
  partner: BillingPartner;
};

export type QueryBillingInvoicesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  partner: BillingPartner;
};

export type QueryBulkTransferSurveysStatusArgs = {
  transferId: Scalars['ID'];
};

export type QueryCheckoutCountriesArgs = {
  languageCode: Scalars['String'];
};

export type QueryCollectorArgs = {
  id: Scalars['ID'];
  surveyLangId?: InputMaybe<Scalars['ID']>;
};

export type QueryCollectorsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  surveyId: Scalars['ID'];
};

export type QueryCollectorsDeletedArgs = {
  surveyId: Scalars['ID'];
};

export type QueryConceptTestingCrossTabArgs = {
  projectId: Scalars['ID'];
  reportId: Scalars['ID'];
};

export type QueryConceptTestingCrossTabListArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['ID'];
};

export type QueryConceptTestingProjectArgs = {
  id: Scalars['ID'];
};

export type QueryContentModulesArgs = {
  pageUrl: Scalars['String'];
  placements: Array<Placement>;
};

export type QueryCountryIsTaxExclusiveArgs = {
  countryCode: Scalars['String'];
};

export type QueryCountryMetadataArgs = {
  countryCode: Scalars['String'];
};

export type QueryCrosstabReportArgs = {
  id: Scalars['ID'];
};

export type QueryCrosstabReportListArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  surveyId: Scalars['ID'];
};

export type QueryCurrencyForCountryArgs = {
  countryCode: Scalars['String'];
};

export type QueryCustomEmailDomainByGroupArgs = {
  groupId: Scalars['ID'];
};

export type QueryCustomEmailDomainVerificationStatusArgs = {
  sendingDomain: Scalars['String'];
};

export type QueryCustomQuestionResponseSummariesArgs = {
  compareByStimuliQuestionIds: Array<Scalars['ID']>;
  display?: InputMaybe<CustomQuestionDisplay>;
  filter?: InputMaybe<AnalysisFilterInput>;
  projectId: Scalars['ID'];
};

export type QueryCustomQuestionResponseSummariesByIdsArgs = {
  compareByStimuliQuestionIds: Array<Scalars['ID']>;
  filter?: InputMaybe<AnalysisFilterInput>;
  projectId: Scalars['ID'];
  questionIds: Array<Scalars['ID']>;
};

export type QueryCustomQuestionResponseSummariesByStimulusArgs = {
  display?: InputMaybe<CustomQuestionDisplay>;
  filter?: InputMaybe<AnalysisFilterInput>;
  projectId: Scalars['ID'];
};

export type QueryCustomQuestionResponseSummaryArgs = {
  compareByStimuli?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AnalysisFilterInput>;
  projectId: Scalars['ID'];
  questionId: Scalars['ID'];
};

export type QueryCustomQuestionWordCloudsArgs = {
  display?: InputMaybe<CustomQuestionDisplay>;
  filter?: InputMaybe<AnalysisFilterInput>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['ID'];
};

export type QueryDashboardArgs = {
  id: Scalars['ID'];
};

export type QueryDashboardListArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  searchParams?: InputMaybe<Scalars['String']>;
  surveyId: Scalars['ID'];
};

export type QueryDashboardQuestionDataArgs = {
  elementId: Scalars['ID'];
  sharedKey: Scalars['ID'];
};

export type QueryDefaultAssetsSettingsArgs = {
  divisionId?: InputMaybe<Scalars['ID']>;
};

export type QueryDefaultEndPageSettingsArgs = {
  smParam: Scalars['String'];
};

export type QueryDetailsFormFieldsArgs = {
  countryCode: Scalars['String'];
};

export type QueryEmailRecipientBySmTokenArgs = {
  smToken: Scalars['String'];
};

export type QueryEntityAutocompleteArgs = {
  input?: InputMaybe<AutocompleteInput>;
};

export type QueryExperimentsArgs = {
  pageReferer: Scalars['String'];
  pageUrl: Scalars['String'];
};

export type QueryFilterTitlesArgs = {
  filter?: InputMaybe<AnalysisFilterInput>;
  surveyId: Scalars['ID'];
};

export type QueryGetEmailRevertInfoArgs = {
  token: Scalars['String'];
};

export type QueryGetEntityQuestionsArgs = {
  input?: InputMaybe<EntityQuestionsInput>;
};

export type QueryGetOecJobsArgs = {
  questionId: Scalars['ID'];
  surveyId: Scalars['ID'];
};

export type QueryGetOecKeywordsArgs = {
  questionId: Scalars['ID'];
  surveyId: Scalars['ID'];
};

export type QueryGetOecQuestionTagsArgs = {
  questionId: Scalars['ID'];
  surveyId: Scalars['ID'];
};

export type QueryGetOecResponsesArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  questionId: Scalars['ID'];
  searchPhrase?: InputMaybe<Scalars['String']>;
  sortBy?: OecResponseSortBy;
  sortDirection?: SortDirection;
  surveyId: Scalars['ID'];
};

export type QueryGetOecResponseSummaryArgs = {
  questionId: Scalars['ID'];
  surveyId: Scalars['ID'];
};

export type QueryGetPackageFeatureSetArgs = {
  packageId: Scalars['ID'];
};

export type QueryGetResponseBundlesArgs = {
  countryCode: Scalars['String'];
  packageId: Scalars['ID'];
  partner: Scalars['String'];
  responsePackType: Scalars['String'];
};

export type QueryGetSurveyStatsArgs = {
  surveyId: Scalars['ID'];
};

export type QueryInstalledApplicationsArgs = {
  language: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type QueryInvoiceDetailsArgs = {
  invoiceId: Scalars['ID'];
};

export type QueryIsEmailValidArgs = {
  input: IsEmailValidInput;
};

export type QueryIsValidTokenArgs = {
  token: Scalars['String'];
};

export type QueryLibraryAssetByIdArgs = {
  assetId: Scalars['String'];
};

export type QueryLibraryAssetDownloadUrlArgs = {
  assetId: Scalars['String'];
};

export type QueryLibraryAssetsArgs = {
  assetType?: InputMaybe<Array<LibraryAssetType>>;
  divisionIds?: InputMaybe<Array<Scalars['ID']>>;
  includeTeamAssets?: InputMaybe<Scalars['Boolean']>;
  onlyDefaults?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<LibrarySortBy>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type QueryLocationAutocompleteArgs = {
  input?: InputMaybe<AutocompleteInput>;
};

export type QueryLookerAuthArgs = {
  locale: Scalars['String'];
  src: Scalars['String'];
};

export type QueryLookerExportArgs = {
  format: Scalars['String'];
  query: LookerQuery;
};

export type QueryLookerQueryTaskArgs = {
  queryTaskId: Scalars['ID'];
};

export type QueryMarketingEmailPreferencesArgs = {
  encryptedEmail: Scalars['String'];
};

export type QueryMarketMeasurementInsightsArgs = {
  projectId: Scalars['ID'];
};

export type QueryMarketMeasurementSolutionsPerformanceScoresArgs = {
  input: MarketMeasurementSolutionsPerformanceScoreInput;
};

export type QueryMasterScorecardArgs = {
  combineOption?: InputMaybe<CombineOptions>;
  confidenceLevel?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<AnalysisFilterInput>;
  projectId: Scalars['ID'];
  selectedBenchmarks?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryModulesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type QueryOtherAnswersByProjectArgs = {
  filter?: InputMaybe<AnalysisFilterInput>;
  optionId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['ID'];
  questionId: Scalars['ID'];
};

export type QueryPackagePricingForCountryArgs = {
  countryCode: Scalars['String'];
  packageID: Scalars['Int'];
  partner: Scalars['String'];
};

export type QueryPostcodeMetadataArgs = {
  locale: Scalars['String'];
  postcode: Scalars['String'];
};

export type QueryPreviewApplicationListingDetailsArgs = {
  appId: Scalars['ID'];
  language: Scalars['ID'];
};

export type QueryPreviewConceptTestingCrossTabTableArgs = {
  input: PreviewConceptTestingCrossTabTableInput;
};

export type QueryPricingExperienceArgs = {
  countryCode: Scalars['String'];
  experienceName?: InputMaybe<Scalars['String']>;
  languageCode: Scalars['String'];
};

export type QueryPricingPageExperienceArgs = {
  countryCode: Scalars['String'];
  encryptParams?: InputMaybe<Array<PricingPageEncryptParam>>;
  experienceName?: InputMaybe<Scalars['String']>;
  languageCode: Scalars['String'];
};

export type QueryProfilerQuestionsArgs = {
  input?: InputMaybe<UserProfileItemInput>;
};

export type QueryProjectArgs = {
  id: Scalars['ID'];
};

export type QueryProjectAnswerArgs = {
  id: Scalars['ID'];
  variableId: Scalars['ID'];
};

export type QueryProjectAttributeDataArgs = {
  id: Scalars['ID'];
};

export type QueryProjectByBillingTokenArgs = {
  billingToken: Scalars['String'];
};

export type QueryProjectVariableArgs = {
  id: Scalars['ID'];
};

export type QueryPublishedApplicationListingCategoriesArgs = {
  language: Scalars['ID'];
};

export type QueryPublishedApplicationListingCategoryArgs = {
  categoryKey: Scalars['ID'];
  language: Scalars['ID'];
  subdomain?: InputMaybe<Scalars['String']>;
  tld?: InputMaybe<Scalars['String']>;
};

export type QueryPublishedApplicationListingDetailsArgs = {
  appId: Scalars['ID'];
  language: Scalars['ID'];
};

export type QueryPublishedApplicationListingsArgs = {
  filter?: InputMaybe<PublishedApplicationListingFilter>;
  language: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  subdomain?: InputMaybe<Scalars['String']>;
  tld?: InputMaybe<Scalars['String']>;
};

export type QueryPublishedApplicationListingsByKeywordArgs = {
  keyword: Scalars['String'];
  language: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  subdomain?: InputMaybe<Scalars['String']>;
  tld?: InputMaybe<Scalars['String']>;
};

export type QueryPublishedDashboardArgs = {
  id: Scalars['ID'];
};

export type QueryRbacPermissionsArgs = {
  permissions: Array<RbacPermissionType>;
};

export type QueryRespondentArgs = {
  id: Scalars['ID'];
  languageCode?: InputMaybe<Scalars['String']>;
  surveyId: Scalars['ID'];
};

export type QueryRespondentObfuscatedArgs = {
  languageCode?: InputMaybe<Scalars['String']>;
  smParams: Scalars['String'];
  surveyId: Scalars['ID'];
};

export type QueryRespondentsArgs = {
  filter?: InputMaybe<AnalysisFilterInput>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  surveyId: Scalars['ID'];
};

export type QueryScreenerScorecardArgs = {
  attributeId?: InputMaybe<Scalars['String']>;
  combineOption?: InputMaybe<CombineOptions>;
  confidenceLevel?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<AnalysisFilterInput>;
  projectId: Scalars['ID'];
  surveyId?: InputMaybe<Scalars['String']>;
};

export type QueryScreeningQuestionsArgs = {
  projectId: Scalars['ID'];
};

export type QuerySearchSurveyQuestionTemplatesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query: SurveyQuestionTemplatesQueryInput;
};

export type QuerySolutionsSolutionArgs = {
  id: Scalars['ID'];
};

export type QuerySolutionsStudyArgs = {
  id: Scalars['ID'];
};

export type QuerySolutionsStudyCheckoutInfoArgs = {
  id: Scalars['ID'];
};

export type QueryStockThemeByThemeNameArgs = {
  themeName: Scalars['String'];
};

export type QueryStoredPaymentMethodsArgs = {
  partner: BillingPartner;
};

export type QuerySurveyArgs = {
  id: Scalars['ID'];
  languageCode?: InputMaybe<Scalars['String']>;
};

export type QuerySurveyByObfuscatedIdArgs = {
  obfuscatedId: Scalars['ID'];
};

export type QuerySurveyCategoriesArgs = {
  languageId: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type QuerySurveyCategoryIdsByAttributeArgs = {
  attribute?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type QuerySurveyQuizFeedbackArgs = {
  score: Scalars['String'];
  surveyId: Scalars['ID'];
};

export type QuerySurveyRespondentTrendArgs = {
  surveyId: Scalars['ID'];
  trendBy?: InputMaybe<TrendTimePeriod>;
  trendRange?: InputMaybe<InputDateRangeInput>;
  utcOffset?: InputMaybe<Scalars['Int']>;
};

export type QuerySurveysArgs = {
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SurveySortBy>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type QuerySurveysByTitleArgs = {
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SurveySortBy>;
  sortDirection?: InputMaybe<SortDirection>;
  titleFragment: Scalars['String'];
};

export type QuerySurveyTakingSessionArgs = {
  input: SurveyTakingSessionInput;
};

export type QuerySurveyTemplateArgs = {
  id: Scalars['ID'];
};

export type QuerySurveyTemplateAttributesArgs = {
  id: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type QuerySurveyTemplateByCanonicalNamesArgs = {
  canonicalNames?: InputMaybe<Array<Scalars['String']>>;
};

export type QuerySurveyTemplateCategoriesArgs = {
  languageId: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type QuerySurveyTemplatesArgs = {
  categoryName?: InputMaybe<Scalars['String']>;
  languageId: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type QuerySurveyTemplatesByTitleArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  titleFragment: Scalars['String'];
};

export type QuerySurveyVersionArgs = {
  id: Scalars['ID'];
};

export type QueryTeamImageAssetsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type QueryTeamInviteArgs = {
  inviteToken: Scalars['ID'];
};

export type QueryTeamSurveysArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<TeamSurveySortBy>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type QueryTeamSurveysByTitleArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  titleFragment: Scalars['String'];
};

export type QueryThemeByThemeIdArgs = {
  themeId: Scalars['String'];
};

export type QueryTrackingDashboardArgs = {
  dashboardId: Scalars['ID'];
  embedDomain?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
};

export type QueryTrackingDashboardEmbedArgs = {
  dashboardId: Scalars['ID'];
  embedDomain?: InputMaybe<Scalars['String']>;
  locale: Scalars['String'];
  projectId: Scalars['ID'];
  respondentFilter?: InputMaybe<Scalars['AdvancedFilter']>;
};

export type QueryTrackingDashboardFilterSchemaArgs = {
  dashboardId: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type QueryTrackingDashboardsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['ID'];
};

export type QueryTrackingProjectArgs = {
  id: Scalars['ID'];
};

export type QueryTrackingProjectDataCleaningArgs = {
  projectId: Scalars['ID'];
};

export type QueryTrackingSharedDashboardArgs = {
  embedDomain?: InputMaybe<Scalars['String']>;
  locale: Scalars['String'];
  respondentFilter?: InputMaybe<Scalars['AdvancedFilter']>;
  slug: Scalars['String'];
};

export type QueryTrackingSharedDashboardDataCleaningArgs = {
  slug: Scalars['String'];
};

export type QueryTrackingSharedDashboardFilterSchemaArgs = {
  slug: Scalars['String'];
};

export type QueryTrackingSharedDashboardSharingDetailsArgs = {
  slug: Scalars['String'];
};

export type QueryTrackingTrackerArgs = {
  projectId: Scalars['ID'];
  trackerId: Scalars['ID'];
};

export type QueryTrackingWaveArgs = {
  projectId: Scalars['ID'];
  trackerId: Scalars['ID'];
  waveId: Scalars['ID'];
};

export type QueryUseCaseCorrelationAnalysisArgs = {
  input: UseCaseCorrelationAnalysisInput;
};

export type QueryUseCaseExportJobArgs = {
  id: Scalars['ID'];
  projectId: Scalars['ID'];
  surveyId?: InputMaybe<Scalars['String']>;
};

export type QueryUseCasePerformanceScoresArgs = {
  input: UseCasePerformanceScoreInput;
};

export type QueryUseCaseViewListArgs = {
  projectId: Scalars['ID'];
  surveyId?: InputMaybe<Scalars['String']>;
};

export type QueryUserByIdArgs = {
  id: Scalars['ID'];
};

export type QueryUserPermissionArgs = {
  permission: UserPermissionType;
};

export type QueryUserProfileItemsArgs = {
  input?: InputMaybe<UserProfileItemInput>;
};

export type QueryUserTeamMembershipByIdArgs = {
  id: Scalars['ID'];
};

export type QueryValidateBulkTransferSurveysArgs = {
  input: BulkTransferSurveysInput;
};

export type QueryWelcomeFlowStateArgs = {
  input?: InputMaybe<WelcomeFlowInput>;
};

export type QueryWordCloudByProjectArgs = {
  filter?: InputMaybe<AnalysisFilterInput>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['ID'];
  questionId: Scalars['ID'];
  variationId?: InputMaybe<Scalars['ID']>;
};

export type QueryWordCloudBySurveyArgs = {
  filter?: InputMaybe<AnalysisFilterInput>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  questionId: Scalars['ID'];
  surveyId: Scalars['ID'];
};

export type QueryWordCloudsByQuestionsArgs = {
  filter?: InputMaybe<AnalysisFilterInput>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  questionIds: Array<Scalars['ID']>;
  surveyId: Scalars['ID'];
};

export type QuestionAndAnswerCompare = AnalysisStandardViewCompareRule & {
  __typename?: 'QuestionAndAnswerCompare';
  active: Scalars['Boolean'];
  customHeading?: Maybe<Scalars['String']>;
  defaultHeading: Scalars['String'];
  id: Scalars['ID'];
  questionOptionsToCompare: Array<Maybe<SurveyQuestionOption>>;
  questionToCompare: SurveyQuestion;
};

export type QuestionAnswer = {
  id: Scalars['ID'];
  label: Scalars['String'];
  visible: Scalars['Boolean'];
};

export type QuestionAnswerRequired = {
  __typename?: 'QuestionAnswerRequired';
  errorMessage: Scalars['String'];
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
  type: QuestionRequiredPredicateType;
};

export type QuestionBankConnection = {
  __typename?: 'QuestionBankConnection';
  /** if a question bank question has been edited it is no longer valid as a certified question bank question */
  isCertified: Scalars['Boolean'];
  question: QuestionBankQuestion;
  /** this requires an additional call to svysvc */
  selectedModifiers?: Maybe<Array<QuestionBankModifierSelection>>;
};

export type QuestionBankHeading = {
  __typename?: 'QuestionBankHeading';
  modifiers: Array<QuestionBankModifier>;
  /** the Question possibly containing some modifier placeholders */
  text: Scalars['String'];
};

/**
 * A group of many translated question bank question are tied together via a shared logical_link.  All questions within a logical link have
 * the same meaning but can span languages and versioning changes. It’s the logical link that carries the question type attribute, as no two
 * questions within the same logical link could have different question type.
 */
export type QuestionBankLogicalLink = {
  __typename?: 'QuestionBankLogicalLink';
  analysisType: Scalars['String'];
  family: SurveyQuestionFamily;
  id: Scalars['ID'];
  name: Scalars['String'];
  partner?: Maybe<QuestionBankPartner>;
  variant: SurveyQuestionVariant;
};

export type QuestionBankModifier = {
  __typename?: 'QuestionBankModifier';
  id: Scalars['ID'];
  options?: Maybe<Array<QuestionBankModifierOption>>;
  type: QuestionBankModifierType;
};

export type QuestionBankModifierOption = {
  __typename?: 'QuestionBankModifierOption';
  id: Scalars['ID'];
  /** 0-based index of the option position. */
  position: Scalars['Int'];
  /** Text display for this modifier option. */
  value: Scalars['String'];
};

export type QuestionBankModifierSelection = {
  __typename?: 'QuestionBankModifierSelection';
  id: Scalars['ID'];
  /** Relevant for OPEN_ENDED QuestionBankModifierType */
  openEndedValue?: Maybe<Scalars['String']>;
};

export enum QuestionBankModifierType {
  OpenEnded = 'OPEN_ENDED',
  Semantic = 'SEMANTIC',
  Superficial = 'SUPERFICIAL',
}

export enum QuestionBankPartner {
  Audience = 'AUDIENCE',
  Bavc = 'BAVC',
  Eventbrite = 'EVENTBRITE',
  Harvard = 'HARVARD',
  Hubspot = 'HUBSPOT',
  Leanin = 'LEANIN',
  Shrm = 'SHRM',
  Zendesk = 'ZENDESK',
}

export type QuestionBankQuestion = {
  /**
   * details needed for edit, analyze etc.
   * additional metadata like tags, attributes, categories, locales and description can be added later
   * this requires an additional call to svysvc
   */
  heading: QuestionBankHeading;
  id: Scalars['ID'];
  logicalLink: QuestionBankLogicalLink;
};

export type QuestionBankVariableAnswer = ProjectVariableAnswer & {
  __typename?: 'QuestionBankVariableAnswer';
  canonicalName: Scalars['String'];
  /** @TODO: uncertain of format */
  chosenModifierOptions: Array<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  type: ProjectVariableAnswerType;
  variableId: Scalars['ID'];
};

/** Explicit type for the styling of question body that contains answer options */
export type QuestionBodyStyle = FontStyle & {
  __typename?: 'QuestionBodyStyle';
  fontFamily?: Maybe<Scalars['String']>;
  fontSize?: Maybe<Scalars['Int']>;
  fontStyle?: Maybe<FontStyleType>;
  fontWeight?: Maybe<FontWeightType>;
  /** Highlight color used in a few accessibile themes to improve contrast ratio */
  highlightColor?: Maybe<Scalars['RGBA']>;
  textDecoration?: Maybe<TextDecorationType>;
};

export type QuestionBodyStyleInput = {
  color?: InputMaybe<Scalars['RGBA']>;
  fontFamily?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['String']>;
  fontStyle?: InputMaybe<FontStyleType>;
  fontWeight?: InputMaybe<FontWeightType>;
  highlightColor?: InputMaybe<Scalars['String']>;
  textDecoration?: InputMaybe<TextDecorationType>;
};

/** represents the result of an entity type questions query */
export type QuestionData = {
  __typename?: 'QuestionData';
  questions: Array<WelcomeFlowQuestion>;
};

export type QuestionFieldSet = {
  id: Scalars['ID'];
  label: Scalars['String'];
  visible: Scalars['Boolean'];
};

export enum QuestionFieldValidationType {
  DateIntl = 'DATE_INTL',
  DateUs = 'DATE_US',
  Decimal = 'DECIMAL',
  Email = 'EMAIL',
  FileFormat = 'FILE_FORMAT',
  Integer = 'INTEGER',
  Sum = 'SUM',
  TextLength = 'TEXT_LENGTH',
}

export type QuestionFilterConfiguration = {
  __typename?: 'QuestionFilterConfiguration';
  answer: SurveyQuestionOption;
  question: SurveyQuestion;
};

/**
 * A funnel is an association between 2 questions where the answers selected from
 * the source question are "funneled" to the target question as answers or fieldsets.
 */
export type QuestionFunnel = {
  __typename?: 'QuestionFunnel';
  condition: QuestionFunnelCondition;
  /**
   * Answers that must be selected/unselected for the fieldsets to funnel from source
   * to target, when the source question is a matrix question. Null otherwise.
   */
  conditionAnswers?: Maybe<Array<QuestionAnswer>>;
  id: Scalars['ID'];
  pairings: Array<QuestionFunnelPairing>;
  source: QuestionFunnelPointer;
  target: QuestionFunnelPointer;
};

export enum QuestionFunnelCondition {
  Selected = 'SELECTED',
  Unselected = 'UNSELECTED',
}

export type QuestionFunnelPairing = {
  __typename?: 'QuestionFunnelPairing';
  /** ID of the source Answer or FieldSet */
  from: Scalars['ID'];
  /** ID of the target Answer or FieldSet */
  to: Scalars['ID'];
};

export type QuestionFunnelPointer = {
  __typename?: 'QuestionFunnelPointer';
  funnelType: QuestionFunnelPointerType;
  question: SurveyQuestion;
};

export enum QuestionFunnelPointerType {
  Answer = 'ANSWER',
  Fieldset = 'FIELDSET',
}

export type QuestionHeaderImage = {
  __typename?: 'QuestionHeaderImage';
  imageOptionId: Scalars['ID'];
  s3Key?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type QuestionHeaderRandomAssignment = {
  __typename?: 'QuestionHeaderRandomAssignment';
  percent: Scalars['Float'];
  position: Scalars['Int'];
  variableId: Scalars['ID'];
  variableName?: Maybe<Scalars['String']>;
};

export type QuestionHeading = {
  __typename?: 'QuestionHeading';
  image?: Maybe<HeadingImage>;
  text: Scalars['String'];
};

export type QuestionHeadingConfiguration = {
  __typename?: 'QuestionHeadingConfiguration';
  assignments?: Maybe<Array<RandomAssignmentHeading>>;
  default: QuestionHeading;
};

export enum QuestionLayoutPlacement {
  NewRow = 'NEW_ROW',
  RightAligned = 'RIGHT_ALIGNED',
}

export type QuestionLayoutSpacingOptions = {
  __typename?: 'QuestionLayoutSpacingOptions';
  bottom?: Maybe<Scalars['Int']>;
  left?: Maybe<Scalars['Int']>;
  right?: Maybe<Scalars['Int']>;
  top?: Maybe<Scalars['Int']>;
};

export enum QuestionLayoutWidthFormat {
  Fixed = 'FIXED',
  Percent = 'PERCENT',
}

export type QuestionLayoutWidthOptions = {
  __typename?: 'QuestionLayoutWidthOptions';
  format?: Maybe<QuestionLayoutWidthFormat>;
  width: Scalars['Int'];
};

export type QuestionPosition = {
  __typename?: 'QuestionPosition';
  inPage: Scalars['Int'];
  inSurvey: Scalars['Int'];
  label: Scalars['String'];
  pageId: Scalars['ID'];
};

export enum QuestionRequiredPredicateType {
  All = 'ALL',
  AtLeast = 'AT_LEAST',
  AtMost = 'AT_MOST',
  Exactly = 'EXACTLY',
  Range = 'RANGE',
}

export type QuestionResponseSummary = {
  metadata?: Maybe<ResponseMetadata>;
  respondentSummary?: Maybe<RespondentSummary>;
};

export type QuestionSkipLogicRule = {
  __typename?: 'QuestionSkipLogicRule';
  destination: SkipLogicDestination;
  id: Scalars['ID'];
  skipType: QuestionSkipLogicType;
  sourceAnswer: QuestionAnswer;
};

export enum QuestionSkipLogicType {
  QuestionConditionalCol = 'QUESTION_CONDITIONAL_COL',
  QuestionConditionalRow = 'QUESTION_CONDITIONAL_ROW',
}

/**
 * Configuration type for sorting. Depending on the question type, applies
 * to sorting of fieldsets or answers.
 */
export type QuestionSorting = {
  __typename?: 'QuestionSorting';
  ignoreLast: Scalars['Boolean'];
  type: QuestionSortingKind;
};

export enum QuestionSortingKind {
  Flip = 'FLIP',
  Random = 'RANDOM',
  TextAsc = 'TEXT_ASC',
  TextDesc = 'TEXT_DESC',
}

export type QuestionValidation = {
  errorMessage: Scalars['String'];
  type: QuestionFieldValidationType;
};

export type QuestionVariableAnswer = ProjectVariableAnswer & {
  __typename?: 'QuestionVariableAnswer';
  createdAt: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  question: QuestionVariableAnswerData;
  type: ProjectVariableAnswerType;
  variableId: Scalars['ID'];
};

export type QuestionVariableAnswerData = {
  type: SurveyQuestionType;
};

export type Quiz = {
  __typename?: 'Quiz';
  answers: Array<QuizAnswer>;
  feedback: QuizFeedback;
  id: Scalars['ID'];
  totalPoints: Scalars['Int'];
};

export type QuizAnswer = {
  __typename?: 'QuizAnswer';
  answer: QuestionAnswer;
  correct: Scalars['Boolean'];
  points: Scalars['Int'];
};

export type QuizFeedback = {
  __typename?: 'QuizFeedback';
  correct?: Maybe<Scalars['String']>;
  incorrect?: Maybe<Scalars['String']>;
  partial?: Maybe<Scalars['String']>;
};

/** Filter results by QuizScoreBuckets */
export type QuizScoreBucketsFilter = AnalysisStandardViewFilterRule & {
  __typename?: 'QuizScoreBucketsFilter';
  active: Scalars['Boolean'];
  customHeading?: Maybe<Scalars['String']>;
  defaultHeading: Scalars['String'];
  id: Scalars['ID'];
  quizScoreRanges: Array<QuizScoreRange>;
};

export type QuizScoreRange = {
  __typename?: 'QuizScoreRange';
  id: Scalars['ID'];
  label: Scalars['String'];
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export type Quota = {
  __typename?: 'Quota';
  /**
   * after the quota is met the survey collectors are closed, but
   * what should the user who hit the quota see after answering the quota question?
   */
  destination: OverQuotaDestination;
  /** It's possible for equations to be an empty array but the quota is effectively off */
  equations: Array<QuotaEquation>;
  id: Scalars['ID'];
  label: Scalars['String'];
  questions: Array<QuotaQuestion>;
};

export type QuotaAnswerGroup = {
  __typename?: 'QuotaAnswerGroup';
  answers: Array<QuestionAnswer>;
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type QuotaEquation = {
  __typename?: 'QuotaEquation';
  answerGroups: Array<QuotaAnswerGroup>;
  id: Scalars['ID'];
  label: Scalars['String'];
  maxResponseCount: Scalars['Int'];
  /**
   * Has *this* equations' quota been reached?
   * NOTE: the overall quota can contain multiple equations and they must all be met before the
   * overall quota is met and the collectors are closed.
   */
  quotaReached: Scalars['Boolean'];
};

export type QuotaQuestion = {
  __typename?: 'QuotaQuestion';
  answerGroups: Array<QuotaAnswerGroup>;
  id: Scalars['ID'];
  question: SurveyQuestion;
};

export type RandomAssignmentCompare = AnalysisStandardViewCompareRule & {
  __typename?: 'RandomAssignmentCompare';
  active: Scalars['Boolean'];
  customHeading?: Maybe<Scalars['String']>;
  defaultHeading: Scalars['String'];
  id: Scalars['ID'];
  questionHeadingsToCompare: Array<Maybe<SurveyQuestionHeader>>;
  questionToCompare: SurveyQuestion;
};

export type RandomAssignmentFilter = AnalysisStandardViewFilterRule & {
  __typename?: 'RandomAssignmentFilter';
  active: Scalars['Boolean'];
  customHeading?: Maybe<Scalars['String']>;
  defaultHeading: Scalars['String'];
  id: Scalars['ID'];
  question: SurveyQuestion;
  questionHeadingsToFilter: Array<Maybe<SurveyQuestionHeader>>;
};

export type RandomAssignmentFilterInput = {
  family: SurveyQuestionFamilySet;
  questionId: Scalars['ID'];
  rows: Array<InputMaybe<Scalars['ID']>>;
  subtype: SurveyQuestionSubTypeSet;
};

export type RandomAssignmentHeading = {
  __typename?: 'RandomAssignmentHeading';
  heading: QuestionHeading;
  id: Scalars['ID'];
  variable: RandomAssignmentVariable;
};

export type RandomAssignmentVariable = {
  __typename?: 'RandomAssignmentVariable';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  percent: Scalars['Float'];
  position: Scalars['Int'];
};

export type RankingMenuMatrixLayoutOptions = {
  __typename?: 'RankingMenuMatrixLayoutOptions';
  labelWidthPercent: Scalars['Int'];
  spacing: QuestionLayoutSpacingOptions;
  width: QuestionLayoutWidthOptions;
};

export type RankingQuestionQm = SurveyQuestionQm & {
  __typename?: 'RankingQuestionQM';
  answerNA?: Maybe<ChoiceAnswer>;
  answers: Array<ChoiceAnswer>;
  createdAt: Scalars['DateTime'];
  family: SurveyQuestionFamily;
  fieldSets: Array<FieldSet>;
  hasPiping: Scalars['Boolean'];
  heading: QuestionHeadingConfiguration;
  id: Scalars['ID'];
  layout: RankingMenuMatrixLayoutOptions;
  modifiedAt: Scalars['DateTime'];
  position: QuestionPosition;
  required?: Maybe<QuestionAnswerRequired>;
  sorting?: Maybe<QuestionSorting>;
  variant: SurveyQuestionVariant;
};

export type RatingDateTimeFileUploadLayoutOptions = {
  __typename?: 'RatingDateTimeFileUploadLayoutOptions';
  placement: QuestionLayoutPlacement;
  spacing: QuestionLayoutSpacingOptions;
  width: QuestionLayoutWidthOptions;
};

export enum RatingScaleAnswerSymbol {
  Heart = 'HEART',
  Smiley = 'SMILEY',
  Star = 'STAR',
  Thumb = 'THUMB',
}

export type RatingScaleQuestionBankQuestionQm = QuestionBankQuestion & {
  __typename?: 'RatingScaleQuestionBankQuestionQM';
  answerNA?: Maybe<ChoiceAnswer>;
  answerOther?: Maybe<AnswerOther>;
  answersWeighted: Array<WeightedAnswer>;
  heading: QuestionBankHeading;
  id: Scalars['ID'];
  logicalLink: QuestionBankLogicalLink;
  symbolOptions?: Maybe<RatingScaleSymbolOptions>;
};

export type RatingScaleQuestionQm = SurveyQuestionQm & {
  __typename?: 'RatingScaleQuestionQM';
  answerNA?: Maybe<ChoiceAnswer>;
  answerOther?: Maybe<AnswerOther>;
  answersWeighted: Array<WeightedAnswer>;
  createdAt: Scalars['DateTime'];
  family: SurveyQuestionFamily;
  fieldSet: FieldSet;
  hasPiping: Scalars['Boolean'];
  heading: QuestionHeadingConfiguration;
  id: Scalars['ID'];
  layout: RatingDateTimeFileUploadLayoutOptions;
  modifiedAt: Scalars['DateTime'];
  position: QuestionPosition;
  questionBank?: Maybe<QuestionBankConnection>;
  required?: Maybe<QuestionAnswerRequired>;
  skipLogicRules: Array<QuestionSkipLogicRule>;
  symbolOptions?: Maybe<RatingScaleSymbolOptions>;
  variant: SurveyQuestionVariant;
};

export type RatingScaleSymbolOptions = {
  __typename?: 'RatingScaleSymbolOptions';
  color: Scalars['String'];
  symbol: RatingScaleAnswerSymbol;
};

/** Role Based Access Control Permission indicate whether user is authorized to have an specific permission */
export type RbacPermission = {
  __typename?: 'RbacPermission';
  isAuthorized: Scalars['Boolean'];
  permission: RbacPermissionType;
};

/** Role Based Access Control Permission Type indicate permission types available in usersvc */
export enum RbacPermissionType {
  ActivityExport = 'ACTIVITY_EXPORT',
  ActivityView = 'ACTIVITY_VIEW',
  AdminDashboardView = 'ADMIN_DASHBOARD_VIEW',
  AudienceCreditsManage = 'AUDIENCE_CREDITS_MANAGE',
  AudienceCreditsPurchase = 'AUDIENCE_CREDITS_PURCHASE',
  AudienceCreditsUse = 'AUDIENCE_CREDITS_USE',
  DivisionManage = 'DIVISION_MANAGE',
  DivisionManageUsers = 'DIVISION_MANAGE_USERS',
  DivisionView = 'DIVISION_VIEW',
  DivisionsManage = 'DIVISIONS_MANAGE',
  DivisionsManageUsers = 'DIVISIONS_MANAGE_USERS',
  DivisionsView = 'DIVISIONS_VIEW',
  LibraryContribute = 'LIBRARY_CONTRIBUTE',
  LibraryManageAssets = 'LIBRARY_MANAGE_ASSETS',
  LibraryView = 'LIBRARY_VIEW',
  OfflineDevicesManage = 'OFFLINE_DEVICES_MANAGE',
  OfflineDevicesView = 'OFFLINE_DEVICES_VIEW',
  SettingsManageAudience = 'SETTINGS_MANAGE_AUDIENCE',
  SettingsManageCollectors = 'SETTINGS_MANAGE_COLLECTORS',
  SettingsManageHippa = 'SETTINGS_MANAGE_HIPPA',
  SettingsManagePii = 'SETTINGS_MANAGE_PII',
  SettingsManageResponses = 'SETTINGS_MANAGE_RESPONSES',
  SettingsManageSharing = 'SETTINGS_MANAGE_SHARING',
  SettingsManageTeam = 'SETTINGS_MANAGE_TEAM',
  TeamSummaryView = 'TEAM_SUMMARY_VIEW',
  UsersInvite = 'USERS_INVITE',
  UsersManageAccounts = 'USERS_MANAGE_ACCOUNTS',
  UsersManageSurveys = 'USERS_MANAGE_SURVEYS',
  UsersPromote = 'USERS_PROMOTE',
  WorkgroupsCreate = 'WORKGROUPS_CREATE',
  WorkgroupsManage = 'WORKGROUPS_MANAGE',
  WorkgroupsView = 'WORKGROUPS_VIEW',
}

export type RbpUserAddOnProductSelection = {
  __typename?: 'RbpUserAddOnProductSelection';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['ID']>;
  isComplete: Scalars['Boolean'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy?: Maybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  selectionId: Scalars['ID'];
  skuCostId: Scalars['ID'];
  skuId: Scalars['ID'];
  stripeAddonProductId: Scalars['ID'];
  stripePriceId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type RbpUserAddOnProductSelections = {
  __typename?: 'RbpUserAddOnProductSelections';
  rbpUserAddOnProductSelections: Array<RbpUserAddOnProductSelection>;
};

export type RecommendationOptions = {
  __typename?: 'RecommendationOptions';
  id: Scalars['ID'];
};

export type RecordContentModuleEventInput = {
  event: ContentModuleEvent;
  moduleName: Scalars['String'];
  pageUrl: Scalars['String'];
  properties?: InputMaybe<ContentModuleProperties>;
  timeToClick: Scalars['Float'];
  variation?: InputMaybe<Scalars['String']>;
};

export type RefreshProjectSurveyPayload = {
  __typename?: 'RefreshProjectSurveyPayload';
  survey: ProjectSurveyEntity;
};

export type RejectTeamInviteRequestInput = {
  userId: Scalars['ID'];
};

/** Filter results by relative time period */
export type RelativeTimePeriodFilter = AnalysisStandardViewFilterRule & {
  __typename?: 'RelativeTimePeriodFilter';
  active: Scalars['Boolean'];
  amount: Scalars['Int'];
  customHeading?: Maybe<Scalars['String']>;
  defaultHeading: Scalars['String'];
  id: Scalars['ID'];
  unit: RelativeTimePeriodUnitTypes;
};

export enum RelativeTimePeriodUnitTypes {
  Days = 'DAYS',
  Hours = 'HOURS',
}

export enum RenewalType {
  Month = 'MONTH',
  Year = 'YEAR',
}

export type RequireSurveyQuestionPayload = {
  __typename?: 'RequireSurveyQuestionPayload';
  question?: Maybe<SurveyQuestion>;
  success: Scalars['Boolean'];
};

export type ResendEmailInput = {
  entityId: Scalars['ID'];
  requestReferrer: ResendEmailReferrer;
  status: EmailVerificationStatus;
};

export enum ResendEmailReferrer {
  CollectZeroState = 'COLLECT_ZERO_STATE',
  CreateZeroState = 'CREATE_ZERO_STATE',
  SolutionsCreate = 'SOLUTIONS_CREATE',
}

export type RespApiAnswerInput = {
  answerId?: InputMaybe<Scalars['String']>;
  answerText?: InputMaybe<Scalars['String']>;
  columnId?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  inputType?: InputMaybe<Scalars['String']>;
  menuId?: InputMaybe<Scalars['String']>;
  pageId: Scalars['String'];
  questionId: Scalars['String'];
  randomAssignmentId?: InputMaybe<Scalars['String']>;
  xCoordinate?: InputMaybe<Scalars['String']>;
  yCoordinate?: InputMaybe<Scalars['String']>;
};

export type Respondent = {
  __typename?: 'Respondent';
  /** Given page order for the current survey */
  assignedPageOrder?: Maybe<Array<SurveyPage>>;
  /** Token used to validate the authenticity of this session. */
  clientToken?: Maybe<Scalars['String']>;
  clientTokenExpiresAt?: Maybe<Scalars['DateTime']>;
  collectionMethod: RespondentCollectionMethod;
  /**
   * Collector is nullable in the case of a network failure or when the respondent is
   * a preview respondent.
   */
  collector?: Maybe<Collector>;
  currentPage?: Maybe<SurveyPage>;
  currentQuestion?: Maybe<SurveyQuestionQm>;
  /** custom data */
  customData?: Maybe<Array<RespondentCustomData>>;
  email?: Maybe<Scalars['String']>;
  /** encrypted params when instant results is enabled */
  encryptedInstantResultsSmParam?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  /**
   * Corresponds to the sessionID (uuid) on creation but is then replaced by the
   * respondent ID (numerical ID) once the respondent is persisted.
   */
  id: Scalars['ID'];
  ipAddress?: Maybe<Scalars['String']>;
  /** Set to true if the client is trying to access this session from a blocked IP. */
  isIPBlocked: Scalars['Boolean'];
  /** Set to true when the survey owner's account has been disabled/deleted. */
  isSurveyOwnerDisabled: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  links: RespondentLinks;
  modifiedAt: Scalars['DateTime'];
  quizResults?: Maybe<RespondentQuizResult>;
  /** quiz data */
  quizSummary?: Maybe<RespondentQuizSummary>;
  /**
   * respondent answers to questions
   * @deprecated Please use the resultsQM field
   */
  results?: Maybe<SurveyRespondentResultsList>;
  /** respondent answers to questions */
  resultsQM?: Maybe<Array<SurveyRespondentResultQm>>;
  /** GUID for this survey-taking session. */
  sessionId: Scalars['ID'];
  startedAt?: Maybe<Scalars['DateTime']>;
  status: RespondentStatus;
  /** Survey is nullable in the case of a network failure. */
  survey?: Maybe<Survey>;
  /** Redirect URL based off Survey End Page collector feature */
  surveyEndPageUrl?: Maybe<Scalars['String']>;
  /**
   * When persisted, this is the associated survey version for this respondent.
   * This value is null if the respondent hasn't been persisted yet.
   */
  surveyVersion?: Maybe<Scalars['Int']>;
};

export type RespondentAnswerQm =
  | ChoiceResponse
  | CoordinateResponse
  | ImplicitResponse
  | OpenResponse
  | OtherResponse;

export enum RespondentCollectionMethod {
  Edited = 'EDITED',
  Manual = 'MANUAL',
  Normal = 'NORMAL',
  Preview = 'PREVIEW',
  SurveyPreview = 'SURVEY_PREVIEW',
}

export type RespondentCustomData = {
  __typename?: 'RespondentCustomData';
  position: Scalars['Int'];
  value: Scalars['String'];
};

export type RespondentLinks = {
  __typename?: 'RespondentLinks';
  edit: Scalars['String'];
};

export type RespondentList = PaginatedList & {
  __typename?: 'RespondentList';
  items: Array<Respondent>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type RespondentQuizResult = {
  __typename?: 'RespondentQuizResult';
  correct: Scalars['Int'];
  incorrect: Scalars['Int'];
  partiallyCorrect: Scalars['Int'];
  skipped: Scalars['Int'];
  totalQuestions: Scalars['Int'];
};

export type RespondentQuizSummary = {
  __typename?: 'RespondentQuizSummary';
  maxRank: Scalars['Int'];
  maxScore: Scalars['Float'];
  percent: Scalars['Float'];
  percentile: Scalars['Int'];
  rank: Scalars['Int'];
  score: Scalars['Int'];
};

export enum RespondentStatus {
  Completely = 'COMPLETELY',
  Disqualified = 'DISQUALIFIED',
  Overquota = 'OVERQUOTA',
  Partially = 'PARTIALLY',
}

export type RespondentSummary = {
  __typename?: 'RespondentSummary';
  answered?: Maybe<Scalars['Int']>;
  skipped?: Maybe<Scalars['Int']>;
};

export type RespondToSeatRequestInput = {
  /** The user id of the user who created the seat request */
  id: Scalars['ID'];
  /** Admin provided reason string for the decision */
  responseReason?: InputMaybe<Scalars['String']>;
  /** The status the admin is setting the request to */
  responseStatus: SeatRequestResponseStatus;
};

export type ResponseAllocation = {
  __typename?: 'ResponseAllocation';
  allocationLimit?: Maybe<Scalars['String']>;
  totalCount: Scalars['Int'];
};

export type ResponseBasedPricingSummary =
  | ResponseBasedPricingSummaryData
  | ResponseBasedPricingSummaryEmpty;

export type ResponseBasedPricingSummaryData = {
  __typename?: 'ResponseBasedPricingSummaryData';
  additionalResponseCount: Scalars['Int'];
  baseResponseCount: Scalars['Int'];
  freeResponseCount: Scalars['Int'];
  isUnlimited: Scalars['Boolean'];
  lifetimeResponseCount: Scalars['Int'];
  priorTermUsedCount: Scalars['Int'];
  subscriptionTermResponseCount: Scalars['Int'];
};

export type ResponseBasedPricingSummaryEmpty = {
  __typename?: 'ResponseBasedPricingSummaryEmpty';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type ResponseColumnSummary = {
  __typename?: 'ResponseColumnSummary';
  column?: Maybe<SurveyQuestionColumn>;
  question?: Maybe<SurveyQuestion>;
  weight?: Maybe<Scalars['Float']>;
};

export type ResponseCustomDisplayOptions = {
  __typename?: 'ResponseCustomDisplayOptions';
  color?: Maybe<Scalars['String']>;
};

export enum ResponseDimension {
  /** One dimensional questions only contain rows. */
  OneDimensional = 'ONE_DIMENSIONAL',
  /** Two dimensional questions contain rows and columns. */
  ThreeDimensional = 'THREE_DIMENSIONAL',
  /** Two dimensional questions contain rows and columns. */
  TwoDimensional = 'TWO_DIMENSIONAL',
}

export type ResponseDisplayOptions = {
  __typename?: 'ResponseDisplayOptions';
  customOptions?: Maybe<ResponseCustomDisplayOptions>;
  displaySubtype?: Maybe<Scalars['String']>;
  displayType?: Maybe<Scalars['String']>;
  leftLabel?: Maybe<Scalars['String']>;
  middleLabel?: Maybe<Scalars['String']>;
  rightLabel?: Maybe<Scalars['String']>;
  showDisplayNumber: Scalars['Boolean'];
};

export type ResponseGroupSummary = {
  __typename?: 'ResponseGroupSummary';
  group?: Maybe<SurveyQuestionOther>;
  question?: Maybe<SurveyQuestion>;
  responseColumnSummary?: Maybe<Array<Maybe<ResponseColumnSummary>>>;
  responseRowSummary?: Maybe<Array<Maybe<ResponseRowSummary>>>;
};

export type ResponseMetadata = {
  __typename?: 'ResponseMetadata';
  dimension: ResponseDimension;
  displayOptions?: Maybe<ResponseDisplayOptions>;
  displayType?: Maybe<Scalars['String']>;
  hasVariations: Scalars['Boolean'];
  sentimentAnalysisEnabled: Scalars['Boolean'];
};

export type ResponsePackages = {
  __typename?: 'ResponsePackages';
  activeFromDate: Scalars['DateTime'];
  addOnProducts: Array<AddOnProductItem>;
  canonicalName: Scalars['String'];
  featureSetId: Scalars['ID'];
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  label: Scalars['String'];
  partner: Scalars['String'];
  renewalInterval?: Maybe<Scalars['String']>;
  renewalIntervalCount?: Maybe<Scalars['Int']>;
};

/** Filter results by response quality */
export type ResponseQualityFilter = AnalysisStandardViewFilterRule & {
  __typename?: 'ResponseQualityFilter';
  active: Scalars['Boolean'];
  customHeading?: Maybe<Scalars['String']>;
  defaultHeading: Scalars['String'];
  id: Scalars['ID'];
  responseQualities: Array<ResponseQualityTypes>;
};

export enum ResponseQualityTypes {
  HighQuality = 'HIGH_QUALITY',
  LowQuality = 'LOW_QUALITY',
}

export type ResponseRowSummary = {
  __typename?: 'ResponseRowSummary';
  question?: Maybe<SurveyQuestion>;
  row?: Maybe<SurveyQuestionRow>;
  total?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type ResponseSummaryList = {
  __typename?: 'ResponseSummaryList';
  items: Array<Maybe<QuestionResponseSummary>>;
  totalCount: Scalars['Int'];
};

export enum RestrictedCollectorStatus {
  Disabled = 'DISABLED',
  DisabledUnlessEnabledPerUser = 'DISABLED_UNLESS_ENABLED_PER_USER',
  Enabled = 'ENABLED',
  Hidden = 'HIDDEN',
}

export type RestrictedCollectorTypeTuple = {
  __typename?: 'RestrictedCollectorTypeTuple';
  key: Scalars['ID'];
  value: RestrictedCollectorStatus;
};

export type RevertEmailInput = {
  token: Scalars['String'];
};

export type RuleDescription = {
  __typename?: 'RuleDescription';
  label: Scalars['String'];
  questionId?: Maybe<Scalars['ID']>;
  value?: Maybe<Scalars['String']>;
};

export type SaveExperimentTreatmentInput = {
  /** Assignment Type */
  assignmentType: ExperimentAssignmentType;
  /** Experiment assigned to user */
  experimentId: Scalars['ID'];
  experimentName: Scalars['String'];
  /** Treatment shown to user */
  treatmentId: Scalars['ID'];
  treatmentName: Scalars['String'];
};

export type SaveExperimentTreatmentPayload = {
  __typename?: 'SaveExperimentTreatmentPayload';
  assignments?: Maybe<Scalars['String']>;
  maxAge?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** System for Cross-domain Identity Management settings */
export type ScimSettings = {
  __typename?: 'SCIMSettings';
  isSCIMActive: Scalars['Boolean'];
  scimActivatedAt: Scalars['DateTime'];
};

export type ScreenerScorecard = {
  __typename?: 'ScreenerScorecard';
  id: Scalars['ID'];
  rows: Array<ScreenerScorecardRows>;
};

export type ScreenerScorecardColumns = {
  __typename?: 'ScreenerScorecardColumns';
  attributeName: Scalars['String'];
  bottomTwo?: Maybe<Scalars['Float']>;
  higherSignificance: Array<Maybe<Scalars['String']>>;
  id: Scalars['ID'];
  isSignificant: Scalars['Boolean'];
  labels: Array<Maybe<Scalars['String']>>;
  lowerSignificance: Array<Maybe<Scalars['String']>>;
  percentage: Scalars['Float'];
  rowValues?: Maybe<Array<Maybe<ScreenerScorecardRowValues>>>;
  topTwo?: Maybe<Scalars['Float']>;
};

export type ScreenerScorecardRows = {
  __typename?: 'ScreenerScorecardRows';
  attributeValues: Array<ScreenerScorecardColumns>;
  id: Scalars['ID'];
  label: Scalars['String'];
  nickname: Scalars['String'];
  stimulusId: Scalars['ID'];
  text: Scalars['String'];
  total: Scalars['Int'];
  type: Scalars['String'];
};

export type ScreenerScorecardRowValues = {
  __typename?: 'ScreenerScorecardRowValues';
  count: Scalars['Int'];
  hasTextResponse?: Maybe<Scalars['Boolean']>;
  higherSignificance: Array<Maybe<Scalars['String']>>;
  id: Scalars['ID'];
  isSignificant: Scalars['Boolean'];
  key: Scalars['String'];
  labels: Array<Maybe<Scalars['String']>>;
  lowerSignificance: Array<Maybe<Scalars['String']>>;
  percentage: Scalars['Float'];
  position?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  weight?: Maybe<Scalars['Int']>;
};

export type ScreeningQuestion = {
  __typename?: 'ScreeningQuestion';
  /** A list of IDs that are answer rows on the attached question to disqualify on */
  disqualifyRows: Array<Scalars['ID']>;
  projectId: Scalars['ID'];
  qualificationRate: Scalars['Int'];
  /** the screening question is null if the qualification rate is 100 */
  question?: Maybe<MultipleChoiceQuestion>;
  variableId: Scalars['ID'];
};

export type ScreeningQuestionAnswerOtherMetadata = {
  __typename?: 'ScreeningQuestionAnswerOtherMetadata';
  characterCount: Scalars['Int'];
  id: Scalars['ID'];
  isAnswerChoice: Scalars['Boolean'];
  isEnabled: Scalars['Boolean'];
  lineCount: Scalars['Int'];
  requiredErrorText: Scalars['String'];
  text: Scalars['String'];
};

export type ScreeningQuestionAnswerOtherMetadataInput = {
  characterCount: Scalars['Int'];
  id?: InputMaybe<Scalars['ID']>;
  isAnswerChoice: Scalars['Boolean'];
  isEnabled: Scalars['Boolean'];
  lineCount: Scalars['Int'];
  requiredErrorText: Scalars['String'];
  text: Scalars['String'];
};

/** question metadata should only be used in the authoring flow */
export type ScreeningQuestionMetadata = {
  __typename?: 'ScreeningQuestionMetadata';
  answerOther: ScreeningQuestionAnswerOtherMetadata;
  displayNumber: Scalars['Int'];
  disqualifyingRows: Array<ScreeningQuestionRowOptionMetadata>;
  heading: Scalars['String'];
  id: Scalars['ID'];
  mustSelectRows: Array<ScreeningQuestionRowOptionMetadata>;
  required: ScreeningQuestionRequiredMetadata;
  rows: Array<ScreeningQuestionRowOptionMetadata>;
  sorting?: Maybe<ScreeningQuestionSortingMetadata>;
  type: ChoiceScreeningQuestionFamilyType;
  validation?: Maybe<ScreeningQuestionValidationMetadata>;
};

export type ScreeningQuestionRequiredMetadata = {
  __typename?: 'ScreeningQuestionRequiredMetadata';
  amount: Scalars['Int'];
  id: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
  text: Scalars['String'];
  type: ScreeningQuestionRequiredMetadataType;
};

export type ScreeningQuestionRequiredMetadataInput = {
  amount: Scalars['Int'];
  id: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
  text: Scalars['String'];
  type: ScreeningQuestionRequiredMetadataType;
};

export enum ScreeningQuestionRequiredMetadataType {
  All = 'ALL',
  AtLeast = 'AT_LEAST',
  AtMost = 'AT_MOST',
  Exactly = 'EXACTLY',
  Range = 'RANGE',
}

export type ScreeningQuestionRowOptionMetadata = {
  __typename?: 'ScreeningQuestionRowOptionMetadata';
  id: Scalars['ID'];
  text: Scalars['String'];
};

export type ScreeningQuestionRowOptionMetadataInput = {
  id: Scalars['ID'];
  text: Scalars['String'];
};

export type ScreeningQuestions = {
  __typename?: 'ScreeningQuestions';
  /** question metadata for the authoring flow */
  metadata: Array<ScreeningQuestionMetadata>;
  /** helper field to better resolve each screening question field */
  projectId: Scalars['ID'];
  /** A value ranging from 10 to 100 */
  qualificationRate: Scalars['Int'];
  /** survey question */
  questions: Array<ChoiceScreeningQuestion>;
};

export type ScreeningQuestionSortingMetadata = {
  __typename?: 'ScreeningQuestionSortingMetadata';
  ignoreLast: Scalars['Boolean'];
  isEnabled: Scalars['Boolean'];
  type?: Maybe<ScreeningQuestionSortingMetadataType>;
};

export type ScreeningQuestionSortingMetadataInput = {
  ignoreLast: Scalars['Boolean'];
  isEnabled: Scalars['Boolean'];
  type: ScreeningQuestionSortingMetadataType;
};

export enum ScreeningQuestionSortingMetadataType {
  Alphabetical = 'ALPHABETICAL',
  Flip = 'FLIP',
  Random = 'RANDOM',
}

export type ScreeningQuestionValidationMetadata = {
  __typename?: 'ScreeningQuestionValidationMetadata';
  isEnabled: Scalars['Boolean'];
  range?: Maybe<ScreeningQuestionValidationMetadataRange>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<ScreeningQuestionValidationMetadataType>;
};

export type ScreeningQuestionValidationMetadataInput = {
  isEnabled: Scalars['Boolean'];
  range: ScreeningQuestionValidationMetadataRangeInput;
  text: Scalars['String'];
  type: ScreeningQuestionValidationMetadataType;
};

export type ScreeningQuestionValidationMetadataRange = {
  __typename?: 'ScreeningQuestionValidationMetadataRange';
  endBy?: Maybe<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  startedAt?: Maybe<Scalars['String']>;
};

export type ScreeningQuestionValidationMetadataRangeInput = {
  endBy?: InputMaybe<Scalars['String']>;
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
  startedAt?: InputMaybe<Scalars['String']>;
};

export enum ScreeningQuestionValidationMetadataType {
  Any = 'ANY',
  DateIntl = 'DATE_INTL',
  DateUs = 'DATE_US',
  Decimal = 'DECIMAL',
  Email = 'EMAIL',
  Integer = 'INTEGER',
  TextLength = 'TEXT_LENGTH',
}

/** Input for searching a list of team members */
export type SearchTeamMembershipsInput = {
  divisionIds?: InputMaybe<Array<Scalars['String']>>;
  /** A list of team member types to exclude from results */
  excludedTeamMemberTypes?: InputMaybe<Array<TeamMemberType>>;
  /** A list of user ids to exclude from the results */
  excludedUserIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Results must on match these team member types */
  includedTeamMemberTypes?: InputMaybe<Array<TeamMemberType>>;
  page?: Scalars['Int'];
  pageSize?: Scalars['Int'];
  /** A wildcard search field that will filter on username, email, firstName, and lastName */
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<SearchTeamMembershipsSortBy>;
  sortDirection?: InputMaybe<SortDirection>;
  status?: InputMaybe<TeamMemberStatus>;
  teamMemberType?: InputMaybe<TeamMemberType>;
};

/** Column that the search results should be sorted by */
export enum SearchTeamMembershipsSortBy {
  DivisionId = 'DIVISION_ID',
  DivisionName = 'DIVISION_NAME',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  InviteExpiredAt = 'INVITE_EXPIRED_AT',
  LastName = 'LAST_NAME',
  Status = 'STATUS',
  TeamMemberType = 'TEAM_MEMBER_TYPE',
  TeamMemberTypeSortRank = 'TEAM_MEMBER_TYPE_SORT_RANK',
  UserId = 'USER_ID',
  Username = 'USERNAME',
}

/** A request a user makes to change their seat type within a team. */
export type SeatRequest = {
  __typename?: 'SeatRequest';
  id: Scalars['ID'];
  /** Reminder information */
  reminder?: Maybe<SeatRequestReminder>;
  /** Information about the request */
  request?: Maybe<SeatRequestRequest>;
  /** Information about the response */
  response?: Maybe<SeatRequestResponse>;
  /** The status of the request */
  status: SeatRequestStatus;
  /** The user that initiated the seat request */
  user?: Maybe<SeatRequestUser>;
};

/** A list of seat requests from users to change their seat type within a team */
export type SeatRequestList = PaginatedList & {
  __typename?: 'SeatRequestList';
  items: Array<SeatRequest>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SeatRequestPayload = {
  __typename?: 'SeatRequestPayload';
  seatRequest?: Maybe<SeatRequest>;
  success: Scalars['Boolean'];
};

/** Details about a reminder (if any) for a seat request */
export type SeatRequestReminder = {
  __typename?: 'SeatRequestReminder';
  /** Date most recent reminder was sent */
  count: Scalars['Int'];
  /** Date most recent reminder was sent */
  mostRecentDate: Scalars['DateTime'];
};

/** Details about the user submitted request within a seat request */
export type SeatRequestRequest = {
  __typename?: 'SeatRequestRequest';
  /** datetime that the request was made at */
  date: Scalars['DateTime'];
  /** The id of the seat request */
  id: Scalars['ID'];
  /** User provided reason as to why they want the upgraded seat (optional) */
  reason?: Maybe<Scalars['String']>;
  /** The type of seat being requested */
  seatType: SeatRequestSeatType;
  /** The category for source location where the user is making the seat request from. Must match pre-existing category key that is already translated. */
  sourceCategoryKey: Scalars['String'];
  /** The specific feature that the user is requesting a feature from. Must match feature key in pricingSvc. */
  sourceFeatureKey?: Maybe<Scalars['String']>;
};

/** Information about the response from an admin for a seat request */
export type SeatRequestResponse = {
  __typename?: 'SeatRequestResponse';
  /** Date the request was responded to by admin */
  date?: Maybe<Scalars['DateTime']>;
  /** The reason the request was rejected (optional) */
  reason?: Maybe<Scalars['String']>;
  /** The admin who responded to the request */
  responder?: Maybe<SeatRequestUser>;
  /** The status of the response */
  status: SeatRequestResponseStatus;
};

/** The resolution status of the seat request */
export enum SeatRequestResponseStatus {
  /** The seat request was accepted (and the user's seat was changed) */
  Accepted = 'ACCEPTED',
  /** The seat request was declined */
  Declined = 'DECLINED',
  /** The seat request is still awaiting a response */
  Pending = 'PENDING',
  /**
   * The user has cancelled their own seat request
   * or their seat was changed through another mechanism
   */
  Withdrawn = 'WITHDRAWN',
}

/** The SeatType for the SeatRequest */
export enum SeatRequestSeatType {
  CasualUser = 'CASUAL_USER',
  PowerUser = 'POWER_USER',
}

/** The status of a SeatRequest */
export enum SeatRequestStatus {
  /** Available means the user is eligible to make a request */
  Available = 'AVAILABLE',
  /** Not available means the user is not currently eligible to make a request */
  NotAvailable = 'NOT_AVAILABLE',
  /** A seat request is currently pending */
  Pending = 'PENDING',
  /** The seat request has been responded to. See SeatRequestResponseStatus. */
  Responded = 'RESPONDED',
}

/** The user making the seat request */
export type SeatRequestUser = {
  __typename?: 'SeatRequestUser';
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  username: Scalars['String'];
};

/** Summary of seat counts for this group */
export type SeatSummary = {
  __typename?: 'SeatSummary';
  /** The number of seats still available */
  available: SeatSummaryCount;
  /** The number of seats that are reserved for expired invites */
  expiredInvite: SeatSummaryPowerCount;
  /** The number of seats that are reserved for pending resassignments */
  expiredReassignment: SeatSummaryPowerCount;
  /** Whether there is an unlimted amount for each type of seat */
  isUnlimited: SeatSummaryIsUnlimited;
  /** The number of seats that are reserved for pending invites */
  pendingInvite: SeatSummaryPowerCount;
  /** The number of seats that are reserved for pending resassignments */
  pendingReassignment: SeatSummaryPowerCount;
  /** The number of total seats purchased */
  purchased: SeatSummaryCount;
  /** The number of seats filled but not being reserved for invites or reassignment */
  used: SeatSummaryCount;
};

/** A breakdown of the number of seats for each role int his category */
export type SeatSummaryCount = {
  __typename?: 'SeatSummaryCount';
  /** Number of casual seats in this category */
  casual: Scalars['Int'];
  /** Number of contributor seats in this category */
  contributor: Scalars['Int'];
  /** Number of regular (power) seats in this category */
  power: Scalars['Int'];
};

/** Summary of which categories of seat roles are unlimited */
export type SeatSummaryIsUnlimited = {
  __typename?: 'SeatSummaryIsUnlimited';
  /** Are casual seats unlimited */
  casual: Scalars['Boolean'];
  /** Are contributed seats unlimited */
  contributor: Scalars['Boolean'];
  /** Are regular (power) seats unlimited */
  power: Scalars['Boolean'];
};

/** The number of power seats for this category */
export type SeatSummaryPowerCount = {
  __typename?: 'SeatSummaryPowerCount';
  /** Number of regular (power) seats in this category */
  power: Scalars['Int'];
};

export type SelectedAudienceCriteria = {
  __typename?: 'SelectedAudienceCriteria';
  /** These include any criteria selections outside of the "basicCriteria" selections. */
  advancedCriteria: Array<AudienceCriteriaSelection>;
  balancingCriteria: AudienceBalancingCriteriaSelections;
  basicCriteria: AudienceBasicCriteriaSelections;
};

export type SelectVariableConfiguration = ProjectVariableConfiguration & {
  __typename?: 'SelectVariableConfiguration';
  enabled: Scalars['Boolean'];
  heading?: Maybe<Scalars['String']>;
  options: Array<SelectVariableConfigurationOption>;
  subHeading?: Maybe<Scalars['String']>;
};

export type SelectVariableConfigurationOption = {
  __typename?: 'SelectVariableConfigurationOption';
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type SendCustomEmailDomainTestEmailInput = {
  email: Scalars['String'];
};

export type SendCustomEmailDomainTestEmailPayload = {
  __typename?: 'SendCustomEmailDomainTestEmailPayload';
  errors?: Maybe<Array<ClientError>>;
  success: Scalars['Boolean'];
};

export type SendEmailOptInEmailInput = {
  email: Scalars['String'];
};

export type SendKeywordFeedbackInput = {
  autoGeneratedState: Array<OecKeywordTagInput>;
  modifiedState: Array<OecKeywordTagInput>;
  predictionId: Scalars['ID'];
  questionId: Scalars['ID'];
  surveyId: Scalars['ID'];
};

export type SendTagFeedbackInput = {
  predictedThemes: Array<Scalars['String']>;
  predictionId: Scalars['ID'];
  questionId: Scalars['ID'];
  responseTextId: Scalars['ID'];
  reviewedThemes: Array<Scalars['String']>;
  surveyId: Scalars['ID'];
};

export type SentimentAnalysisTag = {
  __typename?: 'SentimentAnalysisTag';
  hexColor: Scalars['String'];
  id: Scalars['ID'];
  label: SentimentAnalysisTagLabel;
  responseCount: Scalars['Int'];
  tagType: Scalars['String'];
};

export enum SentimentAnalysisTagLabel {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE',
  Unknown = 'UNKNOWN',
  Unprocessed = 'UNPROCESSED',
  Untagged = 'UNTAGGED',
}

export type SentimentFilter = AnalysisStandardViewFilterRule & {
  __typename?: 'SentimentFilter';
  active: Scalars['Boolean'];
  customHeading?: Maybe<Scalars['String']>;
  defaultHeading: Scalars['String'];
  id: Scalars['ID'];
  questionPosition: Scalars['Int'];
  tagLabels: Array<SentimentAnalysisTagLabel>;
  tags: Array<Maybe<Scalars['String']>>;
};

export type SetAudienceSurveyPayload = {
  __typename?: 'SetAudienceSurveyPayload';
  isAudienceSurvey: Scalars['Boolean'];
  survey?: Maybe<Survey>;
};

export type SetEmailOptInInput = {
  token: Scalars['String'];
};

export type SetEmailOptInPayload = {
  __typename?: 'SetEmailOptInPayload';
  email?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type SetEmailOptOutInput = {
  token: Scalars['String'];
};

export type SetMyAccountPreferenceInput = {
  preference: Scalars['String'];
  setting: Scalars['Int'];
};

export type SetNewTimeZoneInput = {
  timeZoneId: Scalars['Int'];
};

export type SetQualificationRatePayload = {
  __typename?: 'SetQualificationRatePayload';
  qualificationRate: Scalars['Int'];
  success: Scalars['Boolean'];
};

export type SetShareCrosstabReportInput = {
  enabled: Scalars['Boolean'];
  reportId: Scalars['ID'];
  ssoAuthRequired: Scalars['Boolean'];
};

export type SetShareCrosstabReportPayload = {
  __typename?: 'SetShareCrosstabReportPayload';
  crosstab?: Maybe<CrossTabReport>;
  success: Scalars['Boolean'];
};

export type SetSurveyAlertsInput = {
  existingSurveyAlerts: Scalars['Boolean'];
  existingSurveyAlertsChange: Scalars['Boolean'];
  newSurveyAlerts: Scalars['Boolean'];
};

export type SetSurveyDomainInput = {
  domainType: Scalars['String'];
};

export type SetSurveyFavoritePayload = {
  __typename?: 'SetSurveyFavoritePayload';
  isFavorite: Scalars['Boolean'];
  success: Scalars['Boolean'];
  survey?: Maybe<Survey>;
};

export type SetSurveyResponseAlertsInput = {
  /** The channel to send the alert */
  channel?: InputMaybe<AlertChannel>;
  /** Whether to turn on alerts for this survey or turn them off */
  enabled: Scalars['Boolean'];
  /** The ID of the survey you want to toggle notifications for */
  surveyId: Scalars['ID'];
};

export type SetSurveyResponseAlertsPayload = {
  __typename?: 'SetSurveyResponseAlertsPayload';
  enabled: Scalars['Boolean'];
  success: Scalars['Boolean'];
  surveyId: Scalars['ID'];
};

export type SetUserLanguagePayload = {
  __typename?: 'SetUserLanguagePayload';
  languageCode: Scalars['String'];
  success: Scalars['Boolean'];
};

export type SharedViewPayload = {
  __typename?: 'SharedViewPayload';
  sharedView?: Maybe<AnalysisSharedView>;
  success: Scalars['Boolean'];
};

/** A share resource is only a survey for now, but may expand to other types in the future */
export type ShareResourceInput = {
  resourceId: Scalars['ID'];
  type: WorkgroupResourceType;
};

export type ShareResourcesWithWorkgroupInput = {
  resources: Array<ShareResourceInput>;
  teamId: Scalars['ID'];
  workgroupId: Scalars['ID'];
};

export type ShareResourcesWithWorkgroupPayload = {
  __typename?: 'ShareResourcesWithWorkgroupPayload';
  /** A list of workgroup shares that were created */
  resources: Array<Maybe<WorkgroupShare>>;
  success: Scalars['Boolean'];
};

export enum ShareSurveyAction {
  Changed = 'CHANGED',
  Created = 'CREATED',
  Revoked = 'REVOKED',
}

export type ShareSurveyInput = {
  analyzeAccess: CollaboratorAccess;
  collaboratorId: Scalars['ID'];
  collectAccess: CollaboratorAccess;
  designAccess: CollaboratorAccess;
  ownerId: Scalars['ID'];
  surveyId: Scalars['ID'];
};

export type ShareSurveyPayload = {
  __typename?: 'ShareSurveyPayload';
  action?: Maybe<ShareSurveyAction>;
  collaborator?: Maybe<Collaborator>;
  success: Scalars['Boolean'];
};

export type ShareSurveyResponseAlertsInput = {
  channel?: InputMaybe<AlertChannel>;
  /** Whether to share or unshare the survey for all the given sharees */
  enabled?: InputMaybe<Scalars['Boolean']>;
  sharees?: InputMaybe<Array<InputMaybe<ShareSurveyResponseAlertsShareeInput>>>;
  /** The ID of the survey you want to share responses for */
  surveyId: Scalars['ID'];
};

export type ShareSurveyResponseAlertsPayload = {
  __typename?: 'ShareSurveyResponseAlertsPayload';
  collaborators: Array<Collaborator>;
  success: Scalars['Boolean'];
  userErrors: Array<ShareSurveyResponseAlertsUserError>;
};

export type ShareSurveyResponseAlertsSharee = {
  __typename?: 'ShareSurveyResponseAlertsSharee';
  email?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

/** Must provide **one** of userId OR email */
export type ShareSurveyResponseAlertsShareeInput = {
  /** The email of the person you want to share responses with */
  email?: InputMaybe<Scalars['String']>;
  /** The ID of the user you want to share responses with */
  userId?: InputMaybe<Scalars['ID']>;
};

export type ShareSurveyResponseAlertsUserError = {
  __typename?: 'ShareSurveyResponseAlertsUserError';
  reason: Scalars['String'];
  sharee: ShareSurveyResponseAlertsSharee;
};

export type ShareSurveysInput = {
  /** If this share already exists, should we allow it to change the existing permissions */
  allowOverwrite?: InputMaybe<Scalars['Boolean']>;
  /** The person who will receive access */
  collaboratorId: Scalars['ID'];
  /** The level of permissions being shared */
  roles: CollaboratorRoleInput;
  /** The list of surveys being shared */
  surveys: Array<ShareSurveysSurveyInput>;
};

export type ShareSurveysSurveyInput = {
  /** The survey ID */
  id: Scalars['ID'];
  /** The current owner userId of the survey */
  ownerId: Scalars['ID'];
};

export type ShareSurveyWithGroupInput = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  surveyId: Scalars['ID'];
  surveyOwnerUserId: Scalars['ID'];
};

export type ShareSurveyWithGroupPayload = {
  __typename?: 'ShareSurveyWithGroupPayload';
  collaboratorList?: Maybe<CollaboratorList>;
};

export type ShareSurveyWithOrganizationInput = {
  analyzeAccess: CollaboratorAccess;
  collectAccess: CollaboratorAccess;
  designAccess: CollaboratorAccess;
  surveyId: Scalars['ID'];
  surveyOwnerUserId: Scalars['ID'];
};

/** Filter results by since last invite */
export type SinceLastInviteFilter = AnalysisStandardViewFilterRule & {
  __typename?: 'SinceLastInviteFilter';
  active: Scalars['Boolean'];
  collector: Collector;
  customHeading?: Maybe<Scalars['String']>;
  defaultHeading: Scalars['String'];
  id: Scalars['ID'];
};

/**
 * single_choice question type
 * contains rows and other fields
 * we can also use options field to fetch both rows and other
 */
export type SingleChoiceQuestion = SurveyQuestion & {
  __typename?: 'SingleChoiceQuestion';
  absolutePosition: Scalars['Int'];
  /** Analytics for single choice questions. */
  analytics: Analytics1D;
  displayNumber: Scalars['Int'];
  displayOptions: SurveyQuestionDisplayOptions;
  headers: Array<SurveyQuestionHeader>;
  id: Scalars['ID'];
  isAudience: Scalars['Boolean'];
  nickname: Scalars['String'];
  options?: Maybe<SurveyQuestionOptionList>;
  other?: Maybe<SurveyQuestionOther>;
  pageId: Scalars['ID'];
  position: Scalars['Int'];
  questionTemplate?: Maybe<SingleChoiceQuestionTemplate>;
  responseSummary?: Maybe<QuestionResponseSummary>;
  rows?: Maybe<SurveyQuestionRowList>;
  type: SurveyQuestionType;
  validation: SurveyQuestionValidationOptions;
  visible: Scalars['Boolean'];
};

/**
 * single_choice question type
 * contains rows and other fields
 * we can also use options field to fetch both rows and other
 */
export type SingleChoiceQuestionAnalyticsArgs = {
  filter?: InputMaybe<AnalysisFilterInput>;
};

/**
 * single_choice question type
 * contains rows and other fields
 * we can also use options field to fetch both rows and other
 */
export type SingleChoiceQuestionOptionsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/**
 * single_choice question type
 * contains rows and other fields
 * we can also use options field to fetch both rows and other
 */
export type SingleChoiceQuestionRowsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type SingleChoiceQuestionTemplate = SurveyQuestionTemplate & {
  __typename?: 'SingleChoiceQuestionTemplate';
  attributes: Array<SurveyQuestionTemplateAttribute>;
  heading: Scalars['String'];
  id: Scalars['ID'];
  logicalLink: SurveyQuestionTemplateLogicalLink;
  modifiers: Array<SurveyQuestionTemplateModifier>;
  other?: Maybe<SurveyQuestionTemplateOther>;
  rows: Array<SurveyQuestionTemplateRow>;
};

export type SingleSignOnSettings = {
  __typename?: 'SingleSignOnSettings';
  isSSOEnabled: Scalars['Boolean'];
  isUseSSOAuth?: Maybe<Scalars['Boolean']>;
  isUseSSOAuthIsRestricted: Scalars['Boolean'];
};

export type SkipLogicDestination = {
  __typename?: 'SkipLogicDestination';
  /** only QuestionSkipLogic will allow skipping to a specific question at a later page */
  question?: Maybe<SurveyQuestion>;
  type: SkipLogicDestinationType;
};

export enum SkipLogicDestinationType {
  DisqualifyRespondent = 'DISQUALIFY_RESPONDENT',
  EndSurvey = 'END_SURVEY',
  SkipToPage = 'SKIP_TO_PAGE',
}

export type SliderQuestionQm = SurveyQuestionQm & {
  __typename?: 'SliderQuestionQM';
  createdAt: Scalars['DateTime'];
  family: SurveyQuestionFamily;
  hasPiping: Scalars['Boolean'];
  heading: QuestionHeadingConfiguration;
  hideNumericalInput: Scalars['Boolean'];
  id: Scalars['ID'];
  modifiedAt: Scalars['DateTime'];
  position: QuestionPosition;
  required?: Maybe<QuestionAnswerRequired>;
  scaleOptions: SliderScaleOptions;
  variant: SurveyQuestionVariant;
};

export type SliderScaleLabels = {
  __typename?: 'SliderScaleLabels';
  left: Scalars['String'];
  middle?: Maybe<Scalars['String']>;
  right: Scalars['String'];
};

export type SliderScaleOptions = {
  __typename?: 'SliderScaleOptions';
  errorMessage: Scalars['String'];
  /** whether the scale options are the default ones or are these the user modified values */
  isCustom: Scalars['Boolean'];
  labels: SliderScaleLabels;
  maxValue: Scalars['Int'];
  minValue: Scalars['Int'];
  /** where the input should default to. This must be between the validation min and max value, inclusive. */
  startPosition: Scalars['Int'];
  /** the slider will snap to these values and must be a value between 1 and the max validation value */
  stepSize: Scalars['Int'];
};

/**
 * costFactor for data and stats is 1 because data is currently fetched from
 * AnalyzeAPI. AnalyzeAPI in turn calls statsvc to get the question rollup
 * and statsvc loads the entire survey in memory. Thus, there would be a
 * large cost to breaking down the dashboard question query into smaller
 * queries. The new AnalyticSvc API should be able to fetch smaller chunks
 * of question data much faster, and when we migrate to the new service
 * we can break down the dashboard question query into smaller queries to
 * improve performance and render the dashboard incrementally.
 *
 * The structure of the SMQuestions data is nested because we are matching
 * the format of the props to SingleQuestionController in order to avoid
 * having two layers of data mapping: one on the backend mapping to
 * GraphQL and one on the frontend mapping to SMQuestions.
 */
export type SmqAggregateResponse = {
  __typename?: 'SMQAggregateResponse';
  columnHeader?: Maybe<SmqHeader>;
  data: Array<Maybe<SmqDatum>>;
  groupHeader?: Maybe<SmqHeader>;
  id: Scalars['ID'];
  rowHeader: SmqHeader;
  stats?: Maybe<Array<Maybe<SmqStats>>>;
  type: Scalars['String'];
};

export type SmqCustomization = {
  __typename?: 'SMQCustomization';
  axisScale?: Maybe<Scalars['String']>;
  chartType?: Maybe<Scalars['String']>;
  colors: Array<Maybe<Scalars['String']>>;
  dataFormatLabel?: Maybe<Scalars['String']>;
  dataInChart?: Maybe<Scalars['Boolean']>;
  decimalPlaces?: Maybe<Scalars['Int']>;
  iconComponent?: Maybe<SurveyQuestionDisplaySubType>;
  labels: Array<Maybe<Scalars['String']>>;
  matrixDisplay?: Maybe<Scalars['String']>;
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
};

export type SmqDatum = {
  __typename?: 'SMQDatum';
  columnItem?: Maybe<SmqItem>;
  groupItem?: Maybe<SmqItem>;
  percentage: Scalars['Float'];
  rowItem: SmqItem;
  total: Scalars['Float'];
};

export type SmqDisplayOptions = {
  __typename?: 'SMQDisplayOptions';
  customization?: Maybe<SmqCustomization>;
};

export type SmqHeader = {
  __typename?: 'SMQHeader';
  id: Scalars['ID'];
  items: Array<SmqItem>;
};

export type SmqItem = {
  __typename?: 'SMQItem';
  id: Scalars['ID'];
  label: Scalars['String'];
  weight: Scalars['Int'];
};

export type SmqQuestion = {
  __typename?: 'SMQQuestion';
  dashboardType?: Maybe<Scalars['String']>;
  family: Scalars['String'];
  heading: Scalars['String'];
  id: Scalars['ID'];
  variant: Scalars['String'];
};

export type SmqResponseDatum = {
  __typename?: 'SMQResponseDatum';
  content: Scalars['String'];
  id: Scalars['ID'];
  sentiment?: Maybe<Scalars['String']>;
};

export type SmqResponseSet = {
  __typename?: 'SMQResponseSet';
  aggregateResponse?: Maybe<SmqAggregateResponse>;
  answeredCount: Scalars['Int'];
  filterCount: Scalars['Int'];
  responseData?: Maybe<Array<Maybe<SmqResponseDatum>>>;
  skippedCount: Scalars['Int'];
};

/**
 * SMQuestions types
 *
 * SMQ prefix indicates it is a type related to SMQuestions
 */
export type SmqSingleQuestionController = {
  __typename?: 'SMQSingleQuestionController';
  displayOptions: SmqDisplayOptions;
  question: SmqQuestion;
  responseSet: SmqResponseSet;
};

export type SmqStats = {
  __typename?: 'SMQStats';
  across: Scalars['String'];
  column?: Maybe<SmqItem>;
  group?: Maybe<SmqItem>;
  row?: Maybe<SmqItem>;
};

export type SmsCreditUsageSummary = {
  __typename?: 'SmsCreditUsageSummary';
  creditsUsed: Scalars['Int'];
  remainingBalance: Scalars['Int'];
};

/** Data returned from the study checkout action on a successful checkout. */
export type SolutionsCheckoutStudy = {
  __typename?: 'SolutionsCheckoutStudy';
  checkoutUrl?: Maybe<Scalars['String']>;
};

/**
 * Error type to represent study checkout failure.
 * This includes the data returned from the study checkout action on an unsuccessful checkout.
 */
export type SolutionsCheckoutStudyError = {
  __typename?: 'SolutionsCheckoutStudyError';
  code: SolutionsCheckoutStudyErrorCode;
  errors: SolutionsStudyValidationErrors;
  message?: Maybe<Scalars['String']>;
  price: SolutionsStudyPrice;
};

/** Error code to represent study checkout failure. */
export enum SolutionsCheckoutStudyErrorCode {
  StudyHasErrors = 'STUDY_HAS_ERRORS',
}

/**
 * Response type for solutionsCheckoutStudy mutation.
 * Includes error state for when the specified solutionsStudyId is not found or not authorized.
 */
export type SolutionsCheckoutStudyPayload =
  | NotFoundError
  | SolutionsCheckoutStudy
  | SolutionsCheckoutStudyError
  | UnauthorizedError;

/** A wrapper for a boolean configuration field and associated study methodology state object. */
export type SolutionsConfigFieldBooleanMethodologyStateWrapper = {
  __typename?: 'SolutionsConfigFieldBooleanMethodologyStateWrapper';
  configValueMethodologyState: SolutionsConfigValueMethodologyStatePayload;
  item: SolutionsMethodologyConfigFieldBooleanPayload;
};

/** A wrapper for a boolean configuration field and associated study methodology state object. */
export type SolutionsConfigFieldBooleanMethodologyStateWrapperConfigValueMethodologyStateArgs = {
  studyId: Scalars['ID'];
};

export type SolutionsConfigValueMethodologyStateConfigValuePayload =
  | InvalidInputError
  | NotFoundError
  | SolutionsStudyMethodologyConfigReturnValue
  | UnauthorizedError;

export type SolutionsConfigValueMethodologyStatePayload =
  | InvalidInputError
  | NotFoundError
  | SolutionsConfigValueMethodologyStateWrapper
  | UnauthorizedError;

/**
 * Wrapper for a configuration field value and associated study methodology state
 * object.
 */
export type SolutionsConfigValueMethodologyStateWrapper = {
  __typename?: 'SolutionsConfigValueMethodologyStateWrapper';
  /**
   * The current configuration value for the config field associated with the
   * methodology state.
   */
  configValue: SolutionsConfigValueMethodologyStateConfigValuePayload;
  /** The study methodology state object. */
  methodologyState: SolutionsStudyMethodologyState;
};

/**
 * Response type for solutionsCreateStudy mutation.
 * Includes error state for when the specified solutionsSolutionId is not found or unauthorized error or bad input.
 */
export type SolutionsCreateStudyResponse =
  | InvalidInputError
  | NotFoundError
  | SolutionsStudy
  | UnauthorizedError;

/** The data type for a boolean field value. */
export type SolutionsFieldBooleanValue = {
  __typename?: 'SolutionsFieldBooleanValue';
  boolean: Scalars['Boolean'];
};

/** The data type for a currency range field value. */
export type SolutionsFieldCurrencyRangeValue = {
  __typename?: 'SolutionsFieldCurrencyRangeValue';
  /** The ISO 4217 code for the currency. */
  currencyCode: Scalars['String'];
  /** The maximum possible currency value. */
  maximum?: Maybe<Scalars['Float']>;
  /** The minimum possible currency value. */
  minimum: Scalars['Float'];
};

/** The data type for a rich text configuration field value. */
export type SolutionsFieldRichTextValue = {
  __typename?: 'SolutionsFieldRichTextValue';
  text: Scalars['String'];
};

/**
 * The data type for a single choice discrete answer option choice.
 *
 * Returned for a single choice question where the user selected a choice from
 * the available options.
 */
export type SolutionsFieldSingleChoiceChoiceValue = {
  __typename?: 'SolutionsFieldSingleChoiceChoiceValue';
  choice?: Maybe<Scalars['String']>;
};

/**
 * The data type for a single choice discrete answer option choice.
 *
 * Returned for a single choice question where the user selected the open-ended
 * option (e.g. "Other"), if available, and entered some text.
 */
export type SolutionsFieldSingleChoiceOpenEndedValue = {
  __typename?: 'SolutionsFieldSingleChoiceOpenEndedValue';
  openEndedValue: Scalars['String'];
};

/** The data type for a single choice configuration field value. */
export type SolutionsFieldSingleChoiceValue = {
  __typename?: 'SolutionsFieldSingleChoiceValue';
  value: SolutionsFieldSingleChoiceValueTypes;
};

/**
 * A union representing the possible single choice configuration field value
 * types.
 */
export type SolutionsFieldSingleChoiceValueTypes =
  | SolutionsFieldSingleChoiceChoiceValue
  | SolutionsFieldSingleChoiceOpenEndedValue;

/** The data type for a single text field value. */
export type SolutionsFieldText = {
  __typename?: 'SolutionsFieldText';
  text: Scalars['String'];
};

/** The data type for a toggle/text field value. */
export type SolutionsFieldToggleText = {
  __typename?: 'SolutionsFieldToggleText';
  text: Scalars['String'];
  toggleOn: Scalars['Boolean'];
};

/**
 * Data type for catch-all "unknown" field type.
 *
 * Basically values from the API are ignored for this type, and a dummy value is
 * returned.
 */
export type SolutionsFieldUnknown = {
  __typename?: 'SolutionsFieldUnknown';
  value: Scalars['String'];
};

/**
 * Represents error states corresponding to invalid config value input that could
 * not be saved.
 */
export type SolutionsInvalidStudyError = {
  __typename?: 'SolutionsInvalidStudyError';
  code: SolutionsInvalidStudyErrorCode;
  message?: Maybe<Scalars['String']>;
  userMessage?: Maybe<Scalars['String']>;
};

/** Codes for errors corresponding to invalid study input error states. */
export enum SolutionsInvalidStudyErrorCode {
  InvalidStudy = 'INVALID_STUDY',
}

/**
 * Response type for solutionsLaunchStudy query
 * Includes error state for when the specified solutionsStudyId is not found or not authorized.
 */
export type SolutionsLaunchStudyPayload =
  | InvalidInputError
  | NotFoundError
  | SolutionsStudy
  | UnauthorizedError;

/**
 * A methodology object, containing all information required to utilize a
 * specific research methodology in a market research study.
 */
export type SolutionsMethodology = {
  __typename?: 'SolutionsMethodology';
  /** Study configuration information associated with the methodology. */
  config: SolutionsMethodologyConfig;
  /** A brief description of the research methodology. */
  description: Scalars['String'];
  /** The database id of the methodology object. */
  id: Scalars['ID'];
  /** The machine readable name of the methodology. */
  title: Scalars['String'];
};

/** A bucket for all study object fields related to study configuration. */
export type SolutionsMethodologyConfig = {
  __typename?: 'SolutionsMethodologyConfig';
  nodeGroups: SolutionsMethodologyConfigNodeGroupsPayload;
};

/** A bucket for all study object fields related to study configuration. */
export type SolutionsMethodologyConfigNodeGroupsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Configuration field definition for fields of type Boolean. */
export type SolutionsMethodologyConfigFieldBoolean = SolutionsMethodologyConfigFieldDefinition & {
  __typename?: 'SolutionsMethodologyConfigFieldBoolean';
  /** The configuration value associated with the field for a given study. */
  configValue: SolutionsMethodologyConfigFieldBooleanConfigValuePayload;
  description?: Maybe<Scalars['String']>;
  name: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type: SolutionsMethodologyConfigFieldType;
};

/** Configuration field definition for fields of type Boolean. */
export type SolutionsMethodologyConfigFieldBooleanConfigValueArgs = {
  studyId: Scalars['ID'];
};

export type SolutionsMethodologyConfigFieldBooleanConfigValuePayload =
  | InvalidConfigValueError
  | InvalidInputError
  | NotFoundError
  | SolutionsFieldBooleanValue
  | UnauthorizedError;

export type SolutionsMethodologyConfigFieldBooleanPayload =
  | InvalidInputError
  | NotFoundError
  | SolutionsMethodologyConfigFieldBoolean
  | UnauthorizedError;

/** Object representing a choice available in a Single Choice configuration field. */
export type SolutionsMethodologyConfigFieldChoice = {
  __typename?: 'SolutionsMethodologyConfigFieldChoice';
  label: Scalars['String'];
  value: Scalars['String'];
};

/** Configuration field definition for fields of type Currency Range. */
export type SolutionsMethodologyConfigFieldCurrencyRange = SolutionsMethodologyConfigFieldDefinition & {
  __typename?: 'SolutionsMethodologyConfigFieldCurrencyRange';
  /** The configuration value associated with the field for a given study. */
  configValue: SolutionsMethodologyConfigFieldCurrencyRangeConfigValuePayload;
  /**
   * List of ISO 4217 standard currency codes available for the currency range
   * field.
   */
  currencies: Array<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type: SolutionsMethodologyConfigFieldType;
};

/** Configuration field definition for fields of type Currency Range. */
export type SolutionsMethodologyConfigFieldCurrencyRangeConfigValueArgs = {
  studyId: Scalars['ID'];
};

export type SolutionsMethodologyConfigFieldCurrencyRangeConfigValuePayload =
  | InvalidConfigValueError
  | InvalidInputError
  | NotFoundError
  | SolutionsFieldCurrencyRangeValue
  | UnauthorizedError;

/**
 * An object describing a study configuration field, specific to a particular
 * research methodology.
 */
export type SolutionsMethodologyConfigFieldDefinition = {
  description?: Maybe<Scalars['String']>;
  name: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type: SolutionsMethodologyConfigFieldType;
};

/**
 * Wrapper for config field definition objects, with some fields for extra
 * metadata and operations.
 */
export type SolutionsMethodologyConfigFieldDefinitionItem = {
  __typename?: 'SolutionsMethodologyConfigFieldDefinitionItem';
  /**
   * The configuration value associated with the configuration field for a given
   * study, and associated methodology state info.
   */
  configValueMethodologyState: SolutionsConfigValueMethodologyStatePayload;
  item: SolutionsMethodologyConfigFieldDefinition;
};

/**
 * Wrapper for config field definition objects, with some fields for extra
 * metadata and operations.
 */
export type SolutionsMethodologyConfigFieldDefinitionItemConfigValueMethodologyStateArgs = {
  studyId: Scalars['ID'];
};

export type SolutionsMethodologyConfigFieldDefinitionPayload =
  | InvalidInputError
  | NotFoundError
  | SolutionsMethodologyConfigFieldDefinitionItem
  | UnauthorizedError;

/** Configuration field definition for fields of type Rich Text. */
export type SolutionsMethodologyConfigFieldRichText = SolutionsMethodologyConfigFieldDefinition & {
  __typename?: 'SolutionsMethodologyConfigFieldRichText';
  /** The configuration value associated with the field for a given study. */
  configValue: SolutionsMethodologyConfigFieldRichTextConfigValuePayload;
  description?: Maybe<Scalars['String']>;
  name: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type: SolutionsMethodologyConfigFieldType;
};

/** Configuration field definition for fields of type Rich Text. */
export type SolutionsMethodologyConfigFieldRichTextConfigValueArgs = {
  studyId: Scalars['ID'];
};

export type SolutionsMethodologyConfigFieldRichTextConfigValuePayload =
  | InvalidConfigValueError
  | InvalidInputError
  | NotFoundError
  | SolutionsFieldRichTextValue
  | UnauthorizedError;

/** Configuration field definition for fields of type Single Choice. */
export type SolutionsMethodologyConfigFieldSingleChoice = SolutionsMethodologyConfigFieldDefinition & {
  __typename?: 'SolutionsMethodologyConfigFieldSingleChoice';
  /** The list of discrete choices available for the configuration field. */
  choices: Array<SolutionsMethodologyConfigFieldChoice>;
  /** The configuration value associated with the field for a given study. */
  configValue: SolutionsMethodologyConfigFieldSingleChoiceConfigValuePayload;
  description?: Maybe<Scalars['String']>;
  name: Scalars['ID'];
  /**
   * Options related to adding an open-ended option to the list of choices (e.g.
   * an "Other" option with a textbox).
   *
   * Null value indicates that there is no open-ended option associated with the
   * configuration field.
   */
  openEndedChoice?: Maybe<SolutionsMethodologyConfigFieldSingleChoiceOpenEnded>;
  title?: Maybe<Scalars['String']>;
  type: SolutionsMethodologyConfigFieldType;
};

/** Configuration field definition for fields of type Single Choice. */
export type SolutionsMethodologyConfigFieldSingleChoiceConfigValueArgs = {
  studyId: Scalars['ID'];
};

export type SolutionsMethodologyConfigFieldSingleChoiceConfigValuePayload =
  | InvalidConfigValueError
  | InvalidInputError
  | NotFoundError
  | SolutionsFieldSingleChoiceValue
  | UnauthorizedError;

/**
 * Object describing options for the open-ended choice option in a Single Choice
 * configuration field.
 */
export type SolutionsMethodologyConfigFieldSingleChoiceOpenEnded = {
  __typename?: 'SolutionsMethodologyConfigFieldSingleChoiceOpenEnded';
  label: Scalars['String'];
};

/** Configuration field definition for fields of type Text. */
export type SolutionsMethodologyConfigFieldText = SolutionsMethodologyConfigFieldDefinition & {
  __typename?: 'SolutionsMethodologyConfigFieldText';
  /** The configuration value associated with the field for a given study. */
  configValue: SolutionsMethodologyConfigFieldTextConfigValuePayload;
  description?: Maybe<Scalars['String']>;
  name: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type: SolutionsMethodologyConfigFieldType;
};

/** Configuration field definition for fields of type Text. */
export type SolutionsMethodologyConfigFieldTextConfigValueArgs = {
  studyId: Scalars['ID'];
};

export type SolutionsMethodologyConfigFieldTextConfigValuePayload =
  | InvalidConfigValueError
  | InvalidInputError
  | NotFoundError
  | SolutionsFieldText
  | UnauthorizedError;

/** Configuration field definition for fields of type Toggle/Text. */
export type SolutionsMethodologyConfigFieldToggleText = SolutionsMethodologyConfigFieldDefinition & {
  __typename?: 'SolutionsMethodologyConfigFieldToggleText';
  /** The configuration value associated with the field for a given study. */
  configValue: SolutionsMethodologyConfigFieldToggleTextConfigValuePayload;
  description?: Maybe<Scalars['String']>;
  name: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type: SolutionsMethodologyConfigFieldType;
};

/** Configuration field definition for fields of type Toggle/Text. */
export type SolutionsMethodologyConfigFieldToggleTextConfigValueArgs = {
  studyId: Scalars['ID'];
};

export type SolutionsMethodologyConfigFieldToggleTextConfigValuePayload =
  | InvalidConfigValueError
  | InvalidInputError
  | NotFoundError
  | SolutionsFieldToggleText
  | UnauthorizedError;

/**
 * Enum for possible configuration field type values.
 *
 * Each member represents the name of a data type for a configuration field.
 */
export enum SolutionsMethodologyConfigFieldType {
  Boolean = 'BOOLEAN',
  CurrencyRange = 'CURRENCY_RANGE',
  RichText = 'RICH_TEXT',
  SingleChoice = 'SINGLE_CHOICE',
  Text = 'TEXT',
  ToggleText = 'TOGGLE_TEXT',
  Unknown = 'UNKNOWN',
}

/** Configuration field definition for fields of unknown type. */
export type SolutionsMethodologyConfigFieldUnknown = SolutionsMethodologyConfigFieldDefinition & {
  __typename?: 'SolutionsMethodologyConfigFieldUnknown';
  /** The configuration value associated with the field for a given study. */
  configValue: SolutionsMethodologyConfigFieldUnknownConfigValuePayload;
  description?: Maybe<Scalars['String']>;
  name: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type: SolutionsMethodologyConfigFieldType;
};

/** Configuration field definition for fields of unknown type. */
export type SolutionsMethodologyConfigFieldUnknownConfigValueArgs = {
  studyId: Scalars['ID'];
};

export type SolutionsMethodologyConfigFieldUnknownConfigValuePayload =
  | InvalidConfigValueError
  | InvalidInputError
  | NotFoundError
  | SolutionsFieldUnknown
  | UnauthorizedError;

/** A configuration node associated with a particular market research methodology. */
export type SolutionsMethodologyConfigNode = {
  __typename?: 'SolutionsMethodologyConfigNode';
  contents: Array<SolutionsMethodologyConfigNodeContentItem>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
  toggle?: Maybe<SolutionsConfigFieldBooleanMethodologyStateWrapper>;
};

/** Common fields for all configuration node contents objects. */
export type SolutionsMethodologyConfigNodeContentItem = {
  /** The machine-readable name identifying the item; unique within its type. */
  name: Scalars['String'];
  /**
   * Indicates the type of the configuration node contents object.
   *
   * Configuration nodes can have contents of several different types (e.g.
   * survey question previews, study configuration fields).
   */
  type: SolutionsMethodologyConfigNodeContentItemType;
};

/**
 * Configuration node contents object type representing a reference to a
 * configuration field definition.
 */
export type SolutionsMethodologyConfigNodeContentItemConfigField = SolutionsMethodologyConfigNodeContentItem & {
  __typename?: 'SolutionsMethodologyConfigNodeContentItemConfigField';
  /** The configuration field definition object associated with the content item. */
  fieldDefinition: SolutionsMethodologyConfigFieldDefinitionPayload;
  name: Scalars['String'];
  type: SolutionsMethodologyConfigNodeContentItemType;
};

/**
 * Configuration node contents object type representing a reference to a
 * study question preview.
 */
export type SolutionsMethodologyConfigNodeContentItemQuestionPreview = SolutionsMethodologyConfigNodeContentItem & {
  __typename?: 'SolutionsMethodologyConfigNodeContentItemQuestionPreview';
  name: Scalars['String'];
  /**
   * The question preview object associated with the configuration node content
   * item for a given study, and associated methodology state info.
   */
  questionPreviewMethodologyState: SolutionsQuestionPreviewMethodologyStatePayload;
  type: SolutionsMethodologyConfigNodeContentItemType;
};

/**
 * Configuration node contents object type representing a reference to a
 * study question preview.
 */
export type SolutionsMethodologyConfigNodeContentItemQuestionPreviewQuestionPreviewMethodologyStateArgs = {
  studyId: Scalars['ID'];
};

/** Enumeration of type values for possible configuration node contents objects. */
export enum SolutionsMethodologyConfigNodeContentItemType {
  ConfigField = 'CONFIG_FIELD',
  QuestionPreview = 'QUESTION_PREVIEW',
}

/** Object representing an individual methodology configuration node group. */
export type SolutionsMethodologyConfigNodeGroup = {
  __typename?: 'SolutionsMethodologyConfigNodeGroup';
  label: Scalars['String'];
  name: Scalars['String'];
  nodes: SolutionsMethodologyConfigNodesPayload;
};

/** Object representing an individual methodology configuration node group. */
export type SolutionsMethodologyConfigNodeGroupNodesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Paginated list of methodology configuration node groups. */
export type SolutionsMethodologyConfigNodeGroupsList = PaginatedList & {
  __typename?: 'SolutionsMethodologyConfigNodeGroupsList';
  id: Scalars['ID'];
  items: Array<SolutionsMethodologyConfigNodeGroup>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Union operation payload for fetching methodology node groups. */
export type SolutionsMethodologyConfigNodeGroupsPayload =
  | InvalidInputError
  | NotFoundError
  | SolutionsMethodologyConfigNodeGroupsList
  | UnauthorizedError;

/** A paginated list of study configuration nodes. */
export type SolutionsMethodologyConfigNodesList = PaginatedList & {
  __typename?: 'SolutionsMethodologyConfigNodesList';
  id: Scalars['ID'];
  items: Array<SolutionsMethodologyConfigNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SolutionsMethodologyConfigNodesPayload =
  | InvalidInputError
  | NotFoundError
  | SolutionsMethodologyConfigNodesList
  | UnauthorizedError;

export type SolutionsQuestionPreviewMethodologyStatePayload =
  | InvalidInputError
  | NotFoundError
  | SolutionsQuestionPreviewMethodologyStateWrapper
  | UnauthorizedError;

export type SolutionsQuestionPreviewMethodologyStateQuestionPreviewItem = {
  __typename?: 'SolutionsQuestionPreviewMethodologyStateQuestionPreviewItem';
  item: SolutionsStudyQuestionPreview;
};

export type SolutionsQuestionPreviewMethodologyStateQuestionPreviewPayload =
  | InvalidInputError
  | NotFoundError
  | SolutionsQuestionPreviewMethodologyStateQuestionPreviewItem
  | UnauthorizedError;

/**
 * Wrapper for a question preview object and associated study methodology state
 * object.
 */
export type SolutionsQuestionPreviewMethodologyStateWrapper = {
  __typename?: 'SolutionsQuestionPreviewMethodologyStateWrapper';
  /** The study methodology state object. */
  methodologyState: SolutionsStudyMethodologyState;
  /** The methodology state's question preview object. */
  questionPreview: SolutionsQuestionPreviewMethodologyStateQuestionPreviewPayload;
};

export type SolutionsSolution = {
  __typename?: 'SolutionsSolution';
  id: Scalars['ID'];
  methodologies: SolutionsSolutionMethodologiesPayload;
  title: Scalars['String'];
};

export type SolutionsSolutionMethodolgies = {
  __typename?: 'SolutionsSolutionMethodolgies';
  values: Array<SolutionsMethodology>;
};

export type SolutionsSolutionMethodologiesPayload =
  | NotFoundError
  | SolutionsSolutionMethodolgies;

/**
 * Response type for solutionsSolution query.
 *
 * Includes error state for when the specified SolutionsSolution is not found.
 */
export type SolutionsSolutionResponse = NotFoundError | SolutionsSolution;

/**
 * A study object, representing a study that has been created as part of a given
 * market research or other product solution.
 */
export type SolutionsStudy = {
  __typename?: 'SolutionsStudy';
  /** Analysis information related to the study. */
  analysis: SolutionsStudyAnalysis;
  /** The guardrail errors for the study */
  guardrails?: Maybe<SolutionsStudyGuardrailsPayload>;
  id: Scalars['String'];
  /**
   * The current values (or "states") associated with each particular methodology
   * that is a part of the study.
   */
  methodologyState: SolutionsStudyMethodologyStatePayload;
  /** The price information for the study. */
  price?: Maybe<SolutionsStudyPricePayload>;
  /**
   * The solution (or product) that the study is a part of.
   *
   * For example, the study could be a pricing study and belong to the pricing
   * solution offered as a part of our market research product suite.
   */
  solution: SolutionsSolutionResponse;
  /** The survey associated with the study. */
  survey: SolutionsStudySurveyPayload;
  title: Scalars['String'];
};

/** Container for all analysis-related information and data for a study. */
export type SolutionsStudyAnalysis = {
  __typename?: 'SolutionsStudyAnalysis';
  nodeGroups: SolutionsStudyAnalysisNodeGroupsPayload;
  respondentCounts: SolutionsStudyRespondentCountsPayload;
};

/** Container for all analysis-related information and data for a study. */
export type SolutionsStudyAnalysisRespondentCountsArgs = {
  filter?: InputMaybe<AnalysisFilterInput>;
};

/** Data and metadata for a chart series. */
export type SolutionsStudyAnalysisChartSeries = {
  __typename?: 'SolutionsStudyAnalysisChartSeries';
  data: Array<Array<Scalars['Float']>>;
  key: Scalars['String'];
  type: SolutionsStudyAnalysisChartSeriesType;
};

/** Enum for discriminating between series types for charts. */
export enum SolutionsStudyAnalysisChartSeriesType {
  Line = 'LINE',
}

/** Represents a union of all the possible study analysis node types. */
export type SolutionsStudyAnalysisNode =
  | SolutionsStudyAnalysisQuestionNode
  | SolutionsStudyAnalysisQuestionStatisticsNode
  | SolutionsStudyAnalysisSimpleNode
  | SolutionsStudyAnalysisVanWestendorpPricingSensitivityNode;

/**
 * Represents a container for a list of analysis nodes for a given study.
 *
 * Analysis nodes are logically grouped this way, so that they can be organized.
 * For example, a methodology might define analysis node groups that could
 * correspond to pages in a UI, or sections in a spreadsheet.
 */
export type SolutionsStudyAnalysisNodeGroup = {
  __typename?: 'SolutionsStudyAnalysisNodeGroup';
  label: Scalars['String'];
  name: Scalars['String'];
  /** The paginated list of analysis nodes belonging to the node group. */
  nodes: SolutionsStudyAnalysisNodesPayload;
};

/**
 * Represents a container for a list of analysis nodes for a given study.
 *
 * Analysis nodes are logically grouped this way, so that they can be organized.
 * For example, a methodology might define analysis node groups that could
 * correspond to pages in a UI, or sections in a spreadsheet.
 */
export type SolutionsStudyAnalysisNodeGroupNodesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/**
 * List of analysis node groups for a given study.
 *
 * Cost factor is low for this list because it represents a discrete, simple list
 * of groupings for a given study. It is typically very short (usually <5 items),
 * and the objects are very simple.
 */
export type SolutionsStudyAnalysisNodeGroups = {
  __typename?: 'SolutionsStudyAnalysisNodeGroups';
  items: Array<SolutionsStudyAnalysisNodeGroup>;
};

export type SolutionsStudyAnalysisNodeGroupsPayload =
  | ForbiddenError
  | NotFoundError
  | SolutionsStudyAnalysisNodeGroups
  | UnauthorizedError;

/**
 * A paginated list of study analysis nodes.
 *
 * Cost factor is lower because the number of items is not typically very large,
 * and the items only contain a limited amount of information.
 */
export type SolutionsStudyAnalysisNodesList = PaginatedList & {
  __typename?: 'SolutionsStudyAnalysisNodesList';
  id: Scalars['ID'];
  items: Array<SolutionsStudyAnalysisNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SolutionsStudyAnalysisNodesPayload =
  | ForbiddenError
  | InvalidInputError
  | NotFoundError
  | SolutionsStudyAnalysisNodesList
  | UnauthorizedError;

/**
 * Analysis nodes that require standard analysis on a basic survey question.
 *
 * Each SurveyQuestion subtype should have standard analysis fields defined on it.
 */
export type SolutionsStudyAnalysisQuestionNode = {
  __typename?: 'SolutionsStudyAnalysisQuestionNode';
  question: SolutionsStudyAnalysisQuestionNodeQuestionPayload;
  skip?: Maybe<Scalars['Boolean']>;
  type: SolutionsStudyAnalysisQuestionNodeType;
};

export type SolutionsStudyAnalysisQuestionNodeQuestion = {
  __typename?: 'SolutionsStudyAnalysisQuestionNodeQuestion';
  item: SurveyQuestion;
};

export type SolutionsStudyAnalysisQuestionNodeQuestionPayload =
  | NotFoundError
  | SolutionsStudyAnalysisQuestionNodeQuestion;

/** Single-member enum for discriminating survey question analysis node type objects in unions. */
export enum SolutionsStudyAnalysisQuestionNodeType {
  SurveyQuestion = 'SURVEY_QUESTION',
}

/**
 * Analysis nodes for the "question statistics" node type (associated with the
 * simple_example demo methodology.
 */
export type SolutionsStudyAnalysisQuestionStatisticsNode = {
  __typename?: 'SolutionsStudyAnalysisQuestionStatisticsNode';
  question: SolutionsStudyAnalysisQuestionStatisticsNodeQuestionPayload;
  type: SolutionsStudyAnalysisQuestionStatisticsNodeType;
};

/**
 * Analysis nodes for the "question statistics" node type (associated with the
 * simple_example demo methodology.
 */
export type SolutionsStudyAnalysisQuestionStatisticsNodeQuestionArgs = {
  filter?: InputMaybe<AnalysisFilterInput>;
};

/**
 * Type wrapping both the question data and the basic statistics for a single question
 * in the "question statistics" node type.
 */
export type SolutionsStudyAnalysisQuestionStatisticsNodeQuestion = {
  __typename?: 'SolutionsStudyAnalysisQuestionStatisticsNodeQuestion';
  analytics: SolutionsStudyAnalysisQuestionStatisticsNodeQuestionStats;
  item: SurveyQuestion;
};

export type SolutionsStudyAnalysisQuestionStatisticsNodeQuestionPayload =
  | InvalidInputError
  | NotFoundError
  | SolutionsStudyAnalysisQuestionStatisticsNodeQuestion
  | SolutionsStudyNotEnoughResponsesError
  | UnauthorizedError;

/** Type for the basic question statistics for a single question in the "question statistics" node type. */
export type SolutionsStudyAnalysisQuestionStatisticsNodeQuestionStats = {
  __typename?: 'SolutionsStudyAnalysisQuestionStatisticsNodeQuestionStats';
  firstQuartile: Scalars['Float'];
  maximum: Scalars['Float'];
  mean: Scalars['Float'];
  median: Scalars['Float'];
  minimum: Scalars['Float'];
  standardDeviation: Scalars['Float'];
  thirdQuartile: Scalars['Float'];
};

/**
 * Single-member enum for discriminating question statistics node type objects in
 * unions.
 */
export enum SolutionsStudyAnalysisQuestionStatisticsNodeType {
  QuestionStatistics = 'QUESTION_STATISTICS',
}

/**
 * Analysis nodes for the "simple" node type (associated with the simple_example
 * demo methodology.
 *
 * This is a temporary node type for testing the Framework's aggregate analysis
 * capabilities.
 */
export type SolutionsStudyAnalysisSimpleNode = {
  __typename?: 'SolutionsStudyAnalysisSimpleNode';
  type: SolutionsStudyAnalysisSimpleNodeType;
};

/** Single-member enum for discriminating simple_example node type objects in unions. */
export enum SolutionsStudyAnalysisSimpleNodeType {
  Simple = 'SIMPLE',
}

/** Metadata for a Van Westendorp Pricing Sensitivity chart */
export type SolutionsStudyAnalysisVanWestendorpPricingSensitivityMetadata = {
  __typename?: 'SolutionsStudyAnalysisVanWestendorpPricingSensitivityMetadata';
  indifferent: SolutionsStudyAnalysisVanWestendorpPricingSensitivityPointMetadata;
  lowerBound: SolutionsStudyAnalysisVanWestendorpPricingSensitivityPointMetadata;
  optimal: SolutionsStudyAnalysisVanWestendorpPricingSensitivityPointMetadata;
  upperBound: SolutionsStudyAnalysisVanWestendorpPricingSensitivityPointMetadata;
};

/** A study analysis node requiring Van Westendorp analysis. */
export type SolutionsStudyAnalysisVanWestendorpPricingSensitivityNode = {
  __typename?: 'SolutionsStudyAnalysisVanWestendorpPricingSensitivityNode';
  analytics: SolutionsStudyAnalysisVanWestendorpPricingSensitivityNodeAnalyticsPayload;
  type: SolutionsStudyAnalysisVanWestendorpPricingSensitivityNodeType;
};

/** A study analysis node requiring Van Westendorp analysis. */
export type SolutionsStudyAnalysisVanWestendorpPricingSensitivityNodeAnalyticsArgs = {
  filter?: InputMaybe<AnalysisFilterInput>;
};

/** Analytics data for a Van Westendorp Pricing Sensitivity chart */
export type SolutionsStudyAnalysisVanWestendorpPricingSensitivityNodeAnalytics = {
  __typename?: 'SolutionsStudyAnalysisVanWestendorpPricingSensitivityNodeAnalytics';
  metadata: SolutionsStudyAnalysisVanWestendorpPricingSensitivityMetadata;
  series: Array<SolutionsStudyAnalysisChartSeries>;
};

export type SolutionsStudyAnalysisVanWestendorpPricingSensitivityNodeAnalyticsPayload =
  | InvalidInputError
  | NotFoundError
  | SolutionsStudyAnalysisVanWestendorpPricingSensitivityNodeAnalytics
  | SolutionsStudyNotEnoughResponsesError
  | UnauthorizedError;

/** Single-member enum for discriminating Van Westendorp analysis node type objects in unions. */
export enum SolutionsStudyAnalysisVanWestendorpPricingSensitivityNodeType {
  VanWestendorpPricingSensitivity = 'VAN_WESTENDORP_PRICING_SENSITIVITY',
}

/** Metadata for a point of interest on a Van Westendorp Pricing Sensitivity chart */
export type SolutionsStudyAnalysisVanWestendorpPricingSensitivityPointMetadata = {
  __typename?: 'SolutionsStudyAnalysisVanWestendorpPricingSensitivityPointMetadata';
  percentage: Scalars['Float'];
  price: Scalars['Float'];
  responses: Scalars['Float'];
};

/** Data returned from the study precheckout action. */
export type SolutionsStudyCheckoutInfo = {
  __typename?: 'SolutionsStudyCheckoutInfo';
  errors: SolutionsStudyValidationErrors;
  price: SolutionsStudyPrice;
};

/**
 * Response type for solutionsStudyCheckoutInfo query.
 * Includes error state for when the specified solutionsStudyId is not found or not authorized.
 */
export type SolutionsStudyCheckoutInfoPayload =
  | NotFoundError
  | SolutionsStudyCheckoutInfo
  | UnauthorizedError;

/** A single guardrail error for a study */
export type SolutionsStudyGuardrail = {
  __typename?: 'SolutionsStudyGuardrail';
  details: Array<Maybe<Scalars['String']>>;
  heading: Scalars['String'];
  key: Scalars['String'];
};

/** List of guardrail errors for a study */
export type SolutionsStudyGuardrailList = {
  __typename?: 'SolutionsStudyGuardrailList';
  items: Array<Maybe<SolutionsStudyGuardrail>>;
};

/** A union representing the response types for the study guardrail errors */
export type SolutionsStudyGuardrailsPayload =
  | NotFoundError
  | SolutionsStudyGuardrailList
  | UnauthorizedError;

/**
 * Describes a specific study configuration value, including the configuration
 * field name and the current value set for that field.
 */
export type SolutionsStudyMethodologyConfigReturnValue = {
  __typename?: 'SolutionsStudyMethodologyConfigReturnValue';
  id: Scalars['ID'];
  name: Scalars['String'];
  type: SolutionsMethodologyConfigFieldType;
  value: SolutionsStudyMethodologyConfigValueType;
};

export type SolutionsStudyMethodologyConfigValuePayload =
  | NotFoundError
  | SolutionsStudyMethodologyConfigValues
  | SolutionsStudyMethodologyConfigValuesConfigFieldsError
  | UnauthorizedError;

/**
 * A list of methodology-specific configuration values that have been set for a
 * market research study.
 */
export type SolutionsStudyMethodologyConfigValues = {
  __typename?: 'SolutionsStudyMethodologyConfigValues';
  values: Array<SolutionsStudyMethodologyConfigReturnValue>;
};

/**
 * Error type to represent states within configuration value fetch operations
 * where the associated configuration field definition fetch has failed.
 */
export type SolutionsStudyMethodologyConfigValuesConfigFieldsError = {
  __typename?: 'SolutionsStudyMethodologyConfigValuesConfigFieldsError';
  code: SolutionsStudyMethodologyConfigValuesConfigFieldsErrorCode;
  message?: Maybe<Scalars['String']>;
};

/**
 * Error codes to represent states within configuration value fetch operations
 * where the associated configuration field definition fetch has failed.
 */
export enum SolutionsStudyMethodologyConfigValuesConfigFieldsErrorCode {
  FieldDefinitionMissing = 'FIELD_DEFINITION_MISSING',
}

/**
 * A union of all possible market research study configuration field value types.
 *
 * Mirrors the input scalar type SolutionsStudyMethodologyConfigValue. Where
 * possible, this type should be used over the scalar, because it provides schema
 * documentation of the possible configuration field value data types.
 */
export type SolutionsStudyMethodologyConfigValueType =
  | SolutionsFieldBooleanValue
  | SolutionsFieldCurrencyRangeValue
  | SolutionsFieldRichTextValue
  | SolutionsFieldSingleChoiceValue
  | SolutionsFieldText
  | SolutionsFieldToggleText
  | SolutionsFieldUnknown;

/**
 * Current state values for a market research study that relate to a specific
 * research methodology.
 */
export type SolutionsStudyMethodologyState = {
  __typename?: 'SolutionsStudyMethodologyState';
  configValues: SolutionsStudyMethodologyConfigValuePayload;
  id: Scalars['ID'];
  methodology: SolutionsMethodology;
};

export type SolutionsStudyMethodologyStateMethodologyError = {
  __typename?: 'SolutionsStudyMethodologyStateMethodologyError';
  code: SolutionsStudyMethodologyStateMethodologyErrorCode;
  message: Scalars['String'];
};

export enum SolutionsStudyMethodologyStateMethodologyErrorCode {
  MethodologyFetchError = 'METHODOLOGY_FETCH_ERROR',
  MethodologyNotFound = 'METHODOLOGY_NOT_FOUND',
}

export type SolutionsStudyMethodologyStatePayload =
  | NotFoundError
  | SolutionsStudyMethodologyStateMethodologyError
  | SolutionsStudyMethodologyStates
  | UnauthorizedError;

/**
 * Methodology-related states for Solutions market research studies.
 *
 * Contains all the methodology-specific information associated with a market
 * research study. Also lists the specific methodologies that have been selected
 * for a study.
 */
export type SolutionsStudyMethodologyStates = {
  __typename?: 'SolutionsStudyMethodologyStates';
  methodologies: Array<SolutionsMethodology>;
  states: Array<SolutionsStudyMethodologyState>;
};

/** Represent error states corresponding to not analysis due to not enough responses */
export type SolutionsStudyNotEnoughResponsesError = {
  __typename?: 'SolutionsStudyNotEnoughResponsesError';
  code: SolutionsStudyNotEnoughResponsesErrorCode;
  message?: Maybe<Scalars['String']>;
  userMessage?: Maybe<Scalars['String']>;
};

/** Error codes for SolutionsStudyAnalysisNodes corresponding to not enough responses error states. */
export enum SolutionsStudyNotEnoughResponsesErrorCode {
  InsufficientNumberOfResponses = 'INSUFFICIENT_NUMBER_OF_RESPONSES',
}

/** The price information for a study. */
export type SolutionsStudyPrice = {
  __typename?: 'SolutionsStudyPrice';
  currencyCode: Scalars['String'];
  currencySymbol: Scalars['String'];
  totalPrice: Scalars['Float'];
};

/** A union representing the response types for the study price */
export type SolutionsStudyPricePayload =
  | NotFoundError
  | SolutionsStudyPrice
  | UnauthorizedError;

/**
 * An object representing a subset of the fields of a particular question object
 * on a market research study's survey.
 *
 * Typically will be used to show a preview of a survey question.
 */
export type SolutionsStudyQuestionPreview = {
  id: Scalars['ID'];
  /**
   * A human-readable label describing the survey question in the context of the
   * methodology.
   */
  label?: Maybe<Scalars['String']>;
  /**
   * The canonical name of the question bank question associated with the
   * question preview's survey question.
   */
  name: Scalars['String'];
  /** The main text of the question. */
  questionText: Scalars['String'];
  /** The type of the question. */
  questionType: SolutionsStudyQuestionPreviewType;
};

export type SolutionsStudyQuestionPreviewSingleChoice = SolutionsStudyQuestionPreview & {
  __typename?: 'SolutionsStudyQuestionPreviewSingleChoice';
  /** List of answer options for enumeration questions. */
  answerOptions: Array<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  questionText: Scalars['String'];
  questionType: SolutionsStudyQuestionPreviewType;
};

export type SolutionsStudyQuestionPreviewSingleTextbox = SolutionsStudyQuestionPreview & {
  __typename?: 'SolutionsStudyQuestionPreviewSingleTextbox';
  /**
   * Type of available answers for the question preview's associated survey
   * question.
   */
  answerType: Scalars['String'];
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  questionText: Scalars['String'];
  questionType: SolutionsStudyQuestionPreviewType;
};

/** Types of question preview objects. */
export enum SolutionsStudyQuestionPreviewType {
  SingleChoice = 'SINGLE_CHOICE',
  SingleTextbox = 'SINGLE_TEXTBOX',
  UnknownType = 'UNKNOWN_TYPE',
}

export type SolutionsStudyQuestionPreviewUnknownType = SolutionsStudyQuestionPreview & {
  __typename?: 'SolutionsStudyQuestionPreviewUnknownType';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  questionText: Scalars['String'];
  questionType: SolutionsStudyQuestionPreviewType;
};

/** Container for total and filtered response counts for survey */
export type SolutionsStudyRespondentCounts = {
  __typename?: 'SolutionsStudyRespondentCounts';
  context: Scalars['Int'];
  total: Scalars['Int'];
};

export type SolutionsStudyRespondentCountsPayload =
  | ForbiddenError
  | NotFoundError
  | SolutionsStudyRespondentCounts
  | UnauthorizedError;

/**
 * Response type for solutionsStudy query.
 *
 * Includes error state for when the specified SolutionsStudy is not found or Unauthorized
 */
export type SolutionsStudyResponse =
  | NotFoundError
  | SolutionsStudy
  | UnauthorizedError;

export type SolutionsStudySurveyPayload = NotFoundError | Survey;

/** Study validation errors */
export type SolutionsStudyValidationErrors = {
  __typename?: 'SolutionsStudyValidationErrors';
  feasibility: Array<Maybe<Scalars['String']>>;
  guardrails: Array<Maybe<SolutionsStudyGuardrail>>;
  study: Array<Maybe<Scalars['String']>>;
};

/** Study fields with which to update a study object. */
export type SolutionsUpdateStudyInput = {
  title: Scalars['String'];
};

/**
 * Error type to represent errors in config field fetching, after the value
 * update has been completed.
 *
 * Temporary until MRxAPI is able to return a properly-formed field value
 * object, instead of a 204.
 */
export type SolutionsUpdateStudyMethodologyConfigValueDataFetchError = {
  __typename?: 'SolutionsUpdateStudyMethodologyConfigValueDataFetchError';
  code: SolutionsUpdateStudyMethodologyConfigValueDataFetchErrorCode;
  message?: Maybe<Scalars['String']>;
};

/**
 * Error codes for representing errors in config field fetching, after the value
 * update has been completed.
 *
 * Temporary until MRxAPI is able to return a properly-formed field value
 * object, instead of a 204.
 */
export enum SolutionsUpdateStudyMethodologyConfigValueDataFetchErrorCode {
  ConfigFieldDefinitionFetchError = 'CONFIG_FIELD_DEFINITION_FETCH_ERROR',
  ConfigValueFetchError = 'CONFIG_VALUE_FETCH_ERROR',
}

/**
 * Response type union for solutionsUpdateStudyMethodologyConfigValue mutation.
 *
 * TODO: Extra error types for the value fetch will be removed in future
 * (MOD-5722). Some are reused from above (as those will also be removed).
 */
export type SolutionsUpdateStudyMethodologyConfigValuePayload =
  | InvalidConfigValueError
  | InvalidInputError
  | NotFoundError
  | SolutionsStudyMethodologyConfigReturnValue
  | SolutionsUpdateStudyMethodologyConfigValueDataFetchError
  | UnauthorizedError;

/**
 * Response type for solutionsUpdateStudy mutation.
 *
 * TODO: Extra error types for the value fetch will be removed in future
 * (MOD-5722).
 */
export type SolutionsUpdateStudyPayload =
  | InvalidInputError
  | NotFoundError
  | SolutionsInvalidStudyError
  | SolutionsStudy
  | SolutionsUpdateStudyStudyFetchNotFoundError
  | SolutionsUpdateStudyStudyFetchUnauthorizedError
  | UnauthorizedError;

/**
 * Error type to represent not found fetch errors for the study object in
 * solutionsUpdateStudy, after the study has been updated.
 * Temporary until MRxAPI returns a proper study object rather than a 204.
 */
export type SolutionsUpdateStudyStudyFetchNotFoundError = {
  __typename?: 'SolutionsUpdateStudyStudyFetchNotFoundError';
  code: SolutionsUpdateStudyStudyFetchNotFoundErrorCode;
  message?: Maybe<Scalars['String']>;
};

/**
 * Error codes for solutionsUpdateStudy study fetch, representing not found
 * errors.
 */
export enum SolutionsUpdateStudyStudyFetchNotFoundErrorCode {
  StudyNotFound = 'STUDY_NOT_FOUND',
}

/**
 * Error type to represent unauthorized fetch errors for the study object in
 * solutionsUpdateStudy, after the study has been updated.
 * Temporary until MRxAPI returns a proper study object rather than a 204
 */
export type SolutionsUpdateStudyStudyFetchUnauthorizedError = {
  __typename?: 'SolutionsUpdateStudyStudyFetchUnauthorizedError';
  code: SolutionsUpdateStudyStudyFetchUnauthorizedErrorCode;
  message?: Maybe<Scalars['String']>;
};

/**
 * Error codes for solutionsUpdateStudy study fetch, representing unauthorized
 * errors.
 */
export enum SolutionsUpdateStudyStudyFetchUnauthorizedErrorCode {
  StudyUnauthorized = 'STUDY_UNAUTHORIZED',
}

/** Sort direction key. */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type StimuliComparisonQuestionVariableConfiguration = ProjectVariableConfiguration & {
  __typename?: 'StimuliComparisonQuestionVariableConfiguration';
  enabled: Scalars['Boolean'];
  stimuliComparison: ModuleStimuliComparison;
};

export type StimuliPreviewLink = {
  __typename?: 'StimuliPreviewLink';
  name: Scalars['String'];
  url: Scalars['String'];
};

export type StimuliRandomAssignment = {
  __typename?: 'StimuliRandomAssignment';
  percent: Scalars['Float'];
  position: Scalars['Int'];
  variableId: Scalars['ID'];
  variableName: Scalars['String'];
};

export type StockTheme = {
  __typename?: 'StockTheme';
  assetType: LibraryAssetType;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  theme: SurveyTheme;
};

export type StopAudienceCollectorResult = {
  __typename?: 'StopAudienceCollectorResult';
  collectorId: Scalars['ID'];
  success: Scalars['Boolean'];
};

export type StripeInvoice = {
  __typename?: 'StripeInvoice';
  country: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currencyCode: Scalars['String'];
  id: Scalars['ID'];
  lineItems: Array<StripeInvoiceLineItem>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  partner: BillingPartner;
  paymentMethodInfo?: Maybe<UserPaymentMethod>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  status: StripeInvoiceStatus;
  stripeInvoiceId: Scalars['String'];
  subtotal: Scalars['Int'];
  tax: Scalars['Int'];
  taxInvoiceId: Scalars['String'];
  taxPartner: BillingTaxPartner;
  total: Scalars['Int'];
};

export type StripeInvoiceLineItem = {
  __typename?: 'StripeInvoiceLineItem';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  invoiceId: Scalars['ID'];
  isTaxInclusive: Scalars['Boolean'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  quantity: Scalars['Int'];
  skuId: Scalars['Int'];
  stripeLineItemId: Scalars['String'];
  stripePriceId: Scalars['String'];
  subtotal: Scalars['Int'];
  tax: Scalars['Int'];
  unitPrice: Scalars['Int'];
};

export type StripeInvoiceList = {
  __typename?: 'StripeInvoiceList';
  items: Array<StripeInvoice>;
  totalCount: Scalars['Int'];
};

export enum StripeInvoiceStatus {
  Draft = 'DRAFT',
  Open = 'OPEN',
  Paid = 'PAID',
  Uncollectible = 'UNCOLLECTIBLE',
  Void = 'VOID',
}

export type SubmitSurveyResponseError = UserError & {
  __typename?: 'SubmitSurveyResponseError';
  /** SubmitResponseErrorCatalogue */
  code: Scalars['String'];
  /** Refers to collector id this error is related to, when applicable. */
  collectorId?: Maybe<Scalars['ID']>;
  detail: Scalars['String'];
  field?: Maybe<Array<Scalars['String']>>;
  /** Refers to which question specifically is this error related to, when applicable. */
  questionId?: Maybe<Scalars['ID']>;
  /** Refers to survey id this error is related to, when applicable. */
  surveyId?: Maybe<Scalars['ID']>;
};

export type SubmitSurveyResponseInput = {
  /** Collector to submit responses against. */
  collectorId?: InputMaybe<Scalars['ID']>;
  /** Provide a dateCompleted for survey submission. */
  dateCompleted?: InputMaybe<Scalars['DateTime']>;
  /** Provide a dateStarted for the first response submission. */
  dateStarted?: InputMaybe<Scalars['DateTime']>;
  generateQuizResultsSMParams: Scalars['Boolean'];
  instantResultsUrl?: InputMaybe<Scalars['String']>;
  /** Should survey results include IP address for a respondent. */
  isAnonymous: Scalars['Boolean'];
  isThankYouEnabled?: InputMaybe<Scalars['Boolean']>;
  redirectUrl?: InputMaybe<Scalars['String']>;
  reqLocale?: InputMaybe<Scalars['String']>;
  /** Provide a respondent ID when you're submitting responses for an existing respondent. */
  respondentId?: InputMaybe<Scalars['ID']>;
  /** Set of responses being submitted. */
  responses: Array<RespApiAnswerInput>;
  surveyLangId?: InputMaybe<Scalars['ID']>;
  /** Survey version for which responses are being submitted against. */
  surveyVersion: Scalars['Int'];
};

export type SubmitSurveyResponsePayload = {
  __typename?: 'SubmitSurveyResponsePayload';
  encryptedSmParam?: Maybe<Scalars['String']>;
  encryptedSMParamforQuizResults?: Maybe<Scalars['String']>;
  respondent?: Maybe<Respondent>;
  success: Scalars['Boolean'];
  userErrors?: Maybe<Array<SubmitSurveyResponseError>>;
};

export type SubscriptionRenewalInput = {
  cancelAtPeriodEnd: Scalars['Boolean'];
  subscriptionId: Scalars['ID'];
};

export type SummaryBasicStats = {
  __typename?: 'SummaryBasicStats';
  max: Scalars['Float'];
  mean: Scalars['Float'];
  median: Scalars['Float'];
  min: Scalars['Float'];
  questionOption: SurveyQuestionOption;
  standardDeviation: Scalars['Float'];
};

/**
 * This validation configuration is used to enforce that the sum of a list of fields
 * must total "sum".
 */
export type SumValidation = QuestionValidation & {
  __typename?: 'SumValidation';
  errorMessage: Scalars['String'];
  sum: Scalars['Int'];
  type: QuestionFieldValidationType;
};

/** A SurveyMonkey Survey */
export type Survey = {
  __typename?: 'Survey';
  /** Get list of analyze saved views of this survey */
  analysisSavedViews?: Maybe<AnalysisStandardViewList>;
  /** Get list of analyze views of this survey */
  analysisStandardViews?: Maybe<AnalysisStandardViewList>;
  answerableQuestionCount: Scalars['Int'];
  /** list of pre-filled demographic questions from audience panel */
  audienceQuestions?: Maybe<SurveyQuestionList>;
  /** Available languages-tags for survey */
  availableSurveyLanguages: Array<LanguageTag>;
  /** When user creates a survey via Build it for me (BIFM), the survey is associated with a use case */
  bifmUseCase?: Maybe<BifmUseCase>;
  category?: Maybe<SurveyCategory>;
  /** Get the collaborators of this survey */
  collaborators?: Maybe<CollaboratorList>;
  collectorQM?: Maybe<CollectorQm>;
  /** The collectors associated with this survey */
  collectors?: Maybe<CollectorList>;
  collectorsQM?: Maybe<CollectorListQm>;
  createdAt: Scalars['DateTime'];
  crosstabs?: Maybe<CrossTabReportList>;
  dashboards?: Maybe<AnalysisResultsDashboardList>;
  /** Default languages-tag for survey */
  defaultSurveyLanguage: LanguageTag;
  design?: Maybe<SurveyDesign>;
  format?: Maybe<SurveyFormat>;
  hasLogic: Scalars['Boolean'];
  id: Scalars['ID'];
  isAudienceSurvey: Scalars['Boolean'];
  isFavorite: Scalars['Boolean'];
  isOwner: Scalars['Boolean'];
  isQuiz: Scalars['Boolean'];
  /** Default language of survey */
  language: Language;
  /** Set of URL paths to reach various aspects of the survey on SurveyMonkey.com */
  links?: Maybe<SurveyLinks>;
  logic: SurveyLogicList;
  modifiedAt: Scalars['DateTime'];
  /** Navigation button options & customizations */
  navigation?: Maybe<SurveyNavigation>;
  nickname: Scalars['String'];
  /** The pages associated with this survey */
  pages?: Maybe<SurveyPageList>;
  /** Payment question type page */
  paymentPage?: Maybe<SurveyPage>;
  pendingAccessRequests: PendingAccessRequests;
  /** get survey related permissions for the current user. */
  permissions?: Maybe<SurveyPermissions>;
  questionCount: Scalars['Int'];
  /** list of questions associated with this survey */
  questions?: Maybe<SurveyQuestionList>;
  questionsQM?: Maybe<SurveyQuestionListQm>;
  /** quiz options */
  quizOptions?: Maybe<SurveyQuizOptions>;
  quota?: Maybe<SurveyQuota>;
  quotaQM?: Maybe<Quota>;
  /** Get the trends of new responses being collected for this survey */
  respondentTrend?: Maybe<SurveyRespondentTrend>;
  /** Whether or not the calling user has response alerts enabled for this survey */
  responseAlertsEnabled: Scalars['Boolean'];
  /** gets total response counts for the survey from statsvc (slow and eventually consistent) */
  responseCounts?: Maybe<SurveyResponseCounts>;
  /**
   * SurveyMonkey Genius score including predictions for completion time and completion rate
   * Nullable for partial failure reason
   * @deprecated Use scoreV2
   */
  score?: Maybe<SurveyScore>;
  scoreV2?: Maybe<SurveyScoreV2>;
  showQuizAnswers: Scalars['Boolean'];
  stats: SurveyStatsResults;
  status?: Maybe<SurveyStatus>;
  title: Scalars['String'];
  titleHTML: Scalars['String'];
  userCanCopyTemplate: Scalars['Boolean'];
  /** The ID of the user that owns this survey */
  userId: Scalars['ID'];
  /** Version identifier for the survey. Changes whenever the survey is modified. */
  version: Scalars['Int'];
};

/** A SurveyMonkey Survey */
export type SurveyAnalysisSavedViewsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** A SurveyMonkey Survey */
export type SurveyAnalysisStandardViewsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** A SurveyMonkey Survey */
export type SurveyAudienceQuestionsArgs = {
  families?: InputMaybe<Array<SurveyQuestionTypeFamily>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** A SurveyMonkey Survey */
export type SurveyCollaboratorsArgs = {
  kinds?: InputMaybe<Array<CollaboratorKind>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** A SurveyMonkey Survey */
export type SurveyCollectorQmArgs = {
  id: Scalars['ID'];
};

/** A SurveyMonkey Survey */
export type SurveyCollectorsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** A SurveyMonkey Survey */
export type SurveyCollectorsQmArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** A SurveyMonkey Survey */
export type SurveyCrosstabsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** A SurveyMonkey Survey */
export type SurveyDashboardsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** A SurveyMonkey Survey */
export type SurveyLogicArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** A SurveyMonkey Survey */
export type SurveyPagesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** A SurveyMonkey Survey */
export type SurveyPermissionsArgs = {
  target?: InputMaybe<Scalars['ID']>;
};

/** A SurveyMonkey Survey */
export type SurveyQuestionsArgs = {
  families?: InputMaybe<Array<SurveyQuestionTypeFamily>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** A SurveyMonkey Survey */
export type SurveyQuestionsQmArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** A SurveyMonkey Survey */
export type SurveyRespondentTrendArgs = {
  trendBy?: InputMaybe<TrendTimePeriod>;
};

/** A SurveyMonkey Survey */
export type SurveyResponseAlertsEnabledArgs = {
  channels?: InputMaybe<Array<InputMaybe<AlertChannel>>>;
};

export type SurveyButton = {
  __typename?: 'SurveyButton';
  label: Scalars['String'];
};

export type SurveyCategory = {
  __typename?: 'SurveyCategory';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SurveyCategoryIdList = PaginatedList & {
  __typename?: 'SurveyCategoryIdList';
  items: Array<Scalars['ID']>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SurveyCategoryList = PaginatedList & {
  __typename?: 'SurveyCategoryList';
  items: Array<SurveyCategory>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SurveyChoiceResponse = {
  __typename?: 'SurveyChoiceResponse';
  row: SurveyQuestionRow;
};

export type SurveyCssTheme = {
  __typename?: 'SurveyCSSTheme';
  artifacts?: Maybe<SurveyThemeImages>;
  button?: Maybe<CommonStyle>;
  colorPalettes?: Maybe<Array<Maybe<ColorPalette>>>;
  customFonts?: Maybe<FontFaceType>;
  error?: Maybe<CommonStyle>;
  exitLink?: Maybe<CommonStyle>;
  id: Scalars['ID'];
  images?: Maybe<SurveyThemeImages>;
  isAccessible: Scalars['Boolean'];
  isCustomCSSTheme?: Maybe<Scalars['Boolean']>;
  isCustomTheme: Scalars['Boolean'];
  isPremiumTheme: Scalars['Boolean'];
  isStockTheme: Scalars['Boolean'];
  isTeamTheme: Scalars['Boolean'];
  layout?: Maybe<LayoutOptionType>;
  name: Scalars['String'];
  pageTitle?: Maybe<CommonStyle>;
  questionBody?: Maybe<QuestionBodyStyle>;
  questionTitle?: Maybe<CommonStyle>;
  selectedColorPalette?: Maybe<ColorPalette>;
  styles?: Maybe<SurveyThemeStyles>;
  surveyPage?: Maybe<SurveyPageStyle>;
  surveyTitle?: Maybe<CommonStyle>;
  version: SurveyThemeVersion;
};

/** All design settings associated with a survey */
export type SurveyDesign = {
  __typename?: 'SurveyDesign';
  footer?: Maybe<SurveyFooter>;
  logo?: Maybe<SurveyLogo>;
  progressBar?: Maybe<SurveyProgressBar>;
  questionNumbering?: Maybe<SurveyQuestionNumbering>;
  /** Survey level toggle to hide/show page numbers */
  showPageNumbers: Scalars['Boolean'];
  /** Survey level toggle to hide/show page titles (page descriptions are still shown) */
  showPageTitles: Scalars['Boolean'];
  showRequiredQuestionAsterisks: Scalars['Boolean'];
  surveyTitle: SurveyTitle;
  theme?: Maybe<SurveyTheme>;
};

export type SurveyDesignInput = {
  logo?: InputMaybe<SurveyLogoInput>;
  progressBar?: InputMaybe<SurveyProgressBarInput>;
  questionNumbering?: InputMaybe<SurveyQuestionNumberingInput>;
  showSurveyTitle?: InputMaybe<Scalars['Boolean']>;
  themeId?: InputMaybe<Scalars['ID']>;
};

export enum SurveyFileUploadContentType {
  Doc = 'DOC',
  Docx = 'DOCX',
  Gif = 'GIF',
  Jpeg = 'JPEG',
  Pdf = 'PDF',
  Png = 'PNG',
}

export type SurveyFileUploadResponse = {
  __typename?: 'SurveyFileUploadResponse';
  contentType: SurveyFileUploadContentType;
  deletedAt?: Maybe<Scalars['DateTime']>;
  fileStatus: SurveyFileUploadStatus;
  id: Scalars['ID'];
  name: Scalars['String'];
  size: Scalars['Int'];
};

export enum SurveyFileUploadStatus {
  Corrupted = 'CORRUPTED',
  Verified = 'VERIFIED',
  Verifying = 'VERIFYING',
}

export type SurveyFooter = {
  __typename?: 'SurveyFooter';
  enabled?: Maybe<Scalars['Boolean']>;
  grayscale?: Maybe<Scalars['Boolean']>;
};

export enum SurveyFormat {
  Classic = 'CLASSIC',
  Conversational = 'CONVERSATIONAL',
  OneQuestionAtATime = 'ONE_QUESTION_AT_A_TIME',
  SymptomTracking = 'SYMPTOM_TRACKING',
}

export type SurveyIdList = PaginatedList & {
  __typename?: 'SurveyIdList';
  items: Array<Scalars['ID']>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SurveyImageChoiceResponse = {
  __typename?: 'SurveyImageChoiceResponse';
  image: QuestionHeaderImage;
  row: SurveyQuestionRow;
};

export type SurveyLinkDomain = {
  canonicalName: Scalars['String'];
  customDomainType?: Maybe<Scalars['String']>;
  type?: Maybe<SurveyLinkDomainType>;
};

export enum SurveyLinkDomainType {
  Custom = 'CUSTOM',
  Surveymonkey = 'SURVEYMONKEY',
  WhiteLabel = 'WHITE_LABEL',
  Zoomerang = 'ZOOMERANG',
}

/** Computed relative paths to common SurveyMonkey pages associate with a survey */
export type SurveyLinks = {
  __typename?: 'SurveyLinks';
  analyze: Scalars['String'];
  collect: Scalars['String'];
  design: Scalars['String'];
  edit: Scalars['String'];
  embeddedPreview: Scalars['String'];
  mobileAnalyze: Scalars['String'];
  mobileCollect: Scalars['String'];
  mobileDesign: Scalars['String'];
  mobileEdit: Scalars['String'];
  mobilePresent: Scalars['String'];
  mobilePreview: Scalars['String'];
  mobilePreviewAndScore: Scalars['String'];
  mobileSummary: Scalars['String'];
  obfuscatedIdParam: Scalars['String'];
  present: Scalars['String'];
  preview: Scalars['String'];
  previewAndScore: Scalars['String'];
  summary: Scalars['String'];
};

export type SurveyList = PaginatedList & {
  __typename?: 'SurveyList';
  items: Array<Survey>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum SurveyListInclude {
  /** Surveys owned by this user */
  Owned = 'OWNED',
  /** Surveys shared with others by this user. */
  SharedBy = 'SHARED_BY',
  /** Surveys are shared with (and not owned by) this user. */
  SharedWith = 'SHARED_WITH',
}

export type SurveyListInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  folderId?: InputMaybe<Scalars['Int']>;
  include: SurveyListInclude;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  sortColumn: SurveyListSortColumn;
  sortDirection: SortDirection;
  startDate?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum SurveyListSortColumn {
  DateModified = 'DATE_MODIFIED',
  NumResponses = 'NUM_RESPONSES',
  Title = 'TITLE',
}

/**
 * Logic associated with a survey, can include skip or disqualification logic.
 * Each instance represents a single configured logical path in the survey.
 */
export type SurveyLogic = {
  __typename?: 'SurveyLogic';
  active: Scalars['Boolean'];
  destination: SurveyLogicDestination;
  id: Scalars['ID'];
  skipType: SurveyLogicSkipType;
  source: SurveyLogicSource;
};

export type SurveyLogicDestination = {
  __typename?: 'SurveyLogicDestination';
  pageId?: Maybe<Scalars['ID']>;
  questionId?: Maybe<Scalars['ID']>;
  type: SurveyLogicDestinationType;
};

export enum SurveyLogicDestinationType {
  DisqualifyRespondent = 'DISQUALIFY_RESPONDENT',
  EndSurvey = 'END_SURVEY',
  SkipToPage = 'SKIP_TO_PAGE',
}

export type SurveyLogicList = PaginatedList & {
  __typename?: 'SurveyLogicList';
  items: Array<SurveyLogic>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum SurveyLogicSkipType {
  PageUnconditional = 'PAGE_UNCONDITIONAL',
  QuestionConditionalCol = 'QUESTION_CONDITIONAL_COL',
  QuestionConditionalRow = 'QUESTION_CONDITIONAL_ROW',
}

export type SurveyLogicSource = {
  __typename?: 'SurveyLogicSource';
  answerOptionId?: Maybe<Scalars['ID']>;
  pageId: Scalars['ID'];
  questionId?: Maybe<Scalars['ID']>;
};

/** The logo associated with a survey */
export type SurveyLogo = {
  __typename?: 'SurveyLogo';
  enabled: Scalars['Boolean'];
  height?: Maybe<Scalars['Int']>;
  image?: Maybe<Image>;
  size?: Maybe<SurveyLogoSize>;
  verticalAlignment?: Maybe<SurveyLogoAlignment>;
  width?: Maybe<Scalars['Int']>;
};

export enum SurveyLogoAlignment {
  Baseline = 'BASELINE',
  Bottom = 'BOTTOM',
  Center = 'CENTER',
  LeftMiddle = 'LEFT_MIDDLE',
  LeftTop = 'LEFT_TOP',
  RightMiddle = 'RIGHT_MIDDLE',
  RightTop = 'RIGHT_TOP',
  Top = 'TOP',
}

export type SurveyLogoInput = {
  description?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  height?: InputMaybe<Scalars['Int']>;
  s3Key?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<SurveyLogoSize>;
  url?: InputMaybe<Scalars['String']>;
  verticalAlignment?: InputMaybe<SurveyLogoAlignment>;
  width?: InputMaybe<Scalars['Int']>;
};

export enum SurveyLogoSize {
  Actual = 'ACTUAL',
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL',
}

export type SurveyMatrixDropDownResponse = {
  __typename?: 'SurveyMatrixDropDownResponse';
  column: SurveyQuestionColumn;
  columnChoice?: Maybe<SurveyQuestionColumnChoice>;
  row: SurveyQuestionRow;
};

export type SurveyMatrixOpenEndedResponse = {
  __typename?: 'SurveyMatrixOpenEndedResponse';
  row: SurveyQuestionRow;
  text: Scalars['String'];
};

export type SurveyMatrixOtherResponse = {
  __typename?: 'SurveyMatrixOtherResponse';
  row: SurveyQuestionRow;
  text: Scalars['String'];
};

export type SurveyMatrixResponse = {
  __typename?: 'SurveyMatrixResponse';
  column: SurveyQuestionColumn;
  row: SurveyQuestionRow;
};

export type SurveyNavigation = {
  __typename?: 'SurveyNavigation';
  done: SurveyButton;
  /** Exit button is only shown when enabled via design options */
  exit?: Maybe<SurveyButton>;
  next: SurveyButton;
  /** Ok button is only used for One Question at a Time (OQAAT) surveys */
  ok: SurveyButton;
  previous: SurveyButton;
};

export type SurveyOpenEndedResponse = {
  __typename?: 'SurveyOpenEndedResponse';
  text: Scalars['String'];
};

/** response to other field */
export type SurveyOtherResponse = {
  __typename?: 'SurveyOtherResponse';
  other: SurveyQuestionOther;
  text: Scalars['String'];
};

export type SurveyOtherResponseList = PaginatedList & {
  __typename?: 'SurveyOtherResponseList';
  items: Array<SurveyOtherResponse>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SurveyOverQuotaOptions = {
  __typename?: 'SurveyOverQuotaOptions';
  endPageTypeName: Scalars['String'];
  endPageUrl: Scalars['String'];
  message: Scalars['String'];
};

/** A page holding a set of questions within a survey */
export type SurveyPage = {
  __typename?: 'SurveyPage';
  firstQuestionNumber: Scalars['Int'];
  heading: Scalars['String'];
  id: Scalars['ID'];
  position: Scalars['Int'];
  questions?: Maybe<SurveyQuestionList>;
  questionsQM?: Maybe<SurveyQuestionListQm>;
  subHeading: Scalars['String'];
  surveyId: Scalars['ID'];
};

/** A page holding a set of questions within a survey */
export type SurveyPageQuestionsArgs = {
  families?: InputMaybe<Array<SurveyQuestionTypeFamily>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** A page holding a set of questions within a survey */
export type SurveyPageQuestionsQmArgs = {
  languageCode: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type SurveyPageList = PaginatedList & {
  __typename?: 'SurveyPageList';
  items: Array<SurveyPage>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** Overall container of the survey */
export type SurveyPageStyle = {
  __typename?: 'SurveyPageStyle';
  overlayColor?: Maybe<Scalars['RGBA']>;
};

export type SurveyPageStyleInput = {
  overlayColor?: InputMaybe<Scalars['RGBA']>;
};

export type SurveyPaymentResponse = {
  __typename?: 'SurveyPaymentResponse';
  amount: Scalars['String'];
  currencyCode: CurrencyTypeId;
  paymentRespondentName?: Maybe<Scalars['String']>;
  paymentStatus: PaymentStatus;
  row: SurveyQuestionRow;
  transactionId?: Maybe<Scalars['ID']>;
};

/** The permissions that the current user has on different survey pages */
export type SurveyPermissions = {
  __typename?: 'SurveyPermissions';
  /** analyze - view analyze page */
  analyze: Scalars['Boolean'];
  /**
   * We prevent user from sending their survey, i.e prevent access to collect
   * If their survey has paid features that their user account is not
   * authorized to use.
   * Currently applies to basic accounts and select accounts that have file_upload
   * feature in their survey
   */
  canSendSurvey?: Maybe<SurveySendPermissions>;
  /** clear the responses of the survey */
  clearAllResponses: Scalars['Boolean'];
  /** copy the survey with 'target' */
  copy: Scalars['Boolean'];
  /** create a new survey */
  create: Scalars['Boolean'];
  /** DMND-1011: analyze - crosstab access */
  crosstabs: Scalars['Boolean'];
  /** delete the survey */
  delete: Scalars['Boolean'];
  /** analyze - can delete the results */
  deleteResults: Scalars['Boolean'];
  /** design - edit the survey */
  edit: Scalars['Boolean'];
  /** analyze - edit stuff in analyze */
  editAnalyze: Scalars['Boolean'];
  /** analyze - edit survey results in analyze */
  editResults: Scalars['Boolean'];
  /** analyze - export all results of the survey */
  exportAllResults: Scalars['Boolean'];
  /** analyze - export results of the survey */
  exportResults: Scalars['Boolean'];
  /** ability to manage folders on home page */
  folder: Scalars['Boolean'];
  roles?: Maybe<CollaboratorRole>;
  /** share the survey with 'target' */
  share: Scalars['Boolean'];
  /** analyze - can share results of survey with others */
  shareResults: Scalars['Boolean'];
  /** transfer this survey with 'target' (a different account) */
  transfer: Scalars['Boolean'];
  /** unshare the survey with 'target' */
  unshare: Scalars['Boolean'];
  /** design - view the survey */
  view: Scalars['Boolean'];
  /** analyze - see the results of the survey */
  viewResults: Scalars['Boolean'];
  /** view shares in sharing modal */
  viewShares: Scalars['Boolean'];
};

export type SurveyPresentationImageResponse = {
  __typename?: 'SurveyPresentationImageResponse';
  image: QuestionHeaderImage;
  randomAssignment: QuestionHeaderRandomAssignment;
};

export type SurveyPresentationTextResponse = {
  __typename?: 'SurveyPresentationTextResponse';
  presentationText: Scalars['String'];
  randomAssignment: QuestionHeaderRandomAssignment;
};

/** Progress bar setings */
export type SurveyProgressBar = {
  __typename?: 'SurveyProgressBar';
  enabled: Scalars['Boolean'];
  position?: Maybe<SurveyProgressBarPosition>;
  showPageNumber: Scalars['Boolean'];
  showPercent: Scalars['Boolean'];
};

export type SurveyProgressBarInput = {
  enabled: Scalars['Boolean'];
  position?: InputMaybe<SurveyProgressBarPosition>;
  showPageNumber?: InputMaybe<Scalars['Boolean']>;
  showPercent?: InputMaybe<Scalars['Boolean']>;
};

export enum SurveyProgressBarPosition {
  Bottom = 'BOTTOM',
  Disabled = 'DISABLED',
  Top = 'TOP',
}

/** The interface of any query that returns a Survey Page Question */
export type SurveyQuestion = {
  /** The question's 1-based position within the entire survey. */
  absolutePosition: Scalars['Int'];
  /** The display number for the question. Only valid for questions that the respondent can answer. */
  displayNumber: Scalars['Int'];
  displayOptions: SurveyQuestionDisplayOptions;
  headers: Array<SurveyQuestionHeader>;
  id: Scalars['ID'];
  isAudience: Scalars['Boolean'];
  nickname: Scalars['String'];
  pageId: Scalars['ID'];
  /** The question's 1-based position within its page. */
  position: Scalars['Int'];
  type: SurveyQuestionType;
  validation: SurveyQuestionValidationOptions;
  visible: Scalars['Boolean'];
};

export type SurveyQuestionColumn = SurveyQuestionOption & {
  __typename?: 'SurveyQuestionColumn';
  choices: SurveyQuestionColumnChoiceList;
  id: Scalars['ID'];
  position: Scalars['Int'];
  question: SurveyQuestion;
  text: Scalars['String'];
  type: SurveyQuestionOptionType;
  visible: Scalars['Boolean'];
};

export type SurveyQuestionColumnChoicesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type SurveyQuestionColumnChoice = SurveyQuestionOption & {
  __typename?: 'SurveyQuestionColumnChoice';
  id: Scalars['ID'];
  position: Scalars['Int'];
  question: SurveyQuestion;
  text: Scalars['String'];
  type: SurveyQuestionOptionType;
  visible: Scalars['Boolean'];
};

export type SurveyQuestionColumnChoiceList = PaginatedList & {
  __typename?: 'SurveyQuestionColumnChoiceList';
  items: Array<SurveyQuestionColumnChoice>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SurveyQuestionColumnList = PaginatedList & {
  __typename?: 'SurveyQuestionColumnList';
  items: Array<SurveyQuestionColumn>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** The display options of a question */
export type SurveyQuestionDisplayOptions = {
  __typename?: 'SurveyQuestionDisplayOptions';
  showDisplayNum: Scalars['Boolean'];
  subType?: Maybe<SurveyQuestionDisplaySubType>;
  type?: Maybe<SurveyQuestionDisplayType>;
};

export enum SurveyQuestionDisplaySubType {
  Heart = 'HEART',
  Smiley = 'SMILEY',
  Star = 'STAR',
  Thumb = 'THUMB',
}

export enum SurveyQuestionDisplayType {
  Emoji = 'EMOJI',
  FileUpload = 'FILE_UPLOAD',
  ImageChoice = 'IMAGE_CHOICE',
  Slider = 'SLIDER',
}

export enum SurveyQuestionFamily {
  ClickMap = 'CLICK_MAP',
  ContactInfo = 'CONTACT_INFO',
  Datetime = 'DATETIME',
  FileUpload = 'FILE_UPLOAD',
  Matrix = 'MATRIX',
  MultipleChoice = 'MULTIPLE_CHOICE',
  OpenEnded = 'OPEN_ENDED',
  Presentation = 'PRESENTATION',
  Ranking = 'RANKING',
  RatingScale = 'RATING_SCALE',
  Slider = 'SLIDER',
}

export enum SurveyQuestionFamilySet {
  ClickMap = 'CLICK_MAP',
  Datetime = 'DATETIME',
  Demographic = 'DEMOGRAPHIC',
  Matrix = 'MATRIX',
  MultipleChoice = 'MULTIPLE_CHOICE',
  OpenEnded = 'OPEN_ENDED',
  Presentation = 'PRESENTATION',
  SingleChoice = 'SINGLE_CHOICE',
}

/** Survey question header */
export type SurveyQuestionHeader = BaseQuestionHeader & {
  __typename?: 'SurveyQuestionHeader';
  description: Scalars['String'];
  heading?: Maybe<Scalars['String']>;
  image?: Maybe<QuestionHeaderImage>;
  randomAssignment?: Maybe<QuestionHeaderRandomAssignment>;
};

export type SurveyQuestionList = PaginatedList & {
  __typename?: 'SurveyQuestionList';
  items: Array<SurveyQuestion>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SurveyQuestionListQm = PaginatedList & {
  __typename?: 'SurveyQuestionListQM';
  items: Array<SurveyQuestionQm>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** The display option on whether to show numbers next to questions in a survey. */
export type SurveyQuestionNumbering = {
  __typename?: 'SurveyQuestionNumbering';
  enabled: Scalars['Boolean'];
  type?: Maybe<SurveyQuestionNumberingType>;
};

export type SurveyQuestionNumberingInput = {
  enabled: Scalars['Boolean'];
  type?: InputMaybe<SurveyQuestionNumberingType>;
};

/** The format type of numbering associated with a question on a survey */
export enum SurveyQuestionNumberingType {
  /** Numbers are not disabled, associated with enabled as false */
  Disabled = 'DISABLED',
  /** The number starts at 1 on each page */
  Page = 'PAGE',
  /** The number starts at 1 on the first page and continues through pages */
  Survey = 'SURVEY',
}

export type SurveyQuestionOption = {
  id: Scalars['ID'];
  position: Scalars['Int'];
  question: SurveyQuestion;
  text: Scalars['String'];
  type: SurveyQuestionOptionType;
  visible: Scalars['Boolean'];
};

export type SurveyQuestionOptionList = PaginatedList & {
  __typename?: 'SurveyQuestionOptionList';
  items: Array<SurveyQuestionOption>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum SurveyQuestionOptionType {
  Column = 'COLUMN',
  ColumnChoice = 'COLUMN_CHOICE',
  Other = 'OTHER',
  Row = 'ROW',
}

export type SurveyQuestionOther = SurveyQuestionOption & {
  __typename?: 'SurveyQuestionOther';
  applyAllRows: Scalars['Boolean'];
  id: Scalars['ID'];
  isAnswerChoice: Scalars['Boolean'];
  position: Scalars['Int'];
  question: SurveyQuestion;
  text: Scalars['String'];
  type: SurveyQuestionOptionType;
  visible: Scalars['Boolean'];
};

export type SurveyQuestionQm = {
  createdAt?: Maybe<Scalars['DateTime']>;
  family: SurveyQuestionFamily;
  hasPiping: Scalars['Boolean'];
  heading: QuestionHeadingConfiguration;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  position: QuestionPosition;
};

export type SurveyQuestionRequiredInput = {
  amount?: InputMaybe<Scalars['Int']>;
  range?: InputMaybe<SurveyQuestionRequiredRange>;
  text: Scalars['String'];
  type: SurveyQuestionRequiredType;
};

export type SurveyQuestionRequiredRange = {
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export enum SurveyQuestionRequiredType {
  All = 'ALL',
  AtLeast = 'AT_LEAST',
  AtMost = 'AT_MOST',
  Exactly = 'EXACTLY',
  Range = 'RANGE',
}

export type SurveyQuestionRow = SurveyQuestionOption & {
  __typename?: 'SurveyQuestionRow';
  id: Scalars['ID'];
  position: Scalars['Int'];
  question: SurveyQuestion;
  text: Scalars['String'];
  type: SurveyQuestionOptionType;
  visible: Scalars['Boolean'];
};

export type SurveyQuestionRowList = PaginatedList & {
  __typename?: 'SurveyQuestionRowList';
  items: Array<SurveyQuestionRow>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum SurveyQuestionSubTypeSet {
  Both = 'BOTH',
  DateOnly = 'DATE_ONLY',
  DescriptiveText = 'DESCRIPTIVE_TEXT',
  Essay = 'ESSAY',
  Horiz = 'HORIZ',
  Image = 'IMAGE',
  International = 'INTERNATIONAL',
  Menu = 'MENU',
  Multi = 'MULTI',
  Numerical = 'NUMERICAL',
  Ranking = 'RANKING',
  Rating = 'RATING',
  Single = 'SINGLE',
  TimeOnly = 'TIME_ONLY',
  Us = 'US',
  Vertical = 'VERTICAL',
  VerticalThreeCol = 'VERTICAL_THREE_COL',
  VerticalTwoCol = 'VERTICAL_TWO_COL',
  Video = 'VIDEO',
}

export type SurveyQuestionTemplate = {
  attributes: Array<SurveyQuestionTemplateAttribute>;
  heading: Scalars['String'];
  id: Scalars['ID'];
  logicalLink: SurveyQuestionTemplateLogicalLink;
  modifiers: Array<SurveyQuestionTemplateModifier>;
};

export type SurveyQuestionTemplateAttribute = {
  __typename?: 'SurveyQuestionTemplateAttribute';
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type SurveyQuestionTemplateColumn = SurveyQuestionTemplateOption & {
  __typename?: 'SurveyQuestionTemplateColumn';
  choices: Array<SurveyQuestionTemplateColumnChoice>;
  id: Scalars['ID'];
  position: Scalars['Int'];
  text: Scalars['String'];
  type: SurveyQuestionOptionType;
  visible: Scalars['Boolean'];
};

export type SurveyQuestionTemplateColumnChoice = SurveyQuestionTemplateOption & {
  __typename?: 'SurveyQuestionTemplateColumnChoice';
  id: Scalars['ID'];
  position: Scalars['Int'];
  text: Scalars['String'];
  type: SurveyQuestionOptionType;
  visible: Scalars['Boolean'];
};

export type SurveyQuestionTemplateList = PaginatedList & {
  __typename?: 'SurveyQuestionTemplateList';
  items: Array<SurveyQuestionTemplate>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SurveyQuestionTemplateLogicalLink = {
  __typename?: 'SurveyQuestionTemplateLogicalLink';
  canonicalName: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  questionType: SurveyQuestionType;
};

export type SurveyQuestionTemplateModifier = {
  __typename?: 'SurveyQuestionTemplateModifier';
  id: Scalars['ID'];
  options: Array<SurveyQuestionTemplateModifierOption>;
  type: SurveyQuestionTemplateModifierType;
};

export type SurveyQuestionTemplateModifierOption = {
  __typename?: 'SurveyQuestionTemplateModifierOption';
  id: Scalars['ID'];
  /** 0-based index of the option position. */
  position: Scalars['Int'];
  /** Text display for this modifier option. */
  value: Scalars['String'];
};

export enum SurveyQuestionTemplateModifierType {
  OpenEnded = 'OPEN_ENDED',
  Semantic = 'SEMANTIC',
  Superficial = 'SUPERFICIAL',
}

export type SurveyQuestionTemplateOption = {
  id: Scalars['ID'];
  position: Scalars['Int'];
  text: Scalars['String'];
  type: SurveyQuestionOptionType;
  visible: Scalars['Boolean'];
};

export type SurveyQuestionTemplateOther = SurveyQuestionTemplateOption & {
  __typename?: 'SurveyQuestionTemplateOther';
  applyAllRows: Scalars['Boolean'];
  id: Scalars['ID'];
  isAnswerChoice: Scalars['Boolean'];
  numChars: Scalars['Int'];
  numLines: Scalars['Int'];
  position: Scalars['Int'];
  requiredErrorText: Scalars['String'];
  text: Scalars['String'];
  type: SurveyQuestionOptionType;
  visible: Scalars['Boolean'];
};

export type SurveyQuestionTemplateRow = SurveyQuestionTemplateOption & {
  __typename?: 'SurveyQuestionTemplateRow';
  id: Scalars['ID'];
  position: Scalars['Int'];
  text: Scalars['String'];
  type: SurveyQuestionOptionType;
  visible: Scalars['Boolean'];
};

export type SurveyQuestionTemplatesAnyAllTagsQueryInput = {
  all?: InputMaybe<Array<SurveyQuestionTemplatesTagQueryInput>>;
  any?: InputMaybe<Array<SurveyQuestionTemplatesTagQueryInput>>;
};

export type SurveyQuestionTemplatesQueryInput = {
  autocomplete?: InputMaybe<Scalars['String']>;
  canonicalNames?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<SurveyQuestionTemplatesAnyAllTagsQueryInput>;
};

export type SurveyQuestionTemplatesTagQueryInput = {
  canonicalName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

/** The type of the question */
export type SurveyQuestionType = {
  __typename?: 'SurveyQuestionType';
  family?: Maybe<SurveyQuestionFamilySet>;
  name?: Maybe<Scalars['String']>;
  subType?: Maybe<SurveyQuestionSubTypeSet>;
};

export enum SurveyQuestionTypeFamily {
  ClickMap = 'CLICK_MAP',
  Datetime = 'DATETIME',
  Demographic = 'DEMOGRAPHIC',
  Matrix = 'MATRIX',
  MultipleChoice = 'MULTIPLE_CHOICE',
  OpenEnded = 'OPEN_ENDED',
  Presentation = 'PRESENTATION',
  SingleChoice = 'SINGLE_CHOICE',
}

export type SurveyQuestionValidationOptions = {
  __typename?: 'SurveyQuestionValidationOptions';
  isRequired: Scalars['Boolean'];
};

export enum SurveyQuestionVariant {
  /** DATETIME */
  Date = 'DATE',
  Datetime = 'DATETIME',
  /** OPEN_ENDED */
  Essay = 'ESSAY',
  /** FILE_UPLOAD */
  FileUpload = 'FILE_UPLOAD',
  /** PRESENTATION */
  Image = 'IMAGE',
  /** MULTIPLE_CHOICE, MATRIX */
  ManyAnswersCheckbox = 'MANY_ANSWERS_CHECKBOX',
  /** MULTIPLE_CHOICE */
  ManyAnswersImage = 'MANY_ANSWERS_IMAGE',
  /** OPEN_ENDED, CONTACT */
  ManyFields = 'MANY_FIELDS',
  /** MATRIX */
  Menu = 'MENU',
  /** NPS */
  Nps = 'NPS',
  /** MULTIPLE_CHOICE */
  SingleAnswerImage = 'SINGLE_ANSWER_IMAGE',
  /** MULTIPLE_CHOICE */
  SingleAnswerMenu = 'SINGLE_ANSWER_MENU',
  /** MULTIPLE_CHOICE, MATRIX, RATING_SCALE */
  SingleAnswerRadio = 'SINGLE_ANSWER_RADIO',
  /** RATING_SCALE */
  SingleAnswerSymbol = 'SINGLE_ANSWER_SYMBOL',
  /** CLICK_MAP */
  SingleClick = 'SINGLE_CLICK',
  /** OPEN_ENDED */
  SingleLine = 'SINGLE_LINE',
  /** SLIDER */
  SingleSlider = 'SINGLE_SLIDER',
  /** PRESENTATION */
  Text = 'TEXT',
  Time = 'TIME',
}

export type SurveyQuizFeedback = {
  __typename?: 'SurveyQuizFeedback';
  image?: Maybe<Image>;
  message?: Maybe<Scalars['String']>;
};

/** Quiz options for survey */
export type SurveyQuizOptions = {
  __typename?: 'SurveyQuizOptions';
  isQuizMode: Scalars['Boolean'];
  rangeType: Scalars['String'];
  showAnswers: Scalars['Boolean'];
  showResults: Scalars['Boolean'];
};

/** Survey Quota details */
export type SurveyQuota = {
  __typename?: 'SurveyQuota';
  equations: Array<SurveyQuotaEquation>;
  id: Scalars['ID'];
  name: Scalars['String'];
  overquotaOptions?: Maybe<SurveyOverQuotaOptions>;
  questions: Array<SurveyQuotaQuestion>;
};

export type SurveyQuotaEquation = {
  __typename?: 'SurveyQuotaEquation';
  currentResponseCount: Scalars['Int'];
  id: Scalars['ID'];
  label: Scalars['String'];
  maxResponseCount: Scalars['Int'];
  status: Scalars['Boolean'];
};

/** Question associated with a Survey Quota */
export type SurveyQuotaQuestion = {
  __typename?: 'SurveyQuotaQuestion';
  id: Scalars['ID'];
};

export type SurveyRespondentAnswer =
  | SurveyChoiceResponse
  | SurveyFileUploadResponse
  | SurveyImageChoiceResponse
  | SurveyMatrixDropDownResponse
  | SurveyMatrixOpenEndedResponse
  | SurveyMatrixOtherResponse
  | SurveyMatrixResponse
  | SurveyOpenEndedResponse
  | SurveyOtherResponse
  | SurveyPaymentResponse
  | SurveyPresentationImageResponse
  | SurveyPresentationTextResponse;

export type SurveyRespondentResult = {
  __typename?: 'SurveyRespondentResult';
  answers?: Maybe<Array<SurveyRespondentAnswer>>;
  question: SurveyQuestion;
};

export type SurveyRespondentResultQm = {
  __typename?: 'SurveyRespondentResultQM';
  answers?: Maybe<Array<RespondentAnswerQm>>;
  question: SurveyQuestionQm;
  /** Adding variation (optional) to support A/B, depends on question and responses */
  variation?: Maybe<RandomAssignmentHeading>;
};

export type SurveyRespondentResultsList = PaginatedList & {
  __typename?: 'SurveyRespondentResultsList';
  items: Array<SurveyRespondentResult>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** The trend of survey responses being collected */
export type SurveyRespondentTrend = {
  __typename?: 'SurveyRespondentTrend';
  counts?: Maybe<Array<Maybe<SurveyRespondentTrendCount>>>;
  surveyId?: Maybe<Scalars['ID']>;
  trendBy?: Maybe<TrendTimePeriod>;
  trendRange?: Maybe<DateRange>;
};

/** Trend count rollup over a certain range */
export type SurveyRespondentTrendCount = {
  __typename?: 'SurveyRespondentTrendCount';
  count?: Maybe<Scalars['Int']>;
  range?: Maybe<DateRange>;
};

export type SurveyResponseCounts = {
  __typename?: 'SurveyResponseCounts';
  /** the total number of responses for the survey that are currently accessible */
  restrictedTotal: Scalars['Int'];
  /** the total number of responses for the survey */
  total: Scalars['Int'];
};

export type SurveyScore = {
  __typename?: 'SurveyScore';
  /** completion time in seconds */
  completionRate: Scalars['Float'];
  /** completion rate given as probability of complete (0-1) */
  completionTime: Scalars['Float'];
  /**
   * survey score rating represented as one of the following values: 'OK', 'GOOD', 'GREAT', 'PERFECT', 'UNKNOWN'
   * @deprecated Use SurveyScoreRatingV2
   */
  rating: SurveyScoreRating;
  /** mlsvc recommendations */
  recommendationCount: Scalars['Int'];
};

export enum SurveyScoreRating {
  Good = 'GOOD',
  Great = 'GREAT',
  Ok = 'OK',
  Perfect = 'PERFECT',
  /** Unable to map value to a rating */
  Unknown = 'UNKNOWN',
}

export enum SurveyScoreRatingV2 {
  Critical = 'CRITICAL',
  Ok = 'OK',
  Perfect = 'PERFECT',
}

export type SurveyScoreV2 = {
  __typename?: 'SurveyScoreV2';
  /** completion time in seconds */
  completionRate: Scalars['Float'];
  /** completion rate given as probability of complete (0-1) */
  completionTime: Scalars['Float'];
  /** survey score rating represented as one of the following values: 'OK', 'CRITICAL', 'PERFECT' */
  rating: SurveyScoreRatingV2;
  /** mlsvc recommendations */
  recommendationCount: Scalars['Int'];
};

export type SurveySendPermissions = {
  __typename?: 'SurveySendPermissions';
  allowed: Scalars['Boolean'];
  disallowedRedirect?: Maybe<Scalars['String']>;
};

export enum SurveySortBy {
  DateCreated = 'DATE_CREATED',
  DateModified = 'DATE_MODIFIED',
  Nickname = 'NICKNAME',
  ResponseCount = 'RESPONSE_COUNT',
  Title = 'TITLE',
}

export type SurveyStatsResults = {
  __typename?: 'SurveyStatsResults';
  collectorCount: Scalars['Int'];
  questionCount: Scalars['Int'];
  responseCount: Scalars['Int'];
  surveyState: SurveyStatus;
};

/** The status of the Survey, computed based on its questions and collectors. */
export enum SurveyStatus {
  /** The survey is not in draft and has no open collectors */
  Closed = 'CLOSED',
  /** The survey does not have any questions or collectors */
  Draft = 'DRAFT',
  /** The survey is not in draft and has open collectors */
  Open = 'OPEN',
  /** The survey is not in draft and has unconfigured collectors */
  Unconfigured = 'UNCONFIGURED',
}

export type SurveyTakingSessionInput = {
  /** Unique identifier related to the current collector. */
  collectionKey: Scalars['String'];
  languageCode: Scalars['String'];
  /** Encrypted URL parameters provided for the survey-taking page. */
  smParam?: InputMaybe<Scalars['String']>;
  subdomains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SurveyTakingSessionResponse = {
  __typename?: 'SurveyTakingSessionResponse';
  encryptedSmParam?: Maybe<Scalars['String']>;
  isValidSubdomain: Scalars['Boolean'];
  respondent: Respondent;
};

export type SurveyTemplate = {
  __typename?: 'SurveyTemplate';
  answerableQuestionCount: Scalars['Int'];
  canonicalName?: Maybe<Scalars['String']>;
  copyCount: Scalars['Int'];
  id: Scalars['ID'];
  image?: Maybe<Image>;
  /** Whether or not a basic user can copy this template regardless of it having paid features */
  isAllowedBasic: Scalars['Boolean'];
  isCertified: Scalars['Boolean'];
  links?: Maybe<SurveyLinks>;
  longDescription: Scalars['String'];
  pageCount: Scalars['Int'];
  questionCount: Scalars['Int'];
  questions?: Maybe<SurveyQuestionList>;
  responseSummary?: Maybe<ResponseSummaryList>;
  /** @deprecated Use scoreV2 */
  score?: Maybe<SurveyScore>;
  scoreV2?: Maybe<SurveyScoreV2>;
  shortDescription: Scalars['String'];
  themeId: Scalars['ID'];
  title: Scalars['String'];
  /** Whether or not a user can copy this template depending on it having advanced features */
  userCanCopyTemplate: Scalars['Boolean'];
};

export type SurveyTemplateQuestionsArgs = {
  families?: InputMaybe<Array<SurveyQuestionTypeFamily>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type SurveyTemplateResponseSummaryArgs = {
  openEndResponseLimit?: InputMaybe<Scalars['Int']>;
  questionIdList: Array<InputMaybe<Scalars['ID']>>;
  useCache?: InputMaybe<Scalars['Boolean']>;
};

export type SurveyTemplateAttribute = {
  __typename?: 'SurveyTemplateAttribute';
  attributeId: Scalars['ID'];
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type SurveyTemplateAttributesList = PaginatedList & {
  __typename?: 'SurveyTemplateAttributesList';
  items?: Maybe<Array<Maybe<SurveyTemplateAttribute>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SurveyTemplateCategory = {
  __typename?: 'SurveyTemplateCategory';
  id: Scalars['ID'];
  name: Scalars['String'];
  templates: SurveyTemplateList;
};

export type SurveyTemplateCategoryList = PaginatedList & {
  __typename?: 'SurveyTemplateCategoryList';
  items: Array<SurveyTemplateCategory>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SurveyTemplateList = PaginatedList & {
  __typename?: 'SurveyTemplateList';
  items: Array<SurveyTemplate>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** The theme associated with the design settings of a survey */
export type SurveyTheme = {
  __typename?: 'SurveyTheme';
  /** Available resource info; currently for images only and may be extended to include web fonts URLs. */
  artifacts?: Maybe<SurveyThemeImages>;
  /** Generic button style */
  button?: Maybe<CommonStyle>;
  /** All available color palettes associated with the given theme */
  colorPalettes?: Maybe<Array<ColorPalette>>;
  /** Validation error styles */
  error?: Maybe<CommonStyle>;
  /** Exit link style */
  exitLink?: Maybe<CommonStyle>;
  id: Scalars['ID'];
  /** @deprecated This field might be dropped once JSS gets in. */
  images: SurveyThemeImages;
  isAccessible: Scalars['Boolean'];
  isCustomTheme: Scalars['Boolean'];
  isPremiumTheme: Scalars['Boolean'];
  isStockTheme: Scalars['Boolean'];
  isTeamTheme: Scalars['Boolean'];
  /** Page layout */
  layout?: Maybe<LayoutOptionType>;
  name: Scalars['String'];
  /** Page title style */
  pageTitle?: Maybe<CommonStyle>;
  /** Answer options style */
  questionBody?: Maybe<QuestionBodyStyle>;
  /** Question text style */
  questionTitle?: Maybe<CommonStyle>;
  /** Current selected color palette */
  selectedColorPalette?: Maybe<ColorPalette>;
  /** @deprecated This field might be dropped once JSS gets in. */
  styles: SurveyThemeStyles;
  /** Overall survey page container */
  surveyPage?: Maybe<SurveyPageStyle>;
  /** Survey title style */
  surveyTitle?: Maybe<CommonStyle>;
  version: SurveyThemeVersion;
};

/** Image assets associated with the theme */
export type SurveyThemeImages = {
  __typename?: 'SurveyThemeImages';
  background: Image;
  thumbnail: Image;
  /** @deprecated This field might be dropped once v2 theme support is dropped. */
  title: Image;
};

export type SurveyThemeStyles = {
  __typename?: 'SurveyThemeStyles';
  pageTitle: ThemePageTitleStyle;
  progressBar: ThemeProgressBarStyle;
  questionTitle: ThemeQuestionTitleStyle;
  surveyPage: ThemeSurveyPageStyle;
};

export type SurveyThemeStylesInput = {
  pageTitle: ThemePageTitleStyleInput;
  progressBar: ThemeProgressBarStyleInput;
  questionTitle: ThemeQuestionTitleStyleInput;
  surveyPage: ThemeSurveyPageStyleInput;
};

export type SurveyThemeType = SurveyCssTheme | SurveyTheme;

/**
 * Available versions of survey themes
 * Note: Only themes in ver.3 format gets full support.
 */
export enum SurveyThemeVersion {
  Draft = 'DRAFT',
  Retired = 'RETIRED',
  V0 = 'V0',
  V1 = 'V1',
  V2 = 'V2',
  V3 = 'V3',
  Zoomerang = 'ZOOMERANG',
}

export type SurveyTitle = {
  __typename?: 'SurveyTitle';
  enabled: Scalars['Boolean'];
  horizontalAlignment: SurveyTitleHorizontalAlignment;
};

export enum SurveyTitleHorizontalAlignment {
  Center = 'CENTER',
  Left = 'LEFT',
}

export type TagFilter = AnalysisStandardViewFilterRule & {
  __typename?: 'TagFilter';
  active: Scalars['Boolean'];
  customHeading?: Maybe<Scalars['String']>;
  defaultHeading: Scalars['String'];
  id: Scalars['ID'];
  question?: Maybe<SurveyQuestion>;
  tagsToFilter?: Maybe<AnalysisQuestionTags>;
};

/** A team is an entity which holds a collection of SurveyMonkey users/accounts */
export type Team = {
  __typename?: 'Team';
  accountOwner?: Maybe<AccountOwnerPublicInfo>;
  activityLogs?: Maybe<ActivityLogsList>;
  billing: TeamBilling;
  divisions?: Maybe<Array<Division>>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  /** Search for a list of UserTeamMembership */
  searchTeamMemberships?: Maybe<UserTeamMembershipList>;
  /** Get list of pending seat requests for admins to respond to */
  seatRequests: SeatRequestList;
  /** get a summary of filled, pending, and available seats for this team. */
  seatSummary?: Maybe<SeatSummary>;
  settings: TeamSettings;
  sharingPolicy?: Maybe<UserTeamSharingPolicy>;
  smsCreditUsageSummary?: Maybe<SmsCreditUsageSummary>;
  ssoState: TeamSsoState;
  /** Get list of user workgroups */
  userWorkgroups?: Maybe<WorkgroupList>;
  widgetSettings: Array<TeamWidgetSetting>;
  /** Get list of workgroups */
  workgroups?: Maybe<WorkgroupList>;
  /** Get a list of workgroups by a list of workgroup ids */
  workgroupsByIds: Array<Maybe<Workgroup>>;
};

/** A team is an entity which holds a collection of SurveyMonkey users/accounts */
export type TeamActivityLogsArgs = {
  input?: InputMaybe<ActivityLogsInput>;
};

/** A team is an entity which holds a collection of SurveyMonkey users/accounts */
export type TeamSearchTeamMembershipsArgs = {
  input: SearchTeamMembershipsInput;
};

/** A team is an entity which holds a collection of SurveyMonkey users/accounts */
export type TeamSeatRequestsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<SeatRequestResponseStatus>;
};

/** A team is an entity which holds a collection of SurveyMonkey users/accounts */
export type TeamUserWorkgroupsArgs = {
  input: MyWorkgroupsInput;
};

/** A team is an entity which holds a collection of SurveyMonkey users/accounts */
export type TeamWidgetSettingsArgs = {
  divisionId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<TeamWidgetType>;
};

/** A team is an entity which holds a collection of SurveyMonkey users/accounts */
export type TeamWorkgroupsArgs = {
  input?: InputMaybe<WorkgroupsInput>;
};

/** A team is an entity which holds a collection of SurveyMonkey users/accounts */
export type TeamWorkgroupsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};

export type TeamAsset = {
  defaultInDivisions?: Maybe<Array<Division>>;
  groupId: Scalars['ID'];
  isDefault: Scalars['Boolean'];
};

/** A team's billing information */
export type TeamBilling = {
  __typename?: 'TeamBilling';
  account: BillingAccount;
  createdAt: Scalars['DateTime'];
  /** The invoice history of this team */
  invoiceHistory: BillingInvoiceList;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  recentInvoice?: Maybe<BillingInvoice>;
};

/** A team's billing information */
export type TeamBillingInvoiceHistoryArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type TeamImageAsset = Asset &
  ImageAsset &
  TeamAsset & {
    __typename?: 'TeamImageAsset';
    createdAt: Scalars['DateTime'];
    defaultInDivisions?: Maybe<Array<Division>>;
    description: Scalars['String'];
    groupId: Scalars['ID'];
    id: Scalars['ID'];
    isDefault: Scalars['Boolean'];
    name: Scalars['String'];
    s3Key: Scalars['String'];
    thumbnailUrl: Scalars['String'];
    url: Scalars['String'];
  };

export type TeamImageAssetsList = PaginatedList & {
  __typename?: 'TeamImageAssetsList';
  items: Array<TeamImageAsset>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** Represents an invitation to a team */
export type TeamInvite = {
  __typename?: 'TeamInvite';
  /** The email the invitation was sent to */
  email: Scalars['String'];
  /** The group that this invitation is for */
  group?: Maybe<TeamInviteGroup>;
  /** ID of the group this invitation is for */
  groupId: Scalars['ID'];
  /** unique ID for this invitation */
  id: Scalars['ID'];
  /** Token used for accepting this invite */
  inviteToken: Scalars['String'];
  /** The status of the invitation */
  status: TeamInviteStatus;
  /** optionally, an associated member id if this is a reassignment */
  teamMembershipId?: Maybe<Scalars['ID']>;
};

export type TeamInviteGroup = {
  __typename?: 'TeamInviteGroup';
  name: Scalars['String'];
  /** A subset of the group owner's user info */
  owner: TeamInviteGroupOwner;
};

export type TeamInviteGroupOwner = {
  __typename?: 'TeamInviteGroupOwner';
  /** The package of the group owner */
  package: PricingExperiencePackage;
  /** The package ID of the group owner */
  packageId: Scalars['ID'];
};

export type TeamInviteRequestInput = {
  teamId: Scalars['ID'];
};

export enum TeamInviteRequestStatus {
  Available = 'AVAILABLE',
  Invited = 'INVITED',
  Pending = 'PENDING',
  Unavailable = 'UNAVAILABLE',
}

export enum TeamInviteStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  New = 'NEW',
  Pending = 'PENDING',
  ResassignmentPending = 'RESASSIGNMENT_PENDING',
}

/** This enum represents the status of a team member. */
export enum TeamMemberStatus {
  Active = 'ACTIVE',
  CompletedDeletion = 'COMPLETED_DELETION',
  Deactivated = 'DEACTIVATED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  PendingDeletion = 'PENDING_DELETION',
  ReassignmentPending = 'REASSIGNMENT_PENDING',
}

/** The type of user within your team */
export enum TeamMemberType {
  AccountOwner = 'ACCOUNT_OWNER',
  Admin = 'ADMIN',
  Analyst = 'ANALYST',
  Casual = 'CASUAL',
  DivisionAdmin = 'DIVISION_ADMIN',
  Regular = 'REGULAR',
  Unspecified = 'UNSPECIFIED',
}

export type TeamSettings = CommonGroupSettings & {
  __typename?: 'TeamSettings';
  adminShareSetting: AdminShareSetting;
  customSurveyLinkDomain?: Maybe<CustomSurveyLinkDomainSetting>;
  defaultConvertBasicRoleType?: Maybe<MembershipSeatType>;
  defaultConvertPaidRoleType?: Maybe<MembershipSeatType>;
  defaultRoleType?: Maybe<MembershipSeatType>;
  /** Whether division admins are allowed to manage other users */
  divisionAdminsCanManageUsers: Scalars['Boolean'];
  forceAnonymousScope?: Maybe<AnonymousResponseType>;
  groupType?: Maybe<GroupType>;
  isEnterpriseAdminAllowReshare: Scalars['Boolean'];
  isForceAnonymousScopeIdRestricted?: Maybe<Scalars['Boolean']>;
  isHIPAAEnabled: Scalars['Boolean'];
  isPIIEnabled?: Maybe<Scalars['Boolean']>;
  /** Whether non-admin users are permitted to add audience credits directly or not */
  nonAdminsCanAddCredits: Scalars['Boolean'];
  restrictedCollectorTypeIds?: Maybe<Array<RestrictedCollectorTypeTuple>>;
  scim?: Maybe<ScimSettings>;
  sso?: Maybe<SingleSignOnSettings>;
};

/** Indicates how new surveys created by the user should be automatically shared. */
export enum TeamShareSetting {
  ShareFullAccess = 'SHARE_FULL_ACCESS',
  ShareOff = 'SHARE_OFF',
  ShareViewOnly = 'SHARE_VIEW_ONLY',
}

/** The state of single sign-on within a team */
export enum TeamSsoState {
  /** No user in the team uses SSO */
  Disabled = 'DISABLED',
  /** Using SSO is optional for users in the team */
  Optional = 'OPTIONAL',
  /** Using SSO is required for users in the team */
  Required = 'REQUIRED',
}

export type TeamSurvey = {
  __typename?: 'TeamSurvey';
  description: Scalars['String'];
  id: Scalars['ID'];
  links?: Maybe<SurveyLinks>;
  questionCount: Scalars['Int'];
  /** the title of the survey itself */
  surveyTitle: Scalars['String'];
  /** the display title set for the template in the Team Library */
  title: Scalars['String'];
  userCanCopyTemplate: Scalars['Boolean'];
};

export type TeamSurveyList = PaginatedList & {
  __typename?: 'TeamSurveyList';
  items: Array<TeamSurvey>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum TeamSurveySortBy {
  DateCreated = 'DATE_CREATED',
  DateModified = 'DATE_MODIFIED',
  Name = 'NAME',
}

/**
 * Additional settings that are associated with a team that are not considered team settings.
 * Default assets, survey intro text, etc.
 */
export type TeamWidgetSetting = {
  /** The current division admin override setting for the widget. Determines if the division admin can override team-level settings specifically for their managed divisions. */
  divisionOverride?: Maybe<DivisionAdminOverride>;
  id: Scalars['ID'];
  /**
   * Determines if a widget's settings are inherited from the team and not specifically set for a division.
   * Null for team-level widgets.
   */
  inherited?: Maybe<Scalars['Boolean']>;
  /** The level of a widget (whether these settings apply to the team or a division) */
  level: TeamWidgetSettingLevel;
  /** The current restriction setting for the widget. Determines if an end user of this widget must use the current settings, or if they can use their own values (or values from the library, depending on widget type). */
  restriction?: Maybe<TeamWidgetSettingRestriction>;
  /** The type of a widget. */
  type: TeamWidgetType;
};

/** The level of a queried team widget. Team widgets can either be associated with a team overall, or a specific division of a team. */
export enum TeamWidgetSettingLevel {
  Division = 'DIVISION',
  Team = 'TEAM',
}

/** The restriction status for a team widget (whether end users must be restricted to the set values). Can be any combination of LibraryRestriction values depending on the widget. */
export type TeamWidgetSettingRestriction = {
  __typename?: 'TeamWidgetSettingRestriction';
  /**
   * Determines if this restriction is inherited from the team level and not specifically set for a division.
   * Null for team-level widgets.
   */
  inherited?: Maybe<Scalars['Boolean']>;
  /** Determines what restriction is currently set for a team widget. */
  restriction: LibraryRestriction;
};

/**
 * Additional settings that are associated with a team that are not considered team settings.
 * Default assets, survey intro text, etc.
 */
export enum TeamWidgetType {
  DefaultImage = 'DEFAULT_IMAGE',
  DefaultPresentation = 'DEFAULT_PRESENTATION',
  DefaultTemplate = 'DEFAULT_TEMPLATE',
  DefaultTheme = 'DEFAULT_THEME',
  EndPage = 'END_PAGE',
  IntroText = 'INTRO_TEXT',
}

/** Supported CSS text-decoration options */
export enum TextDecorationType {
  None = 'NONE',
  Underline = 'UNDERLINE',
}

/** This validation configuration is used to enforce text inputs. */
export type TextLengthValidation = QuestionValidation & {
  __typename?: 'TextLengthValidation';
  errorMessage: Scalars['String'];
  maxLength: Scalars['Int'];
  minLength: Scalars['Int'];
  /** Can only be TEXT_LENGTH */
  type: QuestionFieldValidationType;
};

export type TextSetting = {
  __typename?: 'TextSetting';
  locale: Scalars['String'];
  text: Scalars['String'];
};

export type TextSettingInput = {
  locale: Scalars['String'];
  text: Scalars['String'];
};

export type TextStimuliVariableConfiguration = ProjectVariableConfiguration & {
  __typename?: 'TextStimuliVariableConfiguration';
  defaultLabel: Scalars['String'];
  enabled: Scalars['Boolean'];
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export type TextVariableConfiguration = ProjectVariableConfiguration & {
  __typename?: 'TextVariableConfiguration';
  enabled: Scalars['Boolean'];
  heading?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  subHeading?: Maybe<Scalars['String']>;
};

export type ThemeAsset = LibraryTheme | StockTheme;

export type ThemePageTitleStyle = {
  __typename?: 'ThemePageTitleStyle';
  backgroundColor?: Maybe<Scalars['String']>;
  fontFamily?: Maybe<Scalars['String']>;
  fontSize?: Maybe<Scalars['Int']>;
  textDecoration?: Maybe<Scalars['String']>;
};

export type ThemePageTitleStyleInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  fontFamily?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['String']>;
  textDecoration?: InputMaybe<Scalars['String']>;
};

export type ThemeProgressBarStyle = {
  __typename?: 'ThemeProgressBarStyle';
  backgroundColor?: Maybe<Scalars['String']>;
};

export type ThemeProgressBarStyleInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
};

export type ThemeQuestionTitleStyle = {
  __typename?: 'ThemeQuestionTitleStyle';
  color?: Maybe<Scalars['String']>;
};

export type ThemeQuestionTitleStyleInput = {
  color?: InputMaybe<Scalars['String']>;
};

export type ThemeSurveyPageStyle = {
  __typename?: 'ThemeSurveyPageStyle';
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<Scalars['String']>;
};

export type ThemeSurveyPageStyleInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  backgroundImage?: InputMaybe<Scalars['String']>;
};

export type ThreeDimensionalResponseData = {
  __typename?: 'ThreeDimensionalResponseData';
  column?: Maybe<SurveyQuestionColumn>;
  group?: Maybe<SurveyQuestionOther>;
  percentage: Scalars['Float'];
  question?: Maybe<SurveyQuestion>;
  row?: Maybe<SurveyQuestionRow>;
  total: Scalars['Int'];
};

export type ThreeDimensionalResponseSummary = QuestionResponseSummary & {
  __typename?: 'ThreeDimensionalResponseSummary';
  items?: Maybe<Array<Maybe<ThreeDimensionalResponseData>>>;
  metadata?: Maybe<ResponseMetadata>;
  perRowBasicStats?: Maybe<PerRowBasicStats>;
  respondentSummary?: Maybe<RespondentSummary>;
  responseGroupSummary?: Maybe<Array<Maybe<ResponseGroupSummary>>>;
  responseRowSummary?: Maybe<Array<Maybe<ResponseRowSummary>>>;
};

/** Filter results by date range */
export type TimePeriodFilter = AnalysisStandardViewFilterRule & {
  __typename?: 'TimePeriodFilter';
  active: Scalars['Boolean'];
  customHeading?: Maybe<Scalars['String']>;
  defaultHeading: Scalars['String'];
  endDate: Scalars['DateTime'];
  id: Scalars['ID'];
  startDate: Scalars['DateTime'];
};

export type TimePeriodFilterInput = {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};

export type TimeZone = {
  __typename?: 'TimeZone';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  selected: Scalars['Boolean'];
};

export type ToggleUseCaseAttributeInput = {
  data: Scalars['String'];
  selected: Scalars['Boolean'];
};

export type TrackingBrand = {
  __typename?: 'TrackingBrand';
  isPrimary: Scalars['Boolean'];
  name: Scalars['String'];
};

/** A dashboard view for tracking visualization widgets */
export type TrackingDashboard = TrackingDashboardFields & {
  __typename?: 'TrackingDashboard';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  sharing?: Maybe<TrackingDashboardSharing>;
  title: Scalars['String'];
};

/** A dashboard embed for tracking visualization widgets */
export type TrackingDashboardEmbed = TrackingDashboardFields & {
  __typename?: 'TrackingDashboardEmbed';
  id: Scalars['ID'];
  links: TrackingDashboardLinks;
  title: Scalars['String'];
};

/** Main fields for Tracking dashboard objects */
export type TrackingDashboardFields = {
  id: Scalars['ID'];
  title: Scalars['String'];
};

/** Filter Schema for TrackingDashboard/TrackingSharedDashboard */
export type TrackingDashboardFilterSchema = {
  __typename?: 'TrackingDashboardFilterSchema';
  dateRange: DateRange;
  questions?: Maybe<TrackingQuestionSet>;
  targetAudiences: Array<TrackingDashboardTargetAudienceFilterable>;
};

/** Tracking dashboard links */
export type TrackingDashboardLinks = {
  __typename?: 'TrackingDashboardLinks';
  /** URL for sharing the dashboard. */
  shareUrl?: Maybe<Scalars['String']>;
  /**
   * Embed URL for dashboard page iframes
   * Be aware that this url is intended for one time use only
   */
  ssoEmbedUrl: Scalars['String'];
};

/** List of tracking dashboards */
export type TrackingDashboardList = PaginatedList & {
  __typename?: 'TrackingDashboardList';
  items: Array<TrackingDashboardListItem>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A dashboard item with basic properties for list viewing */
export type TrackingDashboardListItem = TrackingDashboardFields & {
  __typename?: 'TrackingDashboardListItem';
  id: Scalars['ID'];
  sharing?: Maybe<TrackingDashboardSharing>;
  /** Base64 encoded thumbnail image for dashboard */
  thumbnail: Scalars['String'];
  title: Scalars['String'];
};

/** Partial of the shared dashboard */
export type TrackingDashboardSharing = {
  __typename?: 'TrackingDashboardSharing';
  isEnabled: Scalars['Boolean'];
  slug?: Maybe<Scalars['String']>;
};

/** Tracking Tracker Target Audience partial properties */
export type TrackingDashboardTargetAudienceFilterable = {
  __typename?: 'TrackingDashboardTargetAudienceFilterable';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type TrackingInsightsTimePeriod = {
  __typename?: 'TrackingInsightsTimePeriod';
  end: Scalars['DateTime'];
  respondents: Scalars['Int'];
  start: Scalars['DateTime'];
};

/** The available time comparison that a tracking insights can be produced against */
export enum TrackingInsightTimeComparison {
  Biannually = 'BIANNUALLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Yearly = 'YEARLY',
}

/**
 * Defines a survey invoice that is used for a given wave launch
 * The id can be used to query at billing service
 */
export type TrackingInvoice = {
  __typename?: 'TrackingInvoice';
  id: Scalars['ID'];
  /** Null for paidOn signifies that the invoice has no paid record */
  paidOn?: Maybe<Scalars['DateTime']>;
};

/**
 * Defines a wave launch that is used for a given tracker wave
 * The id is the launch id to identify each individual launch
 */
export type TrackingLaunch = {
  __typename?: 'TrackingLaunch';
  collectors: Array<Collector>;
  /** Null for completedAt signifies that the launch has yet to complete */
  completedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  /** Null for startedAt signifies that the launch has yet to receive any response */
  startedAt?: Maybe<Scalars['DateTime']>;
  state: TrackingLaunchState;
  targetAudience?: Maybe<TrackingTargetAudience>;
};

export enum TrackingLaunchState {
  Complete = 'COMPLETE',
  Draft = 'DRAFT',
  InProgress = 'IN_PROGRESS',
}

/** Defines the information required for an advance market criteria */
export type TrackingMarketAdvCriteria = {
  __typename?: 'TrackingMarketAdvCriteria';
  id: Scalars['String'];
  options: Array<Scalars['String']>;
};

/** Defines the information required for a market age balancing setting */
export type TrackingMarketAgeBalancing = {
  __typename?: 'TrackingMarketAgeBalancing';
  /** Null for details signifies there is no specific age balancing details */
  details?: Maybe<Array<TrackingMarketAgeBalancingDetail>>;
  schema: TrackingMarketBalancingScheme;
};

/** Defines the information required for a market age balancing detail */
export type TrackingMarketAgeBalancingDetail = {
  __typename?: 'TrackingMarketAgeBalancingDetail';
  max: Scalars['Int'];
  min: Scalars['Int'];
  percentage: Scalars['Int'];
};

/** Defines the information required for a market demographic balancing setting */
export type TrackingMarketBalancing = {
  __typename?: 'TrackingMarketBalancing';
  options: TrackingMarketBalancingOption;
  type: TrackingMarketBalancingType;
};

/** Defines the information required for a market demographic balancing details */
export type TrackingMarketBalancingDetails = {
  __typename?: 'TrackingMarketBalancingDetails';
  age: TrackingMarketAgeBalancing;
  gender: TrackingMarketGenderBalancing;
  /** Null for region signifies there is no balancing on region */
  region?: Maybe<TrackingMarketRegionBalancing>;
};

/** Defines the information required for a market demographic balancing option */
export type TrackingMarketBalancingOption = {
  __typename?: 'TrackingMarketBalancingOption';
  /**
   * Null for balancingDetails signifies there is no specific balancing details
   * for age, gender or region
   */
  balancingDetails?: Maybe<TrackingMarketBalancingDetails>;
  maxSchemeLevel: TrackingMarketBalancingScheme;
};

export enum TrackingMarketBalancingScheme {
  BasicCensus = 'BASIC_CENSUS',
  Census = 'CENSUS',
  Crude = 'CRUDE',
  CrudeAge = 'CRUDE_AGE',
  CrudeGenderAge = 'CRUDE_GENDER_AGE',
  Custom = 'CUSTOM',
  Full = 'FULL',
  FullAge = 'FULL_AGE',
  FullCensus = 'FULL_CENSUS',
  FullCensusGenderAge = 'FULL_CENSUS_GENDER_AGE',
  Gender = 'GENDER',
  NoBalance = 'NO_BALANCE',
  None = 'NONE',
}

export enum TrackingMarketBalancingType {
  Automatic = 'AUTOMATIC',
  Custom = 'CUSTOM',
}

/** Defines the information required for a market demographic criteria */
export type TrackingMarketCriteria = {
  __typename?: 'TrackingMarketCriteria';
  /** Empty array for advancedCriteria signifies that such target audience does not have advanced criteria configured. */
  advancedCriteria: Array<TrackingMarketAdvCriteria>;
  /** Null for age signifies that target audience does not have age criteria configured. */
  age?: Maybe<TrackingMarketRangeCriteria>;
  /**
   * Null for children age signifies that such target audience does not have children age criteria configured.
   * This criteria only exists when answer to parental status is has children
   */
  childrenAge?: Maybe<TrackingMarketRangeCriteria>;
  /** Empty array for country signifies that target audience does not have country criteria configured. */
  country: Array<Scalars['String']>;
  /** Empty array for gender signifies that target audience does not have gender criteria configured. */
  gender: Array<Scalars['String']>;
  /** Null for household income signifies that such target audience does not have household income criteria configured. */
  householdIncome?: Maybe<TrackingMarketRangeCriteria>;
  /** Empty array for region signifies that target audience does not have region criteria configured. */
  region: Array<Scalars['String']>;
};

/** Defines the information required for a market gender balancing setting */
export type TrackingMarketGenderBalancing = {
  __typename?: 'TrackingMarketGenderBalancing';
  /** Null for details signifies there is no specific gender balancing details */
  details?: Maybe<TrackingMarketGenderBalancingDetail>;
  schema: TrackingMarketBalancingScheme;
};

/** Defines the information required for a market gender balancing detail */
export type TrackingMarketGenderBalancingDetail = {
  __typename?: 'TrackingMarketGenderBalancingDetail';
  female: Scalars['Int'];
  male: Scalars['Int'];
};

/** Defines the information required for a market range criteria */
export type TrackingMarketRangeCriteria = {
  __typename?: 'TrackingMarketRangeCriteria';
  /** Null for max signifies that the range criteria does not have max value configured */
  max?: Maybe<Scalars['Int']>;
  min: Scalars['Int'];
  /** Null for openEnded signifies that the range criteria does not have openEnded value configured */
  openEnded?: Maybe<Scalars['Boolean']>;
};

/** Defines the information required for a market region balancing setting */
export type TrackingMarketRegionBalancing = {
  __typename?: 'TrackingMarketRegionBalancing';
  /** Empty array for details signifies there is no specific region balancing details */
  details: Array<TrackingMarketRegionBalancingDetail>;
  schema: TrackingMarketBalancingScheme;
};

/** Defines the information required for a market region balancing detail */
export type TrackingMarketRegionBalancingDetail = {
  __typename?: 'TrackingMarketRegionBalancingDetail';
  code: Scalars['Int'];
  percentage: Scalars['Int'];
};

/** Tracking insights coming from a NPS question requires identifying the detractors and promoters */
export type TrackingNpsInsightMeta = {
  __typename?: 'TrackingNpsInsightMeta';
  detractors: Array<TrackingTrackerInsightAnswerOption>;
  promoters: Array<TrackingTrackerInsightAnswerOption>;
};

/**
 * Defines a tracking project which is part of our MRX solutions.
 * A tracking project is the highest level of a long lasting project and it's the entry point for the clients.
 */
export type TrackingProject = {
  __typename?: 'TrackingProject';
  id: Scalars['ID'];
  state: TrackingProjectState;
  title: Scalars['String'];
  trackers: Array<TrackingTracker>;
};

/** Defines the running status for a tracking project ETL job */
export type TrackingProjectDataCleaning = {
  __typename?: 'TrackingProjectDataCleaning';
  /** Null for isETLInProgress signifies there is no ETL job in progress */
  isETLInProgress?: Maybe<Scalars['Boolean']>;
};

export enum TrackingProjectState {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Running = 'RUNNING',
}

/** Defines a question that can be used to filter tracking projects */
export type TrackingQuestion = {
  __typename?: 'TrackingQuestion';
  absolutePosition: Scalars['Int'];
  cols: Array<TrackingQuestionCol>;
  heading: Scalars['String'];
  id: Scalars['ID'];
  rows: Array<TrackingQuestionRow>;
  tags: Array<TrackingQuestionMetadata>;
  type: TrackingQuestionType;
};

/** Defines the column from a question that can be used to filter tracking projects */
export type TrackingQuestionCol = {
  __typename?: 'TrackingQuestionCol';
  id: Scalars['ID'];
  label: Scalars['String'];
  position: Scalars['Int'];
};

/** Defines the family from a question that can be used to filter tracking projects */
export enum TrackingQuestionFamily {
  Matrix = 'MATRIX',
  MultipleChoice = 'MULTIPLE_CHOICE',
  OpenEnded = 'OPEN_ENDED',
  Presentation = 'PRESENTATION',
  SingleChoice = 'SINGLE_CHOICE',
}

export type TrackingQuestionMetadata = {
  __typename?: 'TrackingQuestionMetadata';
  label: Scalars['String'];
  tag: Scalars['String'];
  /** Not all tags may have a type, i.e.: a custom tag may be just that and not have a type */
  type?: Maybe<Scalars['String']>;
};

/** Defines the row from a question that can be used to filter tracking projects */
export type TrackingQuestionRow = {
  __typename?: 'TrackingQuestionRow';
  id: Scalars['ID'];
  isOther: Scalars['Boolean'];
  label: Scalars['String'];
  position: Scalars['Int'];
};

/** Defines questions tha can be used for filtering responses in a tracking project */
export type TrackingQuestionSet = {
  __typename?: 'TrackingQuestionSet';
  /** Demographic related questions */
  demographic: Array<TrackingQuestion>;
  /** Questions that were used in the survey for the tracking project */
  survey: Array<TrackingQuestion>;
};

/** Defines the sub type from a question that can be used to filter tracking projects */
export enum TrackingQuestionSubType {
  Essay = 'ESSAY',
  Menu = 'MENU',
  Multi = 'MULTI',
  Numerical = 'NUMERICAL',
  Ranking = 'RANKING',
  Rating = 'RATING',
  Single = 'SINGLE',
  Vertical = 'VERTICAL',
  VerticalThreeCol = 'VERTICAL_THREE_COL',
  VerticalTwoCol = 'VERTICAL_TWO_COL',
}

/** Defines the type for a tracking question */
export type TrackingQuestionType = {
  __typename?: 'TrackingQuestionType';
  family: TrackingQuestionFamily;
  name: Scalars['String'];
  subType: TrackingQuestionSubType;
};

export type TrackingRespondentsCount = {
  __typename?: 'TrackingRespondentsCount';
  filtered: Scalars['Int'];
  total: Scalars['Int'];
};

/** A single tracking shared dashboard */
export type TrackingSharedDashboard = {
  __typename?: 'TrackingSharedDashboard';
  id: Scalars['ID'];
  links: TrackingDashboardLinks;
  title: Scalars['String'];
};

/** Defines the running status for a tracking dashboard ETL job */
export type TrackingSharedDashboardDataCleaning = {
  __typename?: 'TrackingSharedDashboardDataCleaning';
  /** Null for isETLInProgress signifies there is no ETL job in progress */
  isETLInProgress?: Maybe<Scalars['Boolean']>;
};

/** A single tracking shared dashboard sharing details */
export type TrackingSharedDashboardSharingDetails = {
  __typename?: 'TrackingSharedDashboardSharingDetails';
  sharingEnabled: Scalars['Boolean'];
  title: Scalars['String'];
};

/**
 * Defines the information required for a target audience in a given tracking project tracker.
 * A target audience holds settings and configurations such as demographic(age, gender, region).
 * The id is the target audience id to identify each individual tracker target audience
 */
export type TrackingTargetAudience = {
  __typename?: 'TrackingTargetAudience';
  /** Used to store additional notes on the target audience */
  additionalNotes?: Maybe<Scalars['String']>;
  balancing: TrackingMarketBalancing;
  criteria: TrackingMarketCriteria;
  id: Scalars['ID'];
  /** Represents input needed to create an audience project configuration */
  targetCompletes: Scalars['Int'];
  targetLocaleCode: Scalars['String'];
  targetQualificationRate: Scalars['Int'];
  title: Scalars['String'];
};

/**
 * Defines the information required for a tracker in a given tracking project.
 * A tracker holds settings and configurations for various waves
 * (which should be viewed as an instance of a tracker).
 * The id is the tracker id to identify each individual tracker
 */
export type TrackingTracker = {
  __typename?: 'TrackingTracker';
  /**
   * Used to determine if credits are being pulled automatically from
   * the user's Audience credits.
   */
  automaticPayment: Scalars['Boolean'];
  /** Returns a list of brands found in the tracker's associated survey */
  brands: Array<TrackingBrand>;
  endDate?: Maybe<Scalars['DateTime']>;
  /**
   * NOTE: this would appear to be duplicated. This duplication is inevitable to continue the performance enhancement effort without affecting the Prod
   * The intention is that by removing the surveyId requirement, it is possible to run this query one step earlier.
   * The current use case and the MRx API schema confirms only one to one relationship between Tracker and Survey. Once tracker id is given, the survey id
   * is no longer needed.
   *
   * Returns sets of questions from survey and demographics
   */
  filterSchema?: Maybe<TrackingQuestionSet>;
  frequency: TrackingTrackerFrequency;
  id: Scalars['ID'];
  inTimeInsights?: Maybe<TrackingTrackerInTimeInsightList>;
  primaryChoice: Scalars['String'];
  /** @deprecated Survey ID is no longer needed to get questions. There is a new endpoint called filter_schema_by_tracker_id, and this field will be replaced with filterSchema field */
  questions?: Maybe<TrackingQuestionSet>;
  /** Returns the counts of respondents for total and filtered */
  respondentsCount?: Maybe<TrackingRespondentsCount>;
  startDate: Scalars['DateTime'];
  state: TrackingTrackerState;
  staticInsights?: Maybe<TrackingTrackerStaticInsightList>;
  survey?: Maybe<Survey>;
  targetAudiences: Array<TrackingTargetAudience>;
  title: Scalars['String'];
  waves: Array<TrackingWave>;
};

/**
 * Defines the information required for a tracker in a given tracking project.
 * A tracker holds settings and configurations for various waves
 * (which should be viewed as an instance of a tracker).
 * The id is the tracker id to identify each individual tracker
 */
export type TrackingTrackerInTimeInsightsArgs = {
  timeComparison: TrackingInsightTimeComparison;
};

/**
 * Defines the information required for a tracker in a given tracking project.
 * A tracker holds settings and configurations for various waves
 * (which should be viewed as an instance of a tracker).
 * The id is the tracker id to identify each individual tracker
 */
export type TrackingTrackerQuestionsArgs = {
  surveyId: Scalars['ID'];
};

/**
 * Defines the information required for a tracker in a given tracking project.
 * A tracker holds settings and configurations for various waves
 * (which should be viewed as an instance of a tracker).
 * The id is the tracker id to identify each individual tracker
 */
export type TrackingTrackerRespondentsCountArgs = {
  filtered?: InputMaybe<Scalars['Boolean']>;
  respondentFilter?: InputMaybe<Scalars['AdvancedFilter']>;
};

/**
 * Defines the information required for a tracker in a given tracking project.
 * A tracker holds settings and configurations for various waves
 * (which should be viewed as an instance of a tracker).
 * The id is the tracker id to identify each individual tracker
 */
export type TrackingTrackerStaticInsightsArgs = {
  timeComparison: TrackingInsightTimeComparison;
};

export enum TrackingTrackerFrequency {
  Biannually = 'BIANNUALLY',
  Custom = 'CUSTOM',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY',
}

/** An insight can be linked to either a column or a row from a question */
export type TrackingTrackerInsightAnswerOption =
  | TrackingQuestionCol
  | TrackingQuestionRow;

/**
 * Defines a subgroup insight for an in-time insight.
 * When an in-time insight is produced we may have more details for it.  Ex:
 * For the insight: Patagonia: 'Eco-conscious' increased significantly by 6 pts overall.
 * We may have a subgroup: [30-44, Female] had the biggest lift (+8 pts) since last period.
 */
export type TrackingTrackerInsightSubGroup = {
  __typename?: 'TrackingTrackerInsightSubGroup';
  /** A link to the selected response used for the insight. May link to a row or column */
  answerOption?: Maybe<TrackingTrackerInsightAnswerOption>;
  /** The variation in points when compared with the previous period */
  delta: Scalars['Float'];
  /** The filter object that could be used to apply the insight results */
  filter: Scalars['AdvancedFilter'];
  id: Scalars['ID'];
  /** The number if respondents in this insight */
  respondentsCount: Scalars['Int'];
  /** Informs if the insight in comparison with a previous is increasing or decreasing */
  trend: TrackingTrackerInTimeInsightTrend;
};

/** Defines an in-time insight for a tracking project */
export type TrackingTrackerInTimeInsight = {
  __typename?: 'TrackingTrackerInTimeInsight';
  /** A link to the selected response used for the insight. May link to a row or column */
  answerOption?: Maybe<TrackingTrackerInsightAnswerOption>;
  /** The variation in points when compared with the previous period */
  delta: Scalars['Float'];
  /** The filter object that could be used to apply the insight results */
  filter: Scalars['AdvancedFilter'];
  id: Scalars['ID'];
  /** for nps questions, the meta data includes the column ids of both detractors and promoters */
  npsMeta?: Maybe<TrackingNpsInsightMeta>;
  /** The source question for the insight */
  question?: Maybe<TrackingQuestion>;
  /** The number if respondents in this insight */
  respondentsCount: Scalars['Int'];
  /** Within an insight we may have more specialized and detailed insights */
  subGroup: Array<TrackingTrackerInsightSubGroup>;
  /** Informs if the insight in comparison with a previous is increasing or decreasing */
  trend: TrackingTrackerInTimeInsightTrend;
};

/** Defines a list of over-time insights and associated metadata */
export type TrackingTrackerInTimeInsightList = {
  __typename?: 'TrackingTrackerInTimeInsightList';
  insights: Array<TrackingTrackerInTimeInsight>;
  predictionId: Scalars['String'];
  previousTimePeriod: TrackingInsightsTimePeriod;
  timePeriod: TrackingInsightsTimePeriod;
};

/** The possible trends when doing an in-time insight comparison. */
export enum TrackingTrackerInTimeInsightTrend {
  Decrease = 'DECREASE',
  Increase = 'INCREASE',
}

export enum TrackingTrackerState {
  Complete = 'COMPLETE',
  Draft = 'DRAFT',
  Fielding = 'FIELDING',
  Halted = 'HALTED',
  Published = 'PUBLISHED',
}

/**
 * Defines a static insight for a tracking project.
 * Ex:
 * [Answer option] is at 40 pts overall. [Gender: Women, Age: 18-29] were higher at 52 pts.
 */
export type TrackingTrackerStaticInsight = {
  __typename?: 'TrackingTrackerStaticInsight';
  /** A link to the selected response used for the insight. May link to a row or column */
  answerOption?: Maybe<TrackingTrackerInsightAnswerOption>;
  filter: Scalars['AdvancedFilter'];
  id: Scalars['ID'];
  /**
   * The max percentage is percentage point value (as a float: 45% is 0.45) of the filtered responses.
   * This is the percentage of this group of respondents who chose this answer option, and represents a
   * significant difference when compared to the way that the total (unfiltered) respondents chose this answer option
   */
  maxPercentage: Scalars['Float'];
  /** For nps questions, the metadata includes the column ids for both detractors and promoters */
  npsMeta?: Maybe<TrackingNpsInsightMeta>;
  /**
   * Original percentage is the percentage point value (as a float: 30% is 0.30) of the unfiltered responses.
   * This is the % of the total respondents that chose this answer option.
   */
  originalPercentage: Scalars['Float'];
  question?: Maybe<TrackingQuestion>;
  /** The number if respondents in this insight */
  respondentsCount: Scalars['Int'];
  /** The score is used to rank the insight */
  score: Scalars['Float'];
};

/** Defines a list of static insights and associated metadata */
export type TrackingTrackerStaticInsightList = {
  __typename?: 'TrackingTrackerStaticInsightList';
  insights: Array<TrackingTrackerStaticInsight>;
  predictionId: Scalars['String'];
  timePeriod: TrackingInsightsTimePeriod;
};

/**
 * Defines an instance of tracker (survey). A wave is an instance of a survey sent to completion
 * based on the frequency defined in its Tracker. A wave also holds one or more launches which
 * holds the collectors information.
 * The id is the wave id to identify each individual tracker wave
 */
export type TrackingWave = {
  __typename?: 'TrackingWave';
  /** Null for completedAt signifies that the wave has yet to complete */
  completedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  invoices: Array<TrackingInvoice>;
  launches: Array<TrackingLaunch>;
  scheduledStart: Scalars['DateTime'];
  /** Null for startedAt signifies that the wave has yet to receive any response */
  startedAt?: Maybe<Scalars['DateTime']>;
  state: TrackingWaveState;
};

export enum TrackingWaveState {
  Complete = 'COMPLETE',
  Draft = 'DRAFT',
  InProgress = 'IN_PROGRESS',
}

export enum TransactionProcessType {
  AnnualUpgrade = 'ANNUAL_UPGRADE',
  BenchmarkOneTime = 'BENCHMARK_ONE_TIME',
  BenchmarkRenewable = 'BENCHMARK_RENEWABLE',
  BenchmarkSelfServeRenewable = 'BENCHMARK_SELF_SERVE_RENEWABLE',
  CompUpgrade = 'COMP_UPGRADE',
  ConceptTest = 'CONCEPT_TEST',
  Credit = 'CREDIT',
  CurrencyChange = 'CURRENCY_CHANGE',
  DirectDebitFailure = 'DIRECT_DEBIT_FAILURE',
  GroupOverage = 'GROUP_OVERAGE',
  Incentive = 'INCENTIVE',
  MarketoRenewable = 'MARKETO_RENEWABLE',
  OneTime = 'ONE_TIME',
  PanelSelfServe = 'PANEL_SELF_SERVE',
  Recurring = 'RECURRING',
  SalesforceOneTime = 'SALESFORCE_ONE_TIME',
  SalesforceRenewable = 'SALESFORCE_RENEWABLE',
  Smi = 'SMI',
  SmiCompUpgrade = 'SMI_COMP_UPGRADE',
  SmiP2PUpgrade = 'SMI_P2P_UPGRADE',
  SubscriptionHiddenCompUpgrade = 'SUBSCRIPTION_HIDDEN_COMP_UPGRADE',
  SubscriptionRestart = 'SUBSCRIPTION_RESTART',
  TaxamoRefund = 'TAXAMO_REFUND',
  TempUpgrade = 'TEMP_UPGRADE',
  Wallet = 'WALLET',
  ZoomerangHistoricInvoice = 'ZOOMERANG_HISTORIC_INVOICE',
}

export enum TransactionStatusType {
  Authorized = 'AUTHORIZED',
  Failed = 'FAILED',
  New = 'NEW',
  Paid = 'PAID',
  Pending = 'PENDING',
  PendingAudienceCheckout = 'PENDING_AUDIENCE_CHECKOUT',
  PendingCheckout = 'PENDING_CHECKOUT',
  PendingRefund = 'PENDING_REFUND',
  Void = 'VOID',
}

/** The time periods in which you can filter response trends */
export enum TrendTimePeriod {
  Days = 'DAYS',
  Default = 'DEFAULT',
  Hours = 'HOURS',
  Months = 'MONTHS',
  Quarters = 'QUARTERS',
  Weeks = 'WEEKS',
  Years = 'YEARS',
}

export type TwoDimensionalResponseData = {
  __typename?: 'TwoDimensionalResponseData';
  column?: Maybe<SurveyQuestionColumn>;
  percentage: Scalars['Float'];
  question?: Maybe<SurveyQuestion>;
  row?: Maybe<SurveyQuestionRow>;
  total: Scalars['Int'];
};

export type TwoDimensionalResponseSummary = QuestionResponseSummary & {
  __typename?: 'TwoDimensionalResponseSummary';
  basicStats?: Maybe<Array<SummaryBasicStats>>;
  items?: Maybe<Array<Maybe<TwoDimensionalResponseData>>>;
  metadata?: Maybe<ResponseMetadata>;
  respondentSummary?: Maybe<RespondentSummary>;
  responseColumnSummary?: Maybe<Array<Maybe<ResponseColumnSummary>>>;
  responseRowSummary?: Maybe<Array<Maybe<ResponseRowSummary>>>;
};

/** Represents error states in query responses corresponding to 'unauthorized' API responses. */
export type UnauthorizedError = {
  __typename?: 'UnauthorizedError';
  code: UnauthorizedErrorCode;
  message?: Maybe<Scalars['String']>;
};

/** Codes for errors corresponding to 'unauthorized' error states. */
export enum UnauthorizedErrorCode {
  Unauthorized = 'UNAUTHORIZED',
}

export type UninstallAppInput = {
  appId: Scalars['ID'];
};

export type UninstallAppPayload = {
  __typename?: 'UninstallAppPayload';
  appId: Scalars['ID'];
  success: Scalars['Boolean'];
};

export type UpdateAnalysisDashboardInput = {
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateAnalysisDashboardPayload = {
  __typename?: 'UpdateAnalysisDashboardPayload';
  dashboard?: Maybe<AnalysisResultsDashboard>;
  success: Scalars['Boolean'];
};

export type UpdateAudienceProjectInput = {
  /**
   * If you are starting a new bulk project, you'll need to provide this to the original project
   * by passing in its own collector ID.
   */
  bulkProjectId?: InputMaybe<Scalars['Int']>;
  /** If this project is part of a bulk project, you may specify where in the list it should exist. */
  bulkProjectPosition?: InputMaybe<Scalars['Int']>;
  collectorId: Scalars['Int'];
  projectConfig: AudienceProjectConfigInput;
};

export type UpdateAudienceProjectPayload = {
  __typename?: 'UpdateAudienceProjectPayload';
  errorMessage?: Maybe<Scalars['String']>;
  project?: Maybe<AudienceProject>;
  success: Scalars['Boolean'];
};

export type UpdateCollectorInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateCollectorPayload = {
  __typename?: 'UpdateCollectorPayload';
  collector?: Maybe<Collector>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type UpdateConceptTestingCrossTabReportInput = {
  banners?: InputMaybe<Array<CrossTabTableBannerInput>>;
  projectId: Scalars['ID'];
  reportId: Scalars['ID'];
  stubs?: InputMaybe<Array<CrossTabTableStubInput>>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateConceptTestingCrossTabReportPayload = {
  __typename?: 'UpdateConceptTestingCrossTabReportPayload';
  crosstab?: Maybe<ConceptTestingCrossTabReport>;
  success: Scalars['Boolean'];
};

export type UpdateCrossTabReportInput = {
  banners?: InputMaybe<Array<InputMaybe<CrossTabTableBannerInput>>>;
  description?: InputMaybe<Scalars['String']>;
  reportId: Scalars['ID'];
  stubs?: InputMaybe<Array<InputMaybe<CrossTabTableStubInput>>>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateCrossTabReportPayload = {
  __typename?: 'UpdateCrossTabReportPayload';
  crosstab?: Maybe<CrossTabReport>;
  success: Scalars['Boolean'];
};

export type UpdateDefaultAssetsSettingsInput = {
  altText?: InputMaybe<Scalars['String']>;
  assetType: LibraryAssetType;
  /** This is not a required field as there is no default template asset */
  defaultAssetId?: InputMaybe<Scalars['ID']>;
  divisionAdminOverride?: InputMaybe<Scalars['Boolean']>;
  divisionId?: InputMaybe<Scalars['ID']>;
  endPage?: InputMaybe<EndPageSettingInput>;
  isAltTextEnabled?: InputMaybe<Scalars['Boolean']>;
  restriction?: InputMaybe<LibraryRestriction>;
  sizeType?: InputMaybe<LibraryImageSizeType>;
  text?: InputMaybe<Array<InputMaybe<TextSettingInput>>>;
  verticalAlign?: InputMaybe<LibraryImageAlignType>;
};

export type UpdateDefaultAssetsSettingsPayload = {
  __typename?: 'UpdateDefaultAssetsSettingsPayload';
  defaultAssetsSettingsLibrary: DefaultAssetsSettingsLibrary;
  success: Scalars['Boolean'];
};

export type UpdateLibraryInput = {
  assetId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  divisionId?: InputMaybe<Scalars['ID']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateManageSharingSettingsInput = {
  isEnterpriseAdminAllowReshare: Scalars['Boolean'];
};

export type UpdateManageUsersSettingsInput = {
  defaultConvertBasicRoleType: MembershipSeatType;
  defaultConvertPaidRoleType: MembershipSeatType;
  defaultRoleType: MembershipSeatType;
  divisionAdminsCanManageUsers: Scalars['Boolean'];
};

export type UpdateMarketingEmailPreferencesInput = {
  campaignId?: InputMaybe<Scalars['String']>;
  encryptedEmail: Scalars['String'];
  marketingEmailPreferences: MarketingEmailPreferencesInput;
  origin?: InputMaybe<Scalars['String']>;
};

/** If the update fails, the input values are returned */
export type UpdateMarketingEmailPreferencesPayload = {
  __typename?: 'UpdateMarketingEmailPreferencesPayload';
  marketingEmailPreferences: MarketingEmailPreferences;
  success: Scalars['Boolean'];
};

export type UpdateOecKeywordTagsInput = {
  questionId: Scalars['ID'];
  surveyId: Scalars['ID'];
  tags: Array<OecKeywordTagInput>;
};

export type UpdatePiiSettingsInput = {
  isPIIEnabled: Scalars['Boolean'];
};

export type UpdateProductAddOnInput = {
  isComplete?: InputMaybe<Scalars['Boolean']>;
  modifiedBy: Scalars['Int'];
  quantity: Scalars['Int'];
  skuCostId: Scalars['Int'];
  skuId: Scalars['Int'];
  stripeAddonProductId?: InputMaybe<Scalars['String']>;
  stripePriceId?: InputMaybe<Scalars['String']>;
};

/** input to update userprofile */
export type UpdateProfilerDataInput = {
  includeOnly?: InputMaybe<Array<Scalars['String']>>;
  updates: Array<ProfilerQuestionUpdateInput>;
};

export type UpdateProjectTitleInput = {
  projectId: Scalars['String'];
  title: Scalars['String'];
};

export type UpdateSharedViewInput = {
  allowTeamExport?: InputMaybe<Scalars['Boolean']>;
  branding: AnalysisSharedViewBranding;
  defaultViewId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  domain: Scalars['String'];
  hideOpenEnded: Scalars['Boolean'];
  isEnabled: Scalars['Boolean'];
  isPublic?: InputMaybe<Scalars['Boolean']>;
  modes: Array<InputMaybe<AnalysisSharedViewMode>>;
  name: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  sharableViewId: Scalars['ID'];
  sharedViewId: Scalars['ID'];
  sharedViewKey: Scalars['String'];
  surveyId: Scalars['ID'];
  teamOnlyShare?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
  type: AnalysisSharedViewType;
  updatePassword?: InputMaybe<Scalars['String']>;
};

export type UpdateSurveyDesignPayload = {
  __typename?: 'UpdateSurveyDesignPayload';
  success: Scalars['Boolean'];
  survey?: Maybe<Survey>;
};

export type UpdateTeamMembershipInput = {
  /** The id of the membership being updated. */
  id: Scalars['ID'];
  /** The new type to change the user to. */
  type?: InputMaybe<TeamMemberType>;
};

export type UpdateTeamSettingsPayload = {
  __typename?: 'UpdateTeamSettingsPayload';
  success: Scalars['Boolean'];
};

export type UpdateTrackingDashboardSharingError = UserError & {
  __typename?: 'UpdateTrackingDashboardSharingError';
  code: UpdateTrackingDashboardSharingErrorType;
  detail: Scalars['String'];
  field?: Maybe<Array<Scalars['String']>>;
};

export enum UpdateTrackingDashboardSharingErrorType {
  PasswordProhibited = 'PASSWORD_PROHIBITED',
  PasswordTooShort = 'PASSWORD_TOO_SHORT',
}

export type UpdateTrackingDashboardSharingInput = {
  linkSharingEnabled: Scalars['Boolean'];
  password?: InputMaybe<Scalars['String']>;
};

export type UpdateTrackingDashboardSharingPayload = {
  __typename?: 'UpdateTrackingDashboardSharingPayload';
  sharing?: Maybe<TrackingDashboardSharing>;
  success: Scalars['Boolean'];
  userErrors?: Maybe<Array<UpdateTrackingDashboardSharingError>>;
};

/** input for a user profile response */
export type UpdateUserProfileInput = {
  direction: DirectionType;
  flow: Scalars['String'];
  path: Scalars['String'];
  profile: UserProfileInput;
};

/** wrap state for mutation paylod */
export type UpdateUserProfilePayload = {
  __typename?: 'UpdateUserProfilePayload';
  success: Scalars['Boolean'];
  welcomeFlowState?: Maybe<WelcomeFlowState>;
};

export type UpdateUserThemeInput = {
  button?: InputMaybe<CommonStyleInput>;
  colorPalettes?: InputMaybe<Array<InputMaybe<ColorPaletteInput>>>;
  customFonts?: InputMaybe<FontFaceInput>;
  error?: InputMaybe<CommonStyleInput>;
  exitLink?: InputMaybe<CommonStyleInput>;
  id: Scalars['ID'];
  isCustomCSSTheme?: InputMaybe<Scalars['Boolean']>;
  isTeamTheme?: InputMaybe<Scalars['Boolean']>;
  layout?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pageTitle?: InputMaybe<CommonStyleInput>;
  questionBody?: InputMaybe<QuestionBodyStyleInput>;
  questionTitle?: InputMaybe<CommonStyleInput>;
  selectedColorPalette?: InputMaybe<ColorPaletteInput>;
  styles?: InputMaybe<SurveyThemeStylesInput>;
  surveyPage?: InputMaybe<SurveyPageStyleInput>;
  surveyTitle?: InputMaybe<CommonStyleInput>;
};

export type UpdateUserThemePayload = {
  __typename?: 'UpdateUserThemePayload';
  success: Scalars['Boolean'];
  theme?: Maybe<SurveyCssTheme>;
};

export type UpdateVariableAnswerInput = {
  /**
   * A stringified JSON object. Currently has an open data structure.
   * For any new keys that are not part of the svysvc response, add a _ prefix
   */
  data: Scalars['String'];
  projectId: Scalars['ID'];
  type: ProjectVariableAnswerType;
  variableId: Scalars['ID'];
};

export type UpdateVariableAnswerMetadataInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['ID'];
  variableId: Scalars['ID'];
};

export type UpgradePreviewPayload = {
  __typename?: 'UpgradePreviewPayload';
  proration: Scalars['Float'];
  subtotal: Scalars['Float'];
  success: Scalars['Boolean'];
  tax: Scalars['Float'];
  total: Scalars['Float'];
};

export type UploadFileParametersInput = {
  contentType: Scalars['String'];
  filename: Scalars['String'];
};

export type UseCaseAttributeInput = {
  /** Canonical name for the attribute */
  attributeId: Scalars['String'];
  /** A stringified JSON object. Currently has an open data structure. */
  data?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  /**
   * A stringified JSON object. Currently has an open data structure.
   * This is applicable for standard attributes
   */
  modifiers?: InputMaybe<Scalars['String']>;
};

export type UseCaseAttributeReponsePayload = {
  __typename?: 'UseCaseAttributeReponsePayload';
  attribute?: Maybe<ConceptTestingAttribute>;
  success: Scalars['Boolean'];
};

/** Performance score for a given benchmark */
export type UseCaseBenchmarkPerformanceScore = UseCasePerformanceScore & {
  __typename?: 'UseCaseBenchmarkPerformanceScore';
  attribute: ConceptTestingAttribute;
  benchmark: ConceptTestingBenchmark;
  percentage: Scalars['Float'];
  type: UseCasePerformanceScoreType;
};

/** Performance score for a given concept */
export type UseCaseConceptPerformanceScore = UseCasePerformanceScore & {
  __typename?: 'UseCaseConceptPerformanceScore';
  attribute: ConceptTestingAttribute;
  concept: ConceptTestingStimulus;
  higherSignificance: Array<ConceptTestingStimulus>;
  isSignificant: Scalars['Boolean'];
  lowerSignificance: Array<ConceptTestingStimulus>;
  percentage: Scalars['Float'];
  type: UseCasePerformanceScoreType;
};

/** A list of correlation scores for the given project */
export type UseCaseCorrelationAnalysis = {
  __typename?: 'UseCaseCorrelationAnalysis';
  drivers: Array<UseCaseKeyDriver>;
  hasEnoughResponse: Scalars['Boolean'];
};

export type UseCaseCorrelationAnalysisInput = {
  drivers: Array<Scalars['ID']>;
  filter?: InputMaybe<AnalysisFilterInput>;
  outcome: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type UseCaseExportDataParamsInput = {
  /** Optional, only needed for xls format exports */
  xlsParams?: InputMaybe<AnalysisXlsExportParamsInput>;
};

/** Use Case Export Job type, for Concept Testing and Tracking */
export type UseCaseExportJob = {
  __typename?: 'UseCaseExportJob';
  downloadLink?: Maybe<Scalars['String']>;
  format: AnalysisExportJobFormat;
  id: Scalars['ID'];
  status: AnalysisExportJobStatus;
};

export type UseCaseExportJobInput = {
  /** Custom filename */
  analysisExportJobName: Scalars['String'];
  /** Analysis View ID, either Current view or Original view */
  analysisViewId?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<AnalysisFilterInput>;
  /** File format for export job */
  jobFormat: AnalysisExportJobFormat;
  /** Respondent Count */
  respondentCount?: InputMaybe<Scalars['Int']>;
  /** Survey Id, optional, only needed for Tracking project */
  surveyId?: InputMaybe<Scalars['String']>;
};

/** A correlation score for a particular attribute of a given concept */
export type UseCaseKeyDriver = {
  correlation?: Maybe<Scalars['Float']>;
};

/** Contains data that required in each performance score */
export type UseCasePerformanceScore = {
  attribute: ConceptTestingAttribute;
  percentage: Scalars['Float'];
  type: UseCasePerformanceScoreType;
};

export type UseCasePerformanceScoreInput = {
  combineOption?: InputMaybe<PerformanceScoreCombineOption>;
  confidenceLevel?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<AnalysisFilterInput>;
  projectId: Scalars['ID'];
  selectedBenchmarks?: InputMaybe<Array<Scalars['String']>>;
};

/** All the possible values that can be used as a performance calculation basis */
export enum UseCasePerformanceScoreType {
  Benchmark = 'BENCHMARK',
  Concept = 'CONCEPT',
}

export type UseCaseViewList = {
  __typename?: 'UseCaseViewList';
  /** Current view ID */
  currentView: Scalars['ID'];
  /** Original view ID */
  originalView: Scalars['ID'];
  /** Response counts of the survey */
  responseCounts?: Maybe<ProjectSurveyResponseCounts>;
  surveyId: Scalars['ID'];
};

export type UseCaseViewListResponseCountsArgs = {
  filter?: InputMaybe<AnalysisFilterInput>;
};

/** Represents a SurveyMonkey user. */
export type User = {
  __typename?: 'User';
  audienceCredits?: Maybe<AudienceWallet>;
  /** List of authorized survey link domains this user can select */
  authorizedSurveyLinkDomainList: Array<UserSurveyLinkDomain>;
  /** Returns a list of all available time zones that can be selected */
  availableTimeZones: Array<TimeZone>;
  /** Information about the contributor role type assigned to the user */
  contributorRoleType?: Maybe<ContributorRoleType>;
  /**
   * Returns the themes including premium ones that can be added
   * to a user's Team Library
   */
  customThemes: Array<SurveyTheme>;
  dateJoined: Scalars['DateTime'];
  /** This user's billing address data */
  defaultAddress?: Maybe<BillingAddress>;
  email?: Maybe<Scalars['String']>;
  emailDomain: UserEmailDomain;
  emailVerificationStatus: EmailVerificationStatus;
  features: UserFeatureSet;
  firstName?: Maybe<Scalars['String']>;
  /** Returns the default survey link domain setting */
  groupSurveyLinkDomainSetting: GroupSurveyLinkDomainSetting;
  hasPendingInvoice: Scalars['Boolean'];
  /** This user's HIPAA data */
  hipaa: UserHipaa;
  id: Scalars['ID'];
  invoices: BillingInvoiceList;
  language: Language;
  lastLoggedInAt: Scalars['DateTime'];
  lastName?: Maybe<Scalars['String']>;
  limits: UserLimitSet;
  /** List of user's oauth accounts and their details */
  linkedAccounts?: Maybe<Array<LinkedAccount>>;
  /** Get all users linked to the calling user's auth0 id */
  linkedIdentities?: Maybe<LinkedIdentities>;
  /**
   * User's Division
   *
   * The list of divisions that the user can manage
   */
  managedDivisions?: Maybe<Array<Division>>;
  /** This user's current paid package. */
  package: UserPackage;
  preferences: UserPreferenceSet;
  /** Get information about seat upgrade request for the current user */
  seatRequest?: Maybe<SeatRequest>;
  /** Returns current selected time zone */
  selectedTimeZone: TimeZone;
  /** Returns all user's current Stripe subscriptions */
  subscriptions?: Maybe<UserSubscriptions>;
  /** A list of surveys associated with this user. */
  surveys: SurveyList;
  /** List of surveys shared with a user */
  surveysSharedWith?: Maybe<SurveyList>;
  /** The team account this user belongs to */
  team?: Maybe<Team>;
  /** Information about the user's membership within a team */
  teamMembership?: Maybe<UserTeamMembership>;
  themes: Array<SurveyTheme>;
  themesForLibraryAddAsset: Array<SurveyThemeType>;
  username: Scalars['String'];
  /** The user's credit wallet transactions */
  walletLogs: WalletLogList;
};

/** Represents a SurveyMonkey user. */
export type UserInvoicesArgs = {
  loadFailed?: InputMaybe<Scalars['Boolean']>;
  loadLineItems?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<TransactionProcessType>;
};

/** Represents a SurveyMonkey user. */
export type UserSurveysArgs = {
  input: SurveyListInput;
};

/** Represents a SurveyMonkey user. */
export type UserSurveysSharedWithArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Represents a SurveyMonkey user. */
export type UserThemesArgs = {
  includeCustomThemes?: InputMaybe<Scalars['Boolean']>;
};

/** Represents a SurveyMonkey user. */
export type UserWalletLogsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type UserBillingAccount = {
  __typename?: 'UserBillingAccount';
  billingAccountType: BillingAccountType;
  nextRenewalDate: Scalars['DateTime'];
  packageId: Scalars['ID'];
  packageSkuCostId: Scalars['ID'];
};

export type UserEmailDomain = {
  __typename?: 'UserEmailDomain';
  domain: Scalars['String'];
  lockdown?: Maybe<UserEmailLockdown>;
};

export type UserEmailLockdown = {
  __typename?: 'UserEmailLockdown';
  daysToLockdown: Scalars['Int'];
};

export type UserError = {
  /**
   * Error message intended for BI loggings and error log, this is a human-readable string describing the issue
   * eg. The provided email address does not match our expected format
   */
  detail: Scalars['String'];
  /** Identifier of which input field has an issue */
  field?: Maybe<Array<Scalars['String']>>;
};

/** Whether or not the user has access to a specific feature */
export type UserFeatureSet = {
  __typename?: 'UserFeatureSet';
  adminDashboardEnabled: Scalars['Boolean'];
  analyzeExportEnabled: Scalars['Boolean'];
  analyzePPTExportEnabled: Scalars['Boolean'];
  analyzeSPSSExportEnabled: Scalars['Boolean'];
  auditLogsEnabled: Scalars['Boolean'];
  brandedSurveys: Scalars['Boolean'];
  collectorEmailEnabled: Scalars['Boolean'];
  collectorFacebookMessengerEnabled: Scalars['Boolean'];
  collectorManualDataEntryEnabled: Scalars['Boolean'];
  collectorMobileSdkEnabled: Scalars['Boolean'];
  collectorOfflineKioskEnabled: Scalars['Boolean'];
  collectorPopupEnabled: Scalars['Boolean'];
  deiReporting: Scalars['Boolean'];
  deiReportingResponseUpload: Scalars['Boolean'];
  divisionsEnabled: Scalars['Boolean'];
  endPagePremiumExperience: Scalars['Boolean'];
  /** Gives the user the ability to self-halt Audience projects. */
  haltAudienceProject: Scalars['Boolean'];
  isSentimentalAnalysisEnabled: Scalars['Boolean'];
  liteLibraryEnabled: Scalars['Boolean'];
  logicEnabled: Scalars['Boolean'];
  logoEnabled: Scalars['Boolean'];
  newTeamLibrary: Scalars['Boolean'];
  offlineEnterpriseEnabled: Scalars['Boolean'];
  plansBenchmarksEnabled: Scalars['Boolean'];
  powerCasualEnabled: Scalars['Boolean'];
  shareWithYourOrganization: Scalars['Boolean'];
  showCreateCrosstab: Scalars['Boolean'];
  /**
   * smsCollector indicates only that a user belongs to an enterprise team that have bought the feature.
   * The actual ability to create an sms collector is more complicated including: if the Team admin has
   * allowed it, what datacenter the user is in, contributor role, survey share permissions, etc.
   */
  smsCollector: Scalars['Boolean'];
  teamAudienceCreditsEnabled: Scalars['Boolean'];
  teamsCanDiscover: Scalars['Boolean'];
  teamsCanMakeDiscoverable: Scalars['Boolean'];
  teamsEnabled: Scalars['Boolean'];
  workgroupsEnabled: Scalars['Boolean'];
};

export type UserHipaa = {
  __typename?: 'UserHipaa';
  isEnabled: Scalars['Boolean'];
  isSuspended: Scalars['Boolean'];
};

/**
 * The limits on certain resources or actions the user can perform
 * A value of 0 means the user has unlimited access
 */
export type UserLimitSet = {
  __typename?: 'UserLimitSet';
  analyzeResponseLimit: Scalars['Int'];
  createQuestionLimit: Scalars['Int'];
  maxCollectorsPerSurvey: Scalars['Int'];
};

export type UserPackage = {
  __typename?: 'UserPackage';
  canonicalName: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['ID'];
  isAnnual?: Maybe<Scalars['Boolean']>;
};

export type UserPaymentMethod = {
  __typename?: 'UserPaymentMethod';
  billingAddress: PaymentAddress;
  email: Scalars['String'];
  paymentMethod: PaymentMethodCard;
};

export type UserPaymentMethodList = {
  __typename?: 'UserPaymentMethodList';
  items: Array<UserPaymentMethod>;
  totalCount: Scalars['Int'];
};

/** User Permission indicate whether user is authorized to have an specific permission */
export type UserPermission = {
  __typename?: 'UserPermission';
  isAuthorized?: Maybe<Scalars['Boolean']>;
};

/** User Permission Type indicate types available in platformsyncsvc */
export enum UserPermissionType {
  AudienceCreditsBuy = 'AUDIENCE_CREDITS_BUY',
  AudienceCreditsManage = 'AUDIENCE_CREDITS_MANAGE',
  AudienceCreditsUse = 'AUDIENCE_CREDITS_USE',
}

export type UserPersonalization = {
  __typename?: 'UserPersonalization';
  useCases: Array<Maybe<Scalars['String']>>;
};

export type UserPreferenceSet = {
  __typename?: 'UserPreferenceSet';
  hasAgreedToEnterpriseTOU?: Maybe<Scalars['Boolean']>;
  hasPurchasedModule: Scalars['Boolean'];
  hasSeenAccountPicker: Scalars['Boolean'];
  hasSeenLIHPWelcomeModal: Scalars['Boolean'];
  isBenchmarkingEnabled: Scalars['Boolean'];
  isInsightsEnabled: Scalars['Boolean'];
  loggedInHomeToggleCoachmarkViewCount?: Maybe<Scalars['Int']>;
  newHomePageEnabled?: Maybe<Scalars['Boolean']>;
  paidBenchmarksEnabled: Scalars['Boolean'];
  smsCollectorTypeEnabled: Scalars['Boolean'];
  /** User's preference on the survey alert setting */
  surveyAlertStatus: UserSurveyAlertStatus;
  teamShareDefault: TeamShareSetting;
};

/** a 'complete' set of profile input data */
export type UserProfileInput = {
  academicInstitution?: InputMaybe<ProfileSingleChoiceInput>;
  academicLevel?: InputMaybe<ProfileSingleChoiceInput>;
  entityIdentifier?: InputMaybe<Scalars['String']>;
  indivJobFunction?: InputMaybe<ProfileSingleChoiceInput>;
  indivJobLevel?: InputMaybe<ProfileSingleChoiceInput>;
  nonprofitIndustry?: InputMaybe<ProfileSingleChoiceInput>;
  profileIndustry?: InputMaybe<ProfileSingleChoiceInput>;
  surveyType?: InputMaybe<ProfileMultipleChoiceInput>;
  userPurpose?: InputMaybe<ProfileSingleChoiceInput>;
};

/** represents the result of a user profile items query */
export type UserProfileItem =
  | ProfileMultipleChoiceData
  | ProfileSingleChoiceData;

/** Specifies input for the profile items query */
export type UserProfileItemInput = {
  includeOnly?: InputMaybe<Array<Scalars['String']>>;
};

export type UserSubscription = {
  __typename?: 'UserSubscription';
  id: Scalars['ID'];
  nextRenewableDate: Scalars['DateTime'];
  partner: UserSubscriptionPartner;
  startDate: Scalars['DateTime'];
  status: UserSubscriptionStatus;
  stripePlatformCustomerId: Scalars['ID'];
  subscriptionItems: Array<UserSubscriptionItem>;
};

export type UserSubscriptionItem = {
  __typename?: 'UserSubscriptionItem';
  id: Scalars['ID'];
  quantity: Scalars['Int'];
  skuId: Scalars['String'];
};

export enum UserSubscriptionPartner {
  Surveymonkey = 'SURVEYMONKEY',
  Wufoo = 'WUFOO',
}

export type UserSubscriptions = {
  __typename?: 'UserSubscriptions';
  items: Array<Maybe<UserSubscription>>;
};

export enum UserSubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Incomplete = 'INCOMPLETE',
  IncompleteExpired = 'INCOMPLETE_EXPIRED',
  PastDue = 'PAST_DUE',
  Trialing = 'TRIALING',
  Unpaid = 'UNPAID',
}

/** Indicates if alert is enabled for new and existing surveys */
export enum UserSurveyAlertStatus {
  ExistingOffNewSurveyOff = 'EXISTING_OFF_NEW_SURVEY_OFF',
  ExistingOffNewSurveyOn = 'EXISTING_OFF_NEW_SURVEY_ON',
  ExistingOnNewSurveyOff = 'EXISTING_ON_NEW_SURVEY_OFF',
  ExistingOnNewSurveyOn = 'EXISTING_ON_NEW_SURVEY_ON',
}

export type UserSurveyLinkDomain = SurveyLinkDomain & {
  __typename?: 'UserSurveyLinkDomain';
  canonicalName: Scalars['String'];
  customDomainType?: Maybe<Scalars['String']>;
  hasWhiteLabelCollector: Scalars['Boolean'];
  selected: Scalars['Boolean'];
  type: SurveyLinkDomainType;
};

/** The relationship entity between a user and a team */
export type UserTeamMembership = {
  __typename?: 'UserTeamMembership';
  /** A list of divisions that this member is the admin */
  adminDivisions?: Maybe<Array<Division>>;
  contributorRoleType?: Maybe<ContributorRoleType>;
  /**
   * true if member joined by team sign up page
   * or false if by email invitation
   */
  didJoinByInvitationUrl?: Maybe<Scalars['Boolean']>;
  /** The Division the member belongs to */
  division?: Maybe<Division>;
  /** The email address of the user or of the pending invitation */
  email: Scalars['String'];
  /** ID is the same as group_member_id as defined in our services */
  id: Scalars['ID'];
  /** The day the invitation was expired */
  invitationExpiredAt?: Maybe<Scalars['DateTime']>;
  /**
   * Whether the user is an admin for their team
   * Team owners are also admins
   */
  isAdmin: Scalars['Boolean'];
  /** Whether the user is a division admin */
  isDivisionAdmin: Scalars['Boolean'];
  /** Whether the user is an enterprise user */
  isEnterprise: Scalars['Boolean'];
  /** Is the invitation expired */
  isInvitationExpired: Scalars['Boolean'];
  /** Whether the user is an SSO user */
  isSSO: Scalars['Boolean'];
  memberType: TeamMemberType;
  seatType?: Maybe<MembershipSeatType>;
  status: TeamMemberStatus;
  /** user associated with the team Member. May be null, such as with pending invites */
  user?: Maybe<User>;
};

/** A list of team members. These nodes associate users with teams. */
export type UserTeamMembershipList = PaginatedList & {
  __typename?: 'UserTeamMembershipList';
  items: Array<UserTeamMembership>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UserTeamSharingPolicy = {
  __typename?: 'UserTeamSharingPolicy';
  crosstabs: UserTeamSharingPolicyType;
  dashboards: UserTeamSharingPolicyType;
  instantResults: UserTeamSharingPolicyType;
  sharedViews: UserTeamSharingPolicyType;
};

export enum UserTeamSharingPolicyType {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Sso = 'SSO',
}

export type ValidateBulkTransferSurveyResult = {
  __typename?: 'ValidateBulkTransferSurveyResult';
  error?: Maybe<ValidateBulkTransferSurveyResultError>;
  id: Scalars['ID'];
  isTransferable: Scalars['Boolean'];
};

/** This is the reason why a survey cannot be transfered */
export enum ValidateBulkTransferSurveyResultError {
  /** The survey cannot be transfered because the new user is not authorized to receive it. */
  Authorization = 'AUTHORIZATION',
  /** There is some other error not covered by the other cases. */
  Generic = 'GENERIC',
  /** The survey cannot be transfered because it contains an offline collector (i.e. kiosk mode) */
  Offline = 'OFFLINE',
  /** The survey cannot be transfered because it contains a payment question. */
  Payment = 'PAYMENT',
}

export type ValidateBulkTransferSurveyResults = {
  __typename?: 'ValidateBulkTransferSurveyResults';
  results: Array<ValidateBulkTransferSurveyResult>;
};

export type ValidateTaxExemptionInput = {
  countryCode: Scalars['String'];
  taxId: Scalars['String'];
};

export type ValueVariableAnswer = ProjectVariableAnswer & {
  __typename?: 'ValueVariableAnswer';
  createdAt: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  type: ProjectVariableAnswerType;
  value: Scalars['String'];
  variableId: Scalars['ID'];
};

export type VariableAnswerPayload = {
  __typename?: 'VariableAnswerPayload';
  answer: ProjectVariableAnswer;
  success: Scalars['Boolean'];
};

export type VideoAbQuestionVariableAnswerData = QuestionVariableAnswerData & {
  __typename?: 'VideoABQuestionVariableAnswerData';
  headers: Array<VideoStimuliSurveyQuestionHeader>;
  type: SurveyQuestionType;
};

export type VideoStimuliSurveyQuestionHeader = BaseQuestionHeader & {
  __typename?: 'VideoStimuliSurveyQuestionHeader';
  description: Scalars['String'];
  heading?: Maybe<Scalars['String']>;
  randomAssignment?: Maybe<QuestionHeaderRandomAssignment>;
  uploadedDate?: Maybe<Scalars['DateTime']>;
  videoLink: Scalars['String'];
};

export type VideoStimuliVariableConfiguration = ProjectVariableConfiguration & {
  __typename?: 'VideoStimuliVariableConfiguration';
  defaultLabel: Scalars['String'];
  enabled: Scalars['Boolean'];
  max: Scalars['Int'];
  min: Scalars['Int'];
};

/** Represents a transaction using the audience/credits wallet */
export type WalletLog = {
  __typename?: 'WalletLog';
  billingCountry?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  currencyCode?: Maybe<CurrencyTypeId>;
  description?: Maybe<Scalars['String']>;
  /** Primary key for the credit log entry */
  id: Scalars['ID'];
  invoiceLink: Scalars['String'];
  isCredit?: Maybe<Scalars['Boolean']>;
  /**
   * Amount of this transaction in "cents" (i.e. smallest unit for the currency in question)
   * Can be either positive or negative (debits/credits)
   */
  totalAmountInCents: Scalars['Int'];
  /** Foreign key to correlate wallet logs to their invoice/transaction */
  transactionId: Scalars['ID'];
};

export type WalletLogList = PaginatedList & {
  __typename?: 'WalletLogList';
  items: Array<WalletLog>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** The type of weblink collector, specifies the relationship it has with other weblinks */
export enum WeblinkVariant {
  /** A weblink collector that was created from another weblink */
  Occurrence = 'OCCURRENCE',
  /** A weblink collector that was neither used to create any others, nor was created from any other weblinks */
  Standard = 'STANDARD',
  /** A weblink collector that is the parent of one/many others */
  Template = 'TEMPLATE',
}

export type WeightedAnswer = QuestionAnswer & {
  __typename?: 'WeightedAnswer';
  id: Scalars['ID'];
  label: Scalars['String'];
  visible: Scalars['Boolean'];
  weight?: Maybe<Scalars['Int']>;
};

/** a flag (boolean) question */
export type WelcomeFlowFlagQuestion = WelcomeFlowQuestion & {
  __typename?: 'WelcomeFlowFlagQuestion';
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  profileType?: Maybe<Scalars['String']>;
  responseFlag?: Maybe<Scalars['Boolean']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: WelcomeFlowQuestionType;
};

/**
 * Specifies all input needed to tell API what page to load
 * interface so we can implement for both query and update
 */
export type WelcomeFlowInput = {
  direction: DirectionType;
  flow: Scalars['String'];
  path: Scalars['String'];
};

/** a multiple choice question */
export type WelcomeFlowMultipleChoiceQuestion = WelcomeFlowQuestion & {
  __typename?: 'WelcomeFlowMultipleChoiceQuestion';
  answerOptions: Array<WelcomeFlowQuestionAnswerOption>;
  answerOther?: Maybe<WelcomeFlowQuestionAnswerOption>;
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  profileType?: Maybe<Scalars['String']>;
  responses?: Maybe<ProfileMultipleChoiceData>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: WelcomeFlowQuestionType;
};

/** a number question */
export type WelcomeFlowNumberQuestion = WelcomeFlowQuestion & {
  __typename?: 'WelcomeFlowNumberQuestion';
  /** short form alternate title for compact presentation */
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** descriptive string for when no choice has been made */
  placeholder?: Maybe<Scalars['String']>;
  profileType?: Maybe<Scalars['String']>;
  responseNumber?: Maybe<Scalars['Int']>;
  subtitle?: Maybe<Scalars['String']>;
  /** standard title for question */
  title?: Maybe<Scalars['String']>;
  type: WelcomeFlowQuestionType;
};

/** represents a single routable welcome flow page */
export type WelcomeFlowPage = {
  __typename?: 'WelcomeFlowPage';
  key?: Maybe<WelcomeFlowPageType>;
  questions: Array<WelcomeFlowQuestion>;
};

/** represents the set of distinct pages across all flows */
export enum WelcomeFlowPageType {
  Individual = 'INDIVIDUAL',
  Organization = 'ORGANIZATION',
  SurveyType = 'SURVEY_TYPE',
  UserPurpose = 'USER_PURPOSE',
}

/** common question fields */
export type WelcomeFlowQuestion = {
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  profileType?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: WelcomeFlowQuestionType;
};

/** a single answer option */
export type WelcomeFlowQuestionAnswerOption = {
  __typename?: 'WelcomeFlowQuestionAnswerOption';
  /** answer display name */
  label: Scalars['String'];
  /** answer value */
  name: Scalars['String'];
};

/** represents the set of distinct question types currently supported */
export enum WelcomeFlowQuestionType {
  Flag = 'FLAG',
  MultipleChoice = 'MULTIPLE_CHOICE',
  Number = 'NUMBER',
  SingleChoice = 'SINGLE_CHOICE',
  Text = 'TEXT',
}

/** represents the type of redirection when the flow is being exited */
export enum WelcomeFlowRedirectType {
  /** open target in same window */
  Redirect = 'REDIRECT',
  /** open target in new window */
  Window = 'WINDOW',
}

/** a single choice question */
export type WelcomeFlowSingleChoiceQuestion = WelcomeFlowQuestion & {
  __typename?: 'WelcomeFlowSingleChoiceQuestion';
  answerOptions: Array<WelcomeFlowQuestionAnswerOption>;
  answerOther?: Maybe<WelcomeFlowQuestionAnswerOption>;
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  profileType?: Maybe<Scalars['String']>;
  response?: Maybe<ProfileSingleChoiceData>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: WelcomeFlowQuestionType;
};

/** The full state of a welcome flow page */
export type WelcomeFlowState = {
  __typename?: 'WelcomeFlowState';
  page?: Maybe<WelcomeFlowPage>;
  target?: Maybe<WelcomeFlowTarget>;
};

/** describes the exit target for a flow */
export type WelcomeFlowTarget = {
  __typename?: 'WelcomeFlowTarget';
  target: WelcomeFlowTargetType;
  type: WelcomeFlowRedirectType;
};

/** represents the type of destination when the flow is being exited */
export enum WelcomeFlowTargetType {
  Analyst = 'ANALYST',
  Audience = 'AUDIENCE',
  Create = 'CREATE',
  Dashboard = 'DASHBOARD',
  EduPricingPage = 'EDU_PRICING_PAGE',
}

/** a text question */
export type WelcomeFlowTextQuestion = WelcomeFlowQuestion & {
  __typename?: 'WelcomeFlowTextQuestion';
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  profileType?: Maybe<Scalars['String']>;
  responseText?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: WelcomeFlowQuestionType;
};

export type WordCloud = {
  __typename?: 'WordCloud';
  id: Scalars['ID'];
  question: OpenEndedQuestion;
  total: Scalars['Int'];
  variationId?: Maybe<Scalars['ID']>;
  words: WordCloudTagList;
};

export type WordCloudTag = {
  __typename?: 'WordCloudTag';
  frequency: Scalars['Int'];
  percentage: Scalars['Float'];
  phrase: Scalars['String'];
};

export type WordCloudTagList = PaginatedList & {
  __typename?: 'WordCloudTagList';
  items: Array<WordCloudTag>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A group of users that can share and collaborate on surveys */
export type Workgroup = {
  __typename?: 'Workgroup';
  createdAt: Scalars['DateTime'];
  /** What is the default role that new members are given */
  defaultRole?: Maybe<OrganizationRole>;
  /** the description of the workgroup */
  description: Scalars['String'];
  id: Scalars['ID'];
  /** Is the workgroup visible to all members of the team (not just admins and members of the workgroup) */
  isVisible: Scalars['Boolean'];
  /** List of workgroup members */
  members?: Maybe<WorkgroupMemberList>;
  /** How many members are in the workgroup */
  membersCount: Scalars['Int'];
  /** membership info about the current user */
  membership: WorkgroupMemberSummaryInfo;
  /** The name of the group */
  name: Scalars['String'];
  /** A list of resources shared with the workgroup */
  shares?: Maybe<WorkgroupSharesList>;
  /** How many surveys were shared with this workgroup */
  sharesCount: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

/** A group of users that can share and collaborate on surveys */
export type WorkgroupMembersArgs = {
  input?: InputMaybe<WorkgroupMembersInput>;
};

/** A group of users that can share and collaborate on surveys */
export type WorkgroupSharesArgs = {
  input?: InputMaybe<WorkgroupSharesInput>;
};

/** A list of workgroups for a team */
export type WorkgroupList = PaginatedList & {
  __typename?: 'WorkgroupList';
  items: Array<Workgroup>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A member of a workgroup that can have access to shared surveys */
export type WorkgroupMember = {
  __typename?: 'WorkgroupMember';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  /** Is this member of the workgroup the owner of the workgroup */
  isOwner: Scalars['Boolean'];
  /** What permissions does this member have for surveys shared with this workgroup */
  role?: Maybe<OrganizationRole>;
  /** Has the member been accepted into the group */
  status: WorkgroupMemberStatus;
  updatedAt: Scalars['DateTime'];
};

/** A list of members in the workgroup */
export type WorkgroupMemberList = PaginatedList & {
  __typename?: 'WorkgroupMemberList';
  items: Array<WorkgroupMember>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type WorkgroupMembersInput = {
  page?: Scalars['Int'];
  pageSize?: Scalars['Int'];
};

/** Whether the member has been accepted into the workgroup or not. */
export enum WorkgroupMemberStatus {
  /** The member has been accepted into the workgroup */
  Active = 'ACTIVE',
  /** Pending means the user requested access to the workgroup but it hasn't been approved yet */
  Pending = 'PENDING',
}

/** Info about the current user and if they are a member of a workgroup. */
export type WorkgroupMemberSummaryInfo = {
  __typename?: 'WorkgroupMemberSummaryInfo';
  /** Is this member of the workgroup the owner of the workgroup */
  isOwner: Scalars['Boolean'];
  /** Has the member been accepted into the group. null if the user is not a member. */
  status?: Maybe<WorkgroupMemberStatus>;
};

export enum WorkgroupResourceType {
  Survey = 'SURVEY',
}

/** An entity shared with a workgroup, for example a Survey */
export type WorkgroupShare = {
  __typename?: 'WorkgroupShare';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  owner?: Maybe<User>;
  resource?: Maybe<WorkgroupShareResource>;
  workgroup?: Maybe<Workgroup>;
};

export type WorkgroupShareResource = Survey;

export type WorkgroupSharesInput = {
  page?: Scalars['Int'];
  pageSize?: Scalars['Int'];
};

/** A list of entities shared with a workgroup, for example: surveys */
export type WorkgroupSharesList = PaginatedList & {
  __typename?: 'WorkgroupSharesList';
  items: Array<WorkgroupShare>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type WorkgroupsInput = {
  /** Filter workgroups that contain this userId as a member (or owner) */
  containingUserId?: InputMaybe<Scalars['ID']>;
  /** Filter workgroups that contain this text in the name */
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};
